import { CountryCode,
FeatureCode,
CurrencyCode,
PaymentMethodCode,
PurchaseStatusCode,
RecurrentPaymentStateCode,
SubscriptionStatusCode,
SubscriptionTypeCode,
ProductCode,
VatStatusCode,
AccountActivityTypeCode,
AssetTypeCode,
AccountCategoryCode,
TaxApplicabilityCode,
AccountTypeCode,
DocumentTypeCode,
SelectionCode,
AccountRoleCode,
AccountingCode,
BookkeepingCode,
LanguageCode,
DepreciationTypeCode,
AccruedProcessingTypeCode,
ActionTypeCode,
ActiveEmploymentPolicyToolCode,
ApprovalStatusTypeCode,
AssetStatusCode,
AssetDisposalTypeCode,
AssetItemTypeCode,
AssetValueCode,
BackgroundJobStatusCode,
BackgroundJobTypeCode,
BankCode,
BankAccountNumberFormatTypeCode,
BankAccountRegistrationStatusCode,
BankApiStatementImportFrequencyCode,
BankApiStatementImportRangeCode,
BankExchangeRateFreshnessCode,
BankPaymentOrderStateCode,
BankStatementTypeCode,
LockTypeCode,
ClearedStatusCode,
DocumentStatusCode,
PaymentStatusCode,
PostedStatusCode,
BankTransactionTypeCode,
PayerReliabilityStatusCode,
BankTransactionDocumentNumberLocationCode,
BillingItemTypeCode,
BillingModuleTypeCode,
BillingPricingCode,
CompanyBankAccountTypeCode,
BusinessPartnerDocumentDefaultTypeCode,
CSSZBankTypeCode,
CSSZSubmissionTypeCode,
CSSZTransactionStatusCode,
CbaAssetDisposalTypeCode,
CbaCategoryTaxImpactCode,
CbaEntrySpecialVatCalculationCode,
CbaEntryTypeCode,
VatCode,
CbaEntryLedgerDocumentTypeCode,
ChatParticipantTypeCode,
DocumentLinkTypeCode,
CollectiveAgreementTypeCode,
ColourThemeCode,
CommunicationEntryChannelCode,
CommunicationEntryStateCode,
CommunicationEntryTypeCode,
GovernmentInstitutionCode,
CountryRegionCode,
CompanyStateCode,
TypeOfBusinessCode,
ModuleCode,
CompanyPermissionCode,
CompanyRoleTypeCode,
VatStatementFrequencyCode,
DocumentSourceTypeCode,
VatStatementStatusCode,
VatCanceledStatusCode,
ExternalCorrectedDocumentTypeCode,
CountryClassificationCode,
CountryOrUnionCode,
CsszEmploymentTypeCode,
PrEmploymentTypeCode,
ExchangeRateTypeCode,
CzIsceCode,
CzIscoCode,
DateFormatCode,
DayOfWeekCode,
VariantAccessTypeCode,
VariantTypeCode,
PeriodDayCode,
DeferredPlanPostingTypeCode,
DepreciationPolicyTypeCode,
DepreciationSettingTypeCode,
DetailedEmploymentSpecificationCode,
DocumentBusinessPartnerTypeCode,
InteractionTypeCode,
GrantAssignmentTypeCode,
DocumentImportTypeCode,
UnitOfMeasureCode,
GrantClaimTypeCode,
DocumentItemTypeCode,
PayableReceivableTypeCode,
VatControlStatementSectionCode,
VatDeductionTypeCode,
VatOssCode,
VatReverseChargeCode,
VatStatementSectionCode,
VatViesCode,
DocumentLinkClearingTypeCode,
ElectronicSubmissionSubmissionTypeCode,
ElectronicSubmissionTypeCode,
EmploymentEarlyTerminationReasonCode,
EmploymentRelationshipTerminationReasonCode,
EntityPermissionLevelCode,
EvalaZoomCode,
ExpenseTaxRateCode,
ExportRangeCode,
ExportResultTypeCode,
ExportTypeCode,
LegalEntityCategoryCode,
ReportTypeCode,
FinancialReportLayoutCode,
ReportSectionTypeCode,
FiscalYearStatusCode,
InventoryTypeCode,
FiscalYearCloseSectionTypeCode,
FulfilmentTypeCode,
GeneralPermissionCode,
GovernmentInstitutionTypeCode,
LORegionalOfficeCode,
GrantStatusCode,
InboxEntityTypeCode,
InboxFileSourceCode,
InboxFileStatusCode,
InboxItemLogStateCode,
IntegrationApiImportFrequencyCode,
IntegrationApiImportFromWhenCode,
IntegrationApiImportRangeCode,
IntegrationApiImportedDocumentsCode,
InvoiceServiceIntegrationTypeCode,
JournalEntryTypeCode,
LaborOfficeEmploymentTypeCode,
LegislativeFixedExchangeRateCode,
MandatoryAccountCode,
MandatoryChartOfAccountsCode,
MinorAssetStatusCode,
MonthOfYearCode,
MpsvFreeAccessToLaborMarketTypeCode,
MpsvTaxIdentifierTypeCode,
NoUnemploymentSupportTypeCode,
NotificationPriorityCode,
NotificationTypeCode,
NotificationTypeGroupCode,
NumberRangeTypeCode,
NumberRangeWildcardCode,
OwnershipFormTypeCode,
PaymentDocumentItemTypeCode,
PaymentOrderFormatCode,
PaymentOrderOutputCode,
PostingRuleDocumentTypeCode,
PrAbsenceObstacleTypeCode,
PrAbsenceCategoryTypeCode,
PrAbsenceCategoryOriginCode,
PrAbsenceCategorySubtypeCode,
PrVacationEntitlementInclusionCode,
PrAbsenceCompensationCode,
PrAccountingCategoryCode,
PrAccountingGroupSelectionCode,
PrAccountingItemTypeCode,
PrAccountingItemGroupCode,
PrAnnualTaxItemTypeCode,
PrValueTypeCode,
PrAnnualTaxSettlementStatusCode,
PrAnnualTaxSettlementRequestResultTypeCode,
PrAnnualTaxSettlementRequestStatusTypeCode,
PrAnnualTaxSettlementRequestFormSectionDetailTypeCode,
PrAnnualTaxSettlementRequestFormSectionTypeCode,
PrChildDeductionOrderCode,
PrPropertyAcquisitionCode,
PrIdentifierCode,
PrDisabilityTypeCode,
PrAttendanceStatusCode,
PrAttendanceStatusDisplayCode,
PrWorkIntervalTypeCode,
PrBenefitTypeCode,
PrBenefitTaxFreeLimitCode,
PrOtherBenefitCategoryCode,
PrOtherBenefitTaxAndContributionsApplicabilityCode,
PrOtherBenefitTaxDeducibilityCode,
PrCSSZPaymentMethodCode,
PrHealthInsuranceCompanyCode,
PrSubmissionStatusCode,
PrSubmissionSubtypeCode,
PrSubmissionTypeCode,
PrSubmissionValidationStatusCode,
PrMpsvFamilyRelationCode,
PrCaregivingTypeCode,
PrPensionTypeCode,
PrSubsequentMaternityLeaveStatusCode,
PrMpsvRelationCode,
PrMaternityLeaveEntitlementCode,
PrPaternityLeaveEntitlementCode,
PrSocialEventRequiredActionCode,
PrSocialEventStatusCode,
PrSocialEventTypeCode,
PrChildSupportDeductionTypeCode,
PrCollectionItemChangeTypeCode,
YesNoCode,
PrCzechReductionLimitCode,
PrDistrainmentDepositClosingCode,
PrDistrainmentDeductionTypeCode,
PrInsolvencyDepositClosingCode,
PrDeductionStatusCode,
PrDeductionTypeCode,
PrDeductionCalculationTypeCode,
PrDeductionEntityTypeCode,
PrDelayedIncomeTypeCode,
PrDisabilityDiscountAmountCode,
PrTaxDiscountTypeCode,
PrEducationCode,
PrEldpTypeCode,
PrEldpItemTypeCode,
PrIdentityDocumentTypeCode,
PrSexCode,
PrSalaryPayoutTypeCode,
PrEmployeeCarTaxabilityCode,
PrEmployeeDependentPersonRelationCode,
PrEmployeeStateCode,
PrFormOfStudyTypeCode,
PrMinimumHealthInsuranceTypeCode,
PrSocialInsuranceDiscountTypeCode,
PrEmploymentCategoryCode,
PrEmploymentWorkplaceAddressSelectionCode,
PrEntityValueSourceCode,
PrSalaryComponentTypeCode,
ServiceRelationshipTerminationReasonCode,
PrExtraSalaryComputationTypeCode,
PrTimeBasedBonusTypeCode,
PrRetirementSavingsComputationTypeCode,
PrRegularSalaryTypeCode,
PrFixedBonusDeductionImpactCode,
PrFixedBonusPayOutImpactCode,
PrFixedBonusTaxImpactCode,
PrExtraSalaryTypeCode,
PrExtraSalaryLegislativeValueCode,
PrExtraSalaryOriginCode,
PrForeignInsuranceCarrierTypeCode,
PrForeignInsuranceCarrierSectorTypeCode,
PrHealthInsuranceCompanyBankAccountCode,
PrHolidayPayoutTypeCode,
PrHolidayShiftAssignmentCode,
PrHozChangeCodeCode,
PrIncomeTaxDiscountCode,
SpecificLegalFactTypeCode,
PrJmhzFormTypeCode,
RiskCategoryCode,
PrWorkPermitTypeCode,
PrLegislativeAverageSalaryCode,
PrLegislativePayrollConstantCode,
PrLegislativeYouthEventCompensationHourlyLimitCode,
PrMinimumHealthInsuranceBaseCode,
PrPeriodDocumentTypeCode,
PrPayrollPeriodStatusCode,
PrPayrollSubstitutePayDayCode,
PrSocialInsuranceDiscountIneligibilityReasonCode,
PrSalaryComponentAverageInclusionCode,
PrPayslipEmploymentItemTypeCode,
PrPayslipEmploymentSubitemTypeCode,
PrPayslipItemTypeCode,
PrPayslipSubitemTypeCode,
PrRelevantIncomeCode,
PrRetirementSavingsTypeCode,
PrSocialEventMonthDetailTypeCode,
PrSocialInsuranceRateCode,
ShiftPatternCode,
WorkplaceTypeCode,
PrTaxpayerDeclarationStatusCode,
PrTaxpayerDeclarationTypeCode,
PrUnseizableAmountCode,
PrVacationEntitlementCode,
PrWorkingPatternTypeCode,
PrWorkingPatternIntervalTypeCode,
PrYearOperationSectionTypeCode,
ReceivableAdjustmentGroupCode,
ReceivableAdjustmentTypeCode,
RecurringTaskIntervalCode,
RecurringTaskPeriodCode,
RecurringTaskStateCode,
RecurringTaskTypeCode,
RequiredAccountTypeCode,
RossumJobStatusCode,
SignatoryPersonCode,
TaxCalendarTaxTypeCode,
TaxDepreciationCategoryCode,
TaxPriceLimitCode,
TaxStatementSubmitterCode,
TimeFormatCode,
TimeZoneCode,
UserStatusCode,
VatRateTypeCode,
VatControlStatementCode,
VatPayerRegistrationActionCode,
VatPayerRegistrationLimitCode,
VatStatementCode,
VatStatementSectionCategoryCode,
WebSocketMessageTypeCode,
WriteOffTypeCode } from "./GeneratedEnums";

export interface IEvalaMetadataRule {
    ErrorCode: string;
    Message: string;
    LinkedEntities: {
        DisplayName: string;
        Id: number;
        TypeName: string;
    }[];
    // entity related
    // cannot be deleted - applicable for collection item, e.g. Items(4)
    CannotBeDeleted?: boolean;
    
    // collections related
    // cannot add item in collection - applicable for whole collection, e.g. Items
    CannotAdd?: boolean;
    // cannot remove item from collection - applicable for whole collection, e.g. Items, Attachments
    CannotDelete?: boolean;
}

export interface ODataEntityMetadata {
    count?: number;
    context?: string;
    type?: string;
    etag?: string;
    metadata?: {
        DisabledPropertyRules?: Record<string, IEvalaMetadataRule[]>
        EnabledPropertyRules?: Record<string, IEvalaMetadataRule[]>
    };
}

export interface IEntityBase {
    _metadata?: Record<string, ODataEntityMetadata>;
    "#id"?: number | string;
}

export interface IBankTransactionsPostMultipleLabelParameterEntity extends IEntityBase {
    LabelHierarchyId?: number;
    LabelId?: number;
}

export enum BankTransactionsPostMultipleLabelParameterEntity {
    LabelHierarchyId = "LabelHierarchyId",
    LabelId = "LabelId",
}

export interface ISourcedDateEntity extends IEntityBase {
    Source?: null;
    Date?: Date;
}

export enum SourcedDateEntity {
    Source = "Source",
    Date = "Date",
}

export interface IExportedFileDtoEntity extends IEntityBase {
    FileName?: string;
    Content?: null;
}

export enum ExportedFileDtoEntity {
    FileName = "FileName",
    Content = "Content",
}

export interface IBillingAddressEntity extends IEntityBase {
    Id?: number;
    City?: string;
    CountryCode?: CountryCode;
    Name?: string;
    PostalCode?: string;
    Street?: string;
    TenantId?: number;
    TemporaryGuid?: string;
    Country?: ICountryEntity;
    Tenant?: ITenantEntity;
}

export enum BillingAddressEntity {
    Id = "Id",
    City = "City",
    CountryCode = "CountryCode",
    Name = "Name",
    PostalCode = "PostalCode",
    Street = "Street",
    TenantId = "TenantId",
    TemporaryGuid = "TemporaryGuid",
    Country = "Country",
    Tenant = "Tenant",
}

export interface IBillingContactEntity extends IEntityBase {
    Id?: number;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    Order?: number;
    TenantId?: number;
    TemporaryGuid?: string;
    Tenant?: ITenantEntity;
}

export enum BillingContactEntity {
    Id = "Id",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    Order = "Order",
    TenantId = "TenantId",
    TemporaryGuid = "TemporaryGuid",
    Tenant = "Tenant",
}

export interface IBillingDiscountEntity extends IEntityBase {
    Id?: number;
    PayrollDateTrialStart?: Date;
    RossumFreeMax?: number;
    RossumFreeUsed?: number;
    TenantId?: number;
    PayrollTrialLength?: number;
    LastModifiedByUserGuid?: string;
    TemporaryGuid?: string;
    Subscription?: ISubscriptionEntity;
    Tenant?: ITenantEntity;
}

export enum BillingDiscountEntity {
    Id = "Id",
    PayrollDateTrialStart = "PayrollDateTrialStart",
    RossumFreeMax = "RossumFreeMax",
    RossumFreeUsed = "RossumFreeUsed",
    TenantId = "TenantId",
    PayrollTrialLength = "PayrollTrialLength",
    LastModifiedByUserGuid = "LastModifiedByUserGuid",
    TemporaryGuid = "TemporaryGuid",
    Subscription = "Subscription",
    Tenant = "Tenant",
}

export interface IDatabaseEntity extends IEntityBase {
    Id?: string;
    AcceptsNewTenants?: boolean;
    Version?: string;
}

export enum DatabaseEntity {
    Id = "Id",
    AcceptsNewTenants = "AcceptsNewTenants",
    Version = "Version",
}

export interface IEnabledFeatureEntity extends IEntityBase {
    Id?: number;
    FeatureCode?: FeatureCode;
    TenantId?: number;
    TemporaryGuid?: string;
    Feature?: IFeatureEntity;
    Tenant?: ITenantEntity;
}

export enum EnabledFeatureEntity {
    Id = "Id",
    FeatureCode = "FeatureCode",
    TenantId = "TenantId",
    TemporaryGuid = "TemporaryGuid",
    Feature = "Feature",
    Tenant = "Tenant",
}

export interface IInvitationEntity extends IEntityBase {
    Id?: number;
    CustomerCompanies?: string;
    DateCreated?: Date;
    DateEmailSent?: Date;
    Email?: string;
    FirstName?: string;
    TemporaryGuid?: string;
    IsCustomerInvitation?: boolean;
    LastName?: string;
    TenantUserId?: number;
    Tenant?: ITenantEntity;
}

export enum InvitationEntity {
    Id = "Id",
    CustomerCompanies = "CustomerCompanies",
    DateCreated = "DateCreated",
    DateEmailSent = "DateEmailSent",
    Email = "Email",
    FirstName = "FirstName",
    TemporaryGuid = "TemporaryGuid",
    IsCustomerInvitation = "IsCustomerInvitation",
    LastName = "LastName",
    TenantUserId = "TenantUserId",
    Tenant = "Tenant",
}

export interface IInvoiceEntity extends IEntityBase {
    Id?: number;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    CurrencyCode?: CurrencyCode;
    DateCreated?: Date;
    DateEnd?: Date;
    DateLastPaymentAttempt?: Date;
    DateOfPayment?: Date;
    DateStart?: Date;
    PaymentMethodCode?: PaymentMethodCode;
    S5Number?: string;
    SymbolVariable?: number;
    TenantId?: number;
    PaymentId?: number;
    FileMetadataId?: number;
    LastModifiedByUserGuid?: string;
    TemporaryGuid?: string;
    Currency?: ICurrencyEntity;
    PaymentMethod?: IPaymentMethodEntity;
    Subscription?: ISubscriptionEntity;
    Tenant?: ITenantEntity;
    Items?: IInvoiceItemEntity[];
}

export enum InvoiceEntity {
    Id = "Id",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    CurrencyCode = "CurrencyCode",
    DateCreated = "DateCreated",
    DateEnd = "DateEnd",
    DateLastPaymentAttempt = "DateLastPaymentAttempt",
    DateOfPayment = "DateOfPayment",
    DateStart = "DateStart",
    PaymentMethodCode = "PaymentMethodCode",
    S5Number = "S5Number",
    SymbolVariable = "SymbolVariable",
    TenantId = "TenantId",
    PaymentId = "PaymentId",
    FileMetadataId = "FileMetadataId",
    LastModifiedByUserGuid = "LastModifiedByUserGuid",
    TemporaryGuid = "TemporaryGuid",
    Currency = "Currency",
    PaymentMethod = "PaymentMethod",
    Subscription = "Subscription",
    Tenant = "Tenant",
    Items = "Items",
}

export interface IInvoiceItemEntity extends IEntityBase {
    Id?: number;
    BillingModuleTypeCode?: string;
    InvoiceId?: number;
    Name?: string;
    PriceNet?: number;
    S5articleGuid?: string;
    TenantId?: number;
    Quantity?: number;
    LastModifiedByUserGuid?: string;
    TemporaryGuid?: string;
}

export enum InvoiceItemEntity {
    Id = "Id",
    BillingModuleTypeCode = "BillingModuleTypeCode",
    InvoiceId = "InvoiceId",
    Name = "Name",
    PriceNet = "PriceNet",
    S5articleGuid = "S5articleGuid",
    TenantId = "TenantId",
    Quantity = "Quantity",
    LastModifiedByUserGuid = "LastModifiedByUserGuid",
    TemporaryGuid = "TemporaryGuid",
}

export interface ISubscriptionEntity extends IEntityBase {
    Id?: number;
    CurrencyCode?: CurrencyCode;
    DateCancellation?: Date;
    DateExpiration?: Date;
    DateFree?: Date;
    DateGracefulPeriodEnd?: Date;
    DatePurchase?: Date;
    DateRenewal?: Date;
    DateTrialStart?: Date;
    HasLimitedAccess?: boolean;
    IsGracefulPeriod?: boolean;
    Number?: string;
    PaymentMethodCode?: PaymentMethodCode;
    PurchaseContact?: string;
    PurchaseStatusCode?: PurchaseStatusCode;
    RecurrentPaymentStateCode?: RecurrentPaymentStateCode;
    RequestedPaymentMethodCode?: PaymentMethodCode;
    SubscriptionStatusCode?: SubscriptionStatusCode;
    SubscriptionTypeCode?: SubscriptionTypeCode;
    TenantId?: number;
    CardPaymentLimit?: number;
    GoPayId?: number;
    TrialLength?: number;
    LastModifiedByUserGuid?: string;
    TemporaryGuid?: string;
    Currency?: ICurrencyEntity;
    Discount?: IBillingDiscountEntity;
    PaymentMethod?: IPaymentMethodEntity;
    PurchaseStatus?: IPurchaseStatusEntity;
    RecurrentPaymentState?: IRecurrentPaymentStateEntity;
    RequestedPaymentMethod?: IPaymentMethodEntity;
    SubscriptionStatus?: ISubscriptionStatusEntity;
    SubscriptionType?: ISubscriptionTypeEntity;
    Tenant?: ITenantEntity;
    Invoices?: IInvoiceEntity[];
}

export enum SubscriptionEntity {
    Id = "Id",
    CurrencyCode = "CurrencyCode",
    DateCancellation = "DateCancellation",
    DateExpiration = "DateExpiration",
    DateFree = "DateFree",
    DateGracefulPeriodEnd = "DateGracefulPeriodEnd",
    DatePurchase = "DatePurchase",
    DateRenewal = "DateRenewal",
    DateTrialStart = "DateTrialStart",
    HasLimitedAccess = "HasLimitedAccess",
    IsGracefulPeriod = "IsGracefulPeriod",
    Number = "Number",
    PaymentMethodCode = "PaymentMethodCode",
    PurchaseContact = "PurchaseContact",
    PurchaseStatusCode = "PurchaseStatusCode",
    RecurrentPaymentStateCode = "RecurrentPaymentStateCode",
    RequestedPaymentMethodCode = "RequestedPaymentMethodCode",
    SubscriptionStatusCode = "SubscriptionStatusCode",
    SubscriptionTypeCode = "SubscriptionTypeCode",
    TenantId = "TenantId",
    CardPaymentLimit = "CardPaymentLimit",
    GoPayId = "GoPayId",
    TrialLength = "TrialLength",
    LastModifiedByUserGuid = "LastModifiedByUserGuid",
    TemporaryGuid = "TemporaryGuid",
    Currency = "Currency",
    Discount = "Discount",
    PaymentMethod = "PaymentMethod",
    PurchaseStatus = "PurchaseStatus",
    RecurrentPaymentState = "RecurrentPaymentState",
    RequestedPaymentMethod = "RequestedPaymentMethod",
    SubscriptionStatus = "SubscriptionStatus",
    SubscriptionType = "SubscriptionType",
    Tenant = "Tenant",
    Invoices = "Invoices",
}

export interface ITenantEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateDataDeletion?: Date;
    DomainName?: string;
    ImpactScore?: number;
    IsActive?: boolean;
    IsCanceled?: boolean;
    IsDemo?: boolean;
    IsEmailSendingVerified?: boolean;
    IsOnStaging?: boolean;
    Label?: string;
    LeadScore?: number;
    LegalNumber?: string;
    Name?: string;
    PhoneNumber?: string;
    ProductCode?: ProductCode;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    CustomerSupportGuid?: string;
    S5CustomerGuid?: string;
    CrmAccountGuid?: string;
    CrmOpportunityGuid?: string;
    LastModifiedByUserGuid?: string;
    TemporaryGuid?: string;
    BillingAddress?: IBillingAddressEntity;
    BillingContacts?: IBillingContactEntity[];
    Product?: IProductEntity;
    Subscription?: ISubscriptionEntity;
    VatStatus?: IVatStatusEntity;
}

export enum TenantEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateDataDeletion = "DateDataDeletion",
    DomainName = "DomainName",
    ImpactScore = "ImpactScore",
    IsActive = "IsActive",
    IsCanceled = "IsCanceled",
    IsDemo = "IsDemo",
    IsEmailSendingVerified = "IsEmailSendingVerified",
    IsOnStaging = "IsOnStaging",
    Label = "Label",
    LeadScore = "LeadScore",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PhoneNumber = "PhoneNumber",
    ProductCode = "ProductCode",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    CustomerSupportGuid = "CustomerSupportGuid",
    S5CustomerGuid = "S5CustomerGuid",
    CrmAccountGuid = "CrmAccountGuid",
    CrmOpportunityGuid = "CrmOpportunityGuid",
    LastModifiedByUserGuid = "LastModifiedByUserGuid",
    TemporaryGuid = "TemporaryGuid",
    BillingAddress = "BillingAddress",
    BillingContacts = "BillingContacts",
    Product = "Product",
    Subscription = "Subscription",
    VatStatus = "VatStatus",
}

export interface IAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ActivityTypeCode?: AccountActivityTypeCode;
    AssetAcquisitionTypeCode?: AssetTypeCode;
    CategoryCode?: AccountCategoryCode;
    CurrencyCode?: CurrencyCode;
    Description?: string;
    Detail?: string;
    IsActive?: boolean;
    IsAssignable?: boolean;
    IsBankPostable?: boolean;
    IsClosed?: boolean;
    IsInvertible?: boolean;
    Name?: string;
    Number?: string;
    TaxApplicabilityCode?: TaxApplicabilityCode;
    TypeCode?: AccountTypeCode;
    ActivityType?: IAccountActivityTypeEntity;
    AssetAcquisitionType?: IAssetTypeEntity;
    BalanceSheetLayout?: IBalanceSheetLayoutEntity;
    Category?: IAccountCategoryEntity;
    Currency?: ICurrencyEntity;
    IncomeStatementLayout?: IIncomeStatementLayoutEntity;
    Parent?: IAccountEntity;
    TaxApplicability?: ITaxApplicabilityEntity;
    Type?: IAccountTypeEntity;
    Children?: IAccountEntity[];
}

export enum AccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ActivityTypeCode = "ActivityTypeCode",
    AssetAcquisitionTypeCode = "AssetAcquisitionTypeCode",
    CategoryCode = "CategoryCode",
    CurrencyCode = "CurrencyCode",
    Description = "Description",
    Detail = "Detail",
    IsActive = "IsActive",
    IsAssignable = "IsAssignable",
    IsBankPostable = "IsBankPostable",
    IsClosed = "IsClosed",
    IsInvertible = "IsInvertible",
    Name = "Name",
    Number = "Number",
    TaxApplicabilityCode = "TaxApplicabilityCode",
    TypeCode = "TypeCode",
    ActivityType = "ActivityType",
    AssetAcquisitionType = "AssetAcquisitionType",
    BalanceSheetLayout = "BalanceSheetLayout",
    Category = "Category",
    Currency = "Currency",
    IncomeStatementLayout = "IncomeStatementLayout",
    Parent = "Parent",
    TaxApplicability = "TaxApplicability",
    Type = "Type",
    Children = "Children",
}

export interface IAccountActivityTypeEntity extends IEntityBase {
    Code?: AccountActivityTypeCode;
    Name?: string;
}

export enum AccountActivityTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IAccountAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CreditAccountName?: string;
    CreditAccountNumber?: string;
    DebitAccountName?: string;
    DebitAccountNumber?: string;
    IsActive?: boolean;
    IsAllowedForAllCompanies?: boolean;
    IsDebitAccountVatDeductionForced?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    DocumentTypes?: IAccountAssignmentDocumentTypeEntity[];
    AllowedCompanies?: ICompanyEntity[];
}

export enum AccountAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CreditAccountName = "CreditAccountName",
    CreditAccountNumber = "CreditAccountNumber",
    DebitAccountName = "DebitAccountName",
    DebitAccountNumber = "DebitAccountNumber",
    IsActive = "IsActive",
    IsAllowedForAllCompanies = "IsAllowedForAllCompanies",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    DocumentTypes = "DocumentTypes",
    AllowedCompanies = "AllowedCompanies",
}

export interface IAccountAssignmentCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountAssignmentId?: number;
    AllowedCompanyId?: number;
}

export enum AccountAssignmentCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountAssignmentId = "AccountAssignmentId",
    AllowedCompanyId = "AllowedCompanyId",
}

export interface IAccountAssignmentDocumentTypeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentType?: IDocumentTypeEntity;
}

export enum AccountAssignmentDocumentTypeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentType = "DocumentType",
}

export interface IAccountAssignmentDocumentTypeTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentType?: IDocumentTypeEntity;
}

export enum AccountAssignmentDocumentTypeTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentType = "DocumentType",
}

export interface IAccountAssignmentSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
}

export enum AccountAssignmentSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
}

export interface IAccountAssignmentSelectionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
}

export enum AccountAssignmentSelectionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
}

export interface IAccountAssignmentTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CreditAccountName?: string;
    CreditAccountNumber?: string;
    DebitAccountName?: string;
    DebitAccountNumber?: string;
    IsActive?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    DocumentTypes?: IAccountAssignmentDocumentTypeTemplateEntity[];
}

export enum AccountAssignmentTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CreditAccountName = "CreditAccountName",
    CreditAccountNumber = "CreditAccountNumber",
    DebitAccountName = "DebitAccountName",
    DebitAccountNumber = "DebitAccountNumber",
    IsActive = "IsActive",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    DocumentTypes = "DocumentTypes",
}

export interface IAccountCategoryEntity extends IEntityBase {
    Code?: AccountCategoryCode;
    Name?: string;
}

export enum AccountCategoryEntity {
    Code = "Code",
    Name = "Name",
}

export interface IAccountRoleEntity extends IEntityBase {
    Code?: AccountRoleCode;
    Name?: string;
}

export enum AccountRoleEntity {
    Code = "Code",
    Name = "Name",
}

export interface IAccountTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ActivityTypeCode?: AccountActivityTypeCode;
    AssetAcquisitionTypeCode?: AssetTypeCode;
    CategoryCode?: AccountCategoryCode;
    CurrencyCode?: CurrencyCode;
    Description?: string;
    Detail?: string;
    IsActive?: boolean;
    IsBankPostable?: boolean;
    IsInvertible?: boolean;
    Name?: string;
    Number?: string;
    TaxApplicabilityCode?: TaxApplicabilityCode;
    TypeCode?: AccountTypeCode;
    ActivityType?: IAccountActivityTypeEntity;
    AssetAcquisitionType?: IAssetTypeEntity;
    BalanceSheetLayout?: IBalanceSheetLayoutTemplateEntity;
    Category?: IAccountCategoryEntity;
    Currency?: ICurrencyEntity;
    IncomeStatementLayout?: IIncomeStatementLayoutTemplateEntity;
    Parent?: IAccountTemplateEntity;
    TaxApplicability?: ITaxApplicabilityEntity;
    Type?: IAccountTypeEntity;
    Children?: IAccountTemplateEntity[];
}

export enum AccountTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ActivityTypeCode = "ActivityTypeCode",
    AssetAcquisitionTypeCode = "AssetAcquisitionTypeCode",
    CategoryCode = "CategoryCode",
    CurrencyCode = "CurrencyCode",
    Description = "Description",
    Detail = "Detail",
    IsActive = "IsActive",
    IsBankPostable = "IsBankPostable",
    IsInvertible = "IsInvertible",
    Name = "Name",
    Number = "Number",
    TaxApplicabilityCode = "TaxApplicabilityCode",
    TypeCode = "TypeCode",
    ActivityType = "ActivityType",
    AssetAcquisitionType = "AssetAcquisitionType",
    BalanceSheetLayout = "BalanceSheetLayout",
    Category = "Category",
    Currency = "Currency",
    IncomeStatementLayout = "IncomeStatementLayout",
    Parent = "Parent",
    TaxApplicability = "TaxApplicability",
    Type = "Type",
    Children = "Children",
}

export interface IAccountTypeEntity extends IEntityBase {
    Code?: AccountTypeCode;
    Name?: string;
}

export enum AccountTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IAccountingEntity extends IEntityBase {
    Code?: AccountingCode;
    BookkeepingCode?: BookkeepingCode;
    CountryCode?: CountryCode;
    DefaultLanguageCode?: LanguageCode;
    Description?: string;
    Name?: string;
    Bookkeeping?: IBookkeepingEntity;
    Country?: ICountryEntity;
    DefaultLanguage?: ILanguageEntity;
}

export enum AccountingEntity {
    Code = "Code",
    BookkeepingCode = "BookkeepingCode",
    CountryCode = "CountryCode",
    DefaultLanguageCode = "DefaultLanguageCode",
    Description = "Description",
    Name = "Name",
    Bookkeeping = "Bookkeeping",
    Country = "Country",
    DefaultLanguage = "DefaultLanguage",
}

export interface IAccountingDepreciationPolicyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccumulatedDepreciation?: number;
    CurrencyCode?: CurrencyCode;
    DateFirstDepreciation?: Date;
    DateLastDepreciation?: Date;
    DateRequestedLastDepreciation?: Date;
    Currency?: ICurrencyEntity;
    DepreciationTypeCode?: DepreciationTypeCode;
    UsefulLife?: number;
    DepreciationType?: IDepreciationTypeEntity;
    Items?: IAccountingDepreciationPolicyItemEntity[];
}

export enum AccountingDepreciationPolicyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccumulatedDepreciation = "AccumulatedDepreciation",
    CurrencyCode = "CurrencyCode",
    DateFirstDepreciation = "DateFirstDepreciation",
    DateLastDepreciation = "DateLastDepreciation",
    DateRequestedLastDepreciation = "DateRequestedLastDepreciation",
    Currency = "Currency",
    DepreciationTypeCode = "DepreciationTypeCode",
    UsefulLife = "UsefulLife",
    DepreciationType = "DepreciationType",
    Items = "Items",
}

export interface IAccountingDepreciationPolicyItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccumulatedDepreciation?: number;
    CalculatedExpense?: number;
    CurrencyCode?: CurrencyCode;
    DateDepreciation?: Date;
    EndValue?: number;
    Order?: number;
    Currency?: ICurrencyEntity;
    CalculatedGrantExpense?: number;
    RemainingGrantAmount?: number;
    Document?: IInternalDocumentEntity;
    GrantDocument?: IInternalDocumentEntity;
}

export enum AccountingDepreciationPolicyItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccumulatedDepreciation = "AccumulatedDepreciation",
    CalculatedExpense = "CalculatedExpense",
    CurrencyCode = "CurrencyCode",
    DateDepreciation = "DateDepreciation",
    EndValue = "EndValue",
    Order = "Order",
    Currency = "Currency",
    CalculatedGrantExpense = "CalculatedGrantExpense",
    RemainingGrantAmount = "RemainingGrantAmount",
    Document = "Document",
    GrantDocument = "GrantDocument",
}

export interface IAccruedProcessingTypeEntity extends IEntityBase {
    Code?: AccruedProcessingTypeCode;
    Name?: string;
}

export enum AccruedProcessingTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IActionLogEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ActionDetails?: string;
    ActionId?: string;
    ActionTypeCode?: ActionTypeCode;
    ActionType?: IActionTypeEntity;
}

export enum ActionLogEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ActionDetails = "ActionDetails",
    ActionId = "ActionId",
    ActionTypeCode = "ActionTypeCode",
    ActionType = "ActionType",
}

export interface IActionTypeEntity extends IEntityBase {
    Code?: ActionTypeCode;
    Name?: string;
}

export enum ActionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IActiveEmploymentPolicyToolEntity extends IEntityBase {
    Code?: ActiveEmploymentPolicyToolCode;
    Description?: string;
    MpsvCode?: string;
    Name?: string;
}

export enum ActiveEmploymentPolicyToolEntity {
    Code = "Code",
    Description = "Description",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
}

export enum AddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
}

export interface IApprovalStatusTypeEntity extends IEntityBase {
    Code?: ApprovalStatusTypeCode;
    Name?: string;
}

export enum ApprovalStatusTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IAssetEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountingBalance?: number;
    AcquisitionCostForTax?: number;
    CalculatedPrice?: number;
    CanBeDepreciated?: boolean;
    CurrencyCode?: CurrencyCode;
    DateDisposed?: Date;
    DateFirstPutInUse?: Date;
    DateForUsefulLife?: Date;
    DateInUseFrom?: Date;
    DateRemainingPrices?: Date;
    IsImportedAsset?: boolean;
    IsImproved?: boolean;
    IsInUse?: boolean;
    IsLowPriceAsset?: boolean;
    Name?: string;
    Note?: string;
    NumberOurs?: string;
    StatusCode?: AssetStatusCode;
    TaxBalance?: number;
    TypeCode?: AssetTypeCode;
    ImportedAssetPrice?: number;
    ImportedAssetTaxPrice?: number;
    ImportedAssetGrantValue?: number;
    RemainingAccountingPrice?: number;
    RemainingTaxPrice?: number;
    UsedTaxLimit?: number;
    RemainingTaxYears?: number;
    AccountedGrantAmount?: number;
    AccountingDepreciationPolicy?: IAccountingDepreciationPolicyEntity;
    AccumulatedDepreciationsAccount?: IAccountEntity;
    ChartOfAccounts?: IChartOfAccountsEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DepreciationAccount?: IAccountEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    GrantEquityAccount?: IAccountEntity;
    GrantOtherIncomeAccount?: IAccountEntity;
    InUseAccount?: IAccountEntity;
    NumberRange?: INumberRangeEntity;
    Status?: IAssetStatusEntity;
    TaxDepreciationPolicy?: ITaxDepreciationPolicyEntity;
    Type?: IAssetTypeEntity;
    Attachments?: IAssetAttachmentEntity[];
    Items?: IAssetItemEntity[];
    Labels?: IAssetLabelEntity[];
}

export enum AssetEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountingBalance = "AccountingBalance",
    AcquisitionCostForTax = "AcquisitionCostForTax",
    CalculatedPrice = "CalculatedPrice",
    CanBeDepreciated = "CanBeDepreciated",
    CurrencyCode = "CurrencyCode",
    DateDisposed = "DateDisposed",
    DateFirstPutInUse = "DateFirstPutInUse",
    DateForUsefulLife = "DateForUsefulLife",
    DateInUseFrom = "DateInUseFrom",
    DateRemainingPrices = "DateRemainingPrices",
    IsImportedAsset = "IsImportedAsset",
    IsImproved = "IsImproved",
    IsInUse = "IsInUse",
    IsLowPriceAsset = "IsLowPriceAsset",
    Name = "Name",
    Note = "Note",
    NumberOurs = "NumberOurs",
    StatusCode = "StatusCode",
    TaxBalance = "TaxBalance",
    TypeCode = "TypeCode",
    ImportedAssetPrice = "ImportedAssetPrice",
    ImportedAssetTaxPrice = "ImportedAssetTaxPrice",
    ImportedAssetGrantValue = "ImportedAssetGrantValue",
    RemainingAccountingPrice = "RemainingAccountingPrice",
    RemainingTaxPrice = "RemainingTaxPrice",
    UsedTaxLimit = "UsedTaxLimit",
    RemainingTaxYears = "RemainingTaxYears",
    AccountedGrantAmount = "AccountedGrantAmount",
    AccountingDepreciationPolicy = "AccountingDepreciationPolicy",
    AccumulatedDepreciationsAccount = "AccumulatedDepreciationsAccount",
    ChartOfAccounts = "ChartOfAccounts",
    Company = "Company",
    Currency = "Currency",
    DepreciationAccount = "DepreciationAccount",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    GrantEquityAccount = "GrantEquityAccount",
    GrantOtherIncomeAccount = "GrantOtherIncomeAccount",
    InUseAccount = "InUseAccount",
    NumberRange = "NumberRange",
    Status = "Status",
    TaxDepreciationPolicy = "TaxDepreciationPolicy",
    Type = "Type",
    Attachments = "Attachments",
    Items = "Items",
    Labels = "Labels",
}

export interface IAssetAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum AssetAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IAssetDisposalTypeEntity extends IEntityBase {
    Code?: AssetDisposalTypeCode;
    Name?: string;
}

export enum AssetDisposalTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IAssetItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CreditAccount?: string;
    CurrencyCode?: CurrencyCode;
    DateElectronicSubmissionVatStatement?: Date;
    DateOfTransaction?: Date;
    DateRequestedLastAccountingDepreciation?: Date;
    DateRequestedLastTaxDepreciation?: Date;
    DebitAccount?: string;
    IsForUsefulLifeRefresh?: boolean;
    ItemTypeCode?: AssetItemTypeCode;
    Order?: number;
    UsefulLife?: number;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
    GrantDocument?: IDocumentEntity;
    ItemType?: IAssetItemTypeEntity;
    Children?: IAssetItemEntity[];
    GrantEntries?: IGrantEntryEntity[];
}

export enum AssetItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CreditAccount = "CreditAccount",
    CurrencyCode = "CurrencyCode",
    DateElectronicSubmissionVatStatement = "DateElectronicSubmissionVatStatement",
    DateOfTransaction = "DateOfTransaction",
    DateRequestedLastAccountingDepreciation = "DateRequestedLastAccountingDepreciation",
    DateRequestedLastTaxDepreciation = "DateRequestedLastTaxDepreciation",
    DebitAccount = "DebitAccount",
    IsForUsefulLifeRefresh = "IsForUsefulLifeRefresh",
    ItemTypeCode = "ItemTypeCode",
    Order = "Order",
    UsefulLife = "UsefulLife",
    Currency = "Currency",
    Document = "Document",
    DocumentItem = "DocumentItem",
    GrantDocument = "GrantDocument",
    ItemType = "ItemType",
    Children = "Children",
    GrantEntries = "GrantEntries",
}

export interface IAssetItemTypeEntity extends IEntityBase {
    Code?: AssetItemTypeCode;
    Description?: string;
    Name?: string;
}

export enum AssetItemTypeEntity {
    Code = "Code",
    Description = "Description",
    Name = "Name",
}

export interface IAssetLabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum AssetLabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IAssetStatusEntity extends IEntityBase {
    Code?: AssetStatusCode;
    Name?: string;
}

export enum AssetStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IAssetTypeEntity extends IEntityBase {
    Code?: AssetTypeCode;
    Name?: string;
}

export enum AssetTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IAssetValueEntity extends IEntityBase {
    Code?: AssetValueCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    MinValue?: number;
    Name?: string;
    Country?: ICountryEntity;
}

export enum AssetValueEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    MinValue = "MinValue",
    Name = "Name",
    Country = "Country",
}

export interface IBackgroundJobEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsResultReadable?: boolean;
    IsSeen?: boolean;
    Parameters?: string;
    Result?: string;
    StatusCode?: BackgroundJobStatusCode;
    TypeCode?: BackgroundJobTypeCode;
    DateStarted?: Date;
    DateFinished?: Date;
    Company?: ICompanyEntity;
    Status?: IBackgroundJobStatusEntity;
    Type?: IBackgroundJobTypeEntity;
}

export enum BackgroundJobEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsResultReadable = "IsResultReadable",
    IsSeen = "IsSeen",
    Parameters = "Parameters",
    Result = "Result",
    StatusCode = "StatusCode",
    TypeCode = "TypeCode",
    DateStarted = "DateStarted",
    DateFinished = "DateFinished",
    Company = "Company",
    Status = "Status",
    Type = "Type",
}

export interface IBackgroundJobStatusEntity extends IEntityBase {
    Code?: BackgroundJobStatusCode;
    Name?: string;
}

export enum BackgroundJobStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBackgroundJobTypeEntity extends IEntityBase {
    Code?: BackgroundJobTypeCode;
    ClassName?: string;
    IsServiceJob?: boolean;
    IsSystemJob?: boolean;
    Name?: string;
}

export enum BackgroundJobTypeEntity {
    Code = "Code",
    ClassName = "ClassName",
    IsServiceJob = "IsServiceJob",
    IsSystemJob = "IsSystemJob",
    Name = "Name",
}

export interface IBalanceSheetLayoutEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AssetsReportSectionCode?: string;
    IsAssetsCorrection?: boolean;
    LiabilitiesReportSectionCode?: string;
    AssetsReportSection?: IFinancialReportLayoutSectionEntity;
    LiabilitiesReportSection?: IFinancialReportLayoutSectionEntity;
}

export enum BalanceSheetLayoutEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AssetsReportSectionCode = "AssetsReportSectionCode",
    IsAssetsCorrection = "IsAssetsCorrection",
    LiabilitiesReportSectionCode = "LiabilitiesReportSectionCode",
    AssetsReportSection = "AssetsReportSection",
    LiabilitiesReportSection = "LiabilitiesReportSection",
}

export interface IBalanceSheetLayoutTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AssetsReportSectionCode?: string;
    IsAssetsCorrection?: boolean;
    LiabilitiesReportSectionCode?: string;
    AssetsReportSection?: IFinancialReportLayoutSectionEntity;
    LiabilitiesReportSection?: IFinancialReportLayoutSectionEntity;
}

export enum BalanceSheetLayoutTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AssetsReportSectionCode = "AssetsReportSectionCode",
    IsAssetsCorrection = "IsAssetsCorrection",
    LiabilitiesReportSectionCode = "LiabilitiesReportSectionCode",
    AssetsReportSection = "AssetsReportSection",
    LiabilitiesReportSection = "LiabilitiesReportSection",
}

export interface IBankEntity extends IEntityBase {
    Code?: BankCode;
    BankStatementApiSupported?: boolean;
    CountryCode?: CountryCode;
    LogoId?: number;
    Name?: string;
    PaymentOrdersImportApiSupported?: boolean;
    SWIFT?: string;
    ShortName?: string;
    Country?: ICountryEntity;
}

export enum BankEntity {
    Code = "Code",
    BankStatementApiSupported = "BankStatementApiSupported",
    CountryCode = "CountryCode",
    LogoId = "LogoId",
    Name = "Name",
    PaymentOrdersImportApiSupported = "PaymentOrdersImportApiSupported",
    SWIFT = "SWIFT",
    ShortName = "ShortName",
    Country = "Country",
}

export interface IBankAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    Country?: ICountryEntity;
}

export enum BankAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    Country = "Country",
}

export interface IBankAccountBalanceEntity extends IEntityBase {
    Id?: number;
    TransactionBalance?: number;
    TransactionCurrencyCode?: CurrencyCode;
    DateBalanceChanged?: Date;
    TransactionCurrency?: ICurrencyEntity;
}

export enum BankAccountBalanceEntity {
    Id = "Id",
    TransactionBalance = "TransactionBalance",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    DateBalanceChanged = "DateBalanceChanged",
    TransactionCurrency = "TransactionCurrency",
}

export interface IBankAccountNumberFormatTypeEntity extends IEntityBase {
    Code?: BankAccountNumberFormatTypeCode;
    Name?: string;
}

export enum BankAccountNumberFormatTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBankAccountRegistrationStatusEntity extends IEntityBase {
    Code?: BankAccountRegistrationStatusCode;
    Name?: string;
}

export enum BankAccountRegistrationStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBankApiConnectionSettingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BankAccountId?: string;
    ClientName?: string;
    ContractNumber?: string;
    DateExpirationApiKey?: Date;
    ErrorMessage?: string;
    ApiKeySetter?: string;
    ApiKeyId?: number;
    RegistrationInfoId?: number;
}

export enum BankApiConnectionSettingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BankAccountId = "BankAccountId",
    ClientName = "ClientName",
    ContractNumber = "ContractNumber",
    DateExpirationApiKey = "DateExpirationApiKey",
    ErrorMessage = "ErrorMessage",
    ApiKeySetter = "ApiKeySetter",
    ApiKeyId = "ApiKeyId",
    RegistrationInfoId = "RegistrationInfoId",
}

export interface IBankApiStatementImportFrequencyEntity extends IEntityBase {
    Code?: BankApiStatementImportFrequencyCode;
    Name?: string;
}

export enum BankApiStatementImportFrequencyEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBankApiStatementImportRangeEntity extends IEntityBase {
    Code?: BankApiStatementImportRangeCode;
    Name?: string;
}

export enum BankApiStatementImportRangeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBankApiStatementImportSettingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BankApiStatementImportFrequencyCode?: BankApiStatementImportFrequencyCode;
    BankApiStatementImportRangeCode?: BankApiStatementImportRangeCode;
    DateFrom?: Date;
    BankApiStatementImportFrequency?: IBankApiStatementImportFrequencyEntity;
    BankApiStatementImportRange?: IBankApiStatementImportRangeEntity;
}

export enum BankApiStatementImportSettingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BankApiStatementImportFrequencyCode = "BankApiStatementImportFrequencyCode",
    BankApiStatementImportRangeCode = "BankApiStatementImportRangeCode",
    DateFrom = "DateFrom",
    BankApiStatementImportFrequency = "BankApiStatementImportFrequency",
    BankApiStatementImportRange = "BankApiStatementImportRange",
}

export interface IBankExchangeRateFreshnessEntity extends IEntityBase {
    Code?: BankExchangeRateFreshnessCode;
    Name?: string;
}

export enum BankExchangeRateFreshnessEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBankPaymentOrderStateEntity extends IEntityBase {
    Code?: BankPaymentOrderStateCode;
    Name?: string;
}

export enum BankPaymentOrderStateEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBankStatementEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BankStatementTypeCode?: BankStatementTypeCode;
    DateFrom?: Date;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    Balance?: IStatementBalanceEntity;
    BankAccountBase?: IBusinessAccountBaseEntity;
    BankStatementType?: IBankStatementTypeEntity;
    NumberRange?: INumberRangeEntity;
    Attachments?: IStatementAttachmentEntity[];
    Locks?: IBankStatementLockEntity[];
    Chats?: IChatEntity[];
    IsVisible?: boolean;
    BankAccount?: ICompanyBankAccountEntity;
    Transactions?: IBankTransactionEntity[];
}

export enum BankStatementEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BankStatementTypeCode = "BankStatementTypeCode",
    DateFrom = "DateFrom",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    Balance = "Balance",
    BankAccountBase = "BankAccountBase",
    BankStatementType = "BankStatementType",
    NumberRange = "NumberRange",
    Attachments = "Attachments",
    Locks = "Locks",
    Chats = "Chats",
    IsVisible = "IsVisible",
    BankAccount = "BankAccount",
    Transactions = "Transactions",
}

export interface IBankStatementCsvSettingsTextEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AmountFormat?: string;
    DataStartPosition?: number;
    DateFormat?: string;
    FileEncoding?: string;
    HeaderPosition?: number;
}

export enum BankStatementCsvSettingsTextEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AmountFormat = "AmountFormat",
    DataStartPosition = "DataStartPosition",
    DateFormat = "DateFormat",
    FileEncoding = "FileEncoding",
    HeaderPosition = "HeaderPosition",
}

export interface IBankStatementLockEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: LockTypeCode;
    Type?: ILockTypeEntity;
}

export enum BankStatementLockEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
}

export interface IBankStatementTypeEntity extends IEntityBase {
    Code?: BankStatementTypeCode;
    Name?: string;
}

export enum BankStatementTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBankTransactionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsUnrelatedToBusiness?: boolean;
    Note?: string;
    NumberOurs?: string;
    PaymentStatusCode?: PaymentStatusCode;
    PostedStatusCode?: PostedStatusCode;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionCurrencyCode?: CurrencyCode;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    NumberRange?: INumberRangeEntity;
    PaymentDocumentDraft?: IPaymentDocumentDraftEntity;
    PaymentStatus?: IPaymentStatusEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    Attachments?: IPaymentDocumentAttachmentEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Items?: IPaymentDocumentItemEntity[];
    Labels?: IPaymentDocumentLabelEntity[];
    Locks?: IPaymentDocumentLockEntity[];
    Chats?: IChatEntity[];
    BankTransactionTypeCode?: BankTransactionTypeCode;
    DateBankTransaction?: Date;
    Order?: number;
    RemittanceInformation?: string;
    PaymentInformation?: string;
    SymbolVariable?: string;
    SymbolSpecific?: string;
    SymbolConstant?: string;
    BankTransactionType?: IBankTransactionTypeEntity;
    BankAccountDescription?: string;
    BankInternalId?: string;
    DoesWaitForDuplicateCheck?: boolean;
    IsDuplicate?: boolean;
    PaymentType?: string;
    BankAccount?: IBankTransactionBankAccountEntity;
    BankStatement?: IBankStatementEntity;
    BusinessPartner?: IBankTransactionBusinessPartnerEntity;
}

export enum BankTransactionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsUnrelatedToBusiness = "IsUnrelatedToBusiness",
    Note = "Note",
    NumberOurs = "NumberOurs",
    PaymentStatusCode = "PaymentStatusCode",
    PostedStatusCode = "PostedStatusCode",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    NumberRange = "NumberRange",
    PaymentDocumentDraft = "PaymentDocumentDraft",
    PaymentStatus = "PaymentStatus",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    Attachments = "Attachments",
    DocumentLinks = "DocumentLinks",
    Items = "Items",
    Labels = "Labels",
    Locks = "Locks",
    Chats = "Chats",
    BankTransactionTypeCode = "BankTransactionTypeCode",
    DateBankTransaction = "DateBankTransaction",
    Order = "Order",
    RemittanceInformation = "RemittanceInformation",
    PaymentInformation = "PaymentInformation",
    SymbolVariable = "SymbolVariable",
    SymbolSpecific = "SymbolSpecific",
    SymbolConstant = "SymbolConstant",
    BankTransactionType = "BankTransactionType",
    BankAccountDescription = "BankAccountDescription",
    BankInternalId = "BankInternalId",
    DoesWaitForDuplicateCheck = "DoesWaitForDuplicateCheck",
    IsDuplicate = "IsDuplicate",
    PaymentType = "PaymentType",
    BankAccount = "BankAccount",
    BankStatement = "BankStatement",
    BusinessPartner = "BusinessPartner",
}

export interface IBankTransactionBankAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
    Country?: ICountryEntity;
}

export enum BankTransactionBankAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    Country = "Country",
}

export interface IBankTransactionBankAccountDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
    Country?: ICountryEntity;
}

export enum BankTransactionBankAccountDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    Country = "Country",
}

export interface IBankTransactionBusinessPartnerEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    LegalNumber?: string;
    Name?: string;
    PayerReliabilityStatusCode?: PayerReliabilityStatusCode;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    BusinessPartner?: IBusinessPartnerEntity;
    Country?: ICountryEntity;
    PayerReliabilityStatus?: IPayerReliabilityStatusEntity;
    VatStatus?: IVatStatusEntity;
}

export enum BankTransactionBusinessPartnerEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PayerReliabilityStatusCode = "PayerReliabilityStatusCode",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    BusinessPartner = "BusinessPartner",
    Country = "Country",
    PayerReliabilityStatus = "PayerReliabilityStatus",
    VatStatus = "VatStatus",
}

export interface IBankTransactionBusinessPartnerDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    LegalNumber?: string;
    Name?: string;
    PayerReliabilityStatusCode?: PayerReliabilityStatusCode;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    BusinessPartner?: IBusinessPartnerEntity;
    Country?: ICountryEntity;
    PayerReliabilityStatus?: IPayerReliabilityStatusEntity;
    VatStatus?: IVatStatusEntity;
}

export enum BankTransactionBusinessPartnerDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PayerReliabilityStatusCode = "PayerReliabilityStatusCode",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    BusinessPartner = "BusinessPartner",
    Country = "Country",
    PayerReliabilityStatus = "PayerReliabilityStatus",
    VatStatus = "VatStatus",
}

export interface IBankTransactionCsvColumnMappingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ColumnId?: number;
    PropertyName?: string;
}

export enum BankTransactionCsvColumnMappingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ColumnId = "ColumnId",
    PropertyName = "PropertyName",
}

export interface IBankTransactionDocumentNumberLocationEntity extends IEntityBase {
    Code?: BankTransactionDocumentNumberLocationCode;
    Name?: string;
}

export enum BankTransactionDocumentNumberLocationEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBankTransactionDuplicateEntity extends IEntityBase {
    NotId?: number;
    CompanyBankAccount?: ICompanyBankAccountEntity;
    SourceBankStatement?: IBankStatementEntity;
    SourceBankTransaction?: IBankTransactionEntity;
    TargetBankStatement?: IBankStatementEntity;
    TargetBankTransaction?: IBankTransactionEntity;
}

export enum BankTransactionDuplicateEntity {
    NotId = "NotId",
    CompanyBankAccount = "CompanyBankAccount",
    SourceBankStatement = "SourceBankStatement",
    SourceBankTransaction = "SourceBankTransaction",
    TargetBankStatement = "TargetBankStatement",
    TargetBankTransaction = "TargetBankTransaction",
}

export interface IBankTransactionTypeEntity extends IEntityBase {
    Code?: BankTransactionTypeCode;
    Name?: string;
}

export enum BankTransactionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBillingEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BillingEventType?: null;
    BillingEventSubType?: null;
    BillingEventDetail?: null;
    Amount?: number;
    CompanyId?: number;
    AccountingCode?: string;
    UserId?: number;
    ModuleCode?: string;
}

export enum BillingEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BillingEventType = "BillingEventType",
    BillingEventSubType = "BillingEventSubType",
    BillingEventDetail = "BillingEventDetail",
    Amount = "Amount",
    CompanyId = "CompanyId",
    AccountingCode = "AccountingCode",
    UserId = "UserId",
    ModuleCode = "ModuleCode",
}

export interface IBillingItemTypeEntity extends IEntityBase {
    Code?: BillingItemTypeCode;
    Name?: string;
}

export enum BillingItemTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBillingModuleTypeEntity extends IEntityBase {
    Code?: BillingModuleTypeCode;
    Name?: string;
    S5articleGuid?: string;
}

export enum BillingModuleTypeEntity {
    Code = "Code",
    Name = "Name",
    S5articleGuid = "S5articleGuid",
}

export interface IBillingPricingEntity extends IEntityBase {
    Code?: BillingPricingCode;
    AccountingCode?: AccountingCode;
    BillingModuleTypeCode?: BillingModuleTypeCode;
    CountryCode?: CountryCode;
    CurrencyCode?: CurrencyCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Price?: number;
    ProductCode?: ProductCode;
    Accounting?: IAccountingEntity;
    BillingModuleType?: IBillingModuleTypeEntity;
    Country?: ICountryEntity;
    Currency?: ICurrencyEntity;
    Product?: IProductEntity;
}

export enum BillingPricingEntity {
    Code = "Code",
    AccountingCode = "AccountingCode",
    BillingModuleTypeCode = "BillingModuleTypeCode",
    CountryCode = "CountryCode",
    CurrencyCode = "CurrencyCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Price = "Price",
    ProductCode = "ProductCode",
    Accounting = "Accounting",
    BillingModuleType = "BillingModuleType",
    Country = "Country",
    Currency = "Currency",
    Product = "Product",
}

export interface IBookkeepingEntity extends IEntityBase {
    Code?: BookkeepingCode;
    Name?: string;
}

export enum BookkeepingEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBusinessAccountBaseEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    Country?: ICountryEntity;
    BalanceSheetAccountName?: string;
    BalanceSheetAccountNumberPrefix?: string;
    BalanceSheetAccountNumberSuffix?: string;
    CompanyBankAccountTypeCode?: CompanyBankAccountTypeCode;
    CurrencyCode?: CurrencyCode;
    HasAutoPosting?: boolean;
    InitialBalance?: number;
    InitialTransactionBalance?: number;
    IsActive?: boolean;
    IsDefault?: boolean;
    IsOss?: boolean;
    Name?: string;
    TransactionCurrencyCode?: CurrencyCode;
    Balance?: IBankAccountBalanceEntity;
    BankApiConnectionSetting?: IBankApiConnectionSettingEntity;
    BankApiStatementImportSetting?: IBankApiStatementImportSettingEntity;
    BankStatementCsvSettingsText?: IBankStatementCsvSettingsTextEntity;
    BankStatementNumberRangeDefinition?: INumberRangeDefinitionEntity;
    Company?: ICompanyEntity;
    CompanyBankAccountType?: ICompanyBankAccountTypeEntity;
    Currency?: ICurrencyEntity;
    Logo?: IFileMetadataEntity;
    TransactionCurrency?: ICurrencyEntity;
    BankTransactionCsvColumnMappings?: IBankTransactionCsvColumnMappingEntity[];
}

export enum BusinessAccountBaseEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    Country = "Country",
    BalanceSheetAccountName = "BalanceSheetAccountName",
    BalanceSheetAccountNumberPrefix = "BalanceSheetAccountNumberPrefix",
    BalanceSheetAccountNumberSuffix = "BalanceSheetAccountNumberSuffix",
    CompanyBankAccountTypeCode = "CompanyBankAccountTypeCode",
    CurrencyCode = "CurrencyCode",
    HasAutoPosting = "HasAutoPosting",
    InitialBalance = "InitialBalance",
    InitialTransactionBalance = "InitialTransactionBalance",
    IsActive = "IsActive",
    IsDefault = "IsDefault",
    IsOss = "IsOss",
    Name = "Name",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    Balance = "Balance",
    BankApiConnectionSetting = "BankApiConnectionSetting",
    BankApiStatementImportSetting = "BankApiStatementImportSetting",
    BankStatementCsvSettingsText = "BankStatementCsvSettingsText",
    BankStatementNumberRangeDefinition = "BankStatementNumberRangeDefinition",
    Company = "Company",
    CompanyBankAccountType = "CompanyBankAccountType",
    Currency = "Currency",
    Logo = "Logo",
    TransactionCurrency = "TransactionCurrency",
    BankTransactionCsvColumnMappings = "BankTransactionCsvColumnMappings",
}

export interface IBusinessPartnerEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CountryCode?: CountryCode;
    DataBoxId?: string;
    IsLegalPerson?: boolean;
    IsSynchronizedWithAres?: boolean;
    LegalNumber?: string;
    Name?: string;
    Note?: string;
    PayerReliabilityStatusCode?: PayerReliabilityStatusCode;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    BillingAddress?: IBusinessPartnerBillingAddressEntity;
    Company?: ICompanyEntity;
    CorrespondenceAddress?: IBusinessPartnerCorrespondenceAddressEntity;
    Country?: ICountryEntity;
    IssuedDocumentDefault?: IBusinessPartnerIssuedDocumentDefaultEntity;
    PayerReliabilityStatus?: IPayerReliabilityStatusEntity;
    ReceivedDocumentDefault?: IBusinessPartnerReceivedDocumentDefaultEntity;
    VatStatus?: IVatStatusEntity;
    Attachments?: IBusinessPartnerAttachmentEntity[];
    BankAccounts?: IBusinessPartnerBankAccountEntity[];
    Contacts?: IBusinessPartnerContactEntity[];
}

export enum BusinessPartnerEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CountryCode = "CountryCode",
    DataBoxId = "DataBoxId",
    IsLegalPerson = "IsLegalPerson",
    IsSynchronizedWithAres = "IsSynchronizedWithAres",
    LegalNumber = "LegalNumber",
    Name = "Name",
    Note = "Note",
    PayerReliabilityStatusCode = "PayerReliabilityStatusCode",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    BillingAddress = "BillingAddress",
    Company = "Company",
    CorrespondenceAddress = "CorrespondenceAddress",
    Country = "Country",
    IssuedDocumentDefault = "IssuedDocumentDefault",
    PayerReliabilityStatus = "PayerReliabilityStatus",
    ReceivedDocumentDefault = "ReceivedDocumentDefault",
    VatStatus = "VatStatus",
    Attachments = "Attachments",
    BankAccounts = "BankAccounts",
    Contacts = "Contacts",
}

export interface IBusinessPartnerAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum BusinessPartnerAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IBusinessPartnerBankAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    Country?: ICountryEntity;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    Description?: string;
    IsDefaultForReceivedDocuments?: boolean;
    Order?: number;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
}

export enum BusinessPartnerBankAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    Country = "Country",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    Description = "Description",
    IsDefaultForReceivedDocuments = "IsDefaultForReceivedDocuments",
    Order = "Order",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
}

export interface IBusinessPartnerBankAccountViewEntity extends IEntityBase {
    Id?: number;
    AbaNumber?: string;
    AccountNumber?: string;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    Description?: string;
    IBAN?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BusinessPartner?: IBusinessPartnerEntity;
    Country?: ICountryEntity;
}

export enum BusinessPartnerBankAccountViewEntity {
    Id = "Id",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    Description = "Description",
    IBAN = "IBAN",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BusinessPartner = "BusinessPartner",
    Country = "Country",
}

export interface IBusinessPartnerBillingAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
}

export enum BusinessPartnerBillingAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
}

export interface IBusinessPartnerContactEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    PhoneNumber?: string;
    Description?: string;
    Order?: number;
    Role?: string;
}

export enum BusinessPartnerContactEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    PhoneNumber = "PhoneNumber",
    Description = "Description",
    Order = "Order",
    Role = "Role",
}

export interface IBusinessPartnerCorrespondenceAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
}

export enum BusinessPartnerCorrespondenceAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
}

export interface IBusinessPartnerDocumentDefaultEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DefaultPaymentMethodCode?: PaymentMethodCode;
    Note?: string;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    DaysDue?: number;
    AccountAssignment?: IAccountAssignmentEntity;
    DefaultPaymentMethod?: IPaymentMethodEntity;
    VatClassification?: IVatClassificationEntity;
}

export enum BusinessPartnerDocumentDefaultEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DefaultPaymentMethodCode = "DefaultPaymentMethodCode",
    Note = "Note",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    DaysDue = "DaysDue",
    AccountAssignment = "AccountAssignment",
    DefaultPaymentMethod = "DefaultPaymentMethod",
    VatClassification = "VatClassification",
}

export interface IBusinessPartnerDocumentDefaultTypeEntity extends IEntityBase {
    Code?: BusinessPartnerDocumentDefaultTypeCode;
    Name?: string;
}

export enum BusinessPartnerDocumentDefaultTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IBusinessPartnerIssuedDocumentDefaultEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DefaultPaymentMethodCode?: PaymentMethodCode;
    Note?: string;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    DaysDue?: number;
    AccountAssignment?: IAccountAssignmentEntity;
    DefaultPaymentMethod?: IPaymentMethodEntity;
    VatClassification?: IVatClassificationEntity;
    CompanyBankAccount?: ICompanyBankAccountEntity;
}

export enum BusinessPartnerIssuedDocumentDefaultEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DefaultPaymentMethodCode = "DefaultPaymentMethodCode",
    Note = "Note",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    DaysDue = "DaysDue",
    AccountAssignment = "AccountAssignment",
    DefaultPaymentMethod = "DefaultPaymentMethod",
    VatClassification = "VatClassification",
    CompanyBankAccount = "CompanyBankAccount",
}

export interface IBusinessPartnerReceivedDocumentDefaultEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DefaultPaymentMethodCode?: PaymentMethodCode;
    Note?: string;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    DaysDue?: number;
    AccountAssignment?: IAccountAssignmentEntity;
    DefaultPaymentMethod?: IPaymentMethodEntity;
    VatClassification?: IVatClassificationEntity;
}

export enum BusinessPartnerReceivedDocumentDefaultEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DefaultPaymentMethodCode = "DefaultPaymentMethodCode",
    Note = "Note",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    DaysDue = "DaysDue",
    AccountAssignment = "AccountAssignment",
    DefaultPaymentMethod = "DefaultPaymentMethod",
    VatClassification = "VatClassification",
}

export interface ICBATransactionTypeEntity extends IEntityBase {
    Code?: string;
    Name?: string;
}

export enum CBATransactionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICSSZBankTypeEntity extends IEntityBase {
    Code?: CSSZBankTypeCode;
    Name?: string;
}

export enum CSSZBankTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICSSZSubmissionTypeEntity extends IEntityBase {
    Code?: CSSZSubmissionTypeCode;
    CSSZMessageType?: string;
    GovTalkMessageClass?: string;
    Name?: string;
}

export enum CSSZSubmissionTypeEntity {
    Code = "Code",
    CSSZMessageType = "CSSZMessageType",
    GovTalkMessageClass = "GovTalkMessageClass",
    Name = "Name",
}

export interface ICSSZTransactionStatusEntity extends IEntityBase {
    Code?: CSSZTransactionStatusCode;
    Name?: string;
}

export enum CSSZTransactionStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICashBoxEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BalanceSheetAccountName?: string;
    BalanceSheetAccountNumberPrefix?: string;
    BalanceSheetAccountNumberSuffix?: string;
    CashierName?: string;
    CurrencyCode?: CurrencyCode;
    HasMaterialLiability?: boolean;
    InitialBalance?: number;
    InitialTransactionBalance?: number;
    IsActive?: boolean;
    IsDefault?: boolean;
    Name?: string;
    Note?: string;
    TransactionCurrencyCode?: CurrencyCode;
    Balance?: ICashBoxBalanceEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    ReceiptIssuedNumberRangeDefinition?: INumberRangeDefinitionEntity;
    ReceiptReceivedNumberRangeDefinition?: INumberRangeDefinitionEntity;
    TransactionCurrency?: ICurrencyEntity;
}

export enum CashBoxEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BalanceSheetAccountName = "BalanceSheetAccountName",
    BalanceSheetAccountNumberPrefix = "BalanceSheetAccountNumberPrefix",
    BalanceSheetAccountNumberSuffix = "BalanceSheetAccountNumberSuffix",
    CashierName = "CashierName",
    CurrencyCode = "CurrencyCode",
    HasMaterialLiability = "HasMaterialLiability",
    InitialBalance = "InitialBalance",
    InitialTransactionBalance = "InitialTransactionBalance",
    IsActive = "IsActive",
    IsDefault = "IsDefault",
    Name = "Name",
    Note = "Note",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    Balance = "Balance",
    Company = "Company",
    Currency = "Currency",
    ReceiptIssuedNumberRangeDefinition = "ReceiptIssuedNumberRangeDefinition",
    ReceiptReceivedNumberRangeDefinition = "ReceiptReceivedNumberRangeDefinition",
    TransactionCurrency = "TransactionCurrency",
}

export interface ICashBoxBalanceEntity extends IEntityBase {
    Id?: number;
    TransactionBalance?: number;
    TransactionCurrencyCode?: CurrencyCode;
    DateBalanceChanged?: Date;
    TransactionCurrency?: ICurrencyEntity;
}

export enum CashBoxBalanceEntity {
    Id = "Id",
    TransactionBalance = "TransactionBalance",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    DateBalanceChanged = "DateBalanceChanged",
    TransactionCurrency = "TransactionCurrency",
}

export interface ICashReceiptEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsUnrelatedToBusiness?: boolean;
    Note?: string;
    NumberOurs?: string;
    PaymentStatusCode?: PaymentStatusCode;
    PostedStatusCode?: PostedStatusCode;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionCurrencyCode?: CurrencyCode;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    NumberRange?: INumberRangeEntity;
    PaymentDocumentDraft?: IPaymentDocumentDraftEntity;
    PaymentStatus?: IPaymentStatusEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    Attachments?: IPaymentDocumentAttachmentEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Items?: IPaymentDocumentItemEntity[];
    Labels?: IPaymentDocumentLabelEntity[];
    Locks?: IPaymentDocumentLockEntity[];
    Chats?: IChatEntity[];
    DateIssued?: Date;
    Purpose?: string;
    CashBox?: ICashBoxEntity;
}

export enum CashReceiptEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsUnrelatedToBusiness = "IsUnrelatedToBusiness",
    Note = "Note",
    NumberOurs = "NumberOurs",
    PaymentStatusCode = "PaymentStatusCode",
    PostedStatusCode = "PostedStatusCode",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    NumberRange = "NumberRange",
    PaymentDocumentDraft = "PaymentDocumentDraft",
    PaymentStatus = "PaymentStatus",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    Attachments = "Attachments",
    DocumentLinks = "DocumentLinks",
    Items = "Items",
    Labels = "Labels",
    Locks = "Locks",
    Chats = "Chats",
    DateIssued = "DateIssued",
    Purpose = "Purpose",
    CashBox = "CashBox",
}

export interface ICashReceiptIssuedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsUnrelatedToBusiness?: boolean;
    Note?: string;
    NumberOurs?: string;
    PaymentStatusCode?: PaymentStatusCode;
    PostedStatusCode?: PostedStatusCode;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionCurrencyCode?: CurrencyCode;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    NumberRange?: INumberRangeEntity;
    PaymentDocumentDraft?: IPaymentDocumentDraftEntity;
    PaymentStatus?: IPaymentStatusEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    Attachments?: IPaymentDocumentAttachmentEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Items?: IPaymentDocumentItemEntity[];
    Labels?: IPaymentDocumentLabelEntity[];
    Locks?: IPaymentDocumentLockEntity[];
    Chats?: IChatEntity[];
    DateIssued?: Date;
    Purpose?: string;
    CashBox?: ICashBoxEntity;
    PaidBy?: string;
    PaidTo?: string;
}

export enum CashReceiptIssuedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsUnrelatedToBusiness = "IsUnrelatedToBusiness",
    Note = "Note",
    NumberOurs = "NumberOurs",
    PaymentStatusCode = "PaymentStatusCode",
    PostedStatusCode = "PostedStatusCode",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    NumberRange = "NumberRange",
    PaymentDocumentDraft = "PaymentDocumentDraft",
    PaymentStatus = "PaymentStatus",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    Attachments = "Attachments",
    DocumentLinks = "DocumentLinks",
    Items = "Items",
    Labels = "Labels",
    Locks = "Locks",
    Chats = "Chats",
    DateIssued = "DateIssued",
    Purpose = "Purpose",
    CashBox = "CashBox",
    PaidBy = "PaidBy",
    PaidTo = "PaidTo",
}

export interface ICashReceiptReceivedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsUnrelatedToBusiness?: boolean;
    Note?: string;
    NumberOurs?: string;
    PaymentStatusCode?: PaymentStatusCode;
    PostedStatusCode?: PostedStatusCode;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionCurrencyCode?: CurrencyCode;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    NumberRange?: INumberRangeEntity;
    PaymentDocumentDraft?: IPaymentDocumentDraftEntity;
    PaymentStatus?: IPaymentStatusEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    Attachments?: IPaymentDocumentAttachmentEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Items?: IPaymentDocumentItemEntity[];
    Labels?: IPaymentDocumentLabelEntity[];
    Locks?: IPaymentDocumentLockEntity[];
    Chats?: IChatEntity[];
    DateIssued?: Date;
    Purpose?: string;
    CashBox?: ICashBoxEntity;
    ReceivedBy?: string;
    ReceivedFrom?: string;
}

export enum CashReceiptReceivedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsUnrelatedToBusiness = "IsUnrelatedToBusiness",
    Note = "Note",
    NumberOurs = "NumberOurs",
    PaymentStatusCode = "PaymentStatusCode",
    PostedStatusCode = "PostedStatusCode",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    NumberRange = "NumberRange",
    PaymentDocumentDraft = "PaymentDocumentDraft",
    PaymentStatus = "PaymentStatus",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    Attachments = "Attachments",
    DocumentLinks = "DocumentLinks",
    Items = "Items",
    Labels = "Labels",
    Locks = "Locks",
    Chats = "Chats",
    DateIssued = "DateIssued",
    Purpose = "Purpose",
    CashBox = "CashBox",
    ReceivedBy = "ReceivedBy",
    ReceivedFrom = "ReceivedFrom",
}

export interface ICbaAssetDisposalTypeEntity extends IEntityBase {
    Code?: CbaAssetDisposalTypeCode;
    IsTaxByDefault?: boolean;
    Name?: string;
}

export enum CbaAssetDisposalTypeEntity {
    Code = "Code",
    IsTaxByDefault = "IsTaxByDefault",
    Name = "Name",
}

export interface ICbaCategoryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    IsAssetAcquisition?: boolean;
    Name?: string;
    TaxImpactCode?: CbaCategoryTaxImpactCode;
    TaxPercentage?: number;
    Company?: ICompanyEntity;
    TaxImpact?: ICbaCategoryTaxImpactEntity;
}

export enum CbaCategoryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    IsAssetAcquisition = "IsAssetAcquisition",
    Name = "Name",
    TaxImpactCode = "TaxImpactCode",
    TaxPercentage = "TaxPercentage",
    Company = "Company",
    TaxImpact = "TaxImpact",
}

export interface ICbaCategoryTaxImpactEntity extends IEntityBase {
    Code?: CbaCategoryTaxImpactCode;
    Name?: string;
}

export enum CbaCategoryTaxImpactEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICbaEntryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AmountCleared?: number;
    AmountNonTaxed?: number;
    AmountTaxed?: number;
    AmountVat?: number;
    CbaCategoryTaxImpactCode?: string;
    CurrencyCode?: CurrencyCode;
    DailyRateAmountCleared?: number;
    DailyRateAmountNonTaxed?: number;
    DailyRateAmountTaxed?: number;
    DailyRateAmountVat?: number;
    Date?: Date;
    Description?: string;
    IsAssetAcquisition?: boolean;
    IsReverseProforma?: boolean;
    IsUnrelatedToBusiness?: boolean;
    SpecialVatCalculationCode?: CbaEntrySpecialVatCalculationCode;
    TaxPercentage?: number;
    TransactionAmountCleared?: number;
    TransactionAmountNonTaxed?: number;
    TransactionAmountTaxed?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    TypeCode?: CbaEntryTypeCode;
    VatCode?: VatCode;
    VatPercentage?: number;
    AssetDocumentItem?: IDocumentItemEntity;
    Category?: ICbaCategoryEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DocumentLink?: IDocumentLinkEntity;
    InternalDocument?: IInternalDocumentEntity;
    PairedDocument?: IDocumentEntity;
    PaymentDocument?: IPaymentDocumentEntity;
    PaymentDocumentItem?: IPaymentDocumentItemEntity;
    ProformaDocument?: IDocumentEntity;
    SpecialVatCalculation?: ICbaEntrySpecialVatCalculationEntity;
    TransactionCurrency?: ICurrencyEntity;
    Type?: ICbaEntryTypeEntity;
    Vat?: IVatEntity;
    Labels?: ICbaEntryLabelEntity[];
}

export enum CbaEntryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AmountCleared = "AmountCleared",
    AmountNonTaxed = "AmountNonTaxed",
    AmountTaxed = "AmountTaxed",
    AmountVat = "AmountVat",
    CbaCategoryTaxImpactCode = "CbaCategoryTaxImpactCode",
    CurrencyCode = "CurrencyCode",
    DailyRateAmountCleared = "DailyRateAmountCleared",
    DailyRateAmountNonTaxed = "DailyRateAmountNonTaxed",
    DailyRateAmountTaxed = "DailyRateAmountTaxed",
    DailyRateAmountVat = "DailyRateAmountVat",
    Date = "Date",
    Description = "Description",
    IsAssetAcquisition = "IsAssetAcquisition",
    IsReverseProforma = "IsReverseProforma",
    IsUnrelatedToBusiness = "IsUnrelatedToBusiness",
    SpecialVatCalculationCode = "SpecialVatCalculationCode",
    TaxPercentage = "TaxPercentage",
    TransactionAmountCleared = "TransactionAmountCleared",
    TransactionAmountNonTaxed = "TransactionAmountNonTaxed",
    TransactionAmountTaxed = "TransactionAmountTaxed",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    TypeCode = "TypeCode",
    VatCode = "VatCode",
    VatPercentage = "VatPercentage",
    AssetDocumentItem = "AssetDocumentItem",
    Category = "Category",
    Company = "Company",
    Currency = "Currency",
    DocumentLink = "DocumentLink",
    InternalDocument = "InternalDocument",
    PairedDocument = "PairedDocument",
    PaymentDocument = "PaymentDocument",
    PaymentDocumentItem = "PaymentDocumentItem",
    ProformaDocument = "ProformaDocument",
    SpecialVatCalculation = "SpecialVatCalculation",
    TransactionCurrency = "TransactionCurrency",
    Type = "Type",
    Vat = "Vat",
    Labels = "Labels",
}

export interface ICbaEntryLabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum CbaEntryLabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface ICbaEntryLedgerDocumentTypeEntity extends IEntityBase {
    Code?: CbaEntryLedgerDocumentTypeCode;
    Name?: string;
}

export enum CbaEntryLedgerDocumentTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICbaEntrySpecialVatCalculationEntity extends IEntityBase {
    Code?: CbaEntrySpecialVatCalculationCode;
    Name?: string;
}

export enum CbaEntrySpecialVatCalculationEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICbaEntryTypeEntity extends IEntityBase {
    Code?: CbaEntryTypeCode;
    Name?: string;
}

export enum CbaEntryTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IChartOfAccountsEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    Name?: string;
    Note?: string;
    Company?: ICompanyEntity;
    FiscalYear?: IFiscalYearEntity;
    Accounts?: IAccountEntity[];
}

export enum ChartOfAccountsEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    Name = "Name",
    Note = "Note",
    Company = "Company",
    FiscalYear = "FiscalYear",
    Accounts = "Accounts",
}

export interface IChartOfAccountsTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountingCode?: AccountingCode;
    Description?: string;
    Name?: string;
    Accounting?: IAccountingEntity;
    Company?: ICompanyEntity;
    Accounts?: IAccountTemplateEntity[];
    RequiredAccountTemplates?: IRequiredAccountTemplateEntity[];
}

export enum ChartOfAccountsTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountingCode = "AccountingCode",
    Description = "Description",
    Name = "Name",
    Accounting = "Accounting",
    Company = "Company",
    Accounts = "Accounts",
    RequiredAccountTemplates = "RequiredAccountTemplates",
}

export interface IChartedAccountAssignmentEntity extends IEntityBase {
    NotId?: number;
    DocumentTypeCode?: DocumentTypeCode;
    IsActive?: boolean;
    IsDebitAccountVatDeductionForced?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
    DocumentType?: IDocumentTypeEntity;
}

export enum ChartedAccountAssignmentEntity {
    NotId = "NotId",
    DocumentTypeCode = "DocumentTypeCode",
    IsActive = "IsActive",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
    DocumentType = "DocumentType",
}

export interface IChatEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    InboxFileEntityType?: string;
    IsLinkedEntityDraft?: boolean;
    IsTaxDocument?: boolean;
    LinkedEntityDescriptor?: string;
    LinkedEntityType?: string;
    Title?: string;
    LinkedEntityId?: number;
    DateLastMessage?: Date;
    Document?: IDocumentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    InboxFile?: IInboxFileEntity;
    PaymentDocument?: IPaymentDocumentEntity;
    PaymentDocumentDraft?: IPaymentDocumentDraftEntity;
    Recipient?: IChatParticipantRecipientEntity;
    Sender?: IChatParticipantSenderEntity;
    Statement?: IStatementEntity;
    Messages?: IChatMessageEntity[];
}

export enum ChatEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    InboxFileEntityType = "InboxFileEntityType",
    IsLinkedEntityDraft = "IsLinkedEntityDraft",
    IsTaxDocument = "IsTaxDocument",
    LinkedEntityDescriptor = "LinkedEntityDescriptor",
    LinkedEntityType = "LinkedEntityType",
    Title = "Title",
    LinkedEntityId = "LinkedEntityId",
    DateLastMessage = "DateLastMessage",
    Document = "Document",
    DocumentDraft = "DocumentDraft",
    InboxFile = "InboxFile",
    PaymentDocument = "PaymentDocument",
    PaymentDocumentDraft = "PaymentDocumentDraft",
    Recipient = "Recipient",
    Sender = "Sender",
    Statement = "Statement",
    Messages = "Messages",
}

export interface IChatMessageEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Content?: string;
    Attachments?: IChatMessageAttachmentEntity[];
}

export enum ChatMessageEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Content = "Content",
    Attachments = "Attachments",
}

export interface IChatMessageAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum ChatMessageAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IChatParticipantEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsFlagged?: boolean;
    DateLastRead?: Date;
    User?: IUserEntity;
}

export enum ChatParticipantEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsFlagged = "IsFlagged",
    DateLastRead = "DateLastRead",
    User = "User",
}

export interface IChatParticipantRecipientEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsFlagged?: boolean;
    DateLastRead?: Date;
    User?: IUserEntity;
}

export enum ChatParticipantRecipientEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsFlagged = "IsFlagged",
    DateLastRead = "DateLastRead",
    User = "User",
}

export interface IChatParticipantSenderEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsFlagged?: boolean;
    DateLastRead?: Date;
    User?: IUserEntity;
}

export enum ChatParticipantSenderEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsFlagged = "IsFlagged",
    DateLastRead = "DateLastRead",
    User = "User",
}

export interface IChatParticipantTypeEntity extends IEntityBase {
    Code?: ChatParticipantTypeCode;
    Name?: string;
}

export enum ChatParticipantTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IClearedStatusEntity extends IEntityBase {
    Code?: ClearedStatusCode;
    Name?: string;
}

export enum ClearedStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IClearingDocumentLinkEntity extends IEntityBase {
    Id?: number;
    CurrencyCode?: CurrencyCode;
    DateClearing?: Date;
    PairedDocumentIsTaxDocument?: boolean;
    TransactionAmount?: number;
    TransactionCurrencyCode?: CurrencyCode;
    TypeCode?: DocumentLinkTypeCode;
    Amount?: number;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    PairedDocument?: IDocumentEntity;
    PairedPaymentDocument?: IPaymentDocumentEntity;
    TransactionCurrency?: ICurrencyEntity;
    Type?: IDocumentLinkTypeEntity;
}

export enum ClearingDocumentLinkEntity {
    Id = "Id",
    CurrencyCode = "CurrencyCode",
    DateClearing = "DateClearing",
    PairedDocumentIsTaxDocument = "PairedDocumentIsTaxDocument",
    TransactionAmount = "TransactionAmount",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    TypeCode = "TypeCode",
    Amount = "Amount",
    Currency = "Currency",
    Document = "Document",
    PairedDocument = "PairedDocument",
    PairedPaymentDocument = "PairedPaymentDocument",
    TransactionCurrency = "TransactionCurrency",
    Type = "Type",
}

export interface ICollectiveAgreementTypeEntity extends IEntityBase {
    Code?: CollectiveAgreementTypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum CollectiveAgreementTypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IColourThemeEntity extends IEntityBase {
    Code?: ColourThemeCode;
    Name?: string;
}

export enum ColourThemeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICommunicationEntryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ApiResponseMessage?: string;
    ChannelCode?: CommunicationEntryChannelCode;
    EmailRecipientCount?: number;
    MessageId?: string;
    PaymentOrderAmount?: string;
    PaymentOrderCurrency?: string;
    Recipient?: string;
    RecipientAddress?: string;
    RecipientBankAccountCurrency?: string;
    RecipientBankAccountName?: string;
    RecipientBankAccountNumber?: string;
    RecipientBankName?: string;
    RecipientDataboxId?: string;
    RecipientEmail?: string;
    RecipientLegalNumber?: string;
    Sender?: string;
    SenderAddress?: string;
    SenderDataboxId?: string;
    SenderEmail?: string;
    SenderLegalNumber?: string;
    StateCode?: CommunicationEntryStateCode;
    Subject?: string;
    Text?: string;
    TimeSent?: string;
    TypeCode?: CommunicationEntryTypeCode;
    DateSent?: Date;
    DateStateChange?: Date;
    Channel?: ICommunicationEntryChannelEntity;
    Company?: ICompanyEntity;
    State?: ICommunicationEntryStateEntity;
    Type?: ICommunicationEntryTypeEntity;
    User?: IUserEntity;
    Attachments?: ICommunicationEntryAttachmentEntity[];
}

export enum CommunicationEntryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ApiResponseMessage = "ApiResponseMessage",
    ChannelCode = "ChannelCode",
    EmailRecipientCount = "EmailRecipientCount",
    MessageId = "MessageId",
    PaymentOrderAmount = "PaymentOrderAmount",
    PaymentOrderCurrency = "PaymentOrderCurrency",
    Recipient = "Recipient",
    RecipientAddress = "RecipientAddress",
    RecipientBankAccountCurrency = "RecipientBankAccountCurrency",
    RecipientBankAccountName = "RecipientBankAccountName",
    RecipientBankAccountNumber = "RecipientBankAccountNumber",
    RecipientBankName = "RecipientBankName",
    RecipientDataboxId = "RecipientDataboxId",
    RecipientEmail = "RecipientEmail",
    RecipientLegalNumber = "RecipientLegalNumber",
    Sender = "Sender",
    SenderAddress = "SenderAddress",
    SenderDataboxId = "SenderDataboxId",
    SenderEmail = "SenderEmail",
    SenderLegalNumber = "SenderLegalNumber",
    StateCode = "StateCode",
    Subject = "Subject",
    Text = "Text",
    TimeSent = "TimeSent",
    TypeCode = "TypeCode",
    DateSent = "DateSent",
    DateStateChange = "DateStateChange",
    Channel = "Channel",
    Company = "Company",
    State = "State",
    Type = "Type",
    User = "User",
    Attachments = "Attachments",
}

export interface ICommunicationEntryAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum CommunicationEntryAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface ICommunicationEntryChannelEntity extends IEntityBase {
    Code?: CommunicationEntryChannelCode;
    Name?: string;
}

export enum CommunicationEntryChannelEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICommunicationEntryStateEntity extends IEntityBase {
    Code?: CommunicationEntryStateCode;
    Name?: string;
}

export enum CommunicationEntryStateEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICommunicationEntryTypeEntity extends IEntityBase {
    Code?: CommunicationEntryTypeCode;
    Name?: string;
}

export enum CommunicationEntryTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountingCode?: AccountingCode;
    BirthNumber?: string;
    CompanyRegister?: string;
    CsszIdentificationNumber?: string;
    CurrencyCode?: CurrencyCode;
    CzNaceCode?: string;
    DateInitialized?: Date;
    FinancialAdministrationCode?: GovernmentInstitutionCode;
    InboxEmail?: string;
    IsGeneralPartnership?: boolean;
    LaborOfficeCode?: GovernmentInstitutionCode;
    LegalName?: string;
    LegalNumber?: string;
    Name?: string;
    OtherInstitutionsIdentificationNumber?: string;
    RegionForVzpCode?: CountryRegionCode;
    SocialSecurityCode?: GovernmentInstitutionCode;
    StateCode?: CompanyStateCode;
    StatutoryInsuranceCompanyCode?: GovernmentInstitutionCode;
    TaxNumber?: string;
    TypeOfBusinessCode?: TypeOfBusinessCode;
    UseVatReducedDeduction?: boolean;
    WebPage?: string;
    DefaultStatutoryInsuranceCompanyRate?: number;
    Accounting?: IAccountingEntity;
    CommunicationAddress?: ICompanyCommunicationAddressEntity;
    CommunicationContact?: ICompanyCommunicationContactEntity;
    CompanySetting?: ICompanySettingEntity;
    Currency?: ICurrencyEntity;
    CurrentTemporalPropertyBag?: ICompanyVatStatusTemporalCurrentEntity;
    CzNace?: ICzNaceEntity;
    FinancialAdministration?: IGovernmentInstitutionEntity;
    LaborOffice?: IGovernmentInstitutionEntity;
    LegalAddress?: ICompanyLegalAddressEntity;
    Logo?: IFileMetadataEntity;
    PrPayrollSetting?: IPrPayrollSettingEntity;
    RegionForVzp?: ICountryRegionEntity;
    SocialSecurity?: IGovernmentInstitutionEntity;
    Stamp?: IFileMetadataEntity;
    State?: ICompanyStateEntity;
    StatutoryInsuranceCompany?: IGovernmentInstitutionEntity;
    TaxStatementSignatoryPerson?: ITaxStatementSignatoryPersonEntity;
    TypeOfBusiness?: ITypeOfBusinessEntity;
    Modules?: ICompanyModuleEntity[];
    TemporalPropertyBag?: ICompanyVatStatusTemporalEntity[];
    VatReducedCoefficients?: ICompanyVatReducedCoefficientEntity[];
}

export enum CompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountingCode = "AccountingCode",
    BirthNumber = "BirthNumber",
    CompanyRegister = "CompanyRegister",
    CsszIdentificationNumber = "CsszIdentificationNumber",
    CurrencyCode = "CurrencyCode",
    CzNaceCode = "CzNaceCode",
    DateInitialized = "DateInitialized",
    FinancialAdministrationCode = "FinancialAdministrationCode",
    InboxEmail = "InboxEmail",
    IsGeneralPartnership = "IsGeneralPartnership",
    LaborOfficeCode = "LaborOfficeCode",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    OtherInstitutionsIdentificationNumber = "OtherInstitutionsIdentificationNumber",
    RegionForVzpCode = "RegionForVzpCode",
    SocialSecurityCode = "SocialSecurityCode",
    StateCode = "StateCode",
    StatutoryInsuranceCompanyCode = "StatutoryInsuranceCompanyCode",
    TaxNumber = "TaxNumber",
    TypeOfBusinessCode = "TypeOfBusinessCode",
    UseVatReducedDeduction = "UseVatReducedDeduction",
    WebPage = "WebPage",
    DefaultStatutoryInsuranceCompanyRate = "DefaultStatutoryInsuranceCompanyRate",
    Accounting = "Accounting",
    CommunicationAddress = "CommunicationAddress",
    CommunicationContact = "CommunicationContact",
    CompanySetting = "CompanySetting",
    Currency = "Currency",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    CzNace = "CzNace",
    FinancialAdministration = "FinancialAdministration",
    LaborOffice = "LaborOffice",
    LegalAddress = "LegalAddress",
    Logo = "Logo",
    PrPayrollSetting = "PrPayrollSetting",
    RegionForVzp = "RegionForVzp",
    SocialSecurity = "SocialSecurity",
    Stamp = "Stamp",
    State = "State",
    StatutoryInsuranceCompany = "StatutoryInsuranceCompany",
    TaxStatementSignatoryPerson = "TaxStatementSignatoryPerson",
    TypeOfBusiness = "TypeOfBusiness",
    Modules = "Modules",
    TemporalPropertyBag = "TemporalPropertyBag",
    VatReducedCoefficients = "VatReducedCoefficients",
}

export interface ICompanyBankAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    Country?: ICountryEntity;
    BalanceSheetAccountName?: string;
    BalanceSheetAccountNumberPrefix?: string;
    BalanceSheetAccountNumberSuffix?: string;
    CompanyBankAccountTypeCode?: CompanyBankAccountTypeCode;
    CurrencyCode?: CurrencyCode;
    HasAutoPosting?: boolean;
    InitialBalance?: number;
    InitialTransactionBalance?: number;
    IsActive?: boolean;
    IsDefault?: boolean;
    IsOss?: boolean;
    Name?: string;
    TransactionCurrencyCode?: CurrencyCode;
    Balance?: IBankAccountBalanceEntity;
    BankApiConnectionSetting?: IBankApiConnectionSettingEntity;
    BankApiStatementImportSetting?: IBankApiStatementImportSettingEntity;
    BankStatementCsvSettingsText?: IBankStatementCsvSettingsTextEntity;
    BankStatementNumberRangeDefinition?: INumberRangeDefinitionEntity;
    Company?: ICompanyEntity;
    CompanyBankAccountType?: ICompanyBankAccountTypeEntity;
    Currency?: ICurrencyEntity;
    Logo?: IFileMetadataEntity;
    TransactionCurrency?: ICurrencyEntity;
    BankTransactionCsvColumnMappings?: IBankTransactionCsvColumnMappingEntity[];
    PaymentOrderExportCounter?: number;
}

export enum CompanyBankAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    Country = "Country",
    BalanceSheetAccountName = "BalanceSheetAccountName",
    BalanceSheetAccountNumberPrefix = "BalanceSheetAccountNumberPrefix",
    BalanceSheetAccountNumberSuffix = "BalanceSheetAccountNumberSuffix",
    CompanyBankAccountTypeCode = "CompanyBankAccountTypeCode",
    CurrencyCode = "CurrencyCode",
    HasAutoPosting = "HasAutoPosting",
    InitialBalance = "InitialBalance",
    InitialTransactionBalance = "InitialTransactionBalance",
    IsActive = "IsActive",
    IsDefault = "IsDefault",
    IsOss = "IsOss",
    Name = "Name",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    Balance = "Balance",
    BankApiConnectionSetting = "BankApiConnectionSetting",
    BankApiStatementImportSetting = "BankApiStatementImportSetting",
    BankStatementCsvSettingsText = "BankStatementCsvSettingsText",
    BankStatementNumberRangeDefinition = "BankStatementNumberRangeDefinition",
    Company = "Company",
    CompanyBankAccountType = "CompanyBankAccountType",
    Currency = "Currency",
    Logo = "Logo",
    TransactionCurrency = "TransactionCurrency",
    BankTransactionCsvColumnMappings = "BankTransactionCsvColumnMappings",
    PaymentOrderExportCounter = "PaymentOrderExportCounter",
}

export interface ICompanyBankAccountTypeEntity extends IEntityBase {
    Code?: CompanyBankAccountTypeCode;
    Name?: string;
}

export enum CompanyBankAccountTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICompanyCommunicationAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum CompanyCommunicationAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface ICompanyCommunicationContactEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    PhoneNumber?: string;
}

export enum CompanyCommunicationContactEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    PhoneNumber = "PhoneNumber",
}

export interface ICompanyFixedExchangeRateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    ExchangeRateDirect?: number;
    ExchangeRateIndirect?: number;
    ExchangeRatePerUnit?: number;
    IsClosingFiscalYear?: boolean;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
}

export enum CompanyFixedExchangeRateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    ExchangeRateDirect = "ExchangeRateDirect",
    ExchangeRateIndirect = "ExchangeRateIndirect",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    IsClosingFiscalYear = "IsClosingFiscalYear",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
}

export interface ICompanyLegalAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    CityCode?: string;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum CompanyLegalAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    CityCode = "CityCode",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface ICompanyModuleEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsEnabled?: boolean;
    ModuleCode?: ModuleCode;
    Module?: IModuleEntity;
}

export enum CompanyModuleEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsEnabled = "IsEnabled",
    ModuleCode = "ModuleCode",
    Module = "Module",
}

export interface ICompanyPermissionEntity extends IEntityBase {
    Code?: CompanyPermissionCode;
    CompanyRoleTypeCode?: CompanyRoleTypeCode;
    Description?: string;
    FeatureCode?: FeatureCode;
    HasOnlyOwn?: boolean;
    Name?: string;
    CompanyRoleType?: ICompanyRoleTypeEntity;
    Feature?: IFeatureEntity;
}

export enum CompanyPermissionEntity {
    Code = "Code",
    CompanyRoleTypeCode = "CompanyRoleTypeCode",
    Description = "Description",
    FeatureCode = "FeatureCode",
    HasOnlyOwn = "HasOnlyOwn",
    Name = "Name",
    CompanyRoleType = "CompanyRoleType",
    Feature = "Feature",
}

export interface ICompanyRoleEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CompanyRoleName?: string;
    IsSystemRole?: boolean;
    TypeCode?: CompanyRoleTypeCode;
    UserCount?: number;
    Type?: ICompanyRoleTypeEntity;
    CompanyRolePermissions?: ICompanyRolePermissionEntity[];
}

export enum CompanyRoleEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CompanyRoleName = "CompanyRoleName",
    IsSystemRole = "IsSystemRole",
    TypeCode = "TypeCode",
    UserCount = "UserCount",
    Type = "Type",
    CompanyRolePermissions = "CompanyRolePermissions",
}

export interface ICompanyRolePermissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CompanyPermissionCode?: CompanyPermissionCode;
    IsEnabled?: boolean;
    OwnOnly?: boolean;
    CompanyPermission?: ICompanyPermissionEntity;
}

export enum CompanyRolePermissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CompanyPermissionCode = "CompanyPermissionCode",
    IsEnabled = "IsEnabled",
    OwnOnly = "OwnOnly",
    CompanyPermission = "CompanyPermission",
}

export interface ICompanyRoleTypeEntity extends IEntityBase {
    Code?: CompanyRoleTypeCode;
    Name?: string;
}

export enum CompanyRoleTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICompanySettingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateInitialAccountBalances?: Date;
    InitialChartOfAccountsTemplateId?: number;
    InitialYear?: number;
    InitialBalancesDocument?: IInternalDocumentEntity;
    InitialFiscalYear?: IFiscalYearEntity;
    InitialAccountBalances?: IInitialAccountBalanceEntity[];
    TrustedSenders?: ITrustedSenderEntity[];
    InboxApprovers?: IUserEntity[];
    RequiredAccounts?: IRequiredAccountEntity[];
}

export enum CompanySettingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateInitialAccountBalances = "DateInitialAccountBalances",
    InitialChartOfAccountsTemplateId = "InitialChartOfAccountsTemplateId",
    InitialYear = "InitialYear",
    InitialBalancesDocument = "InitialBalancesDocument",
    InitialFiscalYear = "InitialFiscalYear",
    InitialAccountBalances = "InitialAccountBalances",
    TrustedSenders = "TrustedSenders",
    InboxApprovers = "InboxApprovers",
    RequiredAccounts = "RequiredAccounts",
}

export interface ICompanyStateEntity extends IEntityBase {
    Code?: CompanyStateCode;
    Name?: string;
}

export enum CompanyStateEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICompanyVatReducedCoefficientEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    VatReducedCoefficient?: number;
    Year?: number;
}

export enum CompanyVatReducedCoefficientEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    VatReducedCoefficient = "VatReducedCoefficient",
    Year = "Year",
}

export interface ICompanyVatStatusTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    IsOssMode?: boolean;
    VatStatementFrequencyCode?: VatStatementFrequencyCode;
    VatStatusCode?: VatStatusCode;
    VatStatementFrequency?: IVatStatementFrequencyEntity;
    VatStatus?: IVatStatusEntity;
}

export enum CompanyVatStatusTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    IsOssMode = "IsOssMode",
    VatStatementFrequencyCode = "VatStatementFrequencyCode",
    VatStatusCode = "VatStatusCode",
    VatStatementFrequency = "VatStatementFrequency",
    VatStatus = "VatStatus",
}

export interface ICompanyVatStatusTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    IsOssMode?: boolean;
    VatStatementFrequencyCode?: VatStatementFrequencyCode;
    VatStatusCode?: VatStatusCode;
    VatStatementFrequency?: IVatStatementFrequencyEntity;
    VatStatus?: IVatStatusEntity;
}

export enum CompanyVatStatusTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    IsOssMode = "IsOssMode",
    VatStatementFrequencyCode = "VatStatementFrequencyCode",
    VatStatusCode = "VatStatusCode",
    VatStatementFrequency = "VatStatementFrequency",
    VatStatus = "VatStatus",
}

export interface ICompoundJournalEntryEntity extends IEntityBase {
    NotId?: number;
    CreditAmount?: number;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCreated?: Date;
    DebitAmount?: number;
    Description?: string;
    DocumentTypeCode?: DocumentTypeCode;
    IsBalancing?: boolean;
    IsClosing?: boolean;
    IsOpening?: boolean;
    TransactionCreditAmount?: number;
    TransactionCurrencyCode?: CurrencyCode;
    TransactionDebitAmount?: number;
    Account?: IAccountEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
    DocumentType?: IDocumentTypeEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    PairAccount?: IAccountEntity;
    PaymentDocument?: IPaymentDocumentEntity;
    PaymentDocumentItem?: IPaymentDocumentItemEntity;
    TransactionCurrency?: ICurrencyEntity;
}

export enum CompoundJournalEntryEntity {
    NotId = "NotId",
    CreditAmount = "CreditAmount",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCreated = "DateCreated",
    DebitAmount = "DebitAmount",
    Description = "Description",
    DocumentTypeCode = "DocumentTypeCode",
    IsBalancing = "IsBalancing",
    IsClosing = "IsClosing",
    IsOpening = "IsOpening",
    TransactionCreditAmount = "TransactionCreditAmount",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    TransactionDebitAmount = "TransactionDebitAmount",
    Account = "Account",
    Company = "Company",
    Currency = "Currency",
    Document = "Document",
    DocumentItem = "DocumentItem",
    DocumentType = "DocumentType",
    FiscalPeriod = "FiscalPeriod",
    PairAccount = "PairAccount",
    PaymentDocument = "PaymentDocument",
    PaymentDocumentItem = "PaymentDocumentItem",
    TransactionCurrency = "TransactionCurrency",
}

export interface IContactEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    PhoneNumber?: string;
}

export enum ContactEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    PhoneNumber = "PhoneNumber",
}

export interface ICorrectiveInvoiceIssuedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaDocument?: Date;
    DateClearing?: Date;
    DateDocumentVatStatement?: Date;
    DateVatDeduction?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsInternallyManaged?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: VatStatementStatusCode;
    VatOssStatementStatusCode?: VatStatementStatusCode;
    VatStatementStatusCode?: VatStatementStatusCode;
    VatViesStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnitDateVatDeduction?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionEntity;
    BankAccount?: IDocumentBankAccountEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    CbaCategory?: IDocumentCbaCategoryEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    NumberRange?: INumberRangeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionEntity;
    VatControlStatementStatus?: IVatStatementStatusEntity;
    VatOssStatementStatus?: IVatStatementStatusEntity;
    VatStatementStatus?: IVatStatementStatusEntity;
    VatViesStatementStatus?: IVatStatementStatusEntity;
    Attachments?: IDocumentAttachmentEntity[];
    DocumentItems?: IDocumentItemViewEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Labels?: IDocumentLabelEntity[];
    Locks?: IDocumentLockEntity[];
    OppositeDocumentLinks?: IOppositeDocumentDocumentLinkEntity[];
    Payments?: IOppositePaymentDocumentDocumentLinkEntity[];
    ClearingDocumentLinks?: IClearingDocumentLinkEntity[];
    CorrectiveDocumentDrafts?: IDocumentDraftEntity[];
    DeferredPlans?: IDeferredPlanEntity[];
    Chats?: IChatEntity[];
    ElectronicSubmissions?: IElectronicSubmissionEntity[];
    BankPaymentOrderStateCode?: BankPaymentOrderStateCode;
    DateBankApiPaymentOrder?: Date;
    DateDue?: Date;
    DateIssued?: Date;
    DateTaxableSupply?: Date;
    Explanation?: string;
    ExternalCorrectedDocumentNumber?: string;
    ExternalCorrectedDocumentTypeCode?: ExternalCorrectedDocumentTypeCode;
    PaymentMethodCode?: PaymentMethodCode;
    SymbolMatching?: string;
    TextBeforeItems?: string;
    TransactionAmountToPay?: number;
    TransactionAmountToReceive?: number;
    BankPaymentOrderState?: IBankPaymentOrderStateEntity;
    CashBox?: ICashBoxEntity;
    ExternalCorrectedDocumentType?: IExternalCorrectedDocumentTypeEntity;
    PaymentMethod?: IPaymentMethodEntity;
    Items?: IRegularDocumentItemEntity[];
    CorrectedDocuments?: IDocumentEntity[];
}

export enum CorrectiveInvoiceIssuedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaDocument = "DateCbaDocument",
    DateClearing = "DateClearing",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateVatDeduction = "DateVatDeduction",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsInternallyManaged = "IsInternallyManaged",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BusinessPartner = "BusinessPartner",
    CbaCategory = "CbaCategory",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    DocumentDraft = "DocumentDraft",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    NumberRange = "NumberRange",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassificationSelection = "VatClassificationSelection",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
    Attachments = "Attachments",
    DocumentItems = "DocumentItems",
    DocumentLinks = "DocumentLinks",
    Labels = "Labels",
    Locks = "Locks",
    OppositeDocumentLinks = "OppositeDocumentLinks",
    Payments = "Payments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    CorrectiveDocumentDrafts = "CorrectiveDocumentDrafts",
    DeferredPlans = "DeferredPlans",
    Chats = "Chats",
    ElectronicSubmissions = "ElectronicSubmissions",
    BankPaymentOrderStateCode = "BankPaymentOrderStateCode",
    DateBankApiPaymentOrder = "DateBankApiPaymentOrder",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DateTaxableSupply = "DateTaxableSupply",
    Explanation = "Explanation",
    ExternalCorrectedDocumentNumber = "ExternalCorrectedDocumentNumber",
    ExternalCorrectedDocumentTypeCode = "ExternalCorrectedDocumentTypeCode",
    PaymentMethodCode = "PaymentMethodCode",
    SymbolMatching = "SymbolMatching",
    TextBeforeItems = "TextBeforeItems",
    TransactionAmountToPay = "TransactionAmountToPay",
    TransactionAmountToReceive = "TransactionAmountToReceive",
    BankPaymentOrderState = "BankPaymentOrderState",
    CashBox = "CashBox",
    ExternalCorrectedDocumentType = "ExternalCorrectedDocumentType",
    PaymentMethod = "PaymentMethod",
    Items = "Items",
    CorrectedDocuments = "CorrectedDocuments",
}

export interface ICorrectiveInvoiceReceivedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaDocument?: Date;
    DateClearing?: Date;
    DateDocumentVatStatement?: Date;
    DateVatDeduction?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsInternallyManaged?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: VatStatementStatusCode;
    VatOssStatementStatusCode?: VatStatementStatusCode;
    VatStatementStatusCode?: VatStatementStatusCode;
    VatViesStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnitDateVatDeduction?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionEntity;
    BankAccount?: IDocumentBankAccountEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    CbaCategory?: IDocumentCbaCategoryEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    NumberRange?: INumberRangeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionEntity;
    VatControlStatementStatus?: IVatStatementStatusEntity;
    VatOssStatementStatus?: IVatStatementStatusEntity;
    VatStatementStatus?: IVatStatementStatusEntity;
    VatViesStatementStatus?: IVatStatementStatusEntity;
    Attachments?: IDocumentAttachmentEntity[];
    DocumentItems?: IDocumentItemViewEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Labels?: IDocumentLabelEntity[];
    Locks?: IDocumentLockEntity[];
    OppositeDocumentLinks?: IOppositeDocumentDocumentLinkEntity[];
    Payments?: IOppositePaymentDocumentDocumentLinkEntity[];
    ClearingDocumentLinks?: IClearingDocumentLinkEntity[];
    CorrectiveDocumentDrafts?: IDocumentDraftEntity[];
    DeferredPlans?: IDeferredPlanEntity[];
    Chats?: IChatEntity[];
    ElectronicSubmissions?: IElectronicSubmissionEntity[];
    BankPaymentOrderStateCode?: BankPaymentOrderStateCode;
    DateBankApiPaymentOrder?: Date;
    DateDue?: Date;
    DateIssued?: Date;
    DateReceived?: Date;
    DateTaxableSupply?: Date;
    Explanation?: string;
    ExternalCorrectedDocumentNumber?: string;
    ExternalCorrectedDocumentTypeCode?: ExternalCorrectedDocumentTypeCode;
    PaymentMethodCode?: PaymentMethodCode;
    SymbolMatching?: string;
    TextBeforeItems?: string;
    TransactionAmountToPay?: number;
    TransactionAmountToReceive?: number;
    BankPaymentOrderState?: IBankPaymentOrderStateEntity;
    CashBox?: ICashBoxEntity;
    ExternalCorrectedDocumentType?: IExternalCorrectedDocumentTypeEntity;
    PaymentMethod?: IPaymentMethodEntity;
    Items?: IRegularDocumentItemEntity[];
    CorrectedDocuments?: IDocumentEntity[];
}

export enum CorrectiveInvoiceReceivedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaDocument = "DateCbaDocument",
    DateClearing = "DateClearing",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateVatDeduction = "DateVatDeduction",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsInternallyManaged = "IsInternallyManaged",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BusinessPartner = "BusinessPartner",
    CbaCategory = "CbaCategory",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    DocumentDraft = "DocumentDraft",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    NumberRange = "NumberRange",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassificationSelection = "VatClassificationSelection",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
    Attachments = "Attachments",
    DocumentItems = "DocumentItems",
    DocumentLinks = "DocumentLinks",
    Labels = "Labels",
    Locks = "Locks",
    OppositeDocumentLinks = "OppositeDocumentLinks",
    Payments = "Payments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    CorrectiveDocumentDrafts = "CorrectiveDocumentDrafts",
    DeferredPlans = "DeferredPlans",
    Chats = "Chats",
    ElectronicSubmissions = "ElectronicSubmissions",
    BankPaymentOrderStateCode = "BankPaymentOrderStateCode",
    DateBankApiPaymentOrder = "DateBankApiPaymentOrder",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DateReceived = "DateReceived",
    DateTaxableSupply = "DateTaxableSupply",
    Explanation = "Explanation",
    ExternalCorrectedDocumentNumber = "ExternalCorrectedDocumentNumber",
    ExternalCorrectedDocumentTypeCode = "ExternalCorrectedDocumentTypeCode",
    PaymentMethodCode = "PaymentMethodCode",
    SymbolMatching = "SymbolMatching",
    TextBeforeItems = "TextBeforeItems",
    TransactionAmountToPay = "TransactionAmountToPay",
    TransactionAmountToReceive = "TransactionAmountToReceive",
    BankPaymentOrderState = "BankPaymentOrderState",
    CashBox = "CashBox",
    ExternalCorrectedDocumentType = "ExternalCorrectedDocumentType",
    PaymentMethod = "PaymentMethod",
    Items = "Items",
    CorrectedDocuments = "CorrectedDocuments",
}

export interface ICountryEntity extends IEntityBase {
    Code?: CountryCode;
    Code3?: string;
    DefaultCurrencyCode?: CurrencyCode;
    IsEEA?: boolean;
    IsEuMember?: boolean;
    IsSepa?: boolean;
    Name?: string;
    NumericCode?: string;
    DefaultCurrency?: ICurrencyEntity;
    Currencies?: ICurrencyEntity[];
}

export enum CountryEntity {
    Code = "Code",
    Code3 = "Code3",
    DefaultCurrencyCode = "DefaultCurrencyCode",
    IsEEA = "IsEEA",
    IsEuMember = "IsEuMember",
    IsSepa = "IsSepa",
    Name = "Name",
    NumericCode = "NumericCode",
    DefaultCurrency = "DefaultCurrency",
    Currencies = "Currencies",
}

export interface ICountryClassificationEntity extends IEntityBase {
    Code?: CountryClassificationCode;
    Name?: string;
}

export enum CountryClassificationEntity {
    Code = "Code",
    Name = "Name",
}

export interface ICountryOrUnionEntity extends IEntityBase {
    Code?: CountryOrUnionCode;
    Code3?: string;
    DefaultCurrencyCode?: CurrencyCode;
    IsEuMember?: boolean;
    Name?: string;
    NumericCode?: string;
    DefaultCurrency?: ICurrencyEntity;
    Currencies?: ICurrencyEntity[];
}

export enum CountryOrUnionEntity {
    Code = "Code",
    Code3 = "Code3",
    DefaultCurrencyCode = "DefaultCurrencyCode",
    IsEuMember = "IsEuMember",
    Name = "Name",
    NumericCode = "NumericCode",
    DefaultCurrency = "DefaultCurrency",
    Currencies = "Currencies",
}

export interface ICountryRegionEntity extends IEntityBase {
    Code?: CountryRegionCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum CountryRegionEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface ICsszEmploymentTypeEntity extends IEntityBase {
    Code?: CsszEmploymentTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    EmploymentTypeCode?: PrEmploymentTypeCode;
    Name?: string;
    ShortName?: string;
    Country?: ICountryEntity;
    EmploymentType?: IPrEmploymentTypeEntity;
}

export enum CsszEmploymentTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    EmploymentTypeCode = "EmploymentTypeCode",
    Name = "Name",
    ShortName = "ShortName",
    Country = "Country",
    EmploymentType = "EmploymentType",
}

export interface ICurrencyEntity extends IEntityBase {
    Code?: CurrencyCode;
    DefaultCountryCode?: CountryOrUnionCode;
    Name?: string;
    NumericCode?: string;
    MinorUnit?: number;
    DefaultCountry?: ICountryOrUnionEntity;
}

export enum CurrencyEntity {
    Code = "Code",
    DefaultCountryCode = "DefaultCountryCode",
    Name = "Name",
    NumericCode = "NumericCode",
    MinorUnit = "MinorUnit",
    DefaultCountry = "DefaultCountry",
}

export interface ICurrencyUsedByCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BankExchangeRateFreshnessCode?: BankExchangeRateFreshnessCode;
    CountryCode?: CountryOrUnionCode;
    ExchangeRateTypeCode?: ExchangeRateTypeCode;
    FromCurrencyCode?: CurrencyCode;
    SetFixedExchangeRate?: boolean;
    ToCurrencyCode?: CurrencyCode;
    Amount?: number;
    ExchangeRateDirect?: number;
    BankExchangeRateFreshness?: IBankExchangeRateFreshnessEntity;
    Company?: ICompanyEntity;
    Country?: ICountryOrUnionEntity;
    ExchangeRateType?: IExchangeRateTypeEntity;
    FromCurrency?: ICurrencyEntity;
    ToCurrency?: ICurrencyEntity;
    FixedExchangeRates?: ICompanyFixedExchangeRateEntity[];
}

export enum CurrencyUsedByCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BankExchangeRateFreshnessCode = "BankExchangeRateFreshnessCode",
    CountryCode = "CountryCode",
    ExchangeRateTypeCode = "ExchangeRateTypeCode",
    FromCurrencyCode = "FromCurrencyCode",
    SetFixedExchangeRate = "SetFixedExchangeRate",
    ToCurrencyCode = "ToCurrencyCode",
    Amount = "Amount",
    ExchangeRateDirect = "ExchangeRateDirect",
    BankExchangeRateFreshness = "BankExchangeRateFreshness",
    Company = "Company",
    Country = "Country",
    ExchangeRateType = "ExchangeRateType",
    FromCurrency = "FromCurrency",
    ToCurrency = "ToCurrency",
    FixedExchangeRates = "FixedExchangeRates",
}

export interface ICurrencyWithExchangeRateInfoEntity extends IEntityBase {
    Id?: number;
    Code?: string;
    DefaultCountryCode?: string;
    IsCurrencyExchangeRateProvidedByCentralBank?: boolean;
    IsCurrencyExchangeRateProvidedByCentralBankDaily?: boolean;
    Name?: string;
    NumericCode?: string;
    MinorUnit?: number;
}

export enum CurrencyWithExchangeRateInfoEntity {
    Id = "Id",
    Code = "Code",
    DefaultCountryCode = "DefaultCountryCode",
    IsCurrencyExchangeRateProvidedByCentralBank = "IsCurrencyExchangeRateProvidedByCentralBank",
    IsCurrencyExchangeRateProvidedByCentralBankDaily = "IsCurrencyExchangeRateProvidedByCentralBankDaily",
    Name = "Name",
    NumericCode = "NumericCode",
    MinorUnit = "MinorUnit",
}

export interface ICustomerPortalPaymentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankCode?: string;
    BusinessPartnerName?: string;
    CountryCode?: CountryCode;
    DateDue?: Date;
    DocumentTypeCode?: DocumentTypeCode;
    IBAN?: string;
    IsPaid?: boolean;
    LegalNumber?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    QrCode?: string;
    RemittanceInformation?: string;
    SWIFT?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmountDue?: number;
    TransactionCurrencyCode?: CurrencyCode;
    Country?: ICountryEntity;
    Document?: IDocumentEntity;
    DocumentType?: IDocumentTypeEntity;
    TransactionCurrency?: ICurrencyEntity;
}

export enum CustomerPortalPaymentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankCode = "BankCode",
    BusinessPartnerName = "BusinessPartnerName",
    CountryCode = "CountryCode",
    DateDue = "DateDue",
    DocumentTypeCode = "DocumentTypeCode",
    IBAN = "IBAN",
    IsPaid = "IsPaid",
    LegalNumber = "LegalNumber",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    QrCode = "QrCode",
    RemittanceInformation = "RemittanceInformation",
    SWIFT = "SWIFT",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    Country = "Country",
    Document = "Document",
    DocumentType = "DocumentType",
    TransactionCurrency = "TransactionCurrency",
}

export interface ICzIsceEntity extends IEntityBase {
    Code?: CzIsceCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Description?: string;
    MpsvCode?: string;
    Name?: string;
    Country?: ICountryEntity;
}

export enum CzIsceEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Description = "Description",
    MpsvCode = "MpsvCode",
    Name = "Name",
    Country = "Country",
}

export interface ICzIscoEntity extends IEntityBase {
    Code?: CzIscoCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Description?: string;
    MpsvCode?: string;
    Name?: string;
    Country?: ICountryEntity;
}

export enum CzIscoEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Description = "Description",
    MpsvCode = "MpsvCode",
    Name = "Name",
    Country = "Country",
}

export interface ICzNaceEntity extends IEntityBase {
    Code?: string;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Description?: string;
    MpsvCode?: string;
    Name?: string;
    Rate?: number;
    Country?: ICountryEntity;
}

export enum CzNaceEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Description = "Description",
    MpsvCode = "MpsvCode",
    Name = "Name",
    Rate = "Rate",
    Country = "Country",
}

export interface IDashboardTaskEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    SequenceOrder?: number;
    DateCompleted?: Date;
}

export enum DashboardTaskEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    SequenceOrder = "SequenceOrder",
    DateCompleted = "DateCompleted",
}

export interface IDataBoxEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AllowReadingNewMessages?: boolean;
    CanCheckMessages?: boolean;
    CanReadMessages?: boolean;
    CanSendMessages?: boolean;
    CompanyAddress?: string;
    CompanyName?: string;
    DataBoxId?: string;
    DataBoxUserName?: string;
    IsActive?: boolean;
    LegalNumber?: string;
    PasswordId?: number;
    UserName?: string;
    PasswordSetter?: string;
    Company?: ICompanyEntity;
}

export enum DataBoxEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AllowReadingNewMessages = "AllowReadingNewMessages",
    CanCheckMessages = "CanCheckMessages",
    CanReadMessages = "CanReadMessages",
    CanSendMessages = "CanSendMessages",
    CompanyAddress = "CompanyAddress",
    CompanyName = "CompanyName",
    DataBoxId = "DataBoxId",
    DataBoxUserName = "DataBoxUserName",
    IsActive = "IsActive",
    LegalNumber = "LegalNumber",
    PasswordId = "PasswordId",
    UserName = "UserName",
    PasswordSetter = "PasswordSetter",
    Company = "Company",
}

export interface IDateFormatEntity extends IEntityBase {
    Code?: DateFormatCode;
    Format?: string;
    Name?: string;
}

export enum DateFormatEntity {
    Code = "Code",
    Format = "Format",
    Name = "Name",
}

export interface IDatesIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    DateTo?: Date;
}

export enum DatesIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
}

export interface IDayOfWeekEntity extends IEntityBase {
    Code?: DayOfWeekCode;
    Name?: string;
}

export enum DayOfWeekEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDefaultVariantEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccessTypeCode?: VariantAccessTypeCode;
    AccountingCode?: AccountingCode;
    VariantTypeCode?: VariantTypeCode;
    VatStatusCode?: VatStatusCode;
    ViewId?: string;
    AccessType?: IVariantAccessTypeEntity;
    Accounting?: IAccountingEntity;
    Owner?: IUserEntity;
    Variant?: IVariantEntity;
    VariantType?: IVariantTypeEntity;
    VatStatus?: IVatStatusEntity;
}

export enum DefaultVariantEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccessTypeCode = "AccessTypeCode",
    AccountingCode = "AccountingCode",
    VariantTypeCode = "VariantTypeCode",
    VatStatusCode = "VatStatusCode",
    ViewId = "ViewId",
    AccessType = "AccessType",
    Accounting = "Accounting",
    Owner = "Owner",
    Variant = "Variant",
    VariantType = "VariantType",
    VatStatus = "VatStatus",
}

export interface IDeferredDocumentEntity extends IEntityBase {
    Id?: number;
    Amount?: number;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DocumentLinkTypeCode?: DocumentLinkTypeCode;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DocumentLinkType?: IDocumentLinkTypeEntity;
    OriginalDocument?: IDocumentEntity;
    TargetDocument?: IInternalDocumentEntity;
}

export enum DeferredDocumentEntity {
    Id = "Id",
    Amount = "Amount",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DocumentLinkTypeCode = "DocumentLinkTypeCode",
    Company = "Company",
    Currency = "Currency",
    DocumentLinkType = "DocumentLinkType",
    OriginalDocument = "OriginalDocument",
    TargetDocument = "TargetDocument",
}

export interface IDeferredPlanEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEnd?: Date;
    DateStart?: Date;
    Description?: string;
    PeriodDayCode?: PeriodDayCode;
    PostingTypeCode?: DeferredPlanPostingTypeCode;
    Account?: IAccountEntity;
    ChartOfAccounts?: IChartOfAccountsEntity;
    Company?: ICompanyEntity;
    OriginalDocument?: IDocumentEntity;
    PeriodDay?: IPeriodDayEntity;
    PostingType?: IDeferredPlanPostingTypeEntity;
    DeferredDocuments?: IDeferredPlanDocumentEntity[];
    OriginalDocumentItems?: IDeferredPlanOriginalDocumentItemEntity[];
}

export enum DeferredPlanEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    Description = "Description",
    PeriodDayCode = "PeriodDayCode",
    PostingTypeCode = "PostingTypeCode",
    Account = "Account",
    ChartOfAccounts = "ChartOfAccounts",
    Company = "Company",
    OriginalDocument = "OriginalDocument",
    PeriodDay = "PeriodDay",
    PostingType = "PostingType",
    DeferredDocuments = "DeferredDocuments",
    OriginalDocumentItems = "OriginalDocumentItems",
}

export interface IDeferredPlanDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    DateAccountingTransaction?: Date;
    TargetDocument?: IInternalDocumentEntity;
    Items?: IDeferredPlanDocumentItemEntity[];
}

export enum DeferredPlanDocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    DateAccountingTransaction = "DateAccountingTransaction",
    TargetDocument = "TargetDocument",
    Items = "Items",
}

export interface IDeferredPlanDocumentItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    OriginalDocumentItem?: IDocumentItemEntity;
    TargetDocumentItem?: IDocumentItemEntity;
}

export enum DeferredPlanDocumentItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    OriginalDocumentItem = "OriginalDocumentItem",
    TargetDocumentItem = "TargetDocumentItem",
}

export interface IDeferredPlanOriginalDocumentItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    OriginalDocumentItem?: IDocumentItemEntity;
}

export enum DeferredPlanOriginalDocumentItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    OriginalDocumentItem = "OriginalDocumentItem",
}

export interface IDeferredPlanPostingTypeEntity extends IEntityBase {
    Code?: DeferredPlanPostingTypeCode;
    Name?: string;
}

export enum DeferredPlanPostingTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDepreciationPolicyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccumulatedDepreciation?: number;
    CurrencyCode?: CurrencyCode;
    DateFirstDepreciation?: Date;
    DateLastDepreciation?: Date;
    DateRequestedLastDepreciation?: Date;
    Currency?: ICurrencyEntity;
}

export enum DepreciationPolicyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccumulatedDepreciation = "AccumulatedDepreciation",
    CurrencyCode = "CurrencyCode",
    DateFirstDepreciation = "DateFirstDepreciation",
    DateLastDepreciation = "DateLastDepreciation",
    DateRequestedLastDepreciation = "DateRequestedLastDepreciation",
    Currency = "Currency",
}

export interface IDepreciationPolicyItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccumulatedDepreciation?: number;
    CalculatedExpense?: number;
    CurrencyCode?: CurrencyCode;
    DateDepreciation?: Date;
    EndValue?: number;
    Order?: number;
    Currency?: ICurrencyEntity;
}

export enum DepreciationPolicyItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccumulatedDepreciation = "AccumulatedDepreciation",
    CalculatedExpense = "CalculatedExpense",
    CurrencyCode = "CurrencyCode",
    DateDepreciation = "DateDepreciation",
    EndValue = "EndValue",
    Order = "Order",
    Currency = "Currency",
}

export interface IDepreciationPolicyTypeEntity extends IEntityBase {
    Code?: DepreciationPolicyTypeCode;
    Name?: string;
}

export enum DepreciationPolicyTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDepreciationSettingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    DepreciationSettingTypeCode?: DepreciationSettingTypeCode;
    PartialExpense?: number;
    DepreciationSettingType?: IDepreciationSettingTypeEntity;
}

export enum DepreciationSettingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    DepreciationSettingTypeCode = "DepreciationSettingTypeCode",
    PartialExpense = "PartialExpense",
    DepreciationSettingType = "DepreciationSettingType",
}

export interface IDepreciationSettingTypeEntity extends IEntityBase {
    Code?: DepreciationSettingTypeCode;
    Name?: string;
}

export enum DepreciationSettingTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDepreciationTypeEntity extends IEntityBase {
    Code?: DepreciationTypeCode;
    Name?: string;
}

export enum DepreciationTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDetailedEmploymentSpecificationEntity extends IEntityBase {
    Code?: DetailedEmploymentSpecificationCode;
    MpsvCode?: string;
    Name?: string;
}

export enum DetailedEmploymentSpecificationEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaDocument?: Date;
    DateClearing?: Date;
    DateDocumentVatStatement?: Date;
    DateVatDeduction?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsInternallyManaged?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: VatStatementStatusCode;
    VatOssStatementStatusCode?: VatStatementStatusCode;
    VatStatementStatusCode?: VatStatementStatusCode;
    VatViesStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnitDateVatDeduction?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionEntity;
    BankAccount?: IDocumentBankAccountEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    CbaCategory?: IDocumentCbaCategoryEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    NumberRange?: INumberRangeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionEntity;
    VatControlStatementStatus?: IVatStatementStatusEntity;
    VatOssStatementStatus?: IVatStatementStatusEntity;
    VatStatementStatus?: IVatStatementStatusEntity;
    VatViesStatementStatus?: IVatStatementStatusEntity;
    Attachments?: IDocumentAttachmentEntity[];
    DocumentItems?: IDocumentItemViewEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Labels?: IDocumentLabelEntity[];
    Locks?: IDocumentLockEntity[];
    OppositeDocumentLinks?: IOppositeDocumentDocumentLinkEntity[];
    Payments?: IOppositePaymentDocumentDocumentLinkEntity[];
    ClearingDocumentLinks?: IClearingDocumentLinkEntity[];
    CorrectiveDocumentDrafts?: IDocumentDraftEntity[];
    DeferredPlans?: IDeferredPlanEntity[];
    Chats?: IChatEntity[];
    ElectronicSubmissions?: IElectronicSubmissionEntity[];
}

export enum DocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaDocument = "DateCbaDocument",
    DateClearing = "DateClearing",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateVatDeduction = "DateVatDeduction",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsInternallyManaged = "IsInternallyManaged",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BusinessPartner = "BusinessPartner",
    CbaCategory = "CbaCategory",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    DocumentDraft = "DocumentDraft",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    NumberRange = "NumberRange",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassificationSelection = "VatClassificationSelection",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
    Attachments = "Attachments",
    DocumentItems = "DocumentItems",
    DocumentLinks = "DocumentLinks",
    Labels = "Labels",
    Locks = "Locks",
    OppositeDocumentLinks = "OppositeDocumentLinks",
    Payments = "Payments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    CorrectiveDocumentDrafts = "CorrectiveDocumentDrafts",
    DeferredPlans = "DeferredPlans",
    Chats = "Chats",
    ElectronicSubmissions = "ElectronicSubmissions",
}

export interface IDocumentAccountAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsDebitAccountVatDeductionForced?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
}

export enum DocumentAccountAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
}

export interface IDocumentAccountAssignmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsDebitAccountVatDeductionForced?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
}

export enum DocumentAccountAssignmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
}

export interface IDocumentAccountAssignmentSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    AccountAssignment?: IDocumentAccountAssignmentEntity;
}

export enum DocumentAccountAssignmentSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    AccountAssignment = "AccountAssignment",
}

export interface IDocumentAccountAssignmentSelectionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    AccountAssignment?: IDocumentAccountAssignmentDraftEntity;
}

export enum DocumentAccountAssignmentSelectionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    AccountAssignment = "AccountAssignment",
}

export interface IDocumentAssetEntryEntity extends IEntityBase {
    NotId?: number;
    Asset?: IAssetEntity;
    AssetItem?: IAssetItemEntity;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
}

export enum DocumentAssetEntryEntity {
    NotId = "NotId",
    Asset = "Asset",
    AssetItem = "AssetItem",
    Document = "Document",
    DocumentItem = "DocumentItem",
}

export interface IDocumentAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum DocumentAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IDocumentAttachmentDeletedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum DocumentAttachmentDeletedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IDocumentAttachmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum DocumentAttachmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IDocumentBankAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
    Country?: ICountryEntity;
}

export enum DocumentBankAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    Country = "Country",
}

export interface IDocumentBankAccountDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
    Country?: ICountryEntity;
}

export enum DocumentBankAccountDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    Country = "Country",
}

export interface IDocumentBusinessPartnerEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    LegalNumber?: string;
    Name?: string;
    PayerReliabilityStatusCode?: PayerReliabilityStatusCode;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    BusinessPartner?: IBusinessPartnerEntity;
    Country?: ICountryEntity;
    PayerReliabilityStatus?: IPayerReliabilityStatusEntity;
    VatStatus?: IVatStatusEntity;
    DocumentBusinessPartnerTypeCode?: DocumentBusinessPartnerTypeCode;
    DocumentBusinessPartnerType?: IDocumentBusinessPartnerTypeEntity;
    Employee?: IPrEmployeeEntity;
}

export enum DocumentBusinessPartnerEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PayerReliabilityStatusCode = "PayerReliabilityStatusCode",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    BusinessPartner = "BusinessPartner",
    Country = "Country",
    PayerReliabilityStatus = "PayerReliabilityStatus",
    VatStatus = "VatStatus",
    DocumentBusinessPartnerTypeCode = "DocumentBusinessPartnerTypeCode",
    DocumentBusinessPartnerType = "DocumentBusinessPartnerType",
    Employee = "Employee",
}

export interface IDocumentBusinessPartnerDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    LegalNumber?: string;
    Name?: string;
    PayerReliabilityStatusCode?: PayerReliabilityStatusCode;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    BusinessPartner?: IBusinessPartnerEntity;
    Country?: ICountryEntity;
    PayerReliabilityStatus?: IPayerReliabilityStatusEntity;
    VatStatus?: IVatStatusEntity;
    DocumentBusinessPartnerTypeCode?: DocumentBusinessPartnerTypeCode;
    DocumentBusinessPartnerType?: IDocumentBusinessPartnerTypeEntity;
    Employee?: IPrEmployeeEntity;
}

export enum DocumentBusinessPartnerDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PayerReliabilityStatusCode = "PayerReliabilityStatusCode",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    BusinessPartner = "BusinessPartner",
    Country = "Country",
    PayerReliabilityStatus = "PayerReliabilityStatus",
    VatStatus = "VatStatus",
    DocumentBusinessPartnerTypeCode = "DocumentBusinessPartnerTypeCode",
    DocumentBusinessPartnerType = "DocumentBusinessPartnerType",
    Employee = "Employee",
}

export interface IDocumentBusinessPartnerTypeEntity extends IEntityBase {
    Code?: DocumentBusinessPartnerTypeCode;
    Name?: string;
}

export enum DocumentBusinessPartnerTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDocumentCbaCategoryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsAssetAcquisition?: boolean;
    TaxImpactCode?: CbaCategoryTaxImpactCode;
    TaxPercentage?: number;
    Category?: ICbaCategoryEntity;
    TaxImpact?: ICbaCategoryTaxImpactEntity;
}

export enum DocumentCbaCategoryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsAssetAcquisition = "IsAssetAcquisition",
    TaxImpactCode = "TaxImpactCode",
    TaxPercentage = "TaxPercentage",
    Category = "Category",
    TaxImpact = "TaxImpact",
}

export interface IDocumentCbaCategoryDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsAssetAcquisition?: boolean;
    TaxImpactCode?: CbaCategoryTaxImpactCode;
    TaxPercentage?: number;
    Category?: ICbaCategoryEntity;
    TaxImpact?: ICbaCategoryTaxImpactEntity;
}

export enum DocumentCbaCategoryDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsAssetAcquisition = "IsAssetAcquisition",
    TaxImpactCode = "TaxImpactCode",
    TaxPercentage = "TaxPercentage",
    Category = "Category",
    TaxImpact = "TaxImpact",
}

export interface IDocumentDeleteLogEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateDocumentVatStatement?: Date;
    DocumentId?: number;
    DocumentTypeCode?: DocumentTypeCode;
    InteractionTypeCode?: InteractionTypeCode;
    NumberOurs?: string;
    VatControlStatementStatusCode?: string;
    VatOssStatementStatusCode?: string;
    VatStatementStatusCode?: string;
    VatViesStatementStatusCode?: string;
    DocumentType?: IDocumentTypeEntity;
    InteractionType?: IInteractionTypeEntity;
    Attachments?: IDocumentAttachmentDeletedEntity[];
}

export enum DocumentDeleteLogEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DocumentId = "DocumentId",
    DocumentTypeCode = "DocumentTypeCode",
    InteractionTypeCode = "InteractionTypeCode",
    NumberOurs = "NumberOurs",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    DocumentType = "DocumentType",
    InteractionType = "InteractionType",
    Attachments = "Attachments",
}

export interface IDocumentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BankPaymentOrderStateCode?: BankPaymentOrderStateCode;
    CalculateVat?: boolean;
    CbaEntryTypeCode?: CbaEntryTypeCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateBankApiPaymentOrder?: Date;
    DateCbaDocument?: Date;
    DateCbaEntry?: Date;
    DateDocumentVatStatement?: Date;
    DateDue?: Date;
    DateIssued?: Date;
    DatePaymentReceived?: Date;
    DateProcessed?: Date;
    DateReceived?: Date;
    DateTaxableSupply?: Date;
    DateVatCancellation?: Date;
    DateVatDeduction?: Date;
    DateVatReapplication?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    Explanation?: string;
    ExternalCorrectedDocumentNumber?: string;
    ExternalCorrectedDocumentTypeCode?: ExternalCorrectedDocumentTypeCode;
    InboxSenderEmail?: string;
    IsTaxDocument?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PaymentMethodCode?: PaymentMethodCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolMatching?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TextBeforeItems?: string;
    TransactionCurrencyCode?: CurrencyCode;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    TransactionAmount?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionAmountDue?: number;
    ExchangeRatePerUnit?: number;
    ExchangeRatePerUnitDateVatDeduction?: number;
    VatCancellationAmount?: number;
    CountByDocumentTypeCodeAndNumberOurs?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionDraftEntity;
    BankAccount?: IDocumentBankAccountDraftEntity;
    BankPaymentOrderState?: IBankPaymentOrderStateEntity;
    BusinessPartner?: IDocumentBusinessPartnerDraftEntity;
    CashBox?: ICashBoxEntity;
    CbaCategory?: IDocumentCbaCategoryDraftEntity;
    CbaEntryType?: ICbaEntryTypeEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentDraftEntity;
    Document?: IDocumentEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    ExternalCorrectedDocumentType?: IExternalCorrectedDocumentTypeEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    GeneratedByRecurringTask?: IRecurringTaskEntity;
    NumberRange?: INumberRangeEntity;
    PaymentMethod?: IPaymentMethodEntity;
    TemplateForRecurringTask?: IRecurringTaskEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionDraftEntity;
    Attachments?: IDocumentAttachmentDraftEntity[];
    DocumentLinks?: IDocumentLinkDraftEntity[];
    Items?: IDocumentItemDraftEntity[];
    Labels?: IDocumentLabelDraftEntity[];
    Locks?: IDocumentLockDraftEntity[];
    CorrectedDocuments?: IDocumentEntity[];
    Chats?: IChatEntity[];
}

export enum DocumentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BankPaymentOrderStateCode = "BankPaymentOrderStateCode",
    CalculateVat = "CalculateVat",
    CbaEntryTypeCode = "CbaEntryTypeCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateBankApiPaymentOrder = "DateBankApiPaymentOrder",
    DateCbaDocument = "DateCbaDocument",
    DateCbaEntry = "DateCbaEntry",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DatePaymentReceived = "DatePaymentReceived",
    DateProcessed = "DateProcessed",
    DateReceived = "DateReceived",
    DateTaxableSupply = "DateTaxableSupply",
    DateVatCancellation = "DateVatCancellation",
    DateVatDeduction = "DateVatDeduction",
    DateVatReapplication = "DateVatReapplication",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    Explanation = "Explanation",
    ExternalCorrectedDocumentNumber = "ExternalCorrectedDocumentNumber",
    ExternalCorrectedDocumentTypeCode = "ExternalCorrectedDocumentTypeCode",
    InboxSenderEmail = "InboxSenderEmail",
    IsTaxDocument = "IsTaxDocument",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PaymentMethodCode = "PaymentMethodCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolMatching = "SymbolMatching",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TextBeforeItems = "TextBeforeItems",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    TransactionAmount = "TransactionAmount",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionAmountDue = "TransactionAmountDue",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    VatCancellationAmount = "VatCancellationAmount",
    CountByDocumentTypeCodeAndNumberOurs = "CountByDocumentTypeCodeAndNumberOurs",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BankPaymentOrderState = "BankPaymentOrderState",
    BusinessPartner = "BusinessPartner",
    CashBox = "CashBox",
    CbaCategory = "CbaCategory",
    CbaEntryType = "CbaEntryType",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    Document = "Document",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    ExternalCorrectedDocumentType = "ExternalCorrectedDocumentType",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    GeneratedByRecurringTask = "GeneratedByRecurringTask",
    NumberRange = "NumberRange",
    PaymentMethod = "PaymentMethod",
    TemplateForRecurringTask = "TemplateForRecurringTask",
    TransactionCurrency = "TransactionCurrency",
    VatClassificationSelection = "VatClassificationSelection",
    Attachments = "Attachments",
    DocumentLinks = "DocumentLinks",
    Items = "Items",
    Labels = "Labels",
    Locks = "Locks",
    CorrectedDocuments = "CorrectedDocuments",
    Chats = "Chats",
}

export interface IDocumentGrantAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    GrantAssignmentTypeCode?: GrantAssignmentTypeCode;
    Grant?: IGrantEntity;
    GrantAssignmentType?: IGrantAssignmentTypeEntity;
    Divisions?: IGrantAssignmentDivisionEntity[];
}

export enum DocumentGrantAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    GrantAssignmentTypeCode = "GrantAssignmentTypeCode",
    Grant = "Grant",
    GrantAssignmentType = "GrantAssignmentType",
    Divisions = "Divisions",
}

export interface IDocumentGrantAssignmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    GrantAssignmentTypeCode?: GrantAssignmentTypeCode;
    Grant?: IGrantEntity;
    GrantAssignmentType?: IGrantAssignmentTypeEntity;
    Divisions?: IGrantAssignmentDivisionDraftEntity[];
}

export enum DocumentGrantAssignmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    GrantAssignmentTypeCode = "GrantAssignmentTypeCode",
    Grant = "Grant",
    GrantAssignmentType = "GrantAssignmentType",
    Divisions = "Divisions",
}

export interface IDocumentImportTypeEntity extends IEntityBase {
    Code?: DocumentImportTypeCode;
    Name?: string;
}

export enum DocumentImportTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDocumentItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    Description?: string;
    Note?: string;
    Order?: number;
    TransactionAmount?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    VatCode?: VatCode;
    AccountAssignmentSelection?: IDocumentItemAccountAssignmentSelectionEntity;
    CbaCategory?: IDocumentItemCbaCategoryEntity;
    DocumentItemDraft?: IDocumentItemDraftEntity;
    GrantAssignment?: IDocumentItemGrantAssignmentEntity;
    GrantClaim?: IGrantClaimEntity;
    LabelSelection?: IDocumentItemLabelSelectionEntity;
    Vat?: IVatEntity;
    VatClassificationSelection?: IDocumentItemVatClassificationSelectionEntity;
    GrantEntries?: IGrantEntryEntity[];
}

export enum DocumentItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    Description = "Description",
    Note = "Note",
    Order = "Order",
    TransactionAmount = "TransactionAmount",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    VatCode = "VatCode",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    CbaCategory = "CbaCategory",
    DocumentItemDraft = "DocumentItemDraft",
    GrantAssignment = "GrantAssignment",
    GrantClaim = "GrantClaim",
    LabelSelection = "LabelSelection",
    Vat = "Vat",
    VatClassificationSelection = "VatClassificationSelection",
    GrantEntries = "GrantEntries",
}

export interface IDocumentItemAccountAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsDebitAccountVatDeductionForced?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
}

export enum DocumentItemAccountAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
}

export interface IDocumentItemAccountAssignmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsDebitAccountVatDeductionForced?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
}

export enum DocumentItemAccountAssignmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
}

export interface IDocumentItemAccountAssignmentSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    AccountAssignment?: IDocumentItemAccountAssignmentEntity;
}

export enum DocumentItemAccountAssignmentSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    AccountAssignment = "AccountAssignment",
}

export interface IDocumentItemAccountAssignmentSelectionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    AccountAssignment?: IDocumentItemAccountAssignmentDraftEntity;
}

export enum DocumentItemAccountAssignmentSelectionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    AccountAssignment = "AccountAssignment",
}

export interface IDocumentItemCbaCategoryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsAssetAcquisition?: boolean;
    TaxImpactCode?: CbaCategoryTaxImpactCode;
    TaxPercentage?: number;
    Category?: ICbaCategoryEntity;
    TaxImpact?: ICbaCategoryTaxImpactEntity;
}

export enum DocumentItemCbaCategoryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsAssetAcquisition = "IsAssetAcquisition",
    TaxImpactCode = "TaxImpactCode",
    TaxPercentage = "TaxPercentage",
    Category = "Category",
    TaxImpact = "TaxImpact",
}

export interface IDocumentItemCbaCategoryDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsAssetAcquisition?: boolean;
    TaxImpactCode?: CbaCategoryTaxImpactCode;
    TaxPercentage?: number;
    Category?: ICbaCategoryEntity;
    TaxImpact?: ICbaCategoryTaxImpactEntity;
}

export enum DocumentItemCbaCategoryDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsAssetAcquisition = "IsAssetAcquisition",
    TaxImpactCode = "TaxImpactCode",
    TaxPercentage = "TaxPercentage",
    Category = "Category",
    TaxImpact = "TaxImpact",
}

export interface IDocumentItemDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    Note?: string;
    Order?: number;
    TransactionCurrencyCode?: CurrencyCode;
    UnitOfMeasureCode?: UnitOfMeasureCode;
    VatCode?: VatCode;
    Quantity?: number;
    UnitPrice?: number;
    UnitPriceNet?: number;
    UnitPriceVat?: number;
    TransactionUnitPrice?: number;
    TransactionUnitPriceNet?: number;
    TransactionUnitPriceVat?: number;
    DiscountPercent?: number;
    Discount?: number;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    TransactionAmount?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    AccountAssignmentSelection?: IDocumentItemAccountAssignmentSelectionDraftEntity;
    CbaCategory?: IDocumentItemCbaCategoryDraftEntity;
    DocumentItem?: IDocumentItemEntity;
    GrantAssignment?: IDocumentItemGrantAssignmentDraftEntity;
    LabelSelection?: IDocumentItemLabelSelectionDraftEntity;
    LinkedDocument?: IDocumentEntity;
    TransactionCurrency?: ICurrencyEntity;
    UnitOfMeasure?: IUnitOfMeasureEntity;
    Vat?: IVatEntity;
    VatClassificationSelection?: IDocumentItemVatClassificationSelectionDraftEntity;
}

export enum DocumentItemDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    Note = "Note",
    Order = "Order",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    UnitOfMeasureCode = "UnitOfMeasureCode",
    VatCode = "VatCode",
    Quantity = "Quantity",
    UnitPrice = "UnitPrice",
    UnitPriceNet = "UnitPriceNet",
    UnitPriceVat = "UnitPriceVat",
    TransactionUnitPrice = "TransactionUnitPrice",
    TransactionUnitPriceNet = "TransactionUnitPriceNet",
    TransactionUnitPriceVat = "TransactionUnitPriceVat",
    DiscountPercent = "DiscountPercent",
    Discount = "Discount",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    TransactionAmount = "TransactionAmount",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    CbaCategory = "CbaCategory",
    DocumentItem = "DocumentItem",
    GrantAssignment = "GrantAssignment",
    LabelSelection = "LabelSelection",
    LinkedDocument = "LinkedDocument",
    TransactionCurrency = "TransactionCurrency",
    UnitOfMeasure = "UnitOfMeasure",
    Vat = "Vat",
    VatClassificationSelection = "VatClassificationSelection",
}

export interface IDocumentItemGrantAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    GrantAssignmentTypeCode?: GrantAssignmentTypeCode;
    Grant?: IGrantEntity;
    GrantAssignmentType?: IGrantAssignmentTypeEntity;
    Divisions?: IGrantAssignmentDivisionEntity[];
}

export enum DocumentItemGrantAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    GrantAssignmentTypeCode = "GrantAssignmentTypeCode",
    Grant = "Grant",
    GrantAssignmentType = "GrantAssignmentType",
    Divisions = "Divisions",
}

export interface IDocumentItemGrantAssignmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    GrantAssignmentTypeCode?: GrantAssignmentTypeCode;
    Grant?: IGrantEntity;
    GrantAssignmentType?: IGrantAssignmentTypeEntity;
    Divisions?: IGrantAssignmentDivisionDraftEntity[];
}

export enum DocumentItemGrantAssignmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    GrantAssignmentTypeCode = "GrantAssignmentTypeCode",
    Grant = "Grant",
    GrantAssignmentType = "GrantAssignmentType",
    Divisions = "Divisions",
}

export interface IDocumentItemLabelSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    Labels?: IItemLabelEntity[];
}

export enum DocumentItemLabelSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    Labels = "Labels",
}

export interface IDocumentItemLabelSelectionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    Labels?: IItemLabelDraftEntity[];
}

export enum DocumentItemLabelSelectionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    Labels = "Labels",
}

export interface IDocumentItemLinkableToGrantViewEntity extends IEntityBase {
    Id?: number;
    Amount?: number;
    CreditAccount?: string;
    CurrencyCode?: CurrencyCode;
    DateCreated?: Date;
    DebitAccount?: string;
    Description?: string;
    DocumentTypeCode?: DocumentTypeCode;
    GrantClaimTypeCode?: GrantClaimTypeCode;
    Note?: string;
    NumberOurs?: string;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
    DocumentType?: IDocumentTypeEntity;
    GrantClaim?: IGrantClaimEntity;
    GrantClaimType?: IGrantClaimTypeEntity;
}

export enum DocumentItemLinkableToGrantViewEntity {
    Id = "Id",
    Amount = "Amount",
    CreditAccount = "CreditAccount",
    CurrencyCode = "CurrencyCode",
    DateCreated = "DateCreated",
    DebitAccount = "DebitAccount",
    Description = "Description",
    DocumentTypeCode = "DocumentTypeCode",
    GrantClaimTypeCode = "GrantClaimTypeCode",
    Note = "Note",
    NumberOurs = "NumberOurs",
    Currency = "Currency",
    Document = "Document",
    DocumentItem = "DocumentItem",
    DocumentType = "DocumentType",
    GrantClaim = "GrantClaim",
    GrantClaimType = "GrantClaimType",
}

export interface IDocumentItemTypeEntity extends IEntityBase {
    Code?: DocumentItemTypeCode;
    Name?: string;
}

export enum DocumentItemTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDocumentItemVatClassificationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CountryClassificationCode?: CountryClassificationCode;
    IsInAutomatedVatInclusionMode?: boolean;
    IsVatRegistered?: boolean;
    Name?: string;
    Note?: string;
    PayableReceivableTypeCode?: PayableReceivableTypeCode;
    VatControlStatementSectionCode?: VatControlStatementSectionCode;
    VatDeductionTypeCode?: VatDeductionTypeCode;
    VatOssCode?: VatOssCode;
    VatReverseChargeCode?: VatReverseChargeCode;
    VatStatementSectionCode?: VatStatementSectionCode;
    VatViesCode?: VatViesCode;
    VatProportionalDeduction?: number;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CountryClassification?: ICountryClassificationEntity;
    NonTaxAccount?: IAccountEntity;
    PayableReceivableType?: IPayableReceivableTypeEntity;
    VatControlStatementSection?: IVatControlStatementSectionEntity;
    VatDeductionType?: IVatDeductionTypeEntity;
    VatOss?: IVatOssEntity;
    VatReverseCharge?: IVatReverseChargeEntity;
    VatStatementSection?: IVatStatementSectionEntity;
    VatVies?: IVatViesEntity;
}

export enum DocumentItemVatClassificationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CountryClassificationCode = "CountryClassificationCode",
    IsInAutomatedVatInclusionMode = "IsInAutomatedVatInclusionMode",
    IsVatRegistered = "IsVatRegistered",
    Name = "Name",
    Note = "Note",
    PayableReceivableTypeCode = "PayableReceivableTypeCode",
    VatControlStatementSectionCode = "VatControlStatementSectionCode",
    VatDeductionTypeCode = "VatDeductionTypeCode",
    VatOssCode = "VatOssCode",
    VatReverseChargeCode = "VatReverseChargeCode",
    VatStatementSectionCode = "VatStatementSectionCode",
    VatViesCode = "VatViesCode",
    VatProportionalDeduction = "VatProportionalDeduction",
    ChartOfAccounts = "ChartOfAccounts",
    CountryClassification = "CountryClassification",
    NonTaxAccount = "NonTaxAccount",
    PayableReceivableType = "PayableReceivableType",
    VatControlStatementSection = "VatControlStatementSection",
    VatDeductionType = "VatDeductionType",
    VatOss = "VatOss",
    VatReverseCharge = "VatReverseCharge",
    VatStatementSection = "VatStatementSection",
    VatVies = "VatVies",
}

export interface IDocumentItemVatClassificationDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CountryClassificationCode?: CountryClassificationCode;
    IsInAutomatedVatInclusionMode?: boolean;
    IsVatRegistered?: boolean;
    Name?: string;
    Note?: string;
    PayableReceivableTypeCode?: PayableReceivableTypeCode;
    VatControlStatementSectionCode?: VatControlStatementSectionCode;
    VatDeductionTypeCode?: VatDeductionTypeCode;
    VatOssCode?: VatOssCode;
    VatReverseChargeCode?: VatReverseChargeCode;
    VatStatementSectionCode?: VatStatementSectionCode;
    VatViesCode?: VatViesCode;
    VatProportionalDeduction?: number;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CountryClassification?: ICountryClassificationEntity;
    NonTaxAccount?: IAccountEntity;
    PayableReceivableType?: IPayableReceivableTypeEntity;
    VatControlStatementSection?: IVatControlStatementSectionEntity;
    VatDeductionType?: IVatDeductionTypeEntity;
    VatOss?: IVatOssEntity;
    VatReverseCharge?: IVatReverseChargeEntity;
    VatStatementSection?: IVatStatementSectionEntity;
    VatVies?: IVatViesEntity;
}

export enum DocumentItemVatClassificationDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CountryClassificationCode = "CountryClassificationCode",
    IsInAutomatedVatInclusionMode = "IsInAutomatedVatInclusionMode",
    IsVatRegistered = "IsVatRegistered",
    Name = "Name",
    Note = "Note",
    PayableReceivableTypeCode = "PayableReceivableTypeCode",
    VatControlStatementSectionCode = "VatControlStatementSectionCode",
    VatDeductionTypeCode = "VatDeductionTypeCode",
    VatOssCode = "VatOssCode",
    VatReverseChargeCode = "VatReverseChargeCode",
    VatStatementSectionCode = "VatStatementSectionCode",
    VatViesCode = "VatViesCode",
    VatProportionalDeduction = "VatProportionalDeduction",
    ChartOfAccounts = "ChartOfAccounts",
    CountryClassification = "CountryClassification",
    NonTaxAccount = "NonTaxAccount",
    PayableReceivableType = "PayableReceivableType",
    VatControlStatementSection = "VatControlStatementSection",
    VatDeductionType = "VatDeductionType",
    VatOss = "VatOss",
    VatReverseCharge = "VatReverseCharge",
    VatStatementSection = "VatStatementSection",
    VatVies = "VatVies",
}

export interface IDocumentItemVatClassificationSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    VatClassification?: IDocumentItemVatClassificationEntity;
}

export enum DocumentItemVatClassificationSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    VatClassification = "VatClassification",
}

export interface IDocumentItemVatClassificationSelectionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    VatClassification?: IDocumentItemVatClassificationDraftEntity;
}

export enum DocumentItemVatClassificationSelectionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    VatClassification = "VatClassification",
}

export interface IDocumentItemViewEntity extends IEntityBase {
    Id?: number;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    Description?: string;
    Note?: string;
    Order?: number;
    TransactionAmount?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    UnitOfMeasureCode?: UnitOfMeasureCode;
    VatCode?: VatCode;
    Quantity?: number;
    UnitPrice?: number;
    UnitPriceNet?: number;
    UnitPriceVat?: number;
    TransactionUnitPrice?: number;
    TransactionUnitPriceNet?: number;
    TransactionUnitPriceVat?: number;
    DiscountPercent?: number;
    Discount?: number;
    AccountAssignmentSelection?: IDocumentItemAccountAssignmentSelectionEntity;
    CbaCategory?: IDocumentItemCbaCategoryEntity;
    DocumentItemDraft?: IDocumentItemDraftEntity;
    GrantAssignment?: IDocumentItemGrantAssignmentEntity;
    GrantClaim?: IGrantClaimEntity;
    LabelSelection?: IDocumentItemLabelSelectionEntity;
    LinkedDocument?: IDocumentEntity;
    TransactionCurrency?: ICurrencyEntity;
    UnitOfMeasure?: IUnitOfMeasureEntity;
    Vat?: IVatEntity;
    VatClassificationSelection?: IDocumentItemVatClassificationSelectionEntity;
    GrantEntries?: IGrantEntryEntity[];
}

export enum DocumentItemViewEntity {
    Id = "Id",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    Description = "Description",
    Note = "Note",
    Order = "Order",
    TransactionAmount = "TransactionAmount",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    UnitOfMeasureCode = "UnitOfMeasureCode",
    VatCode = "VatCode",
    Quantity = "Quantity",
    UnitPrice = "UnitPrice",
    UnitPriceNet = "UnitPriceNet",
    UnitPriceVat = "UnitPriceVat",
    TransactionUnitPrice = "TransactionUnitPrice",
    TransactionUnitPriceNet = "TransactionUnitPriceNet",
    TransactionUnitPriceVat = "TransactionUnitPriceVat",
    DiscountPercent = "DiscountPercent",
    Discount = "Discount",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    CbaCategory = "CbaCategory",
    DocumentItemDraft = "DocumentItemDraft",
    GrantAssignment = "GrantAssignment",
    GrantClaim = "GrantClaim",
    LabelSelection = "LabelSelection",
    LinkedDocument = "LinkedDocument",
    TransactionCurrency = "TransactionCurrency",
    UnitOfMeasure = "UnitOfMeasure",
    Vat = "Vat",
    VatClassificationSelection = "VatClassificationSelection",
    GrantEntries = "GrantEntries",
}

export interface IDocumentLabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum DocumentLabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IDocumentLabelDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum DocumentLabelDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IDocumentLinkEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: DocumentLinkTypeCode;
    Amount?: number;
    TransactionAmount?: number;
    TargetDocument?: IDocumentEntity;
    TargetDocumentItem?: IDocumentItemEntity;
    Type?: IDocumentLinkTypeEntity;
}

export enum DocumentLinkEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    TargetDocument = "TargetDocument",
    TargetDocumentItem = "TargetDocumentItem",
    Type = "Type",
}

export interface IDocumentLinkClearingTypeEntity extends IEntityBase {
    Code?: DocumentLinkClearingTypeCode;
    Name?: string;
}

export enum DocumentLinkClearingTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDocumentLinkDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: DocumentLinkTypeCode;
    Amount?: number;
    TransactionAmount?: number;
    TargetDocument?: IDocumentEntity;
    TargetDocumentItem?: IDocumentItemEntity;
    Type?: IDocumentLinkTypeEntity;
}

export enum DocumentLinkDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    TargetDocument = "TargetDocument",
    TargetDocumentItem = "TargetDocumentItem",
    Type = "Type",
}

export interface IDocumentLinkTypeEntity extends IEntityBase {
    Code?: DocumentLinkTypeCode;
    DocumentLinkClearingTypeCode?: DocumentLinkClearingTypeCode;
    Name?: string;
    DocumentLinkClearingType?: IDocumentLinkClearingTypeEntity;
}

export enum DocumentLinkTypeEntity {
    Code = "Code",
    DocumentLinkClearingTypeCode = "DocumentLinkClearingTypeCode",
    Name = "Name",
    DocumentLinkClearingType = "DocumentLinkClearingType",
}

export interface IDocumentLockEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: LockTypeCode;
    Type?: ILockTypeEntity;
}

export enum DocumentLockEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
}

export interface IDocumentLockDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: LockTypeCode;
    Type?: ILockTypeEntity;
}

export enum DocumentLockDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
}

export interface IDocumentMinorAssetItemEntity extends IEntityBase {
    NotId?: number;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
    MinorAsset?: IMinorAssetEntity;
    MinorAssetItem?: IMinorAssetItemEntity;
}

export enum DocumentMinorAssetItemEntity {
    NotId = "NotId",
    Document = "Document",
    DocumentItem = "DocumentItem",
    MinorAsset = "MinorAsset",
    MinorAssetItem = "MinorAssetItem",
}

export interface IDocumentSourceTypeEntity extends IEntityBase {
    Code?: DocumentSourceTypeCode;
    Name?: string;
}

export enum DocumentSourceTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDocumentStatusEntity extends IEntityBase {
    Code?: DocumentStatusCode;
    Name?: string;
}

export enum DocumentStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IDocumentTypeEntity extends IEntityBase {
    Code?: DocumentTypeCode;
    Name?: string;
    PayableReceivableTypeCode?: PayableReceivableTypeCode;
    PayableReceivableType?: IPayableReceivableTypeEntity;
}

export enum DocumentTypeEntity {
    Code = "Code",
    Name = "Name",
    PayableReceivableTypeCode = "PayableReceivableTypeCode",
    PayableReceivableType = "PayableReceivableType",
}

export interface IDocumentVatClassificationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CountryClassificationCode?: CountryClassificationCode;
    IsInAutomatedVatInclusionMode?: boolean;
    IsVatRegistered?: boolean;
    Name?: string;
    Note?: string;
    PayableReceivableTypeCode?: PayableReceivableTypeCode;
    VatControlStatementSectionCode?: VatControlStatementSectionCode;
    VatDeductionTypeCode?: VatDeductionTypeCode;
    VatOssCode?: VatOssCode;
    VatReverseChargeCode?: VatReverseChargeCode;
    VatStatementSectionCode?: VatStatementSectionCode;
    VatViesCode?: VatViesCode;
    VatProportionalDeduction?: number;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CountryClassification?: ICountryClassificationEntity;
    NonTaxAccount?: IAccountEntity;
    PayableReceivableType?: IPayableReceivableTypeEntity;
    VatControlStatementSection?: IVatControlStatementSectionEntity;
    VatDeductionType?: IVatDeductionTypeEntity;
    VatOss?: IVatOssEntity;
    VatReverseCharge?: IVatReverseChargeEntity;
    VatStatementSection?: IVatStatementSectionEntity;
    VatVies?: IVatViesEntity;
}

export enum DocumentVatClassificationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CountryClassificationCode = "CountryClassificationCode",
    IsInAutomatedVatInclusionMode = "IsInAutomatedVatInclusionMode",
    IsVatRegistered = "IsVatRegistered",
    Name = "Name",
    Note = "Note",
    PayableReceivableTypeCode = "PayableReceivableTypeCode",
    VatControlStatementSectionCode = "VatControlStatementSectionCode",
    VatDeductionTypeCode = "VatDeductionTypeCode",
    VatOssCode = "VatOssCode",
    VatReverseChargeCode = "VatReverseChargeCode",
    VatStatementSectionCode = "VatStatementSectionCode",
    VatViesCode = "VatViesCode",
    VatProportionalDeduction = "VatProportionalDeduction",
    ChartOfAccounts = "ChartOfAccounts",
    CountryClassification = "CountryClassification",
    NonTaxAccount = "NonTaxAccount",
    PayableReceivableType = "PayableReceivableType",
    VatControlStatementSection = "VatControlStatementSection",
    VatDeductionType = "VatDeductionType",
    VatOss = "VatOss",
    VatReverseCharge = "VatReverseCharge",
    VatStatementSection = "VatStatementSection",
    VatVies = "VatVies",
}

export interface IDocumentVatClassificationDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CountryClassificationCode?: CountryClassificationCode;
    IsInAutomatedVatInclusionMode?: boolean;
    IsVatRegistered?: boolean;
    Name?: string;
    Note?: string;
    PayableReceivableTypeCode?: PayableReceivableTypeCode;
    VatControlStatementSectionCode?: VatControlStatementSectionCode;
    VatDeductionTypeCode?: VatDeductionTypeCode;
    VatOssCode?: VatOssCode;
    VatReverseChargeCode?: VatReverseChargeCode;
    VatStatementSectionCode?: VatStatementSectionCode;
    VatViesCode?: VatViesCode;
    VatProportionalDeduction?: number;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CountryClassification?: ICountryClassificationEntity;
    NonTaxAccount?: IAccountEntity;
    PayableReceivableType?: IPayableReceivableTypeEntity;
    VatControlStatementSection?: IVatControlStatementSectionEntity;
    VatDeductionType?: IVatDeductionTypeEntity;
    VatOss?: IVatOssEntity;
    VatReverseCharge?: IVatReverseChargeEntity;
    VatStatementSection?: IVatStatementSectionEntity;
    VatVies?: IVatViesEntity;
}

export enum DocumentVatClassificationDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CountryClassificationCode = "CountryClassificationCode",
    IsInAutomatedVatInclusionMode = "IsInAutomatedVatInclusionMode",
    IsVatRegistered = "IsVatRegistered",
    Name = "Name",
    Note = "Note",
    PayableReceivableTypeCode = "PayableReceivableTypeCode",
    VatControlStatementSectionCode = "VatControlStatementSectionCode",
    VatDeductionTypeCode = "VatDeductionTypeCode",
    VatOssCode = "VatOssCode",
    VatReverseChargeCode = "VatReverseChargeCode",
    VatStatementSectionCode = "VatStatementSectionCode",
    VatViesCode = "VatViesCode",
    VatProportionalDeduction = "VatProportionalDeduction",
    ChartOfAccounts = "ChartOfAccounts",
    CountryClassification = "CountryClassification",
    NonTaxAccount = "NonTaxAccount",
    PayableReceivableType = "PayableReceivableType",
    VatControlStatementSection = "VatControlStatementSection",
    VatDeductionType = "VatDeductionType",
    VatOss = "VatOss",
    VatReverseCharge = "VatReverseCharge",
    VatStatementSection = "VatStatementSection",
    VatVies = "VatVies",
}

export interface IDocumentVatClassificationSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    VatClassification?: IDocumentVatClassificationEntity;
}

export enum DocumentVatClassificationSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    VatClassification = "VatClassification",
}

export interface IDocumentVatClassificationSelectionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    VatClassification?: IDocumentVatClassificationDraftEntity;
}

export enum DocumentVatClassificationSelectionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    VatClassification = "VatClassification",
}

export interface IElectronicSubmissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AreVatDocumentsCreated?: boolean;
    CorrectionReason?: string;
    CurrencyCode?: CurrencyCode;
    DateCorrectionDiscovered?: Date;
    DatePeriodEnd?: Date;
    DatePeriodStart?: Date;
    ElectronicSubmissionSubmissionTypeCode?: ElectronicSubmissionSubmissionTypeCode;
    ElectronicSubmissionTypeCode?: ElectronicSubmissionTypeCode;
    ReferenceNumberOfNotice?: string;
    DateSubmission?: Date;
    VatLiability?: number;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    ElectronicSubmissionSubmissionType?: IElectronicSubmissionSubmissionTypeEntity;
    ElectronicSubmissionType?: IElectronicSubmissionTypeEntity;
    FileMetadata?: IFileMetadataEntity;
    VatClearingDocument?: IInternalDocumentEntity;
    VatStatementDocument?: IDocumentEntity;
    Documents?: IDocumentEntity[];
}

export enum ElectronicSubmissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AreVatDocumentsCreated = "AreVatDocumentsCreated",
    CorrectionReason = "CorrectionReason",
    CurrencyCode = "CurrencyCode",
    DateCorrectionDiscovered = "DateCorrectionDiscovered",
    DatePeriodEnd = "DatePeriodEnd",
    DatePeriodStart = "DatePeriodStart",
    ElectronicSubmissionSubmissionTypeCode = "ElectronicSubmissionSubmissionTypeCode",
    ElectronicSubmissionTypeCode = "ElectronicSubmissionTypeCode",
    ReferenceNumberOfNotice = "ReferenceNumberOfNotice",
    DateSubmission = "DateSubmission",
    VatLiability = "VatLiability",
    Company = "Company",
    Currency = "Currency",
    ElectronicSubmissionSubmissionType = "ElectronicSubmissionSubmissionType",
    ElectronicSubmissionType = "ElectronicSubmissionType",
    FileMetadata = "FileMetadata",
    VatClearingDocument = "VatClearingDocument",
    VatStatementDocument = "VatStatementDocument",
    Documents = "Documents",
}

export interface IElectronicSubmissionPeriodWithDeletedDocumentEntity extends IEntityBase {
    Id?: number;
    DatePeriodEnd?: Date;
    DatePeriodStart?: Date;
    ElectronicSubmissionTypeCode?: string;
    Company?: ICompanyEntity;
}

export enum ElectronicSubmissionPeriodWithDeletedDocumentEntity {
    Id = "Id",
    DatePeriodEnd = "DatePeriodEnd",
    DatePeriodStart = "DatePeriodStart",
    ElectronicSubmissionTypeCode = "ElectronicSubmissionTypeCode",
    Company = "Company",
}

export interface IElectronicSubmissionSubmissionTypeEntity extends IEntityBase {
    Code?: ElectronicSubmissionSubmissionTypeCode;
    Name?: string;
}

export enum ElectronicSubmissionSubmissionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IElectronicSubmissionTypeEntity extends IEntityBase {
    Code?: ElectronicSubmissionTypeCode;
    Name?: string;
}

export enum ElectronicSubmissionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IEmploymentEarlyTerminationReasonEntity extends IEntityBase {
    Code?: EmploymentEarlyTerminationReasonCode;
    MpsvCode?: string;
    Name?: string;
}

export enum EmploymentEarlyTerminationReasonEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IEmploymentRelationshipTerminationReasonEntity extends IEntityBase {
    Code?: EmploymentRelationshipTerminationReasonCode;
    MpsvCode?: string;
    Name?: string;
}

export enum EmploymentRelationshipTerminationReasonEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IEntityEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
}

export enum EntityEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
}

export interface IEntityAccountAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsDebitAccountVatDeductionForced?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
}

export enum EntityAccountAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
}

export interface IEntityAccountAssignmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsDebitAccountVatDeductionForced?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
}

export enum EntityAccountAssignmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
}

export interface IEntityAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum EntityAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IEntityBankAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
    Country?: ICountryEntity;
}

export enum EntityBankAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    Country = "Country",
}

export interface IEntityBankAccountDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
    Country?: ICountryEntity;
}

export enum EntityBankAccountDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    Country = "Country",
}

export interface IEntityBusinessPartnerEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    LegalNumber?: string;
    Name?: string;
    PayerReliabilityStatusCode?: PayerReliabilityStatusCode;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    BusinessPartner?: IBusinessPartnerEntity;
    Country?: ICountryEntity;
    PayerReliabilityStatus?: IPayerReliabilityStatusEntity;
    VatStatus?: IVatStatusEntity;
}

export enum EntityBusinessPartnerEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PayerReliabilityStatusCode = "PayerReliabilityStatusCode",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    BusinessPartner = "BusinessPartner",
    Country = "Country",
    PayerReliabilityStatus = "PayerReliabilityStatus",
    VatStatus = "VatStatus",
}

export interface IEntityBusinessPartnerDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    LegalNumber?: string;
    Name?: string;
    PayerReliabilityStatusCode?: PayerReliabilityStatusCode;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    BusinessPartner?: IBusinessPartnerEntity;
    Country?: ICountryEntity;
    PayerReliabilityStatus?: IPayerReliabilityStatusEntity;
    VatStatus?: IVatStatusEntity;
}

export enum EntityBusinessPartnerDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PayerReliabilityStatusCode = "PayerReliabilityStatusCode",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    BusinessPartner = "BusinessPartner",
    Country = "Country",
    PayerReliabilityStatus = "PayerReliabilityStatus",
    VatStatus = "VatStatus",
}

export interface IEntityCbaCategoryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsAssetAcquisition?: boolean;
    TaxImpactCode?: CbaCategoryTaxImpactCode;
    TaxPercentage?: number;
    Category?: ICbaCategoryEntity;
    TaxImpact?: ICbaCategoryTaxImpactEntity;
}

export enum EntityCbaCategoryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsAssetAcquisition = "IsAssetAcquisition",
    TaxImpactCode = "TaxImpactCode",
    TaxPercentage = "TaxPercentage",
    Category = "Category",
    TaxImpact = "TaxImpact",
}

export interface IEntityCbaCategoryDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsAssetAcquisition?: boolean;
    TaxImpactCode?: CbaCategoryTaxImpactCode;
    TaxPercentage?: number;
    Category?: ICbaCategoryEntity;
    TaxImpact?: ICbaCategoryTaxImpactEntity;
}

export enum EntityCbaCategoryDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsAssetAcquisition = "IsAssetAcquisition",
    TaxImpactCode = "TaxImpactCode",
    TaxPercentage = "TaxPercentage",
    Category = "Category",
    TaxImpact = "TaxImpact",
}

export interface IEntityCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LegalName?: string;
    LegalNumber?: string;
    Company?: ICompanyEntity;
}

export enum EntityCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Company = "Company",
}

export interface IEntityGrantAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    GrantAssignmentTypeCode?: GrantAssignmentTypeCode;
    Grant?: IGrantEntity;
    GrantAssignmentType?: IGrantAssignmentTypeEntity;
    Divisions?: IGrantAssignmentDivisionEntity[];
}

export enum EntityGrantAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    GrantAssignmentTypeCode = "GrantAssignmentTypeCode",
    Grant = "Grant",
    GrantAssignmentType = "GrantAssignmentType",
    Divisions = "Divisions",
}

export interface IEntityGrantAssignmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    GrantAssignmentTypeCode?: GrantAssignmentTypeCode;
    Grant?: IGrantEntity;
    GrantAssignmentType?: IGrantAssignmentTypeEntity;
    Divisions?: IGrantAssignmentDivisionDraftEntity[];
}

export enum EntityGrantAssignmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    GrantAssignmentTypeCode = "GrantAssignmentTypeCode",
    Grant = "Grant",
    GrantAssignmentType = "GrantAssignmentType",
    Divisions = "Divisions",
}

export interface IEntityLabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum EntityLabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IEntityLockEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: LockTypeCode;
    Type?: ILockTypeEntity;
}

export enum EntityLockEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
}

export interface IEntityPermissionLevelEntity extends IEntityBase {
    Code?: EntityPermissionLevelCode;
    Name?: string;
}

export enum EntityPermissionLevelEntity {
    Code = "Code",
    Name = "Name",
}

export interface IEntityTypeEntity extends IEntityBase {
    Code?: string;
    Name?: string;
}

export enum EntityTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IEntityVatClassificationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CountryClassificationCode?: CountryClassificationCode;
    IsInAutomatedVatInclusionMode?: boolean;
    IsVatRegistered?: boolean;
    Name?: string;
    Note?: string;
    PayableReceivableTypeCode?: PayableReceivableTypeCode;
    VatControlStatementSectionCode?: VatControlStatementSectionCode;
    VatDeductionTypeCode?: VatDeductionTypeCode;
    VatOssCode?: VatOssCode;
    VatReverseChargeCode?: VatReverseChargeCode;
    VatStatementSectionCode?: VatStatementSectionCode;
    VatViesCode?: VatViesCode;
    VatProportionalDeduction?: number;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CountryClassification?: ICountryClassificationEntity;
    NonTaxAccount?: IAccountEntity;
    PayableReceivableType?: IPayableReceivableTypeEntity;
    VatControlStatementSection?: IVatControlStatementSectionEntity;
    VatDeductionType?: IVatDeductionTypeEntity;
    VatOss?: IVatOssEntity;
    VatReverseCharge?: IVatReverseChargeEntity;
    VatStatementSection?: IVatStatementSectionEntity;
    VatVies?: IVatViesEntity;
}

export enum EntityVatClassificationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CountryClassificationCode = "CountryClassificationCode",
    IsInAutomatedVatInclusionMode = "IsInAutomatedVatInclusionMode",
    IsVatRegistered = "IsVatRegistered",
    Name = "Name",
    Note = "Note",
    PayableReceivableTypeCode = "PayableReceivableTypeCode",
    VatControlStatementSectionCode = "VatControlStatementSectionCode",
    VatDeductionTypeCode = "VatDeductionTypeCode",
    VatOssCode = "VatOssCode",
    VatReverseChargeCode = "VatReverseChargeCode",
    VatStatementSectionCode = "VatStatementSectionCode",
    VatViesCode = "VatViesCode",
    VatProportionalDeduction = "VatProportionalDeduction",
    ChartOfAccounts = "ChartOfAccounts",
    CountryClassification = "CountryClassification",
    NonTaxAccount = "NonTaxAccount",
    PayableReceivableType = "PayableReceivableType",
    VatControlStatementSection = "VatControlStatementSection",
    VatDeductionType = "VatDeductionType",
    VatOss = "VatOss",
    VatReverseCharge = "VatReverseCharge",
    VatStatementSection = "VatStatementSection",
    VatVies = "VatVies",
}

export interface IEntityVatClassificationDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CountryClassificationCode?: CountryClassificationCode;
    IsInAutomatedVatInclusionMode?: boolean;
    IsVatRegistered?: boolean;
    Name?: string;
    Note?: string;
    PayableReceivableTypeCode?: PayableReceivableTypeCode;
    VatControlStatementSectionCode?: VatControlStatementSectionCode;
    VatDeductionTypeCode?: VatDeductionTypeCode;
    VatOssCode?: VatOssCode;
    VatReverseChargeCode?: VatReverseChargeCode;
    VatStatementSectionCode?: VatStatementSectionCode;
    VatViesCode?: VatViesCode;
    VatProportionalDeduction?: number;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CountryClassification?: ICountryClassificationEntity;
    NonTaxAccount?: IAccountEntity;
    PayableReceivableType?: IPayableReceivableTypeEntity;
    VatControlStatementSection?: IVatControlStatementSectionEntity;
    VatDeductionType?: IVatDeductionTypeEntity;
    VatOss?: IVatOssEntity;
    VatReverseCharge?: IVatReverseChargeEntity;
    VatStatementSection?: IVatStatementSectionEntity;
    VatVies?: IVatViesEntity;
}

export enum EntityVatClassificationDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CountryClassificationCode = "CountryClassificationCode",
    IsInAutomatedVatInclusionMode = "IsInAutomatedVatInclusionMode",
    IsVatRegistered = "IsVatRegistered",
    Name = "Name",
    Note = "Note",
    PayableReceivableTypeCode = "PayableReceivableTypeCode",
    VatControlStatementSectionCode = "VatControlStatementSectionCode",
    VatDeductionTypeCode = "VatDeductionTypeCode",
    VatOssCode = "VatOssCode",
    VatReverseChargeCode = "VatReverseChargeCode",
    VatStatementSectionCode = "VatStatementSectionCode",
    VatViesCode = "VatViesCode",
    VatProportionalDeduction = "VatProportionalDeduction",
    ChartOfAccounts = "ChartOfAccounts",
    CountryClassification = "CountryClassification",
    NonTaxAccount = "NonTaxAccount",
    PayableReceivableType = "PayableReceivableType",
    VatControlStatementSection = "VatControlStatementSection",
    VatDeductionType = "VatDeductionType",
    VatOss = "VatOss",
    VatReverseCharge = "VatReverseCharge",
    VatStatementSection = "VatStatementSection",
    VatVies = "VatVies",
}

export interface IEvalaZoomEntity extends IEntityBase {
    Code?: EvalaZoomCode;
    Name?: string;
}

export enum EvalaZoomEntity {
    Code = "Code",
    Name = "Name",
}

export interface IExchangeRateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CountryCode?: CountryOrUnionCode;
    DateIssued?: Date;
    ExchangeRateDirect?: number;
    ExchangeRateIndirect?: number;
    ExchangeRatePerUnit?: number;
    FromCurrencyCode?: CurrencyCode;
    IsIssuedDaily?: boolean;
    ToCurrencyCode?: CurrencyCode;
    Country?: ICountryOrUnionEntity;
    FromCurrency?: ICurrencyEntity;
    ToCurrency?: ICurrencyEntity;
}

export enum ExchangeRateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CountryCode = "CountryCode",
    DateIssued = "DateIssued",
    ExchangeRateDirect = "ExchangeRateDirect",
    ExchangeRateIndirect = "ExchangeRateIndirect",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    FromCurrencyCode = "FromCurrencyCode",
    IsIssuedDaily = "IsIssuedDaily",
    ToCurrencyCode = "ToCurrencyCode",
    Country = "Country",
    FromCurrency = "FromCurrency",
    ToCurrency = "ToCurrency",
}

export interface IExchangeRateTypeEntity extends IEntityBase {
    Code?: ExchangeRateTypeCode;
    Name?: string;
}

export enum ExchangeRateTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IExpenseTaxRateEntity extends IEntityBase {
    Code?: ExpenseTaxRateCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    PercentageRate?: number;
    Country?: ICountryEntity;
}

export enum ExpenseTaxRateEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    PercentageRate = "PercentageRate",
    Country = "Country",
}

export interface IExportLogEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IncludeAttachments?: boolean;
    RangeCode?: ExportRangeCode;
    ResultTypeCode?: ExportResultTypeCode;
    TypeCode?: ExportTypeCode;
    Company?: ICompanyEntity;
    Range?: IExportRangeEntity;
    ResultType?: IExportResultTypeEntity;
    Type?: IExportTypeEntity;
}

export enum ExportLogEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IncludeAttachments = "IncludeAttachments",
    RangeCode = "RangeCode",
    ResultTypeCode = "ResultTypeCode",
    TypeCode = "TypeCode",
    Company = "Company",
    Range = "Range",
    ResultType = "ResultType",
    Type = "Type",
}

export interface IExportRangeEntity extends IEntityBase {
    Code?: ExportRangeCode;
    Name?: string;
}

export enum ExportRangeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IExportResultTypeEntity extends IEntityBase {
    Code?: ExportResultTypeCode;
    Name?: string;
}

export enum ExportResultTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IExportTypeEntity extends IEntityBase {
    Code?: ExportTypeCode;
    Name?: string;
}

export enum ExportTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IExternalCorrectedDocumentTypeEntity extends IEntityBase {
    Code?: ExternalCorrectedDocumentTypeCode;
    Name?: string;
}

export enum ExternalCorrectedDocumentTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IFeatureEntity extends IEntityBase {
    Code?: FeatureCode;
    Name?: string;
}

export enum FeatureEntity {
    Code = "Code",
    Name = "Name",
}

export interface IFileMetadataEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsIsdocReadable?: boolean;
    IsRossumReadable?: boolean;
    Name?: string;
    Size?: number;
}

export enum FileMetadataEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsIsdocReadable = "IsIsdocReadable",
    IsRossumReadable = "IsRossumReadable",
    Name = "Name",
    Size = "Size",
}

export interface IFinancialReportCloseEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LegalEntityCategoryCode?: LegalEntityCategoryCode;
    ReportTypeCode?: ReportTypeCode;
    FiscalYear?: IFiscalYearEntity;
    LegalEntityCategory?: ILegalEntityCategoryEntity;
    ReportType?: IReportTypeEntity;
    Items?: IFinancialReportCloseItemEntity[];
}

export enum FinancialReportCloseEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LegalEntityCategoryCode = "LegalEntityCategoryCode",
    ReportTypeCode = "ReportTypeCode",
    FiscalYear = "FiscalYear",
    LegalEntityCategory = "LegalEntityCategory",
    ReportType = "ReportType",
    Items = "Items",
}

export interface IFinancialReportCloseItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LineNumber?: number;
    Name?: string;
    Number?: string;
    Amount1?: number;
    Amount2?: number;
    Amount3?: number;
    LastYearAmount?: number;
}

export enum FinancialReportCloseItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LineNumber = "LineNumber",
    Name = "Name",
    Number = "Number",
    Amount1 = "Amount1",
    Amount2 = "Amount2",
    Amount3 = "Amount3",
    LastYearAmount = "LastYearAmount",
}

export interface IFinancialReportLayoutEntity extends IEntityBase {
    Code?: FinancialReportLayoutCode;
    AccountingCode?: AccountingCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    ReportTypeCode?: ReportTypeCode;
    Accounting?: IAccountingEntity;
    Country?: ICountryEntity;
    ReportType?: IReportTypeEntity;
    Sections?: IFinancialReportLayoutSectionEntity[];
}

export enum FinancialReportLayoutEntity {
    Code = "Code",
    AccountingCode = "AccountingCode",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    ReportTypeCode = "ReportTypeCode",
    Accounting = "Accounting",
    Country = "Country",
    ReportType = "ReportType",
    Sections = "Sections",
}

export interface IFinancialReportLayoutSectionEntity extends IEntityBase {
    Code?: string;
    FinancialReportLayoutCode?: FinancialReportLayoutCode;
    IsInBasicView?: boolean;
    Name?: string;
    Number?: string;
    OrderNumber?: number;
    ParentCode?: string;
    ReportSectionTypeCode?: ReportSectionTypeCode;
    FinancialReportLayout?: IFinancialReportLayoutEntity;
    Parent?: IFinancialReportLayoutSectionEntity;
    ReportSectionType?: IReportSectionTypeEntity;
    Children?: IFinancialReportLayoutSectionEntity[];
}

export enum FinancialReportLayoutSectionEntity {
    Code = "Code",
    FinancialReportLayoutCode = "FinancialReportLayoutCode",
    IsInBasicView = "IsInBasicView",
    Name = "Name",
    Number = "Number",
    OrderNumber = "OrderNumber",
    ParentCode = "ParentCode",
    ReportSectionTypeCode = "ReportSectionTypeCode",
    FinancialReportLayout = "FinancialReportLayout",
    Parent = "Parent",
    ReportSectionType = "ReportSectionType",
    Children = "Children",
}

export interface IFiscalPeriodEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEnd?: Date;
    DateStart?: Date;
    IsLockedForAP?: boolean;
    IsLockedForAR?: boolean;
    Name?: string;
    Number?: string;
    Usage?: IFiscalPeriodUsageEntity;
}

export enum FiscalPeriodEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    IsLockedForAP = "IsLockedForAP",
    IsLockedForAR = "IsLockedForAR",
    Name = "Name",
    Number = "Number",
    Usage = "Usage",
}

export interface IFiscalPeriodUsageEntity extends IEntityBase {
    Id?: number;
    DateMax?: Date;
    DateMin?: Date;
}

export enum FiscalPeriodUsageEntity {
    Id = "Id",
    DateMax = "DateMax",
    DateMin = "DateMin",
}

export interface IFiscalYearEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEnd?: Date;
    DateStart?: Date;
    Number?: string;
    StatusCode?: FiscalYearStatusCode;
    ChartOfAccounts?: IChartOfAccountsEntity;
    Company?: ICompanyEntity;
    FiscalYearClose?: IFiscalYearCloseEntity;
    Status?: IFiscalYearStatusEntity;
    Usage?: IFiscalYearUsageEntity;
    Periods?: IFiscalPeriodEntity[];
    NumberRanges?: INumberRangeEntity[];
}

export enum FiscalYearEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    Number = "Number",
    StatusCode = "StatusCode",
    ChartOfAccounts = "ChartOfAccounts",
    Company = "Company",
    FiscalYearClose = "FiscalYearClose",
    Status = "Status",
    Usage = "Usage",
    Periods = "Periods",
    NumberRanges = "NumberRanges",
}

export interface IFiscalYearCloseEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateIncomeTax?: Date;
    ExpenseTaxRateCode?: ExpenseTaxRateCode;
    HasTaxAdvisor?: boolean;
    InventoryTypeCode?: InventoryTypeCode;
    IsAudited?: boolean;
    IsIncomeTaxAmountPosted?: boolean;
    IsSubmissionViaMojeDane?: boolean;
    LegalEntityCategoryCode?: LegalEntityCategoryCode;
    IncomeTaxAmount?: number;
    IncomeTaxPaidAdvanceAmount?: number;
    TaxSavingsAmount?: number;
    DateClosed?: Date;
    BalanceSheetClose?: IInternalDocumentEntity;
    ClosedByUser?: IUserEntity;
    Company?: ICompanyEntity;
    ExpenseTaxRate?: IExpenseTaxRateEntity;
    FiscalYear?: IFiscalYearEntity;
    IncomeExpenseTransfer?: IInternalDocumentEntity;
    IncomeTaxDocument?: IInternalDocumentEntity;
    IncomeTaxPaymentOrReturnDocument?: IDocumentEntity;
    InventoryCheckDocument?: IInternalDocumentEntity;
    InventoryClearingDocument?: IInternalDocumentEntity;
    InventoryType?: IInventoryTypeEntity;
    LegalEntityCategory?: ILegalEntityCategoryEntity;
    NextYearBalanceSheetOpen?: IInternalDocumentEntity;
    NextYearProfitOrLossTransfer?: IInternalDocumentEntity;
    ProfitOrLoss?: IInternalDocumentEntity;
    AdvanceTaxPayments?: IFiscalYearCloseAdvanceTaxEntity[];
    Attachments?: IFiscalYearCloseAttachmentEntity[];
    ExchangeRates?: IFiscalYearCloseExchangeRateEntity[];
    InventoryAccounts?: IFiscalYearCloseInventoryEntity[];
    Sections?: IFiscalYearCloseSectionEntity[];
    TaxStatementXmlAttachments?: ITaxStatementXmlAttachmentEntity[];
    ExchangeRateDocuments?: IInternalDocumentEntity[];
}

export enum FiscalYearCloseEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateIncomeTax = "DateIncomeTax",
    ExpenseTaxRateCode = "ExpenseTaxRateCode",
    HasTaxAdvisor = "HasTaxAdvisor",
    InventoryTypeCode = "InventoryTypeCode",
    IsAudited = "IsAudited",
    IsIncomeTaxAmountPosted = "IsIncomeTaxAmountPosted",
    IsSubmissionViaMojeDane = "IsSubmissionViaMojeDane",
    LegalEntityCategoryCode = "LegalEntityCategoryCode",
    IncomeTaxAmount = "IncomeTaxAmount",
    IncomeTaxPaidAdvanceAmount = "IncomeTaxPaidAdvanceAmount",
    TaxSavingsAmount = "TaxSavingsAmount",
    DateClosed = "DateClosed",
    BalanceSheetClose = "BalanceSheetClose",
    ClosedByUser = "ClosedByUser",
    Company = "Company",
    ExpenseTaxRate = "ExpenseTaxRate",
    FiscalYear = "FiscalYear",
    IncomeExpenseTransfer = "IncomeExpenseTransfer",
    IncomeTaxDocument = "IncomeTaxDocument",
    IncomeTaxPaymentOrReturnDocument = "IncomeTaxPaymentOrReturnDocument",
    InventoryCheckDocument = "InventoryCheckDocument",
    InventoryClearingDocument = "InventoryClearingDocument",
    InventoryType = "InventoryType",
    LegalEntityCategory = "LegalEntityCategory",
    NextYearBalanceSheetOpen = "NextYearBalanceSheetOpen",
    NextYearProfitOrLossTransfer = "NextYearProfitOrLossTransfer",
    ProfitOrLoss = "ProfitOrLoss",
    AdvanceTaxPayments = "AdvanceTaxPayments",
    Attachments = "Attachments",
    ExchangeRates = "ExchangeRates",
    InventoryAccounts = "InventoryAccounts",
    Sections = "Sections",
    TaxStatementXmlAttachments = "TaxStatementXmlAttachments",
    ExchangeRateDocuments = "ExchangeRateDocuments",
}

export interface IFiscalYearCloseAdvanceTaxEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    DateAccountingTransaction?: Date;
    DateDue?: Date;
    IsCreated?: boolean;
    CreatedDocument?: IOtherLiabilityEntity;
}

export enum FiscalYearCloseAdvanceTaxEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateDue = "DateDue",
    IsCreated = "IsCreated",
    CreatedDocument = "CreatedDocument",
}

export interface IFiscalYearCloseAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum FiscalYearCloseAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IFiscalYearCloseExchangeRateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CurrencyCode?: CurrencyCode;
    ExchangeRatePerUnit?: number;
    Currency?: ICurrencyEntity;
}

export enum FiscalYearCloseExchangeRateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CurrencyCode = "CurrencyCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    Currency = "Currency",
}

export interface IFiscalYearCloseInventoryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    ChartOfAccounts?: IChartOfAccountsEntity;
    ConsumptionAccount?: IAccountEntity;
    InventoryAccount?: IAccountEntity;
}

export enum FiscalYearCloseInventoryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    ChartOfAccounts = "ChartOfAccounts",
    ConsumptionAccount = "ConsumptionAccount",
    InventoryAccount = "InventoryAccount",
}

export interface IFiscalYearCloseSectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    HasErrors?: boolean;
    IsChecked?: boolean;
    TypeCode?: FiscalYearCloseSectionTypeCode;
    Type?: IFiscalYearCloseSectionTypeEntity;
}

export enum FiscalYearCloseSectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    HasErrors = "HasErrors",
    IsChecked = "IsChecked",
    TypeCode = "TypeCode",
    Type = "Type",
}

export interface IFiscalYearCloseSectionTypeEntity extends IEntityBase {
    Code?: FiscalYearCloseSectionTypeCode;
    IsAccrual?: boolean;
    IsCashBasis?: boolean;
    Name?: string;
}

export enum FiscalYearCloseSectionTypeEntity {
    Code = "Code",
    IsAccrual = "IsAccrual",
    IsCashBasis = "IsCashBasis",
    Name = "Name",
}

export interface IFiscalYearStatusEntity extends IEntityBase {
    Code?: FiscalYearStatusCode;
    Name?: string;
}

export enum FiscalYearStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IFiscalYearUsageEntity extends IEntityBase {
    Id?: number;
    DateMax?: Date;
    DateMin?: Date;
}

export enum FiscalYearUsageEntity {
    Id = "Id",
    DateMax = "DateMax",
    DateMin = "DateMin",
}

export interface IFlattenAccountEntity extends IEntityBase {
    Id?: number;
    CategoryCode?: string;
    Name?: string;
    Number?: string;
    TaxApplicabilityCode?: string;
    TypeCode?: string;
}

export enum FlattenAccountEntity {
    Id = "Id",
    CategoryCode = "CategoryCode",
    Name = "Name",
    Number = "Number",
    TaxApplicabilityCode = "TaxApplicabilityCode",
    TypeCode = "TypeCode",
}

export interface IForeignInsuranceCarrierAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum ForeignInsuranceCarrierAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface IFulfilmentTypeEntity extends IEntityBase {
    Code?: FulfilmentTypeCode;
    Name?: string;
}

export enum FulfilmentTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IGeneralPermissionEntity extends IEntityBase {
    Code?: GeneralPermissionCode;
    Description?: string;
    IsOwnerOnly?: boolean;
    Name?: string;
}

export enum GeneralPermissionEntity {
    Code = "Code",
    Description = "Description",
    IsOwnerOnly = "IsOwnerOnly",
    Name = "Name",
}

export interface IGeneralRoleEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    GeneralRoleName?: string;
    IsSystemRole?: boolean;
    UserCount?: number;
    GeneralRolePermissions?: IGeneralRolePermissionEntity[];
}

export enum GeneralRoleEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    GeneralRoleName = "GeneralRoleName",
    IsSystemRole = "IsSystemRole",
    UserCount = "UserCount",
    GeneralRolePermissions = "GeneralRolePermissions",
}

export interface IGeneralRolePermissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsEnabled?: boolean;
    PermissionCode?: GeneralPermissionCode;
    Permission?: IGeneralPermissionEntity;
}

export enum GeneralRolePermissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsEnabled = "IsEnabled",
    PermissionCode = "PermissionCode",
    Permission = "Permission",
}

export interface IGovernmentInstitutionEntity extends IEntityBase {
    Code?: GovernmentInstitutionCode;
    City?: string;
    CountryCode?: CountryCode;
    DataBoxId?: string;
    GovernmentInstitutionTypeCode?: GovernmentInstitutionTypeCode;
    LORegionalOfficeCode?: LORegionalOfficeCode;
    Name?: string;
    OpenDataCode?: string;
    PostalCode?: string;
    ShortName?: string;
    Street?: string;
    Ufo?: string;
    UfoName?: string;
    Country?: ICountryEntity;
    GovernmentInstitutionType?: IGovernmentInstitutionTypeEntity;
    LORegionalOffice?: ILORegionalOfficeEntity;
    BankAccounts?: IGovernmentInstitutionBankAccountEntity[];
}

export enum GovernmentInstitutionEntity {
    Code = "Code",
    City = "City",
    CountryCode = "CountryCode",
    DataBoxId = "DataBoxId",
    GovernmentInstitutionTypeCode = "GovernmentInstitutionTypeCode",
    LORegionalOfficeCode = "LORegionalOfficeCode",
    Name = "Name",
    OpenDataCode = "OpenDataCode",
    PostalCode = "PostalCode",
    ShortName = "ShortName",
    Street = "Street",
    Ufo = "Ufo",
    UfoName = "UfoName",
    Country = "Country",
    GovernmentInstitutionType = "GovernmentInstitutionType",
    LORegionalOffice = "LORegionalOffice",
    BankAccounts = "BankAccounts",
}

export interface IGovernmentInstitutionBankAccountEntity extends IEntityBase {
    Code?: string;
    AccountNumber?: string;
    AccountPrefix?: string;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    GovernmentInstitutionBankAccountTypeCode?: string;
    IBAN?: string;
    Name?: string;
    Bank?: IBankEntity;
    Country?: ICountryEntity;
    GovernmentInstitutionBankAccountType?: IGovernmentInstitutionBankAccountTypeEntity;
}

export enum GovernmentInstitutionBankAccountEntity {
    Code = "Code",
    AccountNumber = "AccountNumber",
    AccountPrefix = "AccountPrefix",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    GovernmentInstitutionBankAccountTypeCode = "GovernmentInstitutionBankAccountTypeCode",
    IBAN = "IBAN",
    Name = "Name",
    Bank = "Bank",
    Country = "Country",
    GovernmentInstitutionBankAccountType = "GovernmentInstitutionBankAccountType",
}

export interface IGovernmentInstitutionBankAccountTypeEntity extends IEntityBase {
    Code?: string;
    CountryCode?: string;
    GovernmentInstitutionTypeCode?: GovernmentInstitutionTypeCode;
    Name?: string;
    GovernmentInstitutionType?: IGovernmentInstitutionTypeEntity;
}

export enum GovernmentInstitutionBankAccountTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    GovernmentInstitutionTypeCode = "GovernmentInstitutionTypeCode",
    Name = "Name",
    GovernmentInstitutionType = "GovernmentInstitutionType",
}

export interface IGovernmentInstitutionTypeEntity extends IEntityBase {
    Code?: GovernmentInstitutionTypeCode;
    CountryCode?: CountryCode;
    Name?: string;
    Country?: ICountryEntity;
}

export enum GovernmentInstitutionTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    Name = "Name",
    Country = "Country",
}

export interface IGrantEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ContractNumber?: string;
    DateDeadlineForSettling?: Date;
    DateEnd?: Date;
    DateStart?: Date;
    IsClosed?: boolean;
    Name?: string;
    Note?: string;
    NumberOurs?: string;
    ShortName?: string;
    RequiredParticipation?: number;
    Balance?: IGrantBalanceEntity;
    BusinessPartner?: IGrantBusinessPartnerEntity;
    NumberRange?: INumberRangeEntity;
    Attachments?: IGrantAttachmentEntity[];
    GrantClaims?: IGrantClaimEntity[];
    GrantEntries?: IGrantEntryEntity[];
}

export enum GrantEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ContractNumber = "ContractNumber",
    DateDeadlineForSettling = "DateDeadlineForSettling",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    IsClosed = "IsClosed",
    Name = "Name",
    Note = "Note",
    NumberOurs = "NumberOurs",
    ShortName = "ShortName",
    RequiredParticipation = "RequiredParticipation",
    Balance = "Balance",
    BusinessPartner = "BusinessPartner",
    NumberRange = "NumberRange",
    Attachments = "Attachments",
    GrantClaims = "GrantClaims",
    GrantEntries = "GrantEntries",
}

export interface IGrantAssignmentDivisionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Percentage?: number;
    Amount?: number;
    TransactionAmount?: number;
    Grant?: IGrantEntity;
}

export enum GrantAssignmentDivisionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Percentage = "Percentage",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    Grant = "Grant",
}

export interface IGrantAssignmentDivisionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Percentage?: number;
    Amount?: number;
    TransactionAmount?: number;
    Grant?: IGrantEntity;
}

export enum GrantAssignmentDivisionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Percentage = "Percentage",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    Grant = "Grant",
}

export interface IGrantAssignmentTypeEntity extends IEntityBase {
    Code?: GrantAssignmentTypeCode;
    Name?: string;
}

export enum GrantAssignmentTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IGrantAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum GrantAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IGrantBalanceEntity extends IEntityBase {
    Id?: number;
    Amount?: number;
    BalanceAmount?: number;
    RefundAmount?: number;
    StatusCode?: GrantStatusCode;
    UsedAmount?: number;
    Status?: IGrantStatusEntity;
}

export enum GrantBalanceEntity {
    Id = "Id",
    Amount = "Amount",
    BalanceAmount = "BalanceAmount",
    RefundAmount = "RefundAmount",
    StatusCode = "StatusCode",
    UsedAmount = "UsedAmount",
    Status = "Status",
}

export interface IGrantBusinessPartnerEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    LegalNumber?: string;
    Name?: string;
    PayerReliabilityStatusCode?: PayerReliabilityStatusCode;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    BusinessPartner?: IBusinessPartnerEntity;
    Country?: ICountryEntity;
    PayerReliabilityStatus?: IPayerReliabilityStatusEntity;
    VatStatus?: IVatStatusEntity;
}

export enum GrantBusinessPartnerEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PayerReliabilityStatusCode = "PayerReliabilityStatusCode",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    BusinessPartner = "BusinessPartner",
    Country = "Country",
    PayerReliabilityStatus = "PayerReliabilityStatus",
    VatStatus = "VatStatus",
}

export interface IGrantClaimEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CurrencyCode?: CurrencyCode;
    GrantClaimTypeCode?: GrantClaimTypeCode;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
    Grant?: IGrantEntity;
    GrantClaimType?: IGrantClaimTypeEntity;
}

export enum GrantClaimEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CurrencyCode = "CurrencyCode",
    GrantClaimTypeCode = "GrantClaimTypeCode",
    Currency = "Currency",
    Document = "Document",
    DocumentItem = "DocumentItem",
    Grant = "Grant",
    GrantClaimType = "GrantClaimType",
}

export interface IGrantClaimTypeEntity extends IEntityBase {
    Code?: GrantClaimTypeCode;
    Name?: string;
}

export enum GrantClaimTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IGrantEntryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CurrencyCode?: CurrencyCode;
    EffectiveAmount?: number;
    EffectiveTransactionAmount?: number;
    TransactionAmount?: number;
    TransactionCurrencyCode?: CurrencyCode;
    AssetItem?: IAssetItemEntity;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
    Grant?: IGrantEntity;
    PaymentDocument?: IPaymentDocumentEntity;
    PaymentDocumentItem?: IPaymentDocumentItemEntity;
    TransactionCurrency?: ICurrencyEntity;
}

export enum GrantEntryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CurrencyCode = "CurrencyCode",
    EffectiveAmount = "EffectiveAmount",
    EffectiveTransactionAmount = "EffectiveTransactionAmount",
    TransactionAmount = "TransactionAmount",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    AssetItem = "AssetItem",
    Currency = "Currency",
    Document = "Document",
    DocumentItem = "DocumentItem",
    Grant = "Grant",
    PaymentDocument = "PaymentDocument",
    PaymentDocumentItem = "PaymentDocumentItem",
    TransactionCurrency = "TransactionCurrency",
}

export interface IGrantStatusEntity extends IEntityBase {
    Code?: GrantStatusCode;
    Name?: string;
}

export enum GrantStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IHotspotEntity extends IEntityBase {
    ViewId?: string;
    ElementId?: string;
    IsSystem?: boolean;
}

export enum HotspotEntity {
    ViewId = "ViewId",
    ElementId = "ElementId",
    IsSystem = "IsSystem",
}

export interface IImportDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DocumentTypeCode?: DocumentTypeCode;
    ErrorMessage?: string;
    ImportTypeCode?: DocumentImportTypeCode;
    BackgroundJob?: IBackgroundJobEntity;
    DocumentType?: IDocumentTypeEntity;
    FileMetadata?: IFileMetadataEntity;
    ImportType?: IDocumentImportTypeEntity;
}

export enum ImportDocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DocumentTypeCode = "DocumentTypeCode",
    ErrorMessage = "ErrorMessage",
    ImportTypeCode = "ImportTypeCode",
    BackgroundJob = "BackgroundJob",
    DocumentType = "DocumentType",
    FileMetadata = "FileMetadata",
    ImportType = "ImportType",
}

export interface IInboxEntityTypeEntity extends IEntityBase {
    Code?: InboxEntityTypeCode;
    IsTaxDocument?: boolean;
    Name?: string;
}

export enum InboxEntityTypeEntity {
    Code = "Code",
    IsTaxDocument = "IsTaxDocument",
    Name = "Name",
}

export interface IInboxFileEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ApprovalStatusTypeCode?: ApprovalStatusTypeCode;
    Body?: string;
    DateReceived?: Date;
    EntityTypeCode?: InboxEntityTypeCode;
    InboxFileSourceCode?: InboxFileSourceCode;
    IsSorted?: boolean;
    IsSpam?: boolean;
    Sender?: string;
    Subject?: string;
    ApprovalStatusType?: IApprovalStatusTypeEntity;
    CanceledByUser?: IUserEntity;
    Company?: ICompanyEntity;
    EntityType?: IInboxEntityTypeEntity;
    FileMetadata?: IFileMetadataEntity;
    InboxFileSource?: IInboxFileSourceEntity;
    Chats?: IChatEntity[];
}

export enum InboxFileEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ApprovalStatusTypeCode = "ApprovalStatusTypeCode",
    Body = "Body",
    DateReceived = "DateReceived",
    EntityTypeCode = "EntityTypeCode",
    InboxFileSourceCode = "InboxFileSourceCode",
    IsSorted = "IsSorted",
    IsSpam = "IsSpam",
    Sender = "Sender",
    Subject = "Subject",
    ApprovalStatusType = "ApprovalStatusType",
    CanceledByUser = "CanceledByUser",
    Company = "Company",
    EntityType = "EntityType",
    FileMetadata = "FileMetadata",
    InboxFileSource = "InboxFileSource",
    Chats = "Chats",
}

export interface IInboxFileLogEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    FileName?: string;
    InboxFileStatusCode?: InboxFileStatusCode;
    FileMetadata?: IFileMetadataEntity;
    InboxFileStatus?: IInboxFileStatusEntity;
}

export enum InboxFileLogEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    FileName = "FileName",
    InboxFileStatusCode = "InboxFileStatusCode",
    FileMetadata = "FileMetadata",
    InboxFileStatus = "InboxFileStatus",
}

export interface IInboxFileSourceEntity extends IEntityBase {
    Code?: InboxFileSourceCode;
    Name?: string;
}

export enum InboxFileSourceEntity {
    Code = "Code",
    Name = "Name",
}

export interface IInboxFileStatusEntity extends IEntityBase {
    Code?: InboxFileStatusCode;
    Name?: string;
}

export enum InboxFileStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IInboxItemLogEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateReceived?: Date;
    EntityTypeCode?: InboxEntityTypeCode;
    InboxFileId?: number;
    InboxFileSourceCode?: InboxFileSourceCode;
    InboxItemLogStateCode?: InboxItemLogStateCode;
    Name?: string;
    Sender?: string;
    Subject?: string;
    EntityType?: IInboxEntityTypeEntity;
    InboxFileSource?: IInboxFileSourceEntity;
    InboxItemLogState?: IInboxItemLogStateEntity;
    User?: IUserEntity;
}

export enum InboxItemLogEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateReceived = "DateReceived",
    EntityTypeCode = "EntityTypeCode",
    InboxFileId = "InboxFileId",
    InboxFileSourceCode = "InboxFileSourceCode",
    InboxItemLogStateCode = "InboxItemLogStateCode",
    Name = "Name",
    Sender = "Sender",
    Subject = "Subject",
    EntityType = "EntityType",
    InboxFileSource = "InboxFileSource",
    InboxItemLogState = "InboxItemLogState",
    User = "User",
}

export interface IInboxItemLogStateEntity extends IEntityBase {
    Code?: InboxItemLogStateCode;
    Name?: string;
}

export enum InboxItemLogStateEntity {
    Code = "Code",
    Name = "Name",
}

export interface IIncomeStatementLayoutEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ByFunctionReportSectionCode?: string;
    ByNatureReportSectionCode?: string;
    ByFunctionReportSection?: IFinancialReportLayoutSectionEntity;
    ByNatureReportSection?: IFinancialReportLayoutSectionEntity;
}

export enum IncomeStatementLayoutEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ByFunctionReportSectionCode = "ByFunctionReportSectionCode",
    ByNatureReportSectionCode = "ByNatureReportSectionCode",
    ByFunctionReportSection = "ByFunctionReportSection",
    ByNatureReportSection = "ByNatureReportSection",
}

export interface IIncomeStatementLayoutTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ByFunctionReportSectionCode?: string;
    ByNatureReportSectionCode?: string;
    ByFunctionReportSection?: IFinancialReportLayoutSectionEntity;
    ByNatureReportSection?: IFinancialReportLayoutSectionEntity;
}

export enum IncomeStatementLayoutTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ByFunctionReportSectionCode = "ByFunctionReportSectionCode",
    ByNatureReportSectionCode = "ByNatureReportSectionCode",
    ByFunctionReportSection = "ByFunctionReportSection",
    ByNatureReportSection = "ByNatureReportSection",
}

export interface IInitialAccountBalanceEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    InitialBalance?: number;
    InitialTransactionBalance?: number;
    IsDebit?: boolean;
    Number?: string;
    TransactionCurrencyCode?: CurrencyCode;
    TransactionCurrency?: ICurrencyEntity;
}

export enum InitialAccountBalanceEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    InitialBalance = "InitialBalance",
    InitialTransactionBalance = "InitialTransactionBalance",
    IsDebit = "IsDebit",
    Number = "Number",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    TransactionCurrency = "TransactionCurrency",
}

export interface IIntegrationApiImportFrequencyEntity extends IEntityBase {
    Code?: IntegrationApiImportFrequencyCode;
    Name?: string;
}

export enum IntegrationApiImportFrequencyEntity {
    Code = "Code",
    Name = "Name",
}

export interface IIntegrationApiImportFromWhenEntity extends IEntityBase {
    Code?: IntegrationApiImportFromWhenCode;
    Name?: string;
}

export enum IntegrationApiImportFromWhenEntity {
    Code = "Code",
    Name = "Name",
}

export interface IIntegrationApiImportRangeEntity extends IEntityBase {
    Code?: IntegrationApiImportRangeCode;
    Name?: string;
}

export enum IntegrationApiImportRangeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IIntegrationApiImportedDocumentsEntity extends IEntityBase {
    Code?: IntegrationApiImportedDocumentsCode;
    Name?: string;
}

export enum IntegrationApiImportedDocumentsEntity {
    Code = "Code",
    Name = "Name",
}

export interface IInteractionTypeEntity extends IEntityBase {
    Code?: InteractionTypeCode;
    Name?: string;
}

export enum InteractionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IInternalDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaDocument?: Date;
    DateClearing?: Date;
    DateDocumentVatStatement?: Date;
    DateVatDeduction?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsInternallyManaged?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: VatStatementStatusCode;
    VatOssStatementStatusCode?: VatStatementStatusCode;
    VatStatementStatusCode?: VatStatementStatusCode;
    VatViesStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnitDateVatDeduction?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionEntity;
    BankAccount?: IDocumentBankAccountEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    CbaCategory?: IDocumentCbaCategoryEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    NumberRange?: INumberRangeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionEntity;
    VatControlStatementStatus?: IVatStatementStatusEntity;
    VatOssStatementStatus?: IVatStatementStatusEntity;
    VatStatementStatus?: IVatStatementStatusEntity;
    VatViesStatementStatus?: IVatStatementStatusEntity;
    Attachments?: IDocumentAttachmentEntity[];
    DocumentItems?: IDocumentItemViewEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Labels?: IDocumentLabelEntity[];
    Locks?: IDocumentLockEntity[];
    OppositeDocumentLinks?: IOppositeDocumentDocumentLinkEntity[];
    Payments?: IOppositePaymentDocumentDocumentLinkEntity[];
    ClearingDocumentLinks?: IClearingDocumentLinkEntity[];
    CorrectiveDocumentDrafts?: IDocumentDraftEntity[];
    DeferredPlans?: IDeferredPlanEntity[];
    Chats?: IChatEntity[];
    ElectronicSubmissions?: IElectronicSubmissionEntity[];
    CbaEntryTypeCode?: CbaEntryTypeCode;
    DateCbaEntry?: Date;
    Explanation?: string;
    CbaEntryType?: ICbaEntryTypeEntity;
    Items?: IInternalDocumentItemEntity[];
}

export enum InternalDocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaDocument = "DateCbaDocument",
    DateClearing = "DateClearing",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateVatDeduction = "DateVatDeduction",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsInternallyManaged = "IsInternallyManaged",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BusinessPartner = "BusinessPartner",
    CbaCategory = "CbaCategory",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    DocumentDraft = "DocumentDraft",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    NumberRange = "NumberRange",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassificationSelection = "VatClassificationSelection",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
    Attachments = "Attachments",
    DocumentItems = "DocumentItems",
    DocumentLinks = "DocumentLinks",
    Labels = "Labels",
    Locks = "Locks",
    OppositeDocumentLinks = "OppositeDocumentLinks",
    Payments = "Payments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    CorrectiveDocumentDrafts = "CorrectiveDocumentDrafts",
    DeferredPlans = "DeferredPlans",
    Chats = "Chats",
    ElectronicSubmissions = "ElectronicSubmissions",
    CbaEntryTypeCode = "CbaEntryTypeCode",
    DateCbaEntry = "DateCbaEntry",
    Explanation = "Explanation",
    CbaEntryType = "CbaEntryType",
    Items = "Items",
}

export interface IInternalDocumentItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    Description?: string;
    Note?: string;
    Order?: number;
    TransactionAmount?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    VatCode?: VatCode;
    AccountAssignmentSelection?: IDocumentItemAccountAssignmentSelectionEntity;
    CbaCategory?: IDocumentItemCbaCategoryEntity;
    DocumentItemDraft?: IDocumentItemDraftEntity;
    GrantAssignment?: IDocumentItemGrantAssignmentEntity;
    GrantClaim?: IGrantClaimEntity;
    LabelSelection?: IDocumentItemLabelSelectionEntity;
    Vat?: IVatEntity;
    VatClassificationSelection?: IDocumentItemVatClassificationSelectionEntity;
    GrantEntries?: IGrantEntryEntity[];
    TransactionCurrencyCode?: CurrencyCode;
    LinkedDocument?: IDocumentEntity;
    TransactionCurrency?: ICurrencyEntity;
}

export enum InternalDocumentItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    Description = "Description",
    Note = "Note",
    Order = "Order",
    TransactionAmount = "TransactionAmount",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    VatCode = "VatCode",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    CbaCategory = "CbaCategory",
    DocumentItemDraft = "DocumentItemDraft",
    GrantAssignment = "GrantAssignment",
    GrantClaim = "GrantClaim",
    LabelSelection = "LabelSelection",
    Vat = "Vat",
    VatClassificationSelection = "VatClassificationSelection",
    GrantEntries = "GrantEntries",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    LinkedDocument = "LinkedDocument",
    TransactionCurrency = "TransactionCurrency",
}

export interface IInventoryTypeEntity extends IEntityBase {
    Code?: InventoryTypeCode;
    Name?: string;
}

export enum InventoryTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IInvoiceIssuedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaDocument?: Date;
    DateClearing?: Date;
    DateDocumentVatStatement?: Date;
    DateVatDeduction?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsInternallyManaged?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: VatStatementStatusCode;
    VatOssStatementStatusCode?: VatStatementStatusCode;
    VatStatementStatusCode?: VatStatementStatusCode;
    VatViesStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnitDateVatDeduction?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionEntity;
    BankAccount?: IDocumentBankAccountEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    CbaCategory?: IDocumentCbaCategoryEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    NumberRange?: INumberRangeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionEntity;
    VatControlStatementStatus?: IVatStatementStatusEntity;
    VatOssStatementStatus?: IVatStatementStatusEntity;
    VatStatementStatus?: IVatStatementStatusEntity;
    VatViesStatementStatus?: IVatStatementStatusEntity;
    Attachments?: IDocumentAttachmentEntity[];
    DocumentItems?: IDocumentItemViewEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Labels?: IDocumentLabelEntity[];
    Locks?: IDocumentLockEntity[];
    OppositeDocumentLinks?: IOppositeDocumentDocumentLinkEntity[];
    Payments?: IOppositePaymentDocumentDocumentLinkEntity[];
    ClearingDocumentLinks?: IClearingDocumentLinkEntity[];
    CorrectiveDocumentDrafts?: IDocumentDraftEntity[];
    DeferredPlans?: IDeferredPlanEntity[];
    Chats?: IChatEntity[];
    ElectronicSubmissions?: IElectronicSubmissionEntity[];
    DateDue?: Date;
    DateIssued?: Date;
    DateTaxableSupply?: Date;
    PaymentMethodCode?: PaymentMethodCode;
    SymbolMatching?: string;
    TextBeforeItems?: string;
    TransactionAmountToPay?: number;
    TransactionAmountToReceive?: number;
    CashBox?: ICashBoxEntity;
    PaymentMethod?: IPaymentMethodEntity;
    Items?: IRegularDocumentItemEntity[];
}

export enum InvoiceIssuedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaDocument = "DateCbaDocument",
    DateClearing = "DateClearing",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateVatDeduction = "DateVatDeduction",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsInternallyManaged = "IsInternallyManaged",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BusinessPartner = "BusinessPartner",
    CbaCategory = "CbaCategory",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    DocumentDraft = "DocumentDraft",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    NumberRange = "NumberRange",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassificationSelection = "VatClassificationSelection",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
    Attachments = "Attachments",
    DocumentItems = "DocumentItems",
    DocumentLinks = "DocumentLinks",
    Labels = "Labels",
    Locks = "Locks",
    OppositeDocumentLinks = "OppositeDocumentLinks",
    Payments = "Payments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    CorrectiveDocumentDrafts = "CorrectiveDocumentDrafts",
    DeferredPlans = "DeferredPlans",
    Chats = "Chats",
    ElectronicSubmissions = "ElectronicSubmissions",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DateTaxableSupply = "DateTaxableSupply",
    PaymentMethodCode = "PaymentMethodCode",
    SymbolMatching = "SymbolMatching",
    TextBeforeItems = "TextBeforeItems",
    TransactionAmountToPay = "TransactionAmountToPay",
    TransactionAmountToReceive = "TransactionAmountToReceive",
    CashBox = "CashBox",
    PaymentMethod = "PaymentMethod",
    Items = "Items",
}

export interface IInvoiceReceivedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaDocument?: Date;
    DateClearing?: Date;
    DateDocumentVatStatement?: Date;
    DateVatDeduction?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsInternallyManaged?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: VatStatementStatusCode;
    VatOssStatementStatusCode?: VatStatementStatusCode;
    VatStatementStatusCode?: VatStatementStatusCode;
    VatViesStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnitDateVatDeduction?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionEntity;
    BankAccount?: IDocumentBankAccountEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    CbaCategory?: IDocumentCbaCategoryEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    NumberRange?: INumberRangeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionEntity;
    VatControlStatementStatus?: IVatStatementStatusEntity;
    VatOssStatementStatus?: IVatStatementStatusEntity;
    VatStatementStatus?: IVatStatementStatusEntity;
    VatViesStatementStatus?: IVatStatementStatusEntity;
    Attachments?: IDocumentAttachmentEntity[];
    DocumentItems?: IDocumentItemViewEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Labels?: IDocumentLabelEntity[];
    Locks?: IDocumentLockEntity[];
    OppositeDocumentLinks?: IOppositeDocumentDocumentLinkEntity[];
    Payments?: IOppositePaymentDocumentDocumentLinkEntity[];
    ClearingDocumentLinks?: IClearingDocumentLinkEntity[];
    CorrectiveDocumentDrafts?: IDocumentDraftEntity[];
    DeferredPlans?: IDeferredPlanEntity[];
    Chats?: IChatEntity[];
    ElectronicSubmissions?: IElectronicSubmissionEntity[];
    BankPaymentOrderStateCode?: BankPaymentOrderStateCode;
    DateBankApiPaymentOrder?: Date;
    DateDue?: Date;
    DateIssued?: Date;
    DateReceived?: Date;
    DateTaxableSupply?: Date;
    DateVatCancellation?: Date;
    DateVatReapplication?: Date;
    PaymentMethodCode?: PaymentMethodCode;
    SymbolMatching?: string;
    TextBeforeItems?: string;
    TransactionAmountToPay?: number;
    TransactionAmountToReceive?: number;
    VatCancellationAmount?: number;
    BankPaymentOrderState?: IBankPaymentOrderStateEntity;
    CashBox?: ICashBoxEntity;
    PaymentMethod?: IPaymentMethodEntity;
    Items?: IRegularDocumentItemEntity[];
}

export enum InvoiceReceivedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaDocument = "DateCbaDocument",
    DateClearing = "DateClearing",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateVatDeduction = "DateVatDeduction",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsInternallyManaged = "IsInternallyManaged",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BusinessPartner = "BusinessPartner",
    CbaCategory = "CbaCategory",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    DocumentDraft = "DocumentDraft",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    NumberRange = "NumberRange",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassificationSelection = "VatClassificationSelection",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
    Attachments = "Attachments",
    DocumentItems = "DocumentItems",
    DocumentLinks = "DocumentLinks",
    Labels = "Labels",
    Locks = "Locks",
    OppositeDocumentLinks = "OppositeDocumentLinks",
    Payments = "Payments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    CorrectiveDocumentDrafts = "CorrectiveDocumentDrafts",
    DeferredPlans = "DeferredPlans",
    Chats = "Chats",
    ElectronicSubmissions = "ElectronicSubmissions",
    BankPaymentOrderStateCode = "BankPaymentOrderStateCode",
    DateBankApiPaymentOrder = "DateBankApiPaymentOrder",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DateReceived = "DateReceived",
    DateTaxableSupply = "DateTaxableSupply",
    DateVatCancellation = "DateVatCancellation",
    DateVatReapplication = "DateVatReapplication",
    PaymentMethodCode = "PaymentMethodCode",
    SymbolMatching = "SymbolMatching",
    TextBeforeItems = "TextBeforeItems",
    TransactionAmountToPay = "TransactionAmountToPay",
    TransactionAmountToReceive = "TransactionAmountToReceive",
    VatCancellationAmount = "VatCancellationAmount",
    BankPaymentOrderState = "BankPaymentOrderState",
    CashBox = "CashBox",
    PaymentMethod = "PaymentMethod",
    Items = "Items",
}

export interface IInvoiceServiceIntegrationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    InvoiceServiceIntegrationTypeCode?: InvoiceServiceIntegrationTypeCode;
    Name?: string;
    DateLastRun?: Date;
    InvoiceServiceIntegrationType?: IInvoiceServiceIntegrationTypeEntity;
    Parameters?: IInvoiceServiceIntegrationParametersEntity;
    Settings?: IInvoiceServiceIntegrationSettingsEntity;
}

export enum InvoiceServiceIntegrationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    InvoiceServiceIntegrationTypeCode = "InvoiceServiceIntegrationTypeCode",
    Name = "Name",
    DateLastRun = "DateLastRun",
    InvoiceServiceIntegrationType = "InvoiceServiceIntegrationType",
    Parameters = "Parameters",
    Settings = "Settings",
}

export interface IInvoiceServiceIntegrationParametersEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccessTokenId?: number;
    FakturoidSlug?: string;
    RefreshTokenId?: number;
}

export enum InvoiceServiceIntegrationParametersEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccessTokenId = "AccessTokenId",
    FakturoidSlug = "FakturoidSlug",
    RefreshTokenId = "RefreshTokenId",
}

export interface IInvoiceServiceIntegrationSettingsEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IntegrationApiImportFrequencyCode?: IntegrationApiImportFrequencyCode;
    IntegrationApiImportFromWhenCode?: IntegrationApiImportFromWhenCode;
    IntegrationApiImportedDocumentsCode?: IntegrationApiImportedDocumentsCode;
    IsDocumentPdfImported?: boolean;
    IsInvoiceIssuedImported?: boolean;
    IsInvoiceReceivedImported?: boolean;
    IsOtherLiabilityImported?: boolean;
    IsOtherReceivableImported?: boolean;
    IsProformaInvoiceIssuedImported?: boolean;
    IsProformaInvoiceReceivedImported?: boolean;
    IsTaxDocumentIssuedImported?: boolean;
    IsTaxDocumentReceivedImported?: boolean;
    DateCustom?: Date;
    IntegrationApiImportedDocuments?: IIntegrationApiImportedDocumentsEntity;
    IntegrationApiImportFrequency?: IIntegrationApiImportFrequencyEntity;
    IntegrationApiImportFromWhen?: IIntegrationApiImportFromWhenEntity;
}

export enum InvoiceServiceIntegrationSettingsEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IntegrationApiImportFrequencyCode = "IntegrationApiImportFrequencyCode",
    IntegrationApiImportFromWhenCode = "IntegrationApiImportFromWhenCode",
    IntegrationApiImportedDocumentsCode = "IntegrationApiImportedDocumentsCode",
    IsDocumentPdfImported = "IsDocumentPdfImported",
    IsInvoiceIssuedImported = "IsInvoiceIssuedImported",
    IsInvoiceReceivedImported = "IsInvoiceReceivedImported",
    IsOtherLiabilityImported = "IsOtherLiabilityImported",
    IsOtherReceivableImported = "IsOtherReceivableImported",
    IsProformaInvoiceIssuedImported = "IsProformaInvoiceIssuedImported",
    IsProformaInvoiceReceivedImported = "IsProformaInvoiceReceivedImported",
    IsTaxDocumentIssuedImported = "IsTaxDocumentIssuedImported",
    IsTaxDocumentReceivedImported = "IsTaxDocumentReceivedImported",
    DateCustom = "DateCustom",
    IntegrationApiImportedDocuments = "IntegrationApiImportedDocuments",
    IntegrationApiImportFrequency = "IntegrationApiImportFrequency",
    IntegrationApiImportFromWhen = "IntegrationApiImportFromWhen",
}

export interface IInvoiceServiceIntegrationTypeEntity extends IEntityBase {
    Code?: InvoiceServiceIntegrationTypeCode;
    Name?: string;
}

export enum InvoiceServiceIntegrationTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IIsdocImportDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DocumentTypeCode?: DocumentTypeCode;
    ErrorMessage?: string;
    ImportTypeCode?: DocumentImportTypeCode;
    BackgroundJob?: IBackgroundJobEntity;
    DocumentType?: IDocumentTypeEntity;
    FileMetadata?: IFileMetadataEntity;
    ImportType?: IDocumentImportTypeEntity;
}

export enum IsdocImportDocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DocumentTypeCode = "DocumentTypeCode",
    ErrorMessage = "ErrorMessage",
    ImportTypeCode = "ImportTypeCode",
    BackgroundJob = "BackgroundJob",
    DocumentType = "DocumentType",
    FileMetadata = "FileMetadata",
    ImportType = "ImportType",
}

export interface IItemLabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum ItemLabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IItemLabelDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum ItemLabelDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IItemTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountingCode?: AccountingCode;
    AlwaysOffer?: boolean;
    Description?: string;
    TransactionCurrencyCode?: CurrencyCode;
    UnitOfMeasureCode?: UnitOfMeasureCode;
    VatCode?: VatCode;
    VatStatusCode?: VatStatusCode;
    Quantity?: number;
    TransactionAmount?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    AccountAssignmentSelection?: IItemTemplateAccountAssignmentSelectionEntity;
    Accounting?: IAccountingEntity;
    CbaTaxImpact?: IItemTemplateCbaTaxImpactEntity;
    TransactionCurrency?: ICurrencyEntity;
    UnitOfMeasure?: IUnitOfMeasureEntity;
    Vat?: IVatEntity;
    VatClassificationSelection?: IItemTemplateVatClassificationSelectionEntity;
    VatStatus?: IVatStatusEntity;
    AllowedCompanies?: ICompanyEntity[];
}

export enum ItemTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountingCode = "AccountingCode",
    AlwaysOffer = "AlwaysOffer",
    Description = "Description",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    UnitOfMeasureCode = "UnitOfMeasureCode",
    VatCode = "VatCode",
    VatStatusCode = "VatStatusCode",
    Quantity = "Quantity",
    TransactionAmount = "TransactionAmount",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    Accounting = "Accounting",
    CbaTaxImpact = "CbaTaxImpact",
    TransactionCurrency = "TransactionCurrency",
    UnitOfMeasure = "UnitOfMeasure",
    Vat = "Vat",
    VatClassificationSelection = "VatClassificationSelection",
    VatStatus = "VatStatus",
    AllowedCompanies = "AllowedCompanies",
}

export interface IItemTemplateAccountAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CreditAccountName?: string;
    CreditAccountNumber?: string;
    DebitAccountName?: string;
    DebitAccountNumber?: string;
    Name?: string;
    ShortName?: string;
}

export enum ItemTemplateAccountAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CreditAccountName = "CreditAccountName",
    CreditAccountNumber = "CreditAccountNumber",
    DebitAccountName = "DebitAccountName",
    DebitAccountNumber = "DebitAccountNumber",
    Name = "Name",
    ShortName = "ShortName",
}

export interface IItemTemplateAccountAssignmentSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    AccountAssignment?: IItemTemplateAccountAssignmentEntity;
    Selection?: ISelectionEntity;
}

export enum ItemTemplateAccountAssignmentSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    AccountAssignment = "AccountAssignment",
    Selection = "Selection",
}

export interface IItemTemplateCbaTaxImpactEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsAssetAcquisition?: boolean;
    TaxImpactCode?: CbaCategoryTaxImpactCode;
    TaxPercentage?: number;
    TaxImpact?: ICbaCategoryTaxImpactEntity;
}

export enum ItemTemplateCbaTaxImpactEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsAssetAcquisition = "IsAssetAcquisition",
    TaxImpactCode = "TaxImpactCode",
    TaxPercentage = "TaxPercentage",
    TaxImpact = "TaxImpact",
}

export interface IItemTemplateVatClassificationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    NonTaxAccountName?: string;
    NonTaxAccountNumber?: string;
    VatDeductionTypeCode?: VatDeductionTypeCode;
    VatProportionalDeduction?: number;
    VatDeductionType?: IVatDeductionTypeEntity;
}

export enum ItemTemplateVatClassificationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    NonTaxAccountName = "NonTaxAccountName",
    NonTaxAccountNumber = "NonTaxAccountNumber",
    VatDeductionTypeCode = "VatDeductionTypeCode",
    VatProportionalDeduction = "VatProportionalDeduction",
    VatDeductionType = "VatDeductionType",
}

export interface IItemTemplateVatClassificationSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    VatClassification?: IItemTemplateVatClassificationEntity;
}

export enum ItemTemplateVatClassificationSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    VatClassification = "VatClassification",
}

export interface IJournalEntryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DatePosted?: Date;
    Description?: string;
    DocumentTypeCode?: DocumentTypeCode;
    IsBalancing?: boolean;
    IsClosing?: boolean;
    IsOpening?: boolean;
    IsVatCancellation?: boolean;
    IsVatLockOverridden?: boolean;
    IsVatReapplication?: boolean;
    TransactionAmount?: number;
    TransactionCurrencyCode?: CurrencyCode;
    Company?: ICompanyEntity;
    CreditAccount?: IAccountEntity;
    Currency?: ICurrencyEntity;
    DebitAccount?: IAccountEntity;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
    DocumentType?: IDocumentTypeEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    PaymentDocument?: IPaymentDocumentEntity;
    PaymentDocumentItem?: IPaymentDocumentItemEntity;
    SplitItemAssignment?: ISplitAccountAssignmentEntity;
    TransactionCurrency?: ICurrencyEntity;
    Labels?: IJournalEntryLabelEntity[];
}

export enum JournalEntryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DatePosted = "DatePosted",
    Description = "Description",
    DocumentTypeCode = "DocumentTypeCode",
    IsBalancing = "IsBalancing",
    IsClosing = "IsClosing",
    IsOpening = "IsOpening",
    IsVatCancellation = "IsVatCancellation",
    IsVatLockOverridden = "IsVatLockOverridden",
    IsVatReapplication = "IsVatReapplication",
    TransactionAmount = "TransactionAmount",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    Company = "Company",
    CreditAccount = "CreditAccount",
    Currency = "Currency",
    DebitAccount = "DebitAccount",
    Document = "Document",
    DocumentItem = "DocumentItem",
    DocumentType = "DocumentType",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    PaymentDocument = "PaymentDocument",
    PaymentDocumentItem = "PaymentDocumentItem",
    SplitItemAssignment = "SplitItemAssignment",
    TransactionCurrency = "TransactionCurrency",
    Labels = "Labels",
}

export interface IJournalEntryLabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum JournalEntryLabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IJournalEntryTypeEntity extends IEntityBase {
    Code?: JournalEntryTypeCode;
    Name?: string;
}

export enum JournalEntryTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ILORegionalOfficeEntity extends IEntityBase {
    Code?: LORegionalOfficeCode;
    Name?: string;
}

export enum LORegionalOfficeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ILabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    IsActive?: boolean;
    Name?: string;
    Parent?: ILabelEntity;
    Children?: ILabelEntity[];
}

export enum LabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    IsActive = "IsActive",
    Name = "Name",
    Parent = "Parent",
    Children = "Children",
}

export interface ILabelHierarchyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Color?: string;
    Name?: string;
    Company?: ICompanyEntity;
    Labels?: ILabelEntity[];
}

export enum LabelHierarchyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Color = "Color",
    Name = "Name",
    Company = "Company",
    Labels = "Labels",
}

export interface ILabelSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    Labels?: IItemLabelEntity[];
}

export enum LabelSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    Labels = "Labels",
}

export interface ILabelSelectionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    Labels?: IItemLabelDraftEntity[];
}

export enum LabelSelectionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    Labels = "Labels",
}

export interface ILaborOfficeEmploymentTypeEntity extends IEntityBase {
    Code?: LaborOfficeEmploymentTypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum LaborOfficeEmploymentTypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface ILanguageEntity extends IEntityBase {
    Code?: LanguageCode;
    Code2?: string;
    Code3B?: string;
    Code3T?: string;
    Name?: string;
}

export enum LanguageEntity {
    Code = "Code",
    Code2 = "Code2",
    Code3B = "Code3B",
    Code3T = "Code3T",
    Name = "Name",
}

export interface ILegalEntityCategoryEntity extends IEntityBase {
    Code?: LegalEntityCategoryCode;
    Name?: string;
}

export enum LegalEntityCategoryEntity {
    Code = "Code",
    Name = "Name",
}

export interface ILegislativeFixedExchangeRateEntity extends IEntityBase {
    Code?: LegislativeFixedExchangeRateCode;
    Amount?: number;
    ExchangeRateDirect?: number;
    FromCurrencyCode?: CurrencyCode;
    LegislativeCountryCode?: CountryCode;
    Name?: string;
    ToCurrencyCode?: CurrencyCode;
    Year?: number;
    FromCurrency?: ICurrencyEntity;
    LegislativeCountry?: ICountryEntity;
    ToCurrency?: ICurrencyEntity;
}

export enum LegislativeFixedExchangeRateEntity {
    Code = "Code",
    Amount = "Amount",
    ExchangeRateDirect = "ExchangeRateDirect",
    FromCurrencyCode = "FromCurrencyCode",
    LegislativeCountryCode = "LegislativeCountryCode",
    Name = "Name",
    ToCurrencyCode = "ToCurrencyCode",
    Year = "Year",
    FromCurrency = "FromCurrency",
    LegislativeCountry = "LegislativeCountry",
    ToCurrency = "ToCurrency",
}

export interface ILoanAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    Country?: ICountryEntity;
    BalanceSheetAccountName?: string;
    BalanceSheetAccountNumberPrefix?: string;
    BalanceSheetAccountNumberSuffix?: string;
    CompanyBankAccountTypeCode?: CompanyBankAccountTypeCode;
    CurrencyCode?: CurrencyCode;
    HasAutoPosting?: boolean;
    InitialBalance?: number;
    InitialTransactionBalance?: number;
    IsActive?: boolean;
    IsDefault?: boolean;
    IsOss?: boolean;
    Name?: string;
    TransactionCurrencyCode?: CurrencyCode;
    Balance?: IBankAccountBalanceEntity;
    BankApiConnectionSetting?: IBankApiConnectionSettingEntity;
    BankApiStatementImportSetting?: IBankApiStatementImportSettingEntity;
    BankStatementCsvSettingsText?: IBankStatementCsvSettingsTextEntity;
    BankStatementNumberRangeDefinition?: INumberRangeDefinitionEntity;
    Company?: ICompanyEntity;
    CompanyBankAccountType?: ICompanyBankAccountTypeEntity;
    Currency?: ICurrencyEntity;
    Logo?: IFileMetadataEntity;
    TransactionCurrency?: ICurrencyEntity;
    BankTransactionCsvColumnMappings?: IBankTransactionCsvColumnMappingEntity[];
}

export enum LoanAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    Country = "Country",
    BalanceSheetAccountName = "BalanceSheetAccountName",
    BalanceSheetAccountNumberPrefix = "BalanceSheetAccountNumberPrefix",
    BalanceSheetAccountNumberSuffix = "BalanceSheetAccountNumberSuffix",
    CompanyBankAccountTypeCode = "CompanyBankAccountTypeCode",
    CurrencyCode = "CurrencyCode",
    HasAutoPosting = "HasAutoPosting",
    InitialBalance = "InitialBalance",
    InitialTransactionBalance = "InitialTransactionBalance",
    IsActive = "IsActive",
    IsDefault = "IsDefault",
    IsOss = "IsOss",
    Name = "Name",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    Balance = "Balance",
    BankApiConnectionSetting = "BankApiConnectionSetting",
    BankApiStatementImportSetting = "BankApiStatementImportSetting",
    BankStatementCsvSettingsText = "BankStatementCsvSettingsText",
    BankStatementNumberRangeDefinition = "BankStatementNumberRangeDefinition",
    Company = "Company",
    CompanyBankAccountType = "CompanyBankAccountType",
    Currency = "Currency",
    Logo = "Logo",
    TransactionCurrency = "TransactionCurrency",
    BankTransactionCsvColumnMappings = "BankTransactionCsvColumnMappings",
}

export interface ILoanStatementEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BankStatementTypeCode?: BankStatementTypeCode;
    DateFrom?: Date;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    Balance?: IStatementBalanceEntity;
    BankAccountBase?: IBusinessAccountBaseEntity;
    BankStatementType?: IBankStatementTypeEntity;
    NumberRange?: INumberRangeEntity;
    Attachments?: IStatementAttachmentEntity[];
    Locks?: IBankStatementLockEntity[];
    Chats?: IChatEntity[];
    BankAccount?: ILoanAccountEntity;
    Transactions?: ILoanTransactionEntity[];
}

export enum LoanStatementEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BankStatementTypeCode = "BankStatementTypeCode",
    DateFrom = "DateFrom",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    Balance = "Balance",
    BankAccountBase = "BankAccountBase",
    BankStatementType = "BankStatementType",
    NumberRange = "NumberRange",
    Attachments = "Attachments",
    Locks = "Locks",
    Chats = "Chats",
    BankAccount = "BankAccount",
    Transactions = "Transactions",
}

export interface ILoanTransactionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsUnrelatedToBusiness?: boolean;
    Note?: string;
    NumberOurs?: string;
    PaymentStatusCode?: PaymentStatusCode;
    PostedStatusCode?: PostedStatusCode;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionCurrencyCode?: CurrencyCode;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    NumberRange?: INumberRangeEntity;
    PaymentDocumentDraft?: IPaymentDocumentDraftEntity;
    PaymentStatus?: IPaymentStatusEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    Attachments?: IPaymentDocumentAttachmentEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Items?: IPaymentDocumentItemEntity[];
    Labels?: IPaymentDocumentLabelEntity[];
    Locks?: IPaymentDocumentLockEntity[];
    Chats?: IChatEntity[];
    BankTransactionTypeCode?: BankTransactionTypeCode;
    DateBankTransaction?: Date;
    Order?: number;
    RemittanceInformation?: string;
    PaymentInformation?: string;
    SymbolVariable?: string;
    SymbolSpecific?: string;
    SymbolConstant?: string;
    BankTransactionType?: IBankTransactionTypeEntity;
    BankStatement?: ILoanStatementEntity;
}

export enum LoanTransactionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsUnrelatedToBusiness = "IsUnrelatedToBusiness",
    Note = "Note",
    NumberOurs = "NumberOurs",
    PaymentStatusCode = "PaymentStatusCode",
    PostedStatusCode = "PostedStatusCode",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    NumberRange = "NumberRange",
    PaymentDocumentDraft = "PaymentDocumentDraft",
    PaymentStatus = "PaymentStatus",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    Attachments = "Attachments",
    DocumentLinks = "DocumentLinks",
    Items = "Items",
    Labels = "Labels",
    Locks = "Locks",
    Chats = "Chats",
    BankTransactionTypeCode = "BankTransactionTypeCode",
    DateBankTransaction = "DateBankTransaction",
    Order = "Order",
    RemittanceInformation = "RemittanceInformation",
    PaymentInformation = "PaymentInformation",
    SymbolVariable = "SymbolVariable",
    SymbolSpecific = "SymbolSpecific",
    SymbolConstant = "SymbolConstant",
    BankTransactionType = "BankTransactionType",
    BankStatement = "BankStatement",
}

export interface ILockTypeEntity extends IEntityBase {
    Code?: LockTypeCode;
    Name?: string;
}

export enum LockTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IMandatoryAccountEntity extends IEntityBase {
    Code?: MandatoryAccountCode;
    AccountRoleCode?: AccountRoleCode;
    ModuleCode?: ModuleCode;
    Name?: string;
    Number?: string;
    AccountRole?: IAccountRoleEntity;
    Module?: IModuleEntity;
}

export enum MandatoryAccountEntity {
    Code = "Code",
    AccountRoleCode = "AccountRoleCode",
    ModuleCode = "ModuleCode",
    Name = "Name",
    Number = "Number",
    AccountRole = "AccountRole",
    Module = "Module",
}

export interface IMandatoryChartOfAccountsEntity extends IEntityBase {
    Code?: MandatoryChartOfAccountsCode;
    AccountingCode?: AccountingCode;
    DefaultTemplateId?: number;
    Name?: string;
    Accounting?: IAccountingEntity;
    Accounts?: IMandatoryAccountEntity[];
}

export enum MandatoryChartOfAccountsEntity {
    Code = "Code",
    AccountingCode = "AccountingCode",
    DefaultTemplateId = "DefaultTemplateId",
    Name = "Name",
    Accounting = "Accounting",
    Accounts = "Accounts",
}

export interface IMinorAssetEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CurrencyCode?: CurrencyCode;
    DateOfLastTransaction?: Date;
    Description?: string;
    Note?: string;
    NumberOurs?: string;
    Quantity?: number;
    StatusCode?: MinorAssetStatusCode;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    NumberRange?: INumberRangeEntity;
    Status?: IMinorAssetStatusEntity;
    Attachments?: IMinorAssetAttachmentEntity[];
    Items?: IMinorAssetItemEntity[];
    Labels?: IMinorAssetLabelEntity[];
}

export enum MinorAssetEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CurrencyCode = "CurrencyCode",
    DateOfLastTransaction = "DateOfLastTransaction",
    Description = "Description",
    Note = "Note",
    NumberOurs = "NumberOurs",
    Quantity = "Quantity",
    StatusCode = "StatusCode",
    Company = "Company",
    Currency = "Currency",
    NumberRange = "NumberRange",
    Status = "Status",
    Attachments = "Attachments",
    Items = "Items",
    Labels = "Labels",
}

export interface IMinorAssetAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum MinorAssetAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IMinorAssetHistoryEntryEntity extends IEntityBase {
    NotId?: number;
    MinorAsset?: IMinorAssetEntity;
    MinorAssetHistoryItem?: IMinorAssetHistoryItemEntity;
    MinorAssetItem?: IMinorAssetItemEntity;
}

export enum MinorAssetHistoryEntryEntity {
    NotId = "NotId",
    MinorAsset = "MinorAsset",
    MinorAssetHistoryItem = "MinorAssetHistoryItem",
    MinorAssetItem = "MinorAssetItem",
}

export interface IMinorAssetHistoryItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CurrencyCode?: CurrencyCode;
    DateOfTransaction?: Date;
    IsVatIncluded?: boolean;
    ItemTypeCode?: AssetItemTypeCode;
    Quantity?: number;
    Currency?: ICurrencyEntity;
    ItemType?: IAssetItemTypeEntity;
}

export enum MinorAssetHistoryItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CurrencyCode = "CurrencyCode",
    DateOfTransaction = "DateOfTransaction",
    IsVatIncluded = "IsVatIncluded",
    ItemTypeCode = "ItemTypeCode",
    Quantity = "Quantity",
    Currency = "Currency",
    ItemType = "ItemType",
}

export interface IMinorAssetItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CurrencyCode?: CurrencyCode;
    DateAcquired?: Date;
    DateGuarantee?: Date;
    DateUsefulLife?: Date;
    Description?: string;
    IsVatIncluded?: boolean;
    Note?: string;
    Order?: number;
    Quantity?: number;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
    Items?: IMinorAssetHistoryItemEntity[];
}

export enum MinorAssetItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CurrencyCode = "CurrencyCode",
    DateAcquired = "DateAcquired",
    DateGuarantee = "DateGuarantee",
    DateUsefulLife = "DateUsefulLife",
    Description = "Description",
    IsVatIncluded = "IsVatIncluded",
    Note = "Note",
    Order = "Order",
    Quantity = "Quantity",
    Currency = "Currency",
    Document = "Document",
    DocumentItem = "DocumentItem",
    Items = "Items",
}

export interface IMinorAssetLabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum MinorAssetLabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IMinorAssetStatusEntity extends IEntityBase {
    Code?: MinorAssetStatusCode;
    Name?: string;
}

export enum MinorAssetStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IModuleEntity extends IEntityBase {
    Code?: ModuleCode;
    Description?: string;
    IsBillable?: boolean;
    IsCompanyModule?: boolean;
    Name?: string;
}

export enum ModuleEntity {
    Code = "Code",
    Description = "Description",
    IsBillable = "IsBillable",
    IsCompanyModule = "IsCompanyModule",
    Name = "Name",
}

export interface IMoneyS3ImportDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DocumentTypeCode?: DocumentTypeCode;
    ErrorMessage?: string;
    ImportTypeCode?: DocumentImportTypeCode;
    BackgroundJob?: IBackgroundJobEntity;
    DocumentType?: IDocumentTypeEntity;
    FileMetadata?: IFileMetadataEntity;
    ImportType?: IDocumentImportTypeEntity;
}

export enum MoneyS3ImportDocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DocumentTypeCode = "DocumentTypeCode",
    ErrorMessage = "ErrorMessage",
    ImportTypeCode = "ImportTypeCode",
    BackgroundJob = "BackgroundJob",
    DocumentType = "DocumentType",
    FileMetadata = "FileMetadata",
    ImportType = "ImportType",
}

export interface IMonthOfYearEntity extends IEntityBase {
    Code?: MonthOfYearCode;
    Name?: string;
    Number?: number;
}

export enum MonthOfYearEntity {
    Code = "Code",
    Name = "Name",
    Number = "Number",
}

export interface IMpsvFreeAccessToLaborMarketTypeEntity extends IEntityBase {
    Code?: MpsvFreeAccessToLaborMarketTypeCode;
    Description?: string;
    MpsvCode?: string;
    Name?: string;
}

export enum MpsvFreeAccessToLaborMarketTypeEntity {
    Code = "Code",
    Description = "Description",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IMpsvTaxIdentifierTypeEntity extends IEntityBase {
    Code?: MpsvTaxIdentifierTypeCode;
    Name?: string;
}

export enum MpsvTaxIdentifierTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface INoUnemploymentSupportTypeEntity extends IEntityBase {
    Code?: NoUnemploymentSupportTypeCode;
    Description?: string;
    MpsvCode?: string;
    Name?: string;
}

export enum NoUnemploymentSupportTypeEntity {
    Code = "Code",
    Description = "Description",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface INotificationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    NotificationPriorityCode?: NotificationPriorityCode;
    NotificationTypeCode?: NotificationTypeCode;
    TextArgument?: string;
    DateValidTo?: Date;
    Company?: ICompanyEntity;
    NotificationPriority?: INotificationPriorityEntity;
    NotificationType?: INotificationTypeEntity;
}

export enum NotificationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    NotificationPriorityCode = "NotificationPriorityCode",
    NotificationTypeCode = "NotificationTypeCode",
    TextArgument = "TextArgument",
    DateValidTo = "DateValidTo",
    Company = "Company",
    NotificationPriority = "NotificationPriority",
    NotificationType = "NotificationType",
}

export interface INotificationPriorityEntity extends IEntityBase {
    Code?: NotificationPriorityCode;
    Name?: string;
}

export enum NotificationPriorityEntity {
    Code = "Code",
    Name = "Name",
}

export interface INotificationSettingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsBannerDisabled?: boolean;
    TypeSettings?: INotificationTypeSettingEntity[];
}

export enum NotificationSettingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsBannerDisabled = "IsBannerDisabled",
    TypeSettings = "TypeSettings",
}

export interface INotificationTypeEntity extends IEntityBase {
    Code?: NotificationTypeCode;
    Name?: string;
    NotificationTypeGroupCode?: NotificationTypeGroupCode;
    SendEmailByDefault?: boolean;
    NotificationTypeGroup?: INotificationTypeGroupEntity;
}

export enum NotificationTypeEntity {
    Code = "Code",
    Name = "Name",
    NotificationTypeGroupCode = "NotificationTypeGroupCode",
    SendEmailByDefault = "SendEmailByDefault",
    NotificationTypeGroup = "NotificationTypeGroup",
}

export interface INotificationTypeGroupEntity extends IEntityBase {
    Code?: NotificationTypeGroupCode;
    CompanyPermissionCode?: CompanyPermissionCode;
    Name?: string;
    CompanyPermission?: ICompanyPermissionEntity;
}

export enum NotificationTypeGroupEntity {
    Code = "Code",
    CompanyPermissionCode = "CompanyPermissionCode",
    Name = "Name",
    CompanyPermission = "CompanyPermission",
}

export interface INotificationTypeSettingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsDisabled?: boolean;
    IsSendToEmailEnabled?: boolean;
    NotificationTypeCode?: NotificationTypeCode;
    NotificationType?: INotificationTypeEntity;
}

export enum NotificationTypeSettingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsDisabled = "IsDisabled",
    IsSendToEmailEnabled = "IsSendToEmailEnabled",
    NotificationTypeCode = "NotificationTypeCode",
    NotificationType = "NotificationType",
}

export interface INumberRangeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    InitialValue?: number;
    IsExhausted?: boolean;
    NextNumber?: string;
    NextValue?: number;
    Definition?: INumberRangeDefinitionEntity;
    FiscalYear?: IFiscalYearEntity;
    Usage?: INumberRangeUsageEntity;
}

export enum NumberRangeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    InitialValue = "InitialValue",
    IsExhausted = "IsExhausted",
    NextNumber = "NextNumber",
    NextValue = "NextValue",
    Definition = "Definition",
    FiscalYear = "FiscalYear",
    Usage = "Usage",
}

export interface INumberRangeDefinitionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CarryForward?: boolean;
    CarryForwardPrefix?: string;
    IsActive?: boolean;
    IsDefault?: boolean;
    Name?: string;
    NumberOfDigits?: number;
    NumberRangeTypeCode?: NumberRangeTypeCode;
    NumberRangeTypePrefix?: string;
    PadWithZeros?: boolean;
    Prefix?: string;
    Suffix?: string;
    NumberRangeType?: INumberRangeTypeEntity;
    NumberRanges?: INumberRangeEntity[];
}

export enum NumberRangeDefinitionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CarryForward = "CarryForward",
    CarryForwardPrefix = "CarryForwardPrefix",
    IsActive = "IsActive",
    IsDefault = "IsDefault",
    Name = "Name",
    NumberOfDigits = "NumberOfDigits",
    NumberRangeTypeCode = "NumberRangeTypeCode",
    NumberRangeTypePrefix = "NumberRangeTypePrefix",
    PadWithZeros = "PadWithZeros",
    Prefix = "Prefix",
    Suffix = "Suffix",
    NumberRangeType = "NumberRangeType",
    NumberRanges = "NumberRanges",
}

export interface INumberRangeDefinitionTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CarryForward?: boolean;
    CarryForwardPrefix?: string;
    IsActive?: boolean;
    IsDefault?: boolean;
    Name?: string;
    NumberOfDigits?: number;
    NumberRangeTypeCode?: NumberRangeTypeCode;
    NumberRangeTypePrefix?: string;
    PadWithZeros?: boolean;
    Prefix?: string;
    Suffix?: string;
    NumberRangeType?: INumberRangeTypeEntity;
}

export enum NumberRangeDefinitionTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CarryForward = "CarryForward",
    CarryForwardPrefix = "CarryForwardPrefix",
    IsActive = "IsActive",
    IsDefault = "IsDefault",
    Name = "Name",
    NumberOfDigits = "NumberOfDigits",
    NumberRangeTypeCode = "NumberRangeTypeCode",
    NumberRangeTypePrefix = "NumberRangeTypePrefix",
    PadWithZeros = "PadWithZeros",
    Prefix = "Prefix",
    Suffix = "Suffix",
    NumberRangeType = "NumberRangeType",
}

export interface INumberRangeTypeEntity extends IEntityBase {
    Code?: NumberRangeTypeCode;
    DocumentTypeCode?: DocumentTypeCode;
    EntityTypeCode?: string;
    FeatureCode?: FeatureCode;
    ModuleCode?: ModuleCode;
    Name?: string;
    Prefix?: string;
    DocumentType?: IDocumentTypeEntity;
    EntityType?: IEntityTypeEntity;
    Feature?: IFeatureEntity;
    Module?: IModuleEntity;
    Wildcards?: INumberRangeWildcardEntity[];
}

export enum NumberRangeTypeEntity {
    Code = "Code",
    DocumentTypeCode = "DocumentTypeCode",
    EntityTypeCode = "EntityTypeCode",
    FeatureCode = "FeatureCode",
    ModuleCode = "ModuleCode",
    Name = "Name",
    Prefix = "Prefix",
    DocumentType = "DocumentType",
    EntityType = "EntityType",
    Feature = "Feature",
    Module = "Module",
    Wildcards = "Wildcards",
}

export interface INumberRangeUsageEntity extends IEntityBase {
    Id?: number;
    IsUsed?: boolean;
}

export enum NumberRangeUsageEntity {
    Id = "Id",
    IsUsed = "IsUsed",
}

export interface INumberRangeWildcardEntity extends IEntityBase {
    Code?: NumberRangeWildcardCode;
    Description?: string;
    IsFiscalYearDependent?: boolean;
    Name?: string;
    Replacement?: string;
    Types?: INumberRangeTypeEntity[];
}

export enum NumberRangeWildcardEntity {
    Code = "Code",
    Description = "Description",
    IsFiscalYearDependent = "IsFiscalYearDependent",
    Name = "Name",
    Replacement = "Replacement",
    Types = "Types",
}

export interface IOppositeDocumentDocumentLinkEntity extends IEntityBase {
    Id?: number;
    OppositeDocumentLinkType?: string;
    TypeCode?: DocumentLinkTypeCode;
    Amount?: number;
    TransactionAmount?: number;
    Type?: IDocumentLinkTypeEntity;
    SourceDocument?: IDocumentEntity;
}

export enum OppositeDocumentDocumentLinkEntity {
    Id = "Id",
    OppositeDocumentLinkType = "OppositeDocumentLinkType",
    TypeCode = "TypeCode",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    Type = "Type",
    SourceDocument = "SourceDocument",
}

export interface IOppositeDocumentLinkEntity extends IEntityBase {
    Id?: number;
    OppositeDocumentLinkType?: string;
    TypeCode?: DocumentLinkTypeCode;
    Amount?: number;
    TransactionAmount?: number;
    Type?: IDocumentLinkTypeEntity;
}

export enum OppositeDocumentLinkEntity {
    Id = "Id",
    OppositeDocumentLinkType = "OppositeDocumentLinkType",
    TypeCode = "TypeCode",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    Type = "Type",
}

export interface IOppositePaymentDocumentDocumentLinkEntity extends IEntityBase {
    Id?: number;
    OppositeDocumentLinkType?: string;
    TypeCode?: DocumentLinkTypeCode;
    Amount?: number;
    TransactionAmount?: number;
    Type?: IDocumentLinkTypeEntity;
    SourcePaymentDocument?: IPaymentDocumentEntity;
}

export enum OppositePaymentDocumentDocumentLinkEntity {
    Id = "Id",
    OppositeDocumentLinkType = "OppositeDocumentLinkType",
    TypeCode = "TypeCode",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    Type = "Type",
    SourcePaymentDocument = "SourcePaymentDocument",
}

export interface IOrganizationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    Name?: string;
    AccountingCompany?: ICompanyEntity;
}

export enum OrganizationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    Name = "Name",
    AccountingCompany = "AccountingCompany",
}

export interface IOtherLiabilityEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaDocument?: Date;
    DateClearing?: Date;
    DateDocumentVatStatement?: Date;
    DateVatDeduction?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsInternallyManaged?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: VatStatementStatusCode;
    VatOssStatementStatusCode?: VatStatementStatusCode;
    VatStatementStatusCode?: VatStatementStatusCode;
    VatViesStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnitDateVatDeduction?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionEntity;
    BankAccount?: IDocumentBankAccountEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    CbaCategory?: IDocumentCbaCategoryEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    NumberRange?: INumberRangeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionEntity;
    VatControlStatementStatus?: IVatStatementStatusEntity;
    VatOssStatementStatus?: IVatStatementStatusEntity;
    VatStatementStatus?: IVatStatementStatusEntity;
    VatViesStatementStatus?: IVatStatementStatusEntity;
    Attachments?: IDocumentAttachmentEntity[];
    DocumentItems?: IDocumentItemViewEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Labels?: IDocumentLabelEntity[];
    Locks?: IDocumentLockEntity[];
    OppositeDocumentLinks?: IOppositeDocumentDocumentLinkEntity[];
    Payments?: IOppositePaymentDocumentDocumentLinkEntity[];
    ClearingDocumentLinks?: IClearingDocumentLinkEntity[];
    CorrectiveDocumentDrafts?: IDocumentDraftEntity[];
    DeferredPlans?: IDeferredPlanEntity[];
    Chats?: IChatEntity[];
    ElectronicSubmissions?: IElectronicSubmissionEntity[];
    BankPaymentOrderStateCode?: BankPaymentOrderStateCode;
    DateBankApiPaymentOrder?: Date;
    DateDue?: Date;
    DateIssued?: Date;
    DateReceived?: Date;
    DateTaxableSupply?: Date;
    DateVatCancellation?: Date;
    DateVatReapplication?: Date;
    PaymentMethodCode?: PaymentMethodCode;
    SymbolMatching?: string;
    TextBeforeItems?: string;
    TransactionAmountToPay?: number;
    TransactionAmountToReceive?: number;
    VatCancellationAmount?: number;
    BankPaymentOrderState?: IBankPaymentOrderStateEntity;
    CashBox?: ICashBoxEntity;
    PaymentMethod?: IPaymentMethodEntity;
    Items?: IRegularDocumentItemEntity[];
}

export enum OtherLiabilityEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaDocument = "DateCbaDocument",
    DateClearing = "DateClearing",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateVatDeduction = "DateVatDeduction",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsInternallyManaged = "IsInternallyManaged",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BusinessPartner = "BusinessPartner",
    CbaCategory = "CbaCategory",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    DocumentDraft = "DocumentDraft",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    NumberRange = "NumberRange",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassificationSelection = "VatClassificationSelection",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
    Attachments = "Attachments",
    DocumentItems = "DocumentItems",
    DocumentLinks = "DocumentLinks",
    Labels = "Labels",
    Locks = "Locks",
    OppositeDocumentLinks = "OppositeDocumentLinks",
    Payments = "Payments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    CorrectiveDocumentDrafts = "CorrectiveDocumentDrafts",
    DeferredPlans = "DeferredPlans",
    Chats = "Chats",
    ElectronicSubmissions = "ElectronicSubmissions",
    BankPaymentOrderStateCode = "BankPaymentOrderStateCode",
    DateBankApiPaymentOrder = "DateBankApiPaymentOrder",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DateReceived = "DateReceived",
    DateTaxableSupply = "DateTaxableSupply",
    DateVatCancellation = "DateVatCancellation",
    DateVatReapplication = "DateVatReapplication",
    PaymentMethodCode = "PaymentMethodCode",
    SymbolMatching = "SymbolMatching",
    TextBeforeItems = "TextBeforeItems",
    TransactionAmountToPay = "TransactionAmountToPay",
    TransactionAmountToReceive = "TransactionAmountToReceive",
    VatCancellationAmount = "VatCancellationAmount",
    BankPaymentOrderState = "BankPaymentOrderState",
    CashBox = "CashBox",
    PaymentMethod = "PaymentMethod",
    Items = "Items",
}

export interface IOtherReceivableEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaDocument?: Date;
    DateClearing?: Date;
    DateDocumentVatStatement?: Date;
    DateVatDeduction?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsInternallyManaged?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: VatStatementStatusCode;
    VatOssStatementStatusCode?: VatStatementStatusCode;
    VatStatementStatusCode?: VatStatementStatusCode;
    VatViesStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnitDateVatDeduction?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionEntity;
    BankAccount?: IDocumentBankAccountEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    CbaCategory?: IDocumentCbaCategoryEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    NumberRange?: INumberRangeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionEntity;
    VatControlStatementStatus?: IVatStatementStatusEntity;
    VatOssStatementStatus?: IVatStatementStatusEntity;
    VatStatementStatus?: IVatStatementStatusEntity;
    VatViesStatementStatus?: IVatStatementStatusEntity;
    Attachments?: IDocumentAttachmentEntity[];
    DocumentItems?: IDocumentItemViewEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Labels?: IDocumentLabelEntity[];
    Locks?: IDocumentLockEntity[];
    OppositeDocumentLinks?: IOppositeDocumentDocumentLinkEntity[];
    Payments?: IOppositePaymentDocumentDocumentLinkEntity[];
    ClearingDocumentLinks?: IClearingDocumentLinkEntity[];
    CorrectiveDocumentDrafts?: IDocumentDraftEntity[];
    DeferredPlans?: IDeferredPlanEntity[];
    Chats?: IChatEntity[];
    ElectronicSubmissions?: IElectronicSubmissionEntity[];
    DateDue?: Date;
    DateIssued?: Date;
    DateTaxableSupply?: Date;
    PaymentMethodCode?: PaymentMethodCode;
    SymbolMatching?: string;
    TextBeforeItems?: string;
    TransactionAmountToPay?: number;
    TransactionAmountToReceive?: number;
    CashBox?: ICashBoxEntity;
    PaymentMethod?: IPaymentMethodEntity;
    Items?: IRegularDocumentItemEntity[];
}

export enum OtherReceivableEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaDocument = "DateCbaDocument",
    DateClearing = "DateClearing",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateVatDeduction = "DateVatDeduction",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsInternallyManaged = "IsInternallyManaged",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BusinessPartner = "BusinessPartner",
    CbaCategory = "CbaCategory",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    DocumentDraft = "DocumentDraft",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    NumberRange = "NumberRange",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassificationSelection = "VatClassificationSelection",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
    Attachments = "Attachments",
    DocumentItems = "DocumentItems",
    DocumentLinks = "DocumentLinks",
    Labels = "Labels",
    Locks = "Locks",
    OppositeDocumentLinks = "OppositeDocumentLinks",
    Payments = "Payments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    CorrectiveDocumentDrafts = "CorrectiveDocumentDrafts",
    DeferredPlans = "DeferredPlans",
    Chats = "Chats",
    ElectronicSubmissions = "ElectronicSubmissions",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DateTaxableSupply = "DateTaxableSupply",
    PaymentMethodCode = "PaymentMethodCode",
    SymbolMatching = "SymbolMatching",
    TextBeforeItems = "TextBeforeItems",
    TransactionAmountToPay = "TransactionAmountToPay",
    TransactionAmountToReceive = "TransactionAmountToReceive",
    CashBox = "CashBox",
    PaymentMethod = "PaymentMethod",
    Items = "Items",
}

export interface IOwnershipFormTypeEntity extends IEntityBase {
    Code?: OwnershipFormTypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum OwnershipFormTypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPayableReceivableTypeEntity extends IEntityBase {
    Code?: PayableReceivableTypeCode;
    Name?: string;
}

export enum PayableReceivableTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPayerReliabilityStatusEntity extends IEntityBase {
    Code?: PayerReliabilityStatusCode;
    Name?: string;
}

export enum PayerReliabilityStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPayingDocumentEntity extends IEntityBase {
    Id?: number;
    Amount?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCreated?: Date;
    DateDue?: Date;
    DateIssued?: Date;
    DateReceived?: Date;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    IsTaxDocument?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountToPay?: number;
    TransactionAmountToReceive?: number;
    TransactionCurrencyCode?: CurrencyCode;
    AccountAssignment?: IDocumentAccountAssignmentEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    CorrectiveDocument?: IDocumentEntity;
    Currency?: ICurrencyEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    DocumentItems?: IPayingDocumentItemViewEntity[];
}

export enum PayingDocumentEntity {
    Id = "Id",
    Amount = "Amount",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCreated = "DateCreated",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DateReceived = "DateReceived",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    IsTaxDocument = "IsTaxDocument",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountToPay = "TransactionAmountToPay",
    TransactionAmountToReceive = "TransactionAmountToReceive",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    AccountAssignment = "AccountAssignment",
    BusinessPartner = "BusinessPartner",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    CorrectiveDocument = "CorrectiveDocument",
    Currency = "Currency",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    DocumentItems = "DocumentItems",
}

export interface IPayingDocumentItemViewEntity extends IEntityBase {
    Id?: number;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    Description?: string;
    Note?: string;
    Order?: number;
    TransactionAmount?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    UnitOfMeasureCode?: UnitOfMeasureCode;
    VatCode?: VatCode;
    Quantity?: number;
    UnitPrice?: number;
    UnitPriceNet?: number;
    UnitPriceVat?: number;
    TransactionUnitPrice?: number;
    TransactionUnitPriceNet?: number;
    TransactionUnitPriceVat?: number;
    DiscountPercent?: number;
    Discount?: number;
    AccountAssignmentSelection?: IDocumentItemAccountAssignmentSelectionEntity;
    CbaCategory?: IDocumentItemCbaCategoryEntity;
    DocumentItemDraft?: IDocumentItemDraftEntity;
    GrantAssignment?: IDocumentItemGrantAssignmentEntity;
    LabelSelection?: IDocumentItemLabelSelectionEntity;
    LinkedDocument?: IDocumentEntity;
    TransactionCurrency?: ICurrencyEntity;
    UnitOfMeasure?: IUnitOfMeasureEntity;
    Vat?: IVatEntity;
    VatClassificationSelection?: IDocumentItemVatClassificationSelectionEntity;
    GrantEntries?: IGrantEntryEntity[];
}

export enum PayingDocumentItemViewEntity {
    Id = "Id",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    Description = "Description",
    Note = "Note",
    Order = "Order",
    TransactionAmount = "TransactionAmount",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    UnitOfMeasureCode = "UnitOfMeasureCode",
    VatCode = "VatCode",
    Quantity = "Quantity",
    UnitPrice = "UnitPrice",
    UnitPriceNet = "UnitPriceNet",
    UnitPriceVat = "UnitPriceVat",
    TransactionUnitPrice = "TransactionUnitPrice",
    TransactionUnitPriceNet = "TransactionUnitPriceNet",
    TransactionUnitPriceVat = "TransactionUnitPriceVat",
    DiscountPercent = "DiscountPercent",
    Discount = "Discount",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    CbaCategory = "CbaCategory",
    DocumentItemDraft = "DocumentItemDraft",
    GrantAssignment = "GrantAssignment",
    LabelSelection = "LabelSelection",
    LinkedDocument = "LinkedDocument",
    TransactionCurrency = "TransactionCurrency",
    UnitOfMeasure = "UnitOfMeasure",
    Vat = "Vat",
    VatClassificationSelection = "VatClassificationSelection",
    GrantEntries = "GrantEntries",
}

export interface IPaymentDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsUnrelatedToBusiness?: boolean;
    Note?: string;
    NumberOurs?: string;
    PaymentStatusCode?: PaymentStatusCode;
    PostedStatusCode?: PostedStatusCode;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionCurrencyCode?: CurrencyCode;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    NumberRange?: INumberRangeEntity;
    PaymentDocumentDraft?: IPaymentDocumentDraftEntity;
    PaymentStatus?: IPaymentStatusEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    Attachments?: IPaymentDocumentAttachmentEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Items?: IPaymentDocumentItemEntity[];
    Labels?: IPaymentDocumentLabelEntity[];
    Locks?: IPaymentDocumentLockEntity[];
    Chats?: IChatEntity[];
}

export enum PaymentDocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsUnrelatedToBusiness = "IsUnrelatedToBusiness",
    Note = "Note",
    NumberOurs = "NumberOurs",
    PaymentStatusCode = "PaymentStatusCode",
    PostedStatusCode = "PostedStatusCode",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    NumberRange = "NumberRange",
    PaymentDocumentDraft = "PaymentDocumentDraft",
    PaymentStatus = "PaymentStatus",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    Attachments = "Attachments",
    DocumentLinks = "DocumentLinks",
    Items = "Items",
    Labels = "Labels",
    Locks = "Locks",
    Chats = "Chats",
}

export interface IPaymentDocumentAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PaymentDocumentAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPaymentDocumentAttachmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PaymentDocumentAttachmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPaymentDocumentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BankAccountDescription?: string;
    BankInternalId?: string;
    BankTransactionTypeCode?: BankTransactionTypeCode;
    CurrencyCode?: CurrencyCode;
    DateBankTransaction?: Date;
    DateIssued?: Date;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    InboxSenderEmail?: string;
    Note?: string;
    NumberOurs?: string;
    PaidBy?: string;
    PaidTo?: string;
    PaymentInformation?: string;
    PaymentType?: string;
    Purpose?: string;
    ReceivedBy?: string;
    ReceivedFrom?: string;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionCurrencyCode?: CurrencyCode;
    Amount?: number;
    TransactionAmount?: number;
    ExchangeRatePerUnit?: number;
    BankAccount?: IBankTransactionBankAccountDraftEntity;
    BankStatement?: IStatementEntity;
    BankTransactionType?: IBankTransactionTypeEntity;
    BusinessPartner?: IBankTransactionBusinessPartnerDraftEntity;
    CashBox?: ICashBoxEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    NumberRange?: INumberRangeEntity;
    PaymentDocument?: IPaymentDocumentEntity;
    StatementDraft?: IStatementDraftEntity;
    TransactionCurrency?: ICurrencyEntity;
    Attachments?: IPaymentDocumentAttachmentDraftEntity[];
    Items?: IPaymentDocumentItemDraftEntity[];
    Labels?: IPaymentDocumentDraftLabelEntity[];
    Locks?: IPaymentDocumentLockDraftEntity[];
    Chats?: IChatEntity[];
}

export enum PaymentDocumentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BankAccountDescription = "BankAccountDescription",
    BankInternalId = "BankInternalId",
    BankTransactionTypeCode = "BankTransactionTypeCode",
    CurrencyCode = "CurrencyCode",
    DateBankTransaction = "DateBankTransaction",
    DateIssued = "DateIssued",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    InboxSenderEmail = "InboxSenderEmail",
    Note = "Note",
    NumberOurs = "NumberOurs",
    PaidBy = "PaidBy",
    PaidTo = "PaidTo",
    PaymentInformation = "PaymentInformation",
    PaymentType = "PaymentType",
    Purpose = "Purpose",
    ReceivedBy = "ReceivedBy",
    ReceivedFrom = "ReceivedFrom",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    BankAccount = "BankAccount",
    BankStatement = "BankStatement",
    BankTransactionType = "BankTransactionType",
    BusinessPartner = "BusinessPartner",
    CashBox = "CashBox",
    Company = "Company",
    Currency = "Currency",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    NumberRange = "NumberRange",
    PaymentDocument = "PaymentDocument",
    StatementDraft = "StatementDraft",
    TransactionCurrency = "TransactionCurrency",
    Attachments = "Attachments",
    Items = "Items",
    Labels = "Labels",
    Locks = "Locks",
    Chats = "Chats",
}

export interface IPaymentDocumentDraftLabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum PaymentDocumentDraftLabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IPaymentDocumentItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    DateAccountingTransaction?: Date;
    Order?: number;
    PaymentDocumentItemTypeCode?: PaymentDocumentItemTypeCode;
    TransactionAmount?: number;
    ExchangeRate?: number;
    ClearedAmount?: number;
    AccountAssignmentSelection?: IPaymentDocumentItemAccountAssignmentSelectionEntity;
    CbaCategory?: IPaymentDocumentItemCbaCategoryEntity;
    CreatedByPostingRule?: IPostingRuleEntity;
    DocumentLink?: IDocumentLinkEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    GrantAssignment?: IPaymentDocumentItemGrantAssignmentEntity;
    LabelSelection?: IPaymentDocumentItemLabelSelectionEntity;
    LinkedDocument?: IDocumentEntity;
    PaymentDocumentItemDraft?: IPaymentDocumentItemDraftEntity;
    PaymentDocumentItemType?: IPaymentDocumentItemTypeEntity;
    SplitAccountAssignments?: ISplitAccountAssignmentEntity[];
    GrantEntries?: IGrantEntryEntity[];
}

export enum PaymentDocumentItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    DateAccountingTransaction = "DateAccountingTransaction",
    Order = "Order",
    PaymentDocumentItemTypeCode = "PaymentDocumentItemTypeCode",
    TransactionAmount = "TransactionAmount",
    ExchangeRate = "ExchangeRate",
    ClearedAmount = "ClearedAmount",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    CbaCategory = "CbaCategory",
    CreatedByPostingRule = "CreatedByPostingRule",
    DocumentLink = "DocumentLink",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    GrantAssignment = "GrantAssignment",
    LabelSelection = "LabelSelection",
    LinkedDocument = "LinkedDocument",
    PaymentDocumentItemDraft = "PaymentDocumentItemDraft",
    PaymentDocumentItemType = "PaymentDocumentItemType",
    SplitAccountAssignments = "SplitAccountAssignments",
    GrantEntries = "GrantEntries",
}

export interface IPaymentDocumentItemAccountAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsDebitAccountVatDeductionForced?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
}

export enum PaymentDocumentItemAccountAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
}

export interface IPaymentDocumentItemAccountAssignmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsDebitAccountVatDeductionForced?: boolean;
    Name?: string;
    Note?: string;
    ShortName?: string;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
}

export enum PaymentDocumentItemAccountAssignmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Name = "Name",
    Note = "Note",
    ShortName = "ShortName",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
}

export interface IPaymentDocumentItemAccountAssignmentSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    AccountAssignment?: IPaymentDocumentItemAccountAssignmentEntity;
}

export enum PaymentDocumentItemAccountAssignmentSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    AccountAssignment = "AccountAssignment",
}

export interface IPaymentDocumentItemAccountAssignmentSelectionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    AccountAssignment?: IPaymentDocumentItemAccountAssignmentDraftEntity;
}

export enum PaymentDocumentItemAccountAssignmentSelectionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    AccountAssignment = "AccountAssignment",
}

export interface IPaymentDocumentItemCbaCategoryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsAssetAcquisition?: boolean;
    TaxImpactCode?: CbaCategoryTaxImpactCode;
    TaxPercentage?: number;
    Category?: ICbaCategoryEntity;
    TaxImpact?: ICbaCategoryTaxImpactEntity;
}

export enum PaymentDocumentItemCbaCategoryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsAssetAcquisition = "IsAssetAcquisition",
    TaxImpactCode = "TaxImpactCode",
    TaxPercentage = "TaxPercentage",
    Category = "Category",
    TaxImpact = "TaxImpact",
}

export interface IPaymentDocumentItemCbaCategoryDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsAssetAcquisition?: boolean;
    TaxImpactCode?: CbaCategoryTaxImpactCode;
    TaxPercentage?: number;
    Category?: ICbaCategoryEntity;
    TaxImpact?: ICbaCategoryTaxImpactEntity;
}

export enum PaymentDocumentItemCbaCategoryDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsAssetAcquisition = "IsAssetAcquisition",
    TaxImpactCode = "TaxImpactCode",
    TaxPercentage = "TaxPercentage",
    Category = "Category",
    TaxImpact = "TaxImpact",
}

export interface IPaymentDocumentItemDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateAccountingTransaction?: Date;
    Order?: number;
    PaymentDocumentItemTypeCode?: PaymentDocumentItemTypeCode;
    ExchangeRate?: number;
    ClearedAmount?: number;
    Amount?: number;
    TransactionAmount?: number;
    AccountAssignmentSelection?: IPaymentDocumentItemAccountAssignmentSelectionDraftEntity;
    CbaCategory?: IPaymentDocumentItemCbaCategoryDraftEntity;
    CreatedByPostingRule?: IPostingRuleEntity;
    GrantAssignment?: IPaymentDocumentItemGrantAssignmentDraftEntity;
    LabelSelection?: IPaymentDocumentItemLabelSelectionDraftEntity;
    LinkedDocument?: IDocumentEntity;
    PaymentDocumentItem?: IPaymentDocumentItemEntity;
    PaymentDocumentItemType?: IPaymentDocumentItemTypeEntity;
    SplitAccountAssignments?: ISplitAccountAssignmentDraftEntity[];
}

export enum PaymentDocumentItemDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateAccountingTransaction = "DateAccountingTransaction",
    Order = "Order",
    PaymentDocumentItemTypeCode = "PaymentDocumentItemTypeCode",
    ExchangeRate = "ExchangeRate",
    ClearedAmount = "ClearedAmount",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    CbaCategory = "CbaCategory",
    CreatedByPostingRule = "CreatedByPostingRule",
    GrantAssignment = "GrantAssignment",
    LabelSelection = "LabelSelection",
    LinkedDocument = "LinkedDocument",
    PaymentDocumentItem = "PaymentDocumentItem",
    PaymentDocumentItemType = "PaymentDocumentItemType",
    SplitAccountAssignments = "SplitAccountAssignments",
}

export interface IPaymentDocumentItemGrantAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    GrantAssignmentTypeCode?: GrantAssignmentTypeCode;
    Grant?: IGrantEntity;
    GrantAssignmentType?: IGrantAssignmentTypeEntity;
    Divisions?: IGrantAssignmentDivisionEntity[];
}

export enum PaymentDocumentItemGrantAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    GrantAssignmentTypeCode = "GrantAssignmentTypeCode",
    Grant = "Grant",
    GrantAssignmentType = "GrantAssignmentType",
    Divisions = "Divisions",
}

export interface IPaymentDocumentItemGrantAssignmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    GrantAssignmentTypeCode?: GrantAssignmentTypeCode;
    Grant?: IGrantEntity;
    GrantAssignmentType?: IGrantAssignmentTypeEntity;
    Divisions?: IGrantAssignmentDivisionDraftEntity[];
}

export enum PaymentDocumentItemGrantAssignmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    GrantAssignmentTypeCode = "GrantAssignmentTypeCode",
    Grant = "Grant",
    GrantAssignmentType = "GrantAssignmentType",
    Divisions = "Divisions",
}

export interface IPaymentDocumentItemLabelSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    Labels?: IItemLabelEntity[];
}

export enum PaymentDocumentItemLabelSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    Labels = "Labels",
}

export interface IPaymentDocumentItemLabelSelectionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
    Labels?: IItemLabelDraftEntity[];
}

export enum PaymentDocumentItemLabelSelectionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
    Labels = "Labels",
}

export interface IPaymentDocumentItemTypeEntity extends IEntityBase {
    Code?: PaymentDocumentItemTypeCode;
    Name?: string;
}

export enum PaymentDocumentItemTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPaymentDocumentLabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum PaymentDocumentLabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IPaymentDocumentLockEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: LockTypeCode;
    Type?: ILockTypeEntity;
}

export enum PaymentDocumentLockEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
}

export interface IPaymentDocumentLockDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: LockTypeCode;
    Type?: ILockTypeEntity;
}

export enum PaymentDocumentLockDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
}

export interface IPaymentMethodEntity extends IEntityBase {
    Code?: PaymentMethodCode;
    Name?: string;
}

export enum PaymentMethodEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPaymentOrderFormatEntity extends IEntityBase {
    Code?: PaymentOrderFormatCode;
    Name?: string;
}

export enum PaymentOrderFormatEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPaymentOrderOutputEntity extends IEntityBase {
    Code?: PaymentOrderOutputCode;
    Name?: string;
}

export enum PaymentOrderOutputEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPaymentStatusEntity extends IEntityBase {
    Code?: PaymentStatusCode;
    Name?: string;
}

export enum PaymentStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPeriodDayEntity extends IEntityBase {
    Code?: PeriodDayCode;
    Name?: string;
}

export enum PeriodDayEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPodaniValidationErrorEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorCode?: number;
    ErrorType?: string;
    Message?: string;
}

export enum PodaniValidationErrorEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorCode = "ErrorCode",
    ErrorType = "ErrorType",
    Message = "Message",
}

export interface IPohodaImportDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DocumentTypeCode?: DocumentTypeCode;
    ErrorMessage?: string;
    ImportTypeCode?: DocumentImportTypeCode;
    BackgroundJob?: IBackgroundJobEntity;
    DocumentType?: IDocumentTypeEntity;
    FileMetadata?: IFileMetadataEntity;
    ImportType?: IDocumentImportTypeEntity;
}

export enum PohodaImportDocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DocumentTypeCode = "DocumentTypeCode",
    ErrorMessage = "ErrorMessage",
    ImportTypeCode = "ImportTypeCode",
    BackgroundJob = "BackgroundJob",
    DocumentType = "DocumentType",
    FileMetadata = "FileMetadata",
    ImportType = "ImportType",
}

export interface IPostedStatusEntity extends IEntityBase {
    Code?: PostedStatusCode;
    Name?: string;
}

export enum PostedStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPostingRuleEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AmountInCZKTolerance?: number;
    AmountInTransactionCurrencyTolerance?: number;
    BankTransactionTypeCode?: BankTransactionTypeCode;
    DocumentNumberMustMatchCode?: BankTransactionDocumentNumberLocationCode;
    DocumentSymbolMatchingMustMatchCode?: BankTransactionDocumentNumberLocationCode;
    DocumentTypeCode?: PostingRuleDocumentTypeCode;
    IsActive?: boolean;
    MustAmountInCZKMatch?: boolean;
    MustAmountInTransactionCurrencyMatch?: boolean;
    MustSymbolSpecificMatch?: boolean;
    MustSymbolVariableMatch?: boolean;
    Name?: string;
    Order?: number;
    BankTransactionType?: IBankTransactionTypeEntity;
    Company?: ICompanyEntity;
    DocumentNumberMustMatch?: IBankTransactionDocumentNumberLocationEntity;
    DocumentSymbolMatchingMustMatch?: IBankTransactionDocumentNumberLocationEntity;
    DocumentType?: IPostingRuleDocumentTypeEntity;
    CompanyBankAccounts?: ICompanyBankAccountEntity[];
}

export enum PostingRuleEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AmountInCZKTolerance = "AmountInCZKTolerance",
    AmountInTransactionCurrencyTolerance = "AmountInTransactionCurrencyTolerance",
    BankTransactionTypeCode = "BankTransactionTypeCode",
    DocumentNumberMustMatchCode = "DocumentNumberMustMatchCode",
    DocumentSymbolMatchingMustMatchCode = "DocumentSymbolMatchingMustMatchCode",
    DocumentTypeCode = "DocumentTypeCode",
    IsActive = "IsActive",
    MustAmountInCZKMatch = "MustAmountInCZKMatch",
    MustAmountInTransactionCurrencyMatch = "MustAmountInTransactionCurrencyMatch",
    MustSymbolSpecificMatch = "MustSymbolSpecificMatch",
    MustSymbolVariableMatch = "MustSymbolVariableMatch",
    Name = "Name",
    Order = "Order",
    BankTransactionType = "BankTransactionType",
    Company = "Company",
    DocumentNumberMustMatch = "DocumentNumberMustMatch",
    DocumentSymbolMatchingMustMatch = "DocumentSymbolMatchingMustMatch",
    DocumentType = "DocumentType",
    CompanyBankAccounts = "CompanyBankAccounts",
}

export interface IPostingRuleDocumentTypeEntity extends IEntityBase {
    Code?: PostingRuleDocumentTypeCode;
    Name?: string;
}

export enum PostingRuleDocumentTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAbsenceCategoryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Color?: string;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Description?: string;
    IsActive?: boolean;
    IsExcludedDay?: boolean;
    IsExcludedPeriod?: boolean;
    IsOnRegistry?: boolean;
    ObstacleTypeCode?: PrAbsenceObstacleTypeCode;
    TypeCode?: PrAbsenceCategoryTypeCode;
    CurrentTemporalPropertyBag?: IPrAbsenceCategoryTemporalCurrentEntity;
    ObstacleType?: IPrAbsenceObstacleTypeEntity;
    Type?: IPrAbsenceCategoryTypeEntity;
    TemporalPropertyBag?: IPrAbsenceCategoryTemporalEntity[];
}

export enum PrAbsenceCategoryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Color = "Color",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Description = "Description",
    IsActive = "IsActive",
    IsExcludedDay = "IsExcludedDay",
    IsExcludedPeriod = "IsExcludedPeriod",
    IsOnRegistry = "IsOnRegistry",
    ObstacleTypeCode = "ObstacleTypeCode",
    TypeCode = "TypeCode",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    ObstacleType = "ObstacleType",
    Type = "Type",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrAbsenceCategoryOriginEntity extends IEntityBase {
    Code?: PrAbsenceCategoryOriginCode;
    Name?: string;
}

export enum PrAbsenceCategoryOriginEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAbsenceCategorySubtypeEntity extends IEntityBase {
    Code?: PrAbsenceCategorySubtypeCode;
    Name?: string;
}

export enum PrAbsenceCategorySubtypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAbsenceCategoryTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    VacationEntitlementInclusionCode?: PrVacationEntitlementInclusionCode;
    CompensationRate?: number;
    VacationEntitlementInclusion?: IPrVacationEntitlementInclusionEntity;
}

export enum PrAbsenceCategoryTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    VacationEntitlementInclusionCode = "VacationEntitlementInclusionCode",
    CompensationRate = "CompensationRate",
    VacationEntitlementInclusion = "VacationEntitlementInclusion",
}

export interface IPrAbsenceCategoryTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    VacationEntitlementInclusionCode?: PrVacationEntitlementInclusionCode;
    CompensationRate?: number;
    VacationEntitlementInclusion?: IPrVacationEntitlementInclusionEntity;
}

export enum PrAbsenceCategoryTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    VacationEntitlementInclusionCode = "VacationEntitlementInclusionCode",
    CompensationRate = "CompensationRate",
    VacationEntitlementInclusion = "VacationEntitlementInclusion",
}

export interface IPrAbsenceCategoryTypeEntity extends IEntityBase {
    Code?: PrAbsenceCategoryTypeCode;
    CompensationCode?: PrAbsenceCompensationCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    DefaultColor?: string;
    DefaultIsExcludedDay?: boolean;
    DefaultIsExcludedPeriod?: boolean;
    DefaultIsOnRegistry?: boolean;
    Name?: string;
    ObstacleTypeCode?: PrAbsenceObstacleTypeCode;
    OriginCode?: PrAbsenceCategoryOriginCode;
    Priority?: number;
    VacationEntitlementInclusionCode?: PrVacationEntitlementInclusionCode;
    Compensation?: IPrAbsenceCompensationEntity;
    Country?: ICountryEntity;
    ObstacleType?: IPrAbsenceObstacleTypeEntity;
    Origin?: IPrAbsenceCategoryOriginEntity;
    VacationEntitlementInclusion?: IPrVacationEntitlementInclusionEntity;
}

export enum PrAbsenceCategoryTypeEntity {
    Code = "Code",
    CompensationCode = "CompensationCode",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    DefaultColor = "DefaultColor",
    DefaultIsExcludedDay = "DefaultIsExcludedDay",
    DefaultIsExcludedPeriod = "DefaultIsExcludedPeriod",
    DefaultIsOnRegistry = "DefaultIsOnRegistry",
    Name = "Name",
    ObstacleTypeCode = "ObstacleTypeCode",
    OriginCode = "OriginCode",
    Priority = "Priority",
    VacationEntitlementInclusionCode = "VacationEntitlementInclusionCode",
    Compensation = "Compensation",
    Country = "Country",
    ObstacleType = "ObstacleType",
    Origin = "Origin",
    VacationEntitlementInclusion = "VacationEntitlementInclusion",
}

export interface IPrAbsenceCompensationEntity extends IEntityBase {
    Code?: PrAbsenceCompensationCode;
    Name?: string;
}

export enum PrAbsenceCompensationEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAbsenceObstacleTypeEntity extends IEntityBase {
    Code?: PrAbsenceObstacleTypeCode;
    Name?: string;
}

export enum PrAbsenceObstacleTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAccountAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountingCategoryCode?: PrAccountingCategoryCode;
    AccountingGroupSelectionCode?: PrAccountingGroupSelectionCode;
    CreditAccountNumber?: string;
    DebitAccountNumber?: string;
    ItemTypeCode?: PrAccountingItemTypeCode;
    Name?: string;
    AccountingCategory?: IPrAccountingCategoryEntity;
    AccountingGroupSelection?: IPrAccountingGroupSelectionEntity;
    ItemType?: IPrAccountingItemTypeEntity;
}

export enum PrAccountAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountingCategoryCode = "AccountingCategoryCode",
    AccountingGroupSelectionCode = "AccountingGroupSelectionCode",
    CreditAccountNumber = "CreditAccountNumber",
    DebitAccountNumber = "DebitAccountNumber",
    ItemTypeCode = "ItemTypeCode",
    Name = "Name",
    AccountingCategory = "AccountingCategory",
    AccountingGroupSelection = "AccountingGroupSelection",
    ItemType = "ItemType",
}

export interface IPrAccountAssignmentTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountingCategoryCode?: PrAccountingCategoryCode;
    AccountingGroupSelectionCode?: PrAccountingGroupSelectionCode;
    CreditAccountNumber?: string;
    DebitAccountNumber?: string;
    ItemTypeCode?: PrAccountingItemTypeCode;
    Name?: string;
    AccountingCategory?: IPrAccountingCategoryEntity;
    AccountingGroupSelection?: IPrAccountingGroupSelectionEntity;
    ItemType?: IPrAccountingItemTypeEntity;
}

export enum PrAccountAssignmentTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountingCategoryCode = "AccountingCategoryCode",
    AccountingGroupSelectionCode = "AccountingGroupSelectionCode",
    CreditAccountNumber = "CreditAccountNumber",
    DebitAccountNumber = "DebitAccountNumber",
    ItemTypeCode = "ItemTypeCode",
    Name = "Name",
    AccountingCategory = "AccountingCategory",
    AccountingGroupSelection = "AccountingGroupSelection",
    ItemType = "ItemType",
}

export interface IPrAccountingCategoryEntity extends IEntityBase {
    Code?: PrAccountingCategoryCode;
    Name?: string;
}

export enum PrAccountingCategoryEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAccountingGroupSelectionEntity extends IEntityBase {
    Code?: PrAccountingGroupSelectionCode;
    Name?: string;
}

export enum PrAccountingGroupSelectionEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAccountingItemGroupEntity extends IEntityBase {
    Code?: PrAccountingItemGroupCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Order?: number;
    Country?: ICountryEntity;
}

export enum PrAccountingItemGroupEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Order = "Order",
    Country = "Country",
}

export interface IPrAccountingItemTypeEntity extends IEntityBase {
    Code?: PrAccountingItemTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ItemGroupCode?: PrAccountingItemGroupCode;
    Name?: string;
    Order?: number;
    Country?: ICountryEntity;
    ItemGroup?: IPrAccountingItemGroupEntity;
}

export enum PrAccountingItemTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ItemGroupCode = "ItemGroupCode",
    Name = "Name",
    Order = "Order",
    Country = "Country",
    ItemGroup = "ItemGroup",
}

export interface IPrAnnualTaxItemTypeEntity extends IEntityBase {
    Code?: PrAnnualTaxItemTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    DecimalValueTypeCode?: PrValueTypeCode;
    IntValueTypeCode?: PrValueTypeCode;
    Name?: string;
    Country?: ICountryEntity;
    DecimalValueType?: IPrValueTypeEntity;
    IntValueType?: IPrValueTypeEntity;
}

export enum PrAnnualTaxItemTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    DecimalValueTypeCode = "DecimalValueTypeCode",
    IntValueTypeCode = "IntValueTypeCode",
    Name = "Name",
    Country = "Country",
    DecimalValueType = "DecimalValueType",
    IntValueType = "IntValueType",
}

export interface IPrAnnualTaxSettlementEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    NumberOurs?: string;
    StatusCode?: PrAnnualTaxSettlementStatusCode;
    Year?: number;
    AnnualTaxSettlementRequest?: IPrAnnualTaxSettlementRequestEntity;
    Employee?: IPrEmployeeEntity;
    NumberRange?: INumberRangeEntity;
    Status?: IPrAnnualTaxSettlementStatusEntity;
    Attachments?: IPrAnnualTaxSettlementAttachmentEntity[];
    Items?: IPrAnnualTaxSettlementItemEntity[];
}

export enum PrAnnualTaxSettlementEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    NumberOurs = "NumberOurs",
    StatusCode = "StatusCode",
    Year = "Year",
    AnnualTaxSettlementRequest = "AnnualTaxSettlementRequest",
    Employee = "Employee",
    NumberRange = "NumberRange",
    Status = "Status",
    Attachments = "Attachments",
    Items = "Items",
}

export interface IPrAnnualTaxSettlementAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrAnnualTaxSettlementAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrAnnualTaxSettlementItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrAnnualTaxItemTypeCode;
    DecimalValue?: number;
    IntValue?: number;
    Type?: IPrAnnualTaxItemTypeEntity;
}

export enum PrAnnualTaxSettlementItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    DecimalValue = "DecimalValue",
    IntValue = "IntValue",
    Type = "Type",
}

export interface IPrAnnualTaxSettlementRequestEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    NumberOurs?: string;
    ResultCode?: PrAnnualTaxSettlementRequestResultTypeCode;
    StatusCode?: PrAnnualTaxSettlementRequestStatusTypeCode;
    Year?: number;
    AnnualTaxSettlement?: IPrAnnualTaxSettlementEntity;
    DIP?: IPrAtsrFormSectionDIPEntity;
    Employee?: IPrEmployeeEntity;
    ForeclosureEndBonus?: IPrAtsrFormSectionForeclosureEndBonusEntity;
    Gifts?: IPrAtsrFormSectionGiftsEntity;
    LifeInsurance?: IPrAtsrFormSectionLifeInsuranceEntity;
    LongTermCareInsurance?: IPrAtsrFormSectionLongTermCareInsuranceEntity;
    MortgageInterest?: IPrAtsrFormSectionMortgageInterestEntity;
    NumberRange?: INumberRangeEntity;
    OtherEmployments?: IPrAtsrFormSectionOtherEmploymentsEntity;
    PartnerTaxCredit?: IPrAtsrFormSectionPartnerTaxCreditEntity;
    PensionInsurance?: IPrAtsrFormSectionPensionInsuranceEntity;
    Result?: IPrAnnualTaxSettlementRequestResultTypeEntity;
    Status?: IPrAnnualTaxSettlementRequestStatusTypeEntity;
    SupplementaryPensionSavingsNew?: IPrAtsrFormSectionSupplementaryPensionSavingsNewEntity;
    SupplementaryPensionSavingsOld?: IPrAtsrFormSectionSupplementaryPensionSavingsOldEntity;
    YearlyTaxpayerDeclaration?: IPrTaxpayerDeclarationEntity;
    Attachments?: IPrAnnualTaxSettlementRequestAttachmentEntity[];
}

export enum PrAnnualTaxSettlementRequestEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    NumberOurs = "NumberOurs",
    ResultCode = "ResultCode",
    StatusCode = "StatusCode",
    Year = "Year",
    AnnualTaxSettlement = "AnnualTaxSettlement",
    DIP = "DIP",
    Employee = "Employee",
    ForeclosureEndBonus = "ForeclosureEndBonus",
    Gifts = "Gifts",
    LifeInsurance = "LifeInsurance",
    LongTermCareInsurance = "LongTermCareInsurance",
    MortgageInterest = "MortgageInterest",
    NumberRange = "NumberRange",
    OtherEmployments = "OtherEmployments",
    PartnerTaxCredit = "PartnerTaxCredit",
    PensionInsurance = "PensionInsurance",
    Result = "Result",
    Status = "Status",
    SupplementaryPensionSavingsNew = "SupplementaryPensionSavingsNew",
    SupplementaryPensionSavingsOld = "SupplementaryPensionSavingsOld",
    YearlyTaxpayerDeclaration = "YearlyTaxpayerDeclaration",
    Attachments = "Attachments",
}

export interface IPrAnnualTaxSettlementRequestAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrAnnualTaxSettlementRequestAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrAnnualTaxSettlementRequestFormSectionDetailTypeEntity extends IEntityBase {
    Code?: PrAnnualTaxSettlementRequestFormSectionDetailTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrAnnualTaxSettlementRequestFormSectionDetailTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IPrAnnualTaxSettlementRequestFormSectionTypeEntity extends IEntityBase {
    Code?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrAnnualTaxSettlementRequestFormSectionTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IPrAnnualTaxSettlementRequestResultTypeEntity extends IEntityBase {
    Code?: PrAnnualTaxSettlementRequestResultTypeCode;
    Name?: string;
}

export enum PrAnnualTaxSettlementRequestResultTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAnnualTaxSettlementRequestStatusTypeEntity extends IEntityBase {
    Code?: PrAnnualTaxSettlementRequestStatusTypeCode;
    Name?: string;
}

export enum PrAnnualTaxSettlementRequestStatusTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAnnualTaxSettlementStatusEntity extends IEntityBase {
    Code?: PrAnnualTaxSettlementStatusCode;
    Name?: string;
}

export enum PrAnnualTaxSettlementStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAtsrFormSectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
}

export enum PrAtsrFormSectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
}

export interface IPrAtsrFormSectionAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrAtsrFormSectionAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrAtsrFormSectionDIPEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Amount?: number;
}

export enum PrAtsrFormSectionDIPEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Amount = "Amount",
}

export interface IPrAtsrFormSectionDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionDetailTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionDetailTypeEntity;
    Attachments?: IPrAtsrFormSectionDetailAttachmentEntity[];
}

export enum PrAtsrFormSectionDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
}

export interface IPrAtsrFormSectionDetailAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrAtsrFormSectionDetailAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrAtsrFormSectionDetailChildAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrAtsrFormSectionDetailChildAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrAtsrFormSectionDetailChildDeductionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionDetailTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionDetailTypeEntity;
    Attachments?: IPrAtsrFormSectionDetailAttachmentEntity[];
    ChildDeductionOrderCode?: PrChildDeductionOrderCode;
    DateReceivedFrom?: Date;
    DateReceivedTo?: Date;
    DateZtpFrom?: Date;
    DateZtpTo?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    ChildDeductionOrder?: IPrChildDeductionOrderEntity;
}

export enum PrAtsrFormSectionDetailChildDeductionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    ChildDeductionOrderCode = "ChildDeductionOrderCode",
    DateReceivedFrom = "DateReceivedFrom",
    DateReceivedTo = "DateReceivedTo",
    DateZtpFrom = "DateZtpFrom",
    DateZtpTo = "DateZtpTo",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    ChildDeductionOrder = "ChildDeductionOrder",
}

export interface IPrAtsrFormSectionDetailMortgageLocationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionDetailTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionDetailTypeEntity;
    Attachments?: IPrAtsrFormSectionDetailAttachmentEntity[];
    Amount?: number;
    PropertyAcquisitionCode?: PrPropertyAcquisitionCode;
    Address?: IPrMortgageLocationAddressEntity;
    PropertyAcquisition?: IPrPropertyAcquisitionEntity;
}

export enum PrAtsrFormSectionDetailMortgageLocationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Amount = "Amount",
    PropertyAcquisitionCode = "PropertyAcquisitionCode",
    Address = "Address",
    PropertyAcquisition = "PropertyAcquisition",
}

export interface IPrAtsrFormSectionDetailMortgageOtherPeopleEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionDetailTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionDetailTypeEntity;
    Attachments?: IPrAtsrFormSectionDetailAttachmentEntity[];
    DateIdentifier?: Date;
    FirstName?: string;
    IdentifierCode?: PrIdentifierCode;
    IdentifierValue?: string;
    LastName?: string;
    Address?: IPrMortgageOtherPeopleAddressEntity;
    Identifier?: IPrIdentifierEntity;
}

export enum PrAtsrFormSectionDetailMortgageOtherPeopleEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    DateIdentifier = "DateIdentifier",
    FirstName = "FirstName",
    IdentifierCode = "IdentifierCode",
    IdentifierValue = "IdentifierValue",
    LastName = "LastName",
    Address = "Address",
    Identifier = "Identifier",
}

export interface IPrAtsrFormSectionDetailPartnerTaxCreditEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionDetailTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionDetailTypeEntity;
    Attachments?: IPrAtsrFormSectionDetailAttachmentEntity[];
    ChildDateIdentifier?: Date;
    ChildFirstName?: string;
    ChildIdentifierCode?: PrIdentifierCode;
    ChildIdentifierValue?: string;
    ChildLastName?: string;
    DateIdentifier?: Date;
    FirstName?: string;
    IdentifierCode?: PrIdentifierCode;
    IdentifierValue?: string;
    LastName?: string;
    FromMonth?: number;
    ToMonth?: number;
    ChildIdentifier?: IPrIdentifierEntity;
    Identifier?: IPrIdentifierEntity;
    BirthCertificateAttachments?: IPrAtsrFormSectionDetailChildAttachmentEntity[];
}

export enum PrAtsrFormSectionDetailPartnerTaxCreditEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    ChildDateIdentifier = "ChildDateIdentifier",
    ChildFirstName = "ChildFirstName",
    ChildIdentifierCode = "ChildIdentifierCode",
    ChildIdentifierValue = "ChildIdentifierValue",
    ChildLastName = "ChildLastName",
    DateIdentifier = "DateIdentifier",
    FirstName = "FirstName",
    IdentifierCode = "IdentifierCode",
    IdentifierValue = "IdentifierValue",
    LastName = "LastName",
    FromMonth = "FromMonth",
    ToMonth = "ToMonth",
    ChildIdentifier = "ChildIdentifier",
    Identifier = "Identifier",
    BirthCertificateAttachments = "BirthCertificateAttachments",
}

export interface IPrAtsrFormSectionDetailPartnerTaxCreditZtpEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionDetailTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionDetailTypeEntity;
    Attachments?: IPrAtsrFormSectionDetailAttachmentEntity[];
    IsActive?: boolean;
    FromMonth?: number;
    ToMonth?: number;
}

export enum PrAtsrFormSectionDetailPartnerTaxCreditZtpEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    IsActive = "IsActive",
    FromMonth = "FromMonth",
    ToMonth = "ToMonth",
}

export interface IPrAtsrFormSectionDetailZtpEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionDetailTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionDetailTypeEntity;
    Attachments?: IPrAtsrFormSectionDetailAttachmentEntity[];
    DateFrom?: Date;
    DateTo?: Date;
    DisabilityTypeCode?: PrDisabilityTypeCode;
    IsZtpP?: boolean;
    DisabilityType?: IPrDisabilityTypeEntity;
}

export enum PrAtsrFormSectionDetailZtpEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
    DisabilityTypeCode = "DisabilityTypeCode",
    IsZtpP = "IsZtpP",
    DisabilityType = "DisabilityType",
}

export interface IPrAtsrFormSectionForeclosureEndBonusEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Amount?: number;
}

export enum PrAtsrFormSectionForeclosureEndBonusEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Amount = "Amount",
}

export interface IPrAtsrFormSectionGiftsEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Amount?: number;
}

export enum PrAtsrFormSectionGiftsEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Amount = "Amount",
}

export interface IPrAtsrFormSectionLifeInsuranceEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Amount?: number;
}

export enum PrAtsrFormSectionLifeInsuranceEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Amount = "Amount",
}

export interface IPrAtsrFormSectionLongTermCareInsuranceEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Amount?: number;
}

export enum PrAtsrFormSectionLongTermCareInsuranceEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Amount = "Amount",
}

export interface IPrAtsrFormSectionMortgageInterestEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Locations?: IPrAtsrFormSectionDetailMortgageLocationEntity[];
    OtherPeople?: IPrAtsrFormSectionDetailMortgageOtherPeopleEntity[];
}

export enum PrAtsrFormSectionMortgageInterestEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Locations = "Locations",
    OtherPeople = "OtherPeople",
}

export interface IPrAtsrFormSectionOtherEmploymentAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrAtsrFormSectionOtherEmploymentAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrAtsrFormSectionOtherEmploymentRecordsEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DatePeriodFrom?: Date;
    DatePeriodTo?: Date;
    EmployerName?: string;
    IsFilled?: boolean;
    TaxpayerDeclarationMonths?: string;
    TaxpayerDeclarationSigned?: boolean;
    IncomeAmount?: number;
    PaidIncomeAmount?: number;
    AdditionalIncomeFromFormerPeriodsAmount?: number;
    DeductedTaxDepositFromPaidIncomeAmount?: number;
    DeductedTaxDepositFromAdditionalIncomeAmount?: number;
    SumOfMonthlyBonusAmount?: number;
    Attachment?: IPrAtsrFormSectionOtherEmploymentAttachmentEntity;
    ChildDeductions?: IPrAtsrFormSectionDetailChildDeductionEntity[];
    Ztps?: IPrAtsrFormSectionDetailZtpEntity[];
}

export enum PrAtsrFormSectionOtherEmploymentRecordsEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DatePeriodFrom = "DatePeriodFrom",
    DatePeriodTo = "DatePeriodTo",
    EmployerName = "EmployerName",
    IsFilled = "IsFilled",
    TaxpayerDeclarationMonths = "TaxpayerDeclarationMonths",
    TaxpayerDeclarationSigned = "TaxpayerDeclarationSigned",
    IncomeAmount = "IncomeAmount",
    PaidIncomeAmount = "PaidIncomeAmount",
    AdditionalIncomeFromFormerPeriodsAmount = "AdditionalIncomeFromFormerPeriodsAmount",
    DeductedTaxDepositFromPaidIncomeAmount = "DeductedTaxDepositFromPaidIncomeAmount",
    DeductedTaxDepositFromAdditionalIncomeAmount = "DeductedTaxDepositFromAdditionalIncomeAmount",
    SumOfMonthlyBonusAmount = "SumOfMonthlyBonusAmount",
    Attachment = "Attachment",
    ChildDeductions = "ChildDeductions",
    Ztps = "Ztps",
}

export interface IPrAtsrFormSectionOtherEmploymentsEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    OtherEmployments?: IPrAtsrFormSectionOtherEmploymentRecordsEntity[];
}

export enum PrAtsrFormSectionOtherEmploymentsEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    OtherEmployments = "OtherEmployments",
}

export interface IPrAtsrFormSectionPartnerTaxCreditEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Detail?: IPrAtsrFormSectionDetailPartnerTaxCreditEntity;
    DetailZtp?: IPrAtsrFormSectionDetailPartnerTaxCreditZtpEntity;
}

export enum PrAtsrFormSectionPartnerTaxCreditEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Detail = "Detail",
    DetailZtp = "DetailZtp",
}

export interface IPrAtsrFormSectionPensionInsuranceEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Amount?: number;
}

export enum PrAtsrFormSectionPensionInsuranceEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Amount = "Amount",
}

export interface IPrAtsrFormSectionSupplementaryPensionSavingsNewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Amount?: number;
}

export enum PrAtsrFormSectionSupplementaryPensionSavingsNewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Amount = "Amount",
}

export interface IPrAtsrFormSectionSupplementaryPensionSavingsOldEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Amount?: number;
}

export enum PrAtsrFormSectionSupplementaryPensionSavingsOldEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Amount = "Amount",
}

export interface IPrAtsrSimpleFormSectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsActive?: boolean;
    TypeCode?: PrAnnualTaxSettlementRequestFormSectionTypeCode;
    Type?: IPrAnnualTaxSettlementRequestFormSectionTypeEntity;
    Attachments?: IPrAtsrFormSectionAttachmentEntity[];
    Amount?: number;
}

export enum PrAtsrSimpleFormSectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsActive = "IsActive",
    TypeCode = "TypeCode",
    Type = "Type",
    Attachments = "Attachments",
    Amount = "Amount",
}

export interface IPrAttendanceEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Balance?: number;
    IsStatutoryCompensation?: boolean;
    Month?: number;
    StatusCode?: PrAttendanceStatusCode;
    StatusDisplayCode?: PrAttendanceStatusDisplayCode;
    Year?: number;
    Employment?: IPrEmploymentEntity;
    Status?: IPrAttendanceStatusEntity;
    StatusDisplay?: IPrAttendanceStatusDisplayEntity;
    Summary?: IPrAttendanceSummaryEntity;
    Days?: IPrAttendanceDayEntity[];
}

export enum PrAttendanceEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Balance = "Balance",
    IsStatutoryCompensation = "IsStatutoryCompensation",
    Month = "Month",
    StatusCode = "StatusCode",
    StatusDisplayCode = "StatusDisplayCode",
    Year = "Year",
    Employment = "Employment",
    Status = "Status",
    StatusDisplay = "StatusDisplay",
    Summary = "Summary",
    Days = "Days",
}

export interface IPrAttendanceDayEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Date?: Date;
    IsExcludedDay?: boolean;
    IsExcludedPeriod?: boolean;
    IsOnRegistry?: boolean;
    Planned?: number;
    Intervals?: IPrAttendanceDayIntervalEntity[];
}

export enum PrAttendanceDayEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Date = "Date",
    IsExcludedDay = "IsExcludedDay",
    IsExcludedPeriod = "IsExcludedPeriod",
    IsOnRegistry = "IsOnRegistry",
    Planned = "Planned",
    Intervals = "Intervals",
}

export interface IPrAttendanceDayIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsEndNextDay?: boolean;
    IsPlaceholder?: boolean;
    IsStartNextDay?: boolean;
    IsWholeDay?: boolean;
    Order?: number;
    TimeEnd?: Date;
    TimeStart?: Date;
    WorkTypeCode?: PrWorkIntervalTypeCode;
    AbsenceCategory?: IPrAbsenceCategoryEntity;
    SocialEvent?: IPrSocialEventEntity;
    WorkType?: IPrWorkIntervalTypeEntity;
}

export enum PrAttendanceDayIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsEndNextDay = "IsEndNextDay",
    IsPlaceholder = "IsPlaceholder",
    IsStartNextDay = "IsStartNextDay",
    IsWholeDay = "IsWholeDay",
    Order = "Order",
    TimeEnd = "TimeEnd",
    TimeStart = "TimeStart",
    WorkTypeCode = "WorkTypeCode",
    AbsenceCategory = "AbsenceCategory",
    SocialEvent = "SocialEvent",
    WorkType = "WorkType",
}

export interface IPrAttendanceStatusEntity extends IEntityBase {
    Code?: PrAttendanceStatusCode;
    Name?: string;
}

export enum PrAttendanceStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAttendanceStatusDisplayEntity extends IEntityBase {
    Code?: PrAttendanceStatusDisplayCode;
    Name?: string;
}

export enum PrAttendanceStatusDisplayEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrAttendanceSummaryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BalanceInMinutes?: number;
    DaysDeducted?: number;
    DaysExcluded?: number;
    DaysInRegistrationState?: number;
    DaysWorked?: number;
    FullyCountableTowardVacationInMinutes?: number;
    HolidayCompensatoryInMinutes?: number;
    HolidayNotWorkedInMinutes?: number;
    HolidayPreviousInMinutes?: number;
    HolidayWorkedInMinutes?: number;
    IllnessFullyPaidInMinutes?: number;
    IllnessHalfPaidInMinutes?: number;
    IllnessPaidDays?: number;
    IllnessUnpaidInMinutes?: number;
    LumpSumMealBenefitCount?: number;
    MealVoucherCount?: number;
    NightWorkedInMinutes?: number;
    OvertimeCompensatoryInMinutes?: number;
    OvertimePreviousInMinutes?: number;
    PartiallyCountableTowardVacationInMinutes?: number;
    PeriodsExcluded?: number;
    PlannedInMinutes?: number;
    PreviousMonthSplitWeekPlannedInMinutes?: number;
    PreviousMonthSplitWeekWorkEquivalentTimeInMinutes?: number;
    RemoteWorkInHours?: number;
    TaxedBenefitItemCount?: number;
    WeekendWorkedInMinutes?: number;
    WorkedInMinutes?: number;
    WorkedIncludingHolidaysInMinutes?: number;
    MonthlyWorkingHoursFullTime?: number;
    MonthlyWorkingHours?: number;
    HoursPerWeekFullTime?: number;
    Absences?: IPrAttendanceSummaryAbsenceEntity[];
}

export enum PrAttendanceSummaryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BalanceInMinutes = "BalanceInMinutes",
    DaysDeducted = "DaysDeducted",
    DaysExcluded = "DaysExcluded",
    DaysInRegistrationState = "DaysInRegistrationState",
    DaysWorked = "DaysWorked",
    FullyCountableTowardVacationInMinutes = "FullyCountableTowardVacationInMinutes",
    HolidayCompensatoryInMinutes = "HolidayCompensatoryInMinutes",
    HolidayNotWorkedInMinutes = "HolidayNotWorkedInMinutes",
    HolidayPreviousInMinutes = "HolidayPreviousInMinutes",
    HolidayWorkedInMinutes = "HolidayWorkedInMinutes",
    IllnessFullyPaidInMinutes = "IllnessFullyPaidInMinutes",
    IllnessHalfPaidInMinutes = "IllnessHalfPaidInMinutes",
    IllnessPaidDays = "IllnessPaidDays",
    IllnessUnpaidInMinutes = "IllnessUnpaidInMinutes",
    LumpSumMealBenefitCount = "LumpSumMealBenefitCount",
    MealVoucherCount = "MealVoucherCount",
    NightWorkedInMinutes = "NightWorkedInMinutes",
    OvertimeCompensatoryInMinutes = "OvertimeCompensatoryInMinutes",
    OvertimePreviousInMinutes = "OvertimePreviousInMinutes",
    PartiallyCountableTowardVacationInMinutes = "PartiallyCountableTowardVacationInMinutes",
    PeriodsExcluded = "PeriodsExcluded",
    PlannedInMinutes = "PlannedInMinutes",
    PreviousMonthSplitWeekPlannedInMinutes = "PreviousMonthSplitWeekPlannedInMinutes",
    PreviousMonthSplitWeekWorkEquivalentTimeInMinutes = "PreviousMonthSplitWeekWorkEquivalentTimeInMinutes",
    RemoteWorkInHours = "RemoteWorkInHours",
    TaxedBenefitItemCount = "TaxedBenefitItemCount",
    WeekendWorkedInMinutes = "WeekendWorkedInMinutes",
    WorkedInMinutes = "WorkedInMinutes",
    WorkedIncludingHolidaysInMinutes = "WorkedIncludingHolidaysInMinutes",
    MonthlyWorkingHoursFullTime = "MonthlyWorkingHoursFullTime",
    MonthlyWorkingHours = "MonthlyWorkingHours",
    HoursPerWeekFullTime = "HoursPerWeekFullTime",
    Absences = "Absences",
}

export interface IPrAttendanceSummaryAbsenceEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbsenceCategoryTypeCode?: PrAbsenceCategoryTypeCode;
    Days?: number;
    DaysExcludedDay?: number;
    DaysExcludedPeriod?: number;
    DaysInPension?: number;
    LengthInMinutes?: number;
    Name?: string;
    ObstacleTypeCode?: PrAbsenceObstacleTypeCode;
    CompensationRate?: number;
    AbsenceCategoryType?: IPrAbsenceCategoryTypeEntity;
    ObstacleType?: IPrAbsenceObstacleTypeEntity;
}

export enum PrAttendanceSummaryAbsenceEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbsenceCategoryTypeCode = "AbsenceCategoryTypeCode",
    Days = "Days",
    DaysExcludedDay = "DaysExcludedDay",
    DaysExcludedPeriod = "DaysExcludedPeriod",
    DaysInPension = "DaysInPension",
    LengthInMinutes = "LengthInMinutes",
    Name = "Name",
    ObstacleTypeCode = "ObstacleTypeCode",
    CompensationRate = "CompensationRate",
    AbsenceCategoryType = "AbsenceCategoryType",
    ObstacleType = "ObstacleType",
}

export interface IPrBenefitEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrBenefitTypeCode;
    CurrentTemporalPropertyBag?: IPrBenefitTemporalCurrentEntity;
    Type?: IPrBenefitTypeEntity;
    TemporalPropertyBag?: IPrBenefitTemporalEntity[];
}

export enum PrBenefitEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    Type = "Type",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrBenefitTaxFreeLimitEntity extends IEntityBase {
    Code?: PrBenefitTaxFreeLimitCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    MealBenefitPerUnit?: number;
    Name?: string;
    RemoteWorkAmountPerHour?: number;
    Country?: ICountryEntity;
}

export enum PrBenefitTaxFreeLimitEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    MealBenefitPerUnit = "MealBenefitPerUnit",
    Name = "Name",
    RemoteWorkAmountPerHour = "RemoteWorkAmountPerHour",
    Country = "Country",
}

export interface IPrBenefitTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Amount?: number;
    Name?: string;
    OtherCategoryCode?: PrOtherBenefitCategoryCode;
    TaxAndContributionsApplicabilityCode?: PrOtherBenefitTaxAndContributionsApplicabilityCode;
    TaxDeducibilityCode?: PrOtherBenefitTaxDeducibilityCode;
    AmountEmployee?: number;
    AmountEmployer?: number;
    OtherCategory?: IPrOtherBenefitCategoryEntity;
    TaxAndContributionsApplicability?: IPrOtherBenefitTaxAndContributionsApplicabilityEntity;
    TaxDeducibility?: IPrOtherBenefitTaxDeducibilityEntity;
}

export enum PrBenefitTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Amount = "Amount",
    Name = "Name",
    OtherCategoryCode = "OtherCategoryCode",
    TaxAndContributionsApplicabilityCode = "TaxAndContributionsApplicabilityCode",
    TaxDeducibilityCode = "TaxDeducibilityCode",
    AmountEmployee = "AmountEmployee",
    AmountEmployer = "AmountEmployer",
    OtherCategory = "OtherCategory",
    TaxAndContributionsApplicability = "TaxAndContributionsApplicability",
    TaxDeducibility = "TaxDeducibility",
}

export interface IPrBenefitTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Amount?: number;
    Name?: string;
    OtherCategoryCode?: PrOtherBenefitCategoryCode;
    TaxAndContributionsApplicabilityCode?: PrOtherBenefitTaxAndContributionsApplicabilityCode;
    TaxDeducibilityCode?: PrOtherBenefitTaxDeducibilityCode;
    AmountEmployee?: number;
    AmountEmployer?: number;
    OtherCategory?: IPrOtherBenefitCategoryEntity;
    TaxAndContributionsApplicability?: IPrOtherBenefitTaxAndContributionsApplicabilityEntity;
    TaxDeducibility?: IPrOtherBenefitTaxDeducibilityEntity;
}

export enum PrBenefitTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Amount = "Amount",
    Name = "Name",
    OtherCategoryCode = "OtherCategoryCode",
    TaxAndContributionsApplicabilityCode = "TaxAndContributionsApplicabilityCode",
    TaxDeducibilityCode = "TaxDeducibilityCode",
    AmountEmployee = "AmountEmployee",
    AmountEmployer = "AmountEmployer",
    OtherCategory = "OtherCategory",
    TaxAndContributionsApplicability = "TaxAndContributionsApplicability",
    TaxDeducibility = "TaxDeducibility",
}

export interface IPrBenefitTypeEntity extends IEntityBase {
    Code?: PrBenefitTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrBenefitTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IPrCSSZDecisivePeriodEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ExcludedDays?: number;
    IncludableIncomeAmount?: number;
    Month?: number;
    Year?: number;
}

export enum PrCSSZDecisivePeriodEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ExcludedDays = "ExcludedDays",
    IncludableIncomeAmount = "IncludableIncomeAmount",
    Month = "Month",
    Year = "Year",
}

export interface IPrCSSZPaymentConnectionDeliveryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    HouseNumber?: string;
    PostalCode?: string;
    Street?: string;
    StreetNumber?: string;
}

export enum PrCSSZPaymentConnectionDeliveryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    HouseNumber = "HouseNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    StreetNumber = "StreetNumber",
}

export interface IPrCSSZPaymentConnectionWireTransferAbroadEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
    Country?: ICountryEntity;
    AccountName?: string;
    BankName?: string;
    City?: string;
    HouseNumber?: string;
    PostalCode?: string;
    Street?: string;
    StreetNumber?: string;
}

export enum PrCSSZPaymentConnectionWireTransferAbroadEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    Country = "Country",
    AccountName = "AccountName",
    BankName = "BankName",
    City = "City",
    HouseNumber = "HouseNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    StreetNumber = "StreetNumber",
}

export interface IPrCSSZPaymentConnectionWireTransferCZEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
    Country?: ICountryEntity;
    SymbolSpecific?: string;
}

export enum PrCSSZPaymentConnectionWireTransferCZEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    Country = "Country",
    SymbolSpecific = "SymbolSpecific",
}

export interface IPrCSSZPaymentMethodEntity extends IEntityBase {
    Code?: PrCSSZPaymentMethodCode;
    Name?: string;
}

export enum PrCSSZPaymentMethodEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrCSSZSubmissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Employee?: IPrCSSZSubmissionEmployeeEntity;
}

export enum PrCSSZSubmissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Employee = "Employee",
}

export interface IPrCSSZSubmissionCaregivingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Employee?: IPrCSSZSubmissionEmployeeEntity;
    Detail?: IPrCSSZSubmissionCaregivingDetailEntity;
}

export enum PrCSSZSubmissionCaregivingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Employee = "Employee",
    Detail = "Detail",
}

export interface IPrCSSZSubmissionCaregivingDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AdditionalInfo?: string;
    DateDecisivePeriodEnd?: Date;
    DateDecisivePeriodStart?: Date;
    DecisionNumber?: string;
    IsCorrectiveSubmission?: boolean;
    IsForeigner?: boolean;
    PaymentMethodCode?: PrCSSZPaymentMethodCode;
    UserEmail?: string;
    EstimatedIncomeAmount?: number;
    ExcludedDays?: number;
    IncludableIncomeAmount?: number;
    Company?: IPrCSSZSubmissionCompanyEntity;
    Employment?: IPrCSSZSubmissionEmploymentEntity;
    PaymentConnectionDelivery?: IPrCSSZPaymentConnectionDeliveryEntity;
    PaymentConnectionWireTransferAbroad?: IPrCSSZPaymentConnectionWireTransferAbroadEntity;
    PaymentConnectionWireTransferCZ?: IPrCSSZPaymentConnectionWireTransferCZEntity;
    PaymentMethod?: IPrCSSZPaymentMethodEntity;
    DecisivePeriods?: IPrCSSZDecisivePeriodEntity[];
    DateEnd?: Date;
    DateStart?: Date;
    DoesCareReceiverLiveInSameHousehold?: boolean;
    HasOtherCareGiverBenefitClaim?: boolean;
    IsCaringPersonally?: boolean;
    IsDuration?: boolean;
    IsEnd?: boolean;
    IsOtherCareGiverIncapacitated?: boolean;
    IsStart?: boolean;
    CareReceiver?: IPrCareReceiverSubmissionEntity;
    CaregivingIntervals?: IPrSubmissionCaregivingIntervalEntity[];
    CareReceiverRelationCode?: PrMpsvFamilyRelationCode;
    ClosedSchoolName?: string;
    ClosedSchoolNumber?: string;
    HasChildUnder16InSchool?: boolean;
    IsLoneCaregiver?: boolean;
    IsOtherCareGiverWorking?: boolean;
    ReasonForCareCode?: PrCaregivingTypeCode;
    CareReceiverRelation?: IPrMpsvFamilyRelationEntity;
    EmployerConfirmation?: IPrCSSZSubmissionEmployerConfirmationCaregivingEntity;
    PaymentBasis?: IPrCSSZSubmissionPaymentBasisCaregivingEntity;
    ReasonForCare?: IPrCaregivingTypeEntity;
}

export enum PrCSSZSubmissionCaregivingDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AdditionalInfo = "AdditionalInfo",
    DateDecisivePeriodEnd = "DateDecisivePeriodEnd",
    DateDecisivePeriodStart = "DateDecisivePeriodStart",
    DecisionNumber = "DecisionNumber",
    IsCorrectiveSubmission = "IsCorrectiveSubmission",
    IsForeigner = "IsForeigner",
    PaymentMethodCode = "PaymentMethodCode",
    UserEmail = "UserEmail",
    EstimatedIncomeAmount = "EstimatedIncomeAmount",
    ExcludedDays = "ExcludedDays",
    IncludableIncomeAmount = "IncludableIncomeAmount",
    Company = "Company",
    Employment = "Employment",
    PaymentConnectionDelivery = "PaymentConnectionDelivery",
    PaymentConnectionWireTransferAbroad = "PaymentConnectionWireTransferAbroad",
    PaymentConnectionWireTransferCZ = "PaymentConnectionWireTransferCZ",
    PaymentMethod = "PaymentMethod",
    DecisivePeriods = "DecisivePeriods",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    DoesCareReceiverLiveInSameHousehold = "DoesCareReceiverLiveInSameHousehold",
    HasOtherCareGiverBenefitClaim = "HasOtherCareGiverBenefitClaim",
    IsCaringPersonally = "IsCaringPersonally",
    IsDuration = "IsDuration",
    IsEnd = "IsEnd",
    IsOtherCareGiverIncapacitated = "IsOtherCareGiverIncapacitated",
    IsStart = "IsStart",
    CareReceiver = "CareReceiver",
    CaregivingIntervals = "CaregivingIntervals",
    CareReceiverRelationCode = "CareReceiverRelationCode",
    ClosedSchoolName = "ClosedSchoolName",
    ClosedSchoolNumber = "ClosedSchoolNumber",
    HasChildUnder16InSchool = "HasChildUnder16InSchool",
    IsLoneCaregiver = "IsLoneCaregiver",
    IsOtherCareGiverWorking = "IsOtherCareGiverWorking",
    ReasonForCareCode = "ReasonForCareCode",
    CareReceiverRelation = "CareReceiverRelation",
    EmployerConfirmation = "EmployerConfirmation",
    PaymentBasis = "PaymentBasis",
    ReasonForCare = "ReasonForCare",
}

export interface IPrCSSZSubmissionCaregivingDetailBaseEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AdditionalInfo?: string;
    DateDecisivePeriodEnd?: Date;
    DateDecisivePeriodStart?: Date;
    DecisionNumber?: string;
    IsCorrectiveSubmission?: boolean;
    IsForeigner?: boolean;
    PaymentMethodCode?: PrCSSZPaymentMethodCode;
    UserEmail?: string;
    EstimatedIncomeAmount?: number;
    ExcludedDays?: number;
    IncludableIncomeAmount?: number;
    Company?: IPrCSSZSubmissionCompanyEntity;
    Employment?: IPrCSSZSubmissionEmploymentEntity;
    PaymentConnectionDelivery?: IPrCSSZPaymentConnectionDeliveryEntity;
    PaymentConnectionWireTransferAbroad?: IPrCSSZPaymentConnectionWireTransferAbroadEntity;
    PaymentConnectionWireTransferCZ?: IPrCSSZPaymentConnectionWireTransferCZEntity;
    PaymentMethod?: IPrCSSZPaymentMethodEntity;
    DecisivePeriods?: IPrCSSZDecisivePeriodEntity[];
    DateEnd?: Date;
    DateStart?: Date;
    DoesCareReceiverLiveInSameHousehold?: boolean;
    HasOtherCareGiverBenefitClaim?: boolean;
    IsCaringPersonally?: boolean;
    IsDuration?: boolean;
    IsEnd?: boolean;
    IsOtherCareGiverIncapacitated?: boolean;
    IsStart?: boolean;
    CareReceiver?: IPrCareReceiverSubmissionEntity;
    CaregivingIntervals?: IPrSubmissionCaregivingIntervalEntity[];
}

export enum PrCSSZSubmissionCaregivingDetailBaseEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AdditionalInfo = "AdditionalInfo",
    DateDecisivePeriodEnd = "DateDecisivePeriodEnd",
    DateDecisivePeriodStart = "DateDecisivePeriodStart",
    DecisionNumber = "DecisionNumber",
    IsCorrectiveSubmission = "IsCorrectiveSubmission",
    IsForeigner = "IsForeigner",
    PaymentMethodCode = "PaymentMethodCode",
    UserEmail = "UserEmail",
    EstimatedIncomeAmount = "EstimatedIncomeAmount",
    ExcludedDays = "ExcludedDays",
    IncludableIncomeAmount = "IncludableIncomeAmount",
    Company = "Company",
    Employment = "Employment",
    PaymentConnectionDelivery = "PaymentConnectionDelivery",
    PaymentConnectionWireTransferAbroad = "PaymentConnectionWireTransferAbroad",
    PaymentConnectionWireTransferCZ = "PaymentConnectionWireTransferCZ",
    PaymentMethod = "PaymentMethod",
    DecisivePeriods = "DecisivePeriods",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    DoesCareReceiverLiveInSameHousehold = "DoesCareReceiverLiveInSameHousehold",
    HasOtherCareGiverBenefitClaim = "HasOtherCareGiverBenefitClaim",
    IsCaringPersonally = "IsCaringPersonally",
    IsDuration = "IsDuration",
    IsEnd = "IsEnd",
    IsOtherCareGiverIncapacitated = "IsOtherCareGiverIncapacitated",
    IsStart = "IsStart",
    CareReceiver = "CareReceiver",
    CaregivingIntervals = "CaregivingIntervals",
}

export interface IPrCSSZSubmissionCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LegalName?: string;
    LegalNumber?: string;
    Company?: ICompanyEntity;
    CSSZSymbolVariable?: string;
    SocialSecurityCode?: GovernmentInstitutionCode;
    SocialSecurity?: IGovernmentInstitutionEntity;
}

export enum PrCSSZSubmissionCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Company = "Company",
    CSSZSymbolVariable = "CSSZSymbolVariable",
    SocialSecurityCode = "SocialSecurityCode",
    SocialSecurity = "SocialSecurity",
}

export interface IPrCSSZSubmissionDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AdditionalInfo?: string;
    DateDecisivePeriodEnd?: Date;
    DateDecisivePeriodStart?: Date;
    DecisionNumber?: string;
    IsCorrectiveSubmission?: boolean;
    IsForeigner?: boolean;
    PaymentMethodCode?: PrCSSZPaymentMethodCode;
    UserEmail?: string;
    EstimatedIncomeAmount?: number;
    ExcludedDays?: number;
    IncludableIncomeAmount?: number;
    Company?: IPrCSSZSubmissionCompanyEntity;
    Employment?: IPrCSSZSubmissionEmploymentEntity;
    PaymentConnectionDelivery?: IPrCSSZPaymentConnectionDeliveryEntity;
    PaymentConnectionWireTransferAbroad?: IPrCSSZPaymentConnectionWireTransferAbroadEntity;
    PaymentConnectionWireTransferCZ?: IPrCSSZPaymentConnectionWireTransferCZEntity;
    PaymentMethod?: IPrCSSZPaymentMethodEntity;
    DecisivePeriods?: IPrCSSZDecisivePeriodEntity[];
}

export enum PrCSSZSubmissionDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AdditionalInfo = "AdditionalInfo",
    DateDecisivePeriodEnd = "DateDecisivePeriodEnd",
    DateDecisivePeriodStart = "DateDecisivePeriodStart",
    DecisionNumber = "DecisionNumber",
    IsCorrectiveSubmission = "IsCorrectiveSubmission",
    IsForeigner = "IsForeigner",
    PaymentMethodCode = "PaymentMethodCode",
    UserEmail = "UserEmail",
    EstimatedIncomeAmount = "EstimatedIncomeAmount",
    ExcludedDays = "ExcludedDays",
    IncludableIncomeAmount = "IncludableIncomeAmount",
    Company = "Company",
    Employment = "Employment",
    PaymentConnectionDelivery = "PaymentConnectionDelivery",
    PaymentConnectionWireTransferAbroad = "PaymentConnectionWireTransferAbroad",
    PaymentConnectionWireTransferCZ = "PaymentConnectionWireTransferCZ",
    PaymentMethod = "PaymentMethod",
    DecisivePeriods = "DecisivePeriods",
}

export interface IPrCSSZSubmissionEmployeeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BirthLastName?: string;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    TitleAfterName?: string;
    TitleBeforeName?: string;
    ContactAddress?: IPrEntityEmployeeContactAddressEntity;
    CzechAddress?: IPrEntityEmployeeCzechAddressEntity;
    Employee?: IPrEmployeeEntity;
    PermanentAddress?: IPrEntityEmployeePermanentAddressEntity;
    TaxResidenceAddress?: IPrEntityEmployeeTaxResidenceAddressEntity;
    Email?: string;
    EuSocialInsuranceNumber?: string;
    PhoneNumber?: string;
}

export enum PrCSSZSubmissionEmployeeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BirthLastName = "BirthLastName",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    TitleAfterName = "TitleAfterName",
    TitleBeforeName = "TitleBeforeName",
    ContactAddress = "ContactAddress",
    CzechAddress = "CzechAddress",
    Employee = "Employee",
    PermanentAddress = "PermanentAddress",
    TaxResidenceAddress = "TaxResidenceAddress",
    Email = "Email",
    EuSocialInsuranceNumber = "EuSocialInsuranceNumber",
    PhoneNumber = "PhoneNumber",
}

export interface IPrCSSZSubmissionEmployerConfirmationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    HasWorkedOnEventStartDate?: boolean;
    WorkedHoursOnEventStartDate?: number;
    ShiftLengthOnEventStartDate?: number;
    IncomeFromSmallScaleEmployment?: number;
}

export enum PrCSSZSubmissionEmployerConfirmationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    HasWorkedOnEventStartDate = "HasWorkedOnEventStartDate",
    WorkedHoursOnEventStartDate = "WorkedHoursOnEventStartDate",
    ShiftLengthOnEventStartDate = "ShiftLengthOnEventStartDate",
    IncomeFromSmallScaleEmployment = "IncomeFromSmallScaleEmployment",
}

export interface IPrCSSZSubmissionEmployerConfirmationCaregivingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    HasWorkedOnEventStartDate?: boolean;
    WorkedHoursOnEventStartDate?: number;
    ShiftLengthOnEventStartDate?: number;
    IncomeFromSmallScaleEmployment?: number;
    DateTransferToOtherWork?: Date;
    DateWorkLeaveWithoutPayFrom?: Date;
    DateWorkLeaveWithoutPayTo?: Date;
    HasWorkLeaveWithoutPay?: boolean;
    IsEmploymentInHolidays?: boolean;
    IsStudent?: boolean;
    IsTransferredToOtherWork?: boolean;
}

export enum PrCSSZSubmissionEmployerConfirmationCaregivingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    HasWorkedOnEventStartDate = "HasWorkedOnEventStartDate",
    WorkedHoursOnEventStartDate = "WorkedHoursOnEventStartDate",
    ShiftLengthOnEventStartDate = "ShiftLengthOnEventStartDate",
    IncomeFromSmallScaleEmployment = "IncomeFromSmallScaleEmployment",
    DateTransferToOtherWork = "DateTransferToOtherWork",
    DateWorkLeaveWithoutPayFrom = "DateWorkLeaveWithoutPayFrom",
    DateWorkLeaveWithoutPayTo = "DateWorkLeaveWithoutPayTo",
    HasWorkLeaveWithoutPay = "HasWorkLeaveWithoutPay",
    IsEmploymentInHolidays = "IsEmploymentInHolidays",
    IsStudent = "IsStudent",
    IsTransferredToOtherWork = "IsTransferredToOtherWork",
}

export interface IPrCSSZSubmissionEmployerConfirmationCaregivingBaseEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    HasWorkedOnEventStartDate?: boolean;
    WorkedHoursOnEventStartDate?: number;
    ShiftLengthOnEventStartDate?: number;
    IncomeFromSmallScaleEmployment?: number;
    DateTransferToOtherWork?: Date;
    DateWorkLeaveWithoutPayFrom?: Date;
    DateWorkLeaveWithoutPayTo?: Date;
    HasWorkLeaveWithoutPay?: boolean;
    IsEmploymentInHolidays?: boolean;
    IsStudent?: boolean;
    IsTransferredToOtherWork?: boolean;
}

export enum PrCSSZSubmissionEmployerConfirmationCaregivingBaseEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    HasWorkedOnEventStartDate = "HasWorkedOnEventStartDate",
    WorkedHoursOnEventStartDate = "WorkedHoursOnEventStartDate",
    ShiftLengthOnEventStartDate = "ShiftLengthOnEventStartDate",
    IncomeFromSmallScaleEmployment = "IncomeFromSmallScaleEmployment",
    DateTransferToOtherWork = "DateTransferToOtherWork",
    DateWorkLeaveWithoutPayFrom = "DateWorkLeaveWithoutPayFrom",
    DateWorkLeaveWithoutPayTo = "DateWorkLeaveWithoutPayTo",
    HasWorkLeaveWithoutPay = "HasWorkLeaveWithoutPay",
    IsEmploymentInHolidays = "IsEmploymentInHolidays",
    IsStudent = "IsStudent",
    IsTransferredToOtherWork = "IsTransferredToOtherWork",
}

export interface IPrCSSZSubmissionEmployerConfirmationIllnessLeaveEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    HasWorkedOnEventStartDate?: boolean;
    WorkedHoursOnEventStartDate?: number;
    ShiftLengthOnEventStartDate?: number;
    IncomeFromSmallScaleEmployment?: number;
    DateTransferToOtherWork?: Date;
    DateWorkLeaveWithoutPayFrom?: Date;
    DateWorkLeaveWithoutPayTo?: Date;
    HasWorkLeaveWithoutPay?: boolean;
    IsEmploymentInHolidays?: boolean;
    IsStudent?: boolean;
    IsTransferredToOtherWork?: boolean;
    DatePreviousChildBirth?: Date;
    HasDistrainment?: boolean;
    HasInsolvency?: boolean;
    IsFirstEmploymentLeave?: boolean;
    PensionTypeCode?: PrPensionTypeCode;
    SubsequentMaternityLeaveStatusCode?: PrSubsequentMaternityLeaveStatusCode;
    PensionType?: IPrPensionTypeEntity;
    SubsequentMaternityLeaveStatus?: IPrSubsequentMaternityLeaveStatusEntity;
}

export enum PrCSSZSubmissionEmployerConfirmationIllnessLeaveEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    HasWorkedOnEventStartDate = "HasWorkedOnEventStartDate",
    WorkedHoursOnEventStartDate = "WorkedHoursOnEventStartDate",
    ShiftLengthOnEventStartDate = "ShiftLengthOnEventStartDate",
    IncomeFromSmallScaleEmployment = "IncomeFromSmallScaleEmployment",
    DateTransferToOtherWork = "DateTransferToOtherWork",
    DateWorkLeaveWithoutPayFrom = "DateWorkLeaveWithoutPayFrom",
    DateWorkLeaveWithoutPayTo = "DateWorkLeaveWithoutPayTo",
    HasWorkLeaveWithoutPay = "HasWorkLeaveWithoutPay",
    IsEmploymentInHolidays = "IsEmploymentInHolidays",
    IsStudent = "IsStudent",
    IsTransferredToOtherWork = "IsTransferredToOtherWork",
    DatePreviousChildBirth = "DatePreviousChildBirth",
    HasDistrainment = "HasDistrainment",
    HasInsolvency = "HasInsolvency",
    IsFirstEmploymentLeave = "IsFirstEmploymentLeave",
    PensionTypeCode = "PensionTypeCode",
    SubsequentMaternityLeaveStatusCode = "SubsequentMaternityLeaveStatusCode",
    PensionType = "PensionType",
    SubsequentMaternityLeaveStatus = "SubsequentMaternityLeaveStatus",
}

export interface IPrCSSZSubmissionEmployerConfirmationLongtermCaregivingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    HasWorkedOnEventStartDate?: boolean;
    WorkedHoursOnEventStartDate?: number;
    ShiftLengthOnEventStartDate?: number;
    IncomeFromSmallScaleEmployment?: number;
    DateTransferToOtherWork?: Date;
    DateWorkLeaveWithoutPayFrom?: Date;
    DateWorkLeaveWithoutPayTo?: Date;
    HasWorkLeaveWithoutPay?: boolean;
    IsEmploymentInHolidays?: boolean;
    IsStudent?: boolean;
    IsTransferredToOtherWork?: boolean;
}

export enum PrCSSZSubmissionEmployerConfirmationLongtermCaregivingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    HasWorkedOnEventStartDate = "HasWorkedOnEventStartDate",
    WorkedHoursOnEventStartDate = "WorkedHoursOnEventStartDate",
    ShiftLengthOnEventStartDate = "ShiftLengthOnEventStartDate",
    IncomeFromSmallScaleEmployment = "IncomeFromSmallScaleEmployment",
    DateTransferToOtherWork = "DateTransferToOtherWork",
    DateWorkLeaveWithoutPayFrom = "DateWorkLeaveWithoutPayFrom",
    DateWorkLeaveWithoutPayTo = "DateWorkLeaveWithoutPayTo",
    HasWorkLeaveWithoutPay = "HasWorkLeaveWithoutPay",
    IsEmploymentInHolidays = "IsEmploymentInHolidays",
    IsStudent = "IsStudent",
    IsTransferredToOtherWork = "IsTransferredToOtherWork",
}

export interface IPrCSSZSubmissionEmployerConfirmationMaternityLeaveEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    HasWorkedOnEventStartDate?: boolean;
    WorkedHoursOnEventStartDate?: number;
    ShiftLengthOnEventStartDate?: number;
    IncomeFromSmallScaleEmployment?: number;
    DatePreviousChildBirth?: Date;
    DateTransferToOtherWork?: Date;
    HasDistrainment?: boolean;
    HasInsolvency?: boolean;
    IsTransferredToOtherWork?: boolean;
    PensionTypeCode?: PrPensionTypeCode;
    SubsequentMaternityLeaveStatusCode?: PrSubsequentMaternityLeaveStatusCode;
    PensionType?: IPrPensionTypeEntity;
    SubsequentMaternityLeaveStatus?: IPrSubsequentMaternityLeaveStatusEntity;
}

export enum PrCSSZSubmissionEmployerConfirmationMaternityLeaveEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    HasWorkedOnEventStartDate = "HasWorkedOnEventStartDate",
    WorkedHoursOnEventStartDate = "WorkedHoursOnEventStartDate",
    ShiftLengthOnEventStartDate = "ShiftLengthOnEventStartDate",
    IncomeFromSmallScaleEmployment = "IncomeFromSmallScaleEmployment",
    DatePreviousChildBirth = "DatePreviousChildBirth",
    DateTransferToOtherWork = "DateTransferToOtherWork",
    HasDistrainment = "HasDistrainment",
    HasInsolvency = "HasInsolvency",
    IsTransferredToOtherWork = "IsTransferredToOtherWork",
    PensionTypeCode = "PensionTypeCode",
    SubsequentMaternityLeaveStatusCode = "SubsequentMaternityLeaveStatusCode",
    PensionType = "PensionType",
    SubsequentMaternityLeaveStatus = "SubsequentMaternityLeaveStatus",
}

export interface IPrCSSZSubmissionEmployerConfirmationPaternityLeaveEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    HasWorkedOnEventStartDate?: boolean;
    WorkedHoursOnEventStartDate?: number;
    ShiftLengthOnEventStartDate?: number;
    IncomeFromSmallScaleEmployment?: number;
}

export enum PrCSSZSubmissionEmployerConfirmationPaternityLeaveEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    HasWorkedOnEventStartDate = "HasWorkedOnEventStartDate",
    WorkedHoursOnEventStartDate = "WorkedHoursOnEventStartDate",
    ShiftLengthOnEventStartDate = "ShiftLengthOnEventStartDate",
    IncomeFromSmallScaleEmployment = "IncomeFromSmallScaleEmployment",
}

export interface IPrCSSZSubmissionEmploymentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrEmploymentTypeCode;
    Employment?: IPrEmploymentEntity;
    Type?: IPrEmploymentTypeEntity;
    CsszEmploymentTypeCode?: CsszEmploymentTypeCode;
    DateEnd?: Date;
    DateStart?: Date;
    CsszEmploymentType?: ICsszEmploymentTypeEntity;
}

export enum PrCSSZSubmissionEmploymentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Employment = "Employment",
    Type = "Type",
    CsszEmploymentTypeCode = "CsszEmploymentTypeCode",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    CsszEmploymentType = "CsszEmploymentType",
}

export interface IPrCSSZSubmissionIllnessLeaveEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Employee?: IPrCSSZSubmissionEmployeeEntity;
    Detail?: IPrCSSZSubmissionIllnessLeaveDetailEntity;
}

export enum PrCSSZSubmissionIllnessLeaveEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Employee = "Employee",
    Detail = "Detail",
}

export interface IPrCSSZSubmissionIllnessLeaveDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AdditionalInfo?: string;
    DateDecisivePeriodEnd?: Date;
    DateDecisivePeriodStart?: Date;
    DecisionNumber?: string;
    IsCorrectiveSubmission?: boolean;
    IsForeigner?: boolean;
    PaymentMethodCode?: PrCSSZPaymentMethodCode;
    UserEmail?: string;
    EstimatedIncomeAmount?: number;
    ExcludedDays?: number;
    IncludableIncomeAmount?: number;
    Company?: IPrCSSZSubmissionCompanyEntity;
    Employment?: IPrCSSZSubmissionEmploymentEntity;
    PaymentConnectionDelivery?: IPrCSSZPaymentConnectionDeliveryEntity;
    PaymentConnectionWireTransferAbroad?: IPrCSSZPaymentConnectionWireTransferAbroadEntity;
    PaymentConnectionWireTransferCZ?: IPrCSSZPaymentConnectionWireTransferCZEntity;
    PaymentMethod?: IPrCSSZPaymentMethodEntity;
    DecisivePeriods?: IPrCSSZDecisivePeriodEntity[];
    EmployerConfirmation?: IPrCSSZSubmissionEmployerConfirmationIllnessLeaveEntity;
}

export enum PrCSSZSubmissionIllnessLeaveDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AdditionalInfo = "AdditionalInfo",
    DateDecisivePeriodEnd = "DateDecisivePeriodEnd",
    DateDecisivePeriodStart = "DateDecisivePeriodStart",
    DecisionNumber = "DecisionNumber",
    IsCorrectiveSubmission = "IsCorrectiveSubmission",
    IsForeigner = "IsForeigner",
    PaymentMethodCode = "PaymentMethodCode",
    UserEmail = "UserEmail",
    EstimatedIncomeAmount = "EstimatedIncomeAmount",
    ExcludedDays = "ExcludedDays",
    IncludableIncomeAmount = "IncludableIncomeAmount",
    Company = "Company",
    Employment = "Employment",
    PaymentConnectionDelivery = "PaymentConnectionDelivery",
    PaymentConnectionWireTransferAbroad = "PaymentConnectionWireTransferAbroad",
    PaymentConnectionWireTransferCZ = "PaymentConnectionWireTransferCZ",
    PaymentMethod = "PaymentMethod",
    DecisivePeriods = "DecisivePeriods",
    EmployerConfirmation = "EmployerConfirmation",
}

export interface IPrCSSZSubmissionLongtermCaregivingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Employee?: IPrCSSZSubmissionEmployeeEntity;
    Detail?: IPrCSSZSubmissionLongtermCaregivingDetailEntity;
}

export enum PrCSSZSubmissionLongtermCaregivingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Employee = "Employee",
    Detail = "Detail",
}

export interface IPrCSSZSubmissionLongtermCaregivingDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AdditionalInfo?: string;
    DateDecisivePeriodEnd?: Date;
    DateDecisivePeriodStart?: Date;
    DecisionNumber?: string;
    IsCorrectiveSubmission?: boolean;
    IsForeigner?: boolean;
    PaymentMethodCode?: PrCSSZPaymentMethodCode;
    UserEmail?: string;
    EstimatedIncomeAmount?: number;
    ExcludedDays?: number;
    IncludableIncomeAmount?: number;
    Company?: IPrCSSZSubmissionCompanyEntity;
    Employment?: IPrCSSZSubmissionEmploymentEntity;
    PaymentConnectionDelivery?: IPrCSSZPaymentConnectionDeliveryEntity;
    PaymentConnectionWireTransferAbroad?: IPrCSSZPaymentConnectionWireTransferAbroadEntity;
    PaymentConnectionWireTransferCZ?: IPrCSSZPaymentConnectionWireTransferCZEntity;
    PaymentMethod?: IPrCSSZPaymentMethodEntity;
    DecisivePeriods?: IPrCSSZDecisivePeriodEntity[];
    DateEnd?: Date;
    DateStart?: Date;
    DoesCareReceiverLiveInSameHousehold?: boolean;
    HasOtherCareGiverBenefitClaim?: boolean;
    IsCaringPersonally?: boolean;
    IsDuration?: boolean;
    IsEnd?: boolean;
    IsOtherCareGiverIncapacitated?: boolean;
    IsStart?: boolean;
    CareReceiver?: IPrCareReceiverSubmissionEntity;
    CaregivingIntervals?: IPrSubmissionCaregivingIntervalEntity[];
    CareReceiverRelationshipCode?: PrMpsvRelationCode;
    HasMultipleCaregivers?: boolean;
    CareReceiverRelationship?: IPrMpsvRelationEntity;
    EmployerConfirmation?: IPrCSSZSubmissionEmployerConfirmationLongtermCaregivingEntity;
    PaymentBasis?: IPrCSSZSubmissionPaymentBasisLongtermCaregivingEntity;
}

export enum PrCSSZSubmissionLongtermCaregivingDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AdditionalInfo = "AdditionalInfo",
    DateDecisivePeriodEnd = "DateDecisivePeriodEnd",
    DateDecisivePeriodStart = "DateDecisivePeriodStart",
    DecisionNumber = "DecisionNumber",
    IsCorrectiveSubmission = "IsCorrectiveSubmission",
    IsForeigner = "IsForeigner",
    PaymentMethodCode = "PaymentMethodCode",
    UserEmail = "UserEmail",
    EstimatedIncomeAmount = "EstimatedIncomeAmount",
    ExcludedDays = "ExcludedDays",
    IncludableIncomeAmount = "IncludableIncomeAmount",
    Company = "Company",
    Employment = "Employment",
    PaymentConnectionDelivery = "PaymentConnectionDelivery",
    PaymentConnectionWireTransferAbroad = "PaymentConnectionWireTransferAbroad",
    PaymentConnectionWireTransferCZ = "PaymentConnectionWireTransferCZ",
    PaymentMethod = "PaymentMethod",
    DecisivePeriods = "DecisivePeriods",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    DoesCareReceiverLiveInSameHousehold = "DoesCareReceiverLiveInSameHousehold",
    HasOtherCareGiverBenefitClaim = "HasOtherCareGiverBenefitClaim",
    IsCaringPersonally = "IsCaringPersonally",
    IsDuration = "IsDuration",
    IsEnd = "IsEnd",
    IsOtherCareGiverIncapacitated = "IsOtherCareGiverIncapacitated",
    IsStart = "IsStart",
    CareReceiver = "CareReceiver",
    CaregivingIntervals = "CaregivingIntervals",
    CareReceiverRelationshipCode = "CareReceiverRelationshipCode",
    HasMultipleCaregivers = "HasMultipleCaregivers",
    CareReceiverRelationship = "CareReceiverRelationship",
    EmployerConfirmation = "EmployerConfirmation",
    PaymentBasis = "PaymentBasis",
}

export interface IPrCSSZSubmissionMaternityLeaveEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Employee?: IPrCSSZSubmissionEmployeeEntity;
    Detail?: IPrCSSZSubmissionMaternityLeaveDetailEntity;
}

export enum PrCSSZSubmissionMaternityLeaveEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Employee = "Employee",
    Detail = "Detail",
}

export interface IPrCSSZSubmissionMaternityLeaveDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AdditionalInfo?: string;
    DateDecisivePeriodEnd?: Date;
    DateDecisivePeriodStart?: Date;
    DecisionNumber?: string;
    IsCorrectiveSubmission?: boolean;
    IsForeigner?: boolean;
    PaymentMethodCode?: PrCSSZPaymentMethodCode;
    UserEmail?: string;
    EstimatedIncomeAmount?: number;
    ExcludedDays?: number;
    IncludableIncomeAmount?: number;
    Company?: IPrCSSZSubmissionCompanyEntity;
    Employment?: IPrCSSZSubmissionEmploymentEntity;
    PaymentConnectionDelivery?: IPrCSSZPaymentConnectionDeliveryEntity;
    PaymentConnectionWireTransferAbroad?: IPrCSSZPaymentConnectionWireTransferAbroadEntity;
    PaymentConnectionWireTransferCZ?: IPrCSSZPaymentConnectionWireTransferCZEntity;
    PaymentMethod?: IPrCSSZPaymentMethodEntity;
    DecisivePeriods?: IPrCSSZDecisivePeriodEntity[];
    DateStart?: Date;
    MaternityReasonCode?: PrMaternityLeaveEntitlementCode;
    EmployerConfirmation?: IPrCSSZSubmissionEmployerConfirmationMaternityLeaveEntity;
    MaternityReason?: IPrMaternityLeaveEntitlementEntity;
    Children?: IPrCareReceiverChildEntity[];
}

export enum PrCSSZSubmissionMaternityLeaveDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AdditionalInfo = "AdditionalInfo",
    DateDecisivePeriodEnd = "DateDecisivePeriodEnd",
    DateDecisivePeriodStart = "DateDecisivePeriodStart",
    DecisionNumber = "DecisionNumber",
    IsCorrectiveSubmission = "IsCorrectiveSubmission",
    IsForeigner = "IsForeigner",
    PaymentMethodCode = "PaymentMethodCode",
    UserEmail = "UserEmail",
    EstimatedIncomeAmount = "EstimatedIncomeAmount",
    ExcludedDays = "ExcludedDays",
    IncludableIncomeAmount = "IncludableIncomeAmount",
    Company = "Company",
    Employment = "Employment",
    PaymentConnectionDelivery = "PaymentConnectionDelivery",
    PaymentConnectionWireTransferAbroad = "PaymentConnectionWireTransferAbroad",
    PaymentConnectionWireTransferCZ = "PaymentConnectionWireTransferCZ",
    PaymentMethod = "PaymentMethod",
    DecisivePeriods = "DecisivePeriods",
    DateStart = "DateStart",
    MaternityReasonCode = "MaternityReasonCode",
    EmployerConfirmation = "EmployerConfirmation",
    MaternityReason = "MaternityReason",
    Children = "Children",
}

export interface IPrCSSZSubmissionPaternityLeaveEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Employee?: IPrCSSZSubmissionEmployeeEntity;
    Detail?: IPrCSSZSubmissionPaternityLeaveDetailEntity;
}

export enum PrCSSZSubmissionPaternityLeaveEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Employee = "Employee",
    Detail = "Detail",
}

export interface IPrCSSZSubmissionPaternityLeaveDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AdditionalInfo?: string;
    DateDecisivePeriodEnd?: Date;
    DateDecisivePeriodStart?: Date;
    DecisionNumber?: string;
    IsCorrectiveSubmission?: boolean;
    IsForeigner?: boolean;
    PaymentMethodCode?: PrCSSZPaymentMethodCode;
    UserEmail?: string;
    EstimatedIncomeAmount?: number;
    ExcludedDays?: number;
    IncludableIncomeAmount?: number;
    Company?: IPrCSSZSubmissionCompanyEntity;
    Employment?: IPrCSSZSubmissionEmploymentEntity;
    PaymentConnectionDelivery?: IPrCSSZPaymentConnectionDeliveryEntity;
    PaymentConnectionWireTransferAbroad?: IPrCSSZPaymentConnectionWireTransferAbroadEntity;
    PaymentConnectionWireTransferCZ?: IPrCSSZPaymentConnectionWireTransferCZEntity;
    PaymentMethod?: IPrCSSZPaymentMethodEntity;
    DecisivePeriods?: IPrCSSZDecisivePeriodEntity[];
    DateStart?: Date;
    PaternityReasonCode?: PrPaternityLeaveEntitlementCode;
    CareReceiver?: IPrCareReceiverSubmissionEntity;
    EmployerConfirmation?: IPrCSSZSubmissionEmployerConfirmationPaternityLeaveEntity;
    PaternityReason?: IPrPaternityLeaveEntitlementEntity;
    PaymentBasis?: IPrCSSZSubmissionPaymentBasisPaternityLeaveEntity;
}

export enum PrCSSZSubmissionPaternityLeaveDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AdditionalInfo = "AdditionalInfo",
    DateDecisivePeriodEnd = "DateDecisivePeriodEnd",
    DateDecisivePeriodStart = "DateDecisivePeriodStart",
    DecisionNumber = "DecisionNumber",
    IsCorrectiveSubmission = "IsCorrectiveSubmission",
    IsForeigner = "IsForeigner",
    PaymentMethodCode = "PaymentMethodCode",
    UserEmail = "UserEmail",
    EstimatedIncomeAmount = "EstimatedIncomeAmount",
    ExcludedDays = "ExcludedDays",
    IncludableIncomeAmount = "IncludableIncomeAmount",
    Company = "Company",
    Employment = "Employment",
    PaymentConnectionDelivery = "PaymentConnectionDelivery",
    PaymentConnectionWireTransferAbroad = "PaymentConnectionWireTransferAbroad",
    PaymentConnectionWireTransferCZ = "PaymentConnectionWireTransferCZ",
    PaymentMethod = "PaymentMethod",
    DecisivePeriods = "DecisivePeriods",
    DateStart = "DateStart",
    PaternityReasonCode = "PaternityReasonCode",
    CareReceiver = "CareReceiver",
    EmployerConfirmation = "EmployerConfirmation",
    PaternityReason = "PaternityReason",
    PaymentBasis = "PaymentBasis",
}

export interface IPrCSSZSubmissionPaymentBasisEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateReturnToWork?: Date;
    HasPlannedShifts?: boolean;
    HasWorkedOnPlannedShifts?: boolean;
    ShiftLengthOnLastDayOfSupportPeriod?: number;
    WorkedHoursOnLastDayOfSupportPeriod?: number;
    WorkedInDays?: IPrWorkedInDaysIntervalEntity[];
}

export enum PrCSSZSubmissionPaymentBasisEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateReturnToWork = "DateReturnToWork",
    HasPlannedShifts = "HasPlannedShifts",
    HasWorkedOnPlannedShifts = "HasWorkedOnPlannedShifts",
    ShiftLengthOnLastDayOfSupportPeriod = "ShiftLengthOnLastDayOfSupportPeriod",
    WorkedHoursOnLastDayOfSupportPeriod = "WorkedHoursOnLastDayOfSupportPeriod",
    WorkedInDays = "WorkedInDays",
}

export interface IPrCSSZSubmissionPaymentBasisCaregivingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateReturnToWork?: Date;
    HasPlannedShifts?: boolean;
    HasWorkedOnPlannedShifts?: boolean;
    ShiftLengthOnLastDayOfSupportPeriod?: number;
    WorkedHoursOnLastDayOfSupportPeriod?: number;
    WorkedInDays?: IPrWorkedInDaysIntervalEntity[];
    HasWorkedOnLastDayOfSupportPeriod?: boolean;
}

export enum PrCSSZSubmissionPaymentBasisCaregivingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateReturnToWork = "DateReturnToWork",
    HasPlannedShifts = "HasPlannedShifts",
    HasWorkedOnPlannedShifts = "HasWorkedOnPlannedShifts",
    ShiftLengthOnLastDayOfSupportPeriod = "ShiftLengthOnLastDayOfSupportPeriod",
    WorkedHoursOnLastDayOfSupportPeriod = "WorkedHoursOnLastDayOfSupportPeriod",
    WorkedInDays = "WorkedInDays",
    HasWorkedOnLastDayOfSupportPeriod = "HasWorkedOnLastDayOfSupportPeriod",
}

export interface IPrCSSZSubmissionPaymentBasisLongtermCaregivingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateReturnToWork?: Date;
    HasPlannedShifts?: boolean;
    HasWorkedOnPlannedShifts?: boolean;
    ShiftLengthOnLastDayOfSupportPeriod?: number;
    WorkedHoursOnLastDayOfSupportPeriod?: number;
    WorkedInDays?: IPrWorkedInDaysIntervalEntity[];
    HasWorkLeave?: boolean;
    WorkLeaveDays?: IPrWorkLeaveDaysIntervalEntity[];
    WorkScheduleDays?: IPrWorkScheduleDaysIntervalEntity[];
}

export enum PrCSSZSubmissionPaymentBasisLongtermCaregivingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateReturnToWork = "DateReturnToWork",
    HasPlannedShifts = "HasPlannedShifts",
    HasWorkedOnPlannedShifts = "HasWorkedOnPlannedShifts",
    ShiftLengthOnLastDayOfSupportPeriod = "ShiftLengthOnLastDayOfSupportPeriod",
    WorkedHoursOnLastDayOfSupportPeriod = "WorkedHoursOnLastDayOfSupportPeriod",
    WorkedInDays = "WorkedInDays",
    HasWorkLeave = "HasWorkLeave",
    WorkLeaveDays = "WorkLeaveDays",
    WorkScheduleDays = "WorkScheduleDays",
}

export interface IPrCSSZSubmissionPaymentBasisPaternityLeaveEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateReturnToWork?: Date;
    HasPlannedShifts?: boolean;
    HasWorkedOnPlannedShifts?: boolean;
    ShiftLengthOnLastDayOfSupportPeriod?: number;
    WorkedHoursOnLastDayOfSupportPeriod?: number;
    WorkedInDays?: IPrWorkedInDaysIntervalEntity[];
}

export enum PrCSSZSubmissionPaymentBasisPaternityLeaveEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateReturnToWork = "DateReturnToWork",
    HasPlannedShifts = "HasPlannedShifts",
    HasWorkedOnPlannedShifts = "HasWorkedOnPlannedShifts",
    ShiftLengthOnLastDayOfSupportPeriod = "ShiftLengthOnLastDayOfSupportPeriod",
    WorkedHoursOnLastDayOfSupportPeriod = "WorkedHoursOnLastDayOfSupportPeriod",
    WorkedInDays = "WorkedInDays",
}

export interface IPrCSSZSubmissionResultEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CorrelationId?: string;
    SymbolVariable?: string;
    CSSZSubmissionTypeCode?: CSSZSubmissionTypeCode;
    Result?: string;
    CSSZSubmissionType?: ICSSZSubmissionTypeEntity;
}

export enum PrCSSZSubmissionResultEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CorrelationId = "CorrelationId",
    SymbolVariable = "SymbolVariable",
    CSSZSubmissionTypeCode = "CSSZSubmissionTypeCode",
    Result = "Result",
    CSSZSubmissionType = "CSSZSubmissionType",
}

export interface IPrCareReceiverEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    IdentificationNumber?: string;
    LastName?: string;
}

export enum PrCareReceiverEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    IdentificationNumber = "IdentificationNumber",
    LastName = "LastName",
}

export interface IPrCareReceiverChildEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    IdentificationNumber?: string;
    LastName?: string;
    Order?: number;
}

export enum PrCareReceiverChildEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    IdentificationNumber = "IdentificationNumber",
    LastName = "LastName",
    Order = "Order",
}

export interface IPrCareReceiverSocialEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    IdentificationNumber?: string;
    LastName?: string;
    Attachments?: IPrSocialEventBirthCertificateAttachmentEntity[];
}

export enum PrCareReceiverSocialEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    IdentificationNumber = "IdentificationNumber",
    LastName = "LastName",
    Attachments = "Attachments",
}

export interface IPrCareReceiverSubmissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    IdentificationNumber?: string;
    LastName?: string;
}

export enum PrCareReceiverSubmissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    IdentificationNumber = "IdentificationNumber",
    LastName = "LastName",
}

export interface IPrCaregivingEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEventEnd?: Date;
    DateEventStart?: Date;
    DateRequiredActionFrom?: Date;
    IsProcessed?: boolean;
    NumberOurs?: string;
    NumberTheirs?: string;
    RequiredActionCode?: PrSocialEventRequiredActionCode;
    SocialEventStatusCode?: PrSocialEventStatusCode;
    SocialEventTypeCode?: PrSocialEventTypeCode;
    WorkedHoursOnFirstDay?: number;
    WorkedHoursOnLastDay?: number;
    Employee?: IPrEmployeeEntity;
    Employment?: IPrEmploymentEntity;
    NumberRange?: INumberRangeEntity;
    RequiredAction?: IPrSocialEventRequiredActionEntity;
    SocialEventStatus?: IPrSocialEventStatusEntity;
    SocialEventType?: IPrSocialEventTypeEntity;
    Attachments?: IPrSocialEventAttachmentEntity[];
    AttendanceDayIntervals?: IPrAttendanceDayIntervalEntity[];
    CertificateAttachments?: IPrSocialEventCertificateAttachmentEntity[];
    MonthDetails?: IPrSocialEventMonthDetailEntity[];
    Submissions?: IPrSubmissionEntity[];
    CareReceiverFamilyRelationCode?: PrMpsvFamilyRelationCode;
    CaregivingTypeCode?: PrCaregivingTypeCode;
    FacilityLegalNumber?: string;
    FacilityName?: string;
    IsAllowanceReceiverUnfit?: boolean;
    IsAllowanceReceiverWorking?: boolean;
    IsSameHousehold?: boolean;
    IsSingleCaregiverOfChild?: boolean;
    IsSomeoneElseReceivingAllowance?: boolean;
    CaregivingType?: IPrCaregivingTypeEntity;
    CareReceiver?: IPrCareReceiverSocialEventEntity;
    CareReceiverFamilyRelation?: IPrMpsvFamilyRelationEntity;
}

export enum PrCaregivingEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEventEnd = "DateEventEnd",
    DateEventStart = "DateEventStart",
    DateRequiredActionFrom = "DateRequiredActionFrom",
    IsProcessed = "IsProcessed",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    RequiredActionCode = "RequiredActionCode",
    SocialEventStatusCode = "SocialEventStatusCode",
    SocialEventTypeCode = "SocialEventTypeCode",
    WorkedHoursOnFirstDay = "WorkedHoursOnFirstDay",
    WorkedHoursOnLastDay = "WorkedHoursOnLastDay",
    Employee = "Employee",
    Employment = "Employment",
    NumberRange = "NumberRange",
    RequiredAction = "RequiredAction",
    SocialEventStatus = "SocialEventStatus",
    SocialEventType = "SocialEventType",
    Attachments = "Attachments",
    AttendanceDayIntervals = "AttendanceDayIntervals",
    CertificateAttachments = "CertificateAttachments",
    MonthDetails = "MonthDetails",
    Submissions = "Submissions",
    CareReceiverFamilyRelationCode = "CareReceiverFamilyRelationCode",
    CaregivingTypeCode = "CaregivingTypeCode",
    FacilityLegalNumber = "FacilityLegalNumber",
    FacilityName = "FacilityName",
    IsAllowanceReceiverUnfit = "IsAllowanceReceiverUnfit",
    IsAllowanceReceiverWorking = "IsAllowanceReceiverWorking",
    IsSameHousehold = "IsSameHousehold",
    IsSingleCaregiverOfChild = "IsSingleCaregiverOfChild",
    IsSomeoneElseReceivingAllowance = "IsSomeoneElseReceivingAllowance",
    CaregivingType = "CaregivingType",
    CareReceiver = "CareReceiver",
    CareReceiverFamilyRelation = "CareReceiverFamilyRelation",
}

export interface IPrCaregivingTypeEntity extends IEntityBase {
    Code?: PrCaregivingTypeCode;
    Name?: string;
}

export enum PrCaregivingTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrChildDeductionOrderEntity extends IEntityBase {
    Code?: PrChildDeductionOrderCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Description?: string;
    MpsvCode?: string;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrChildDeductionOrderEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Description = "Description",
    MpsvCode = "MpsvCode",
    Name = "Name",
    Country = "Country",
}

export interface IPrChildSupportDeductionTypeEntity extends IEntityBase {
    Code?: PrChildSupportDeductionTypeCode;
    Name?: string;
}

export enum PrChildSupportDeductionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrCollectionItemChangeTypeEntity extends IEntityBase {
    Code?: PrCollectionItemChangeTypeCode;
    Name?: string;
}

export enum PrCollectionItemChangeTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrCsszHzupnSubmissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Detail?: IPrCsszHzupnSubmissionDetailEntity;
    Employee?: IPrCsszHzupnSubmissionEmployeeEntity;
}

export enum PrCsszHzupnSubmissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Detail = "Detail",
    Employee = "Employee",
}

export interface IPrCsszHzupnSubmissionCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LegalName?: string;
    LegalNumber?: string;
    Company?: ICompanyEntity;
    CSSZSymbolVariable?: string;
    SocialSecurityCode?: GovernmentInstitutionCode;
    SocialSecurity?: IGovernmentInstitutionEntity;
}

export enum PrCsszHzupnSubmissionCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Company = "Company",
    CSSZSymbolVariable = "CSSZSymbolVariable",
    SocialSecurityCode = "SocialSecurityCode",
    SocialSecurity = "SocialSecurity",
}

export interface IPrCsszHzupnSubmissionDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEmployeeStartedEmployment?: Date;
    DateIssued?: Date;
    DecisionNumber?: string;
    EmployeeNotStartedEmploymentReason?: string;
    HasEmployeeStartedEmploymentCode?: YesNoCode;
    IsCorrectiveSubmission?: boolean;
    IsForeigner?: boolean;
    UserEmail?: string;
    WorkedHoursOnLastIllnessDay?: number;
    ShiftLengthOnLastIllnessDay?: number;
    Company?: IPrCsszHzupnSubmissionCompanyEntity;
    HasEmployeeStartedEmployment?: IYesNoEntity;
    WorkedIntervals?: IPrCsszHzupnSubmissionWorkedIntervalEntity[];
}

export enum PrCsszHzupnSubmissionDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEmployeeStartedEmployment = "DateEmployeeStartedEmployment",
    DateIssued = "DateIssued",
    DecisionNumber = "DecisionNumber",
    EmployeeNotStartedEmploymentReason = "EmployeeNotStartedEmploymentReason",
    HasEmployeeStartedEmploymentCode = "HasEmployeeStartedEmploymentCode",
    IsCorrectiveSubmission = "IsCorrectiveSubmission",
    IsForeigner = "IsForeigner",
    UserEmail = "UserEmail",
    WorkedHoursOnLastIllnessDay = "WorkedHoursOnLastIllnessDay",
    ShiftLengthOnLastIllnessDay = "ShiftLengthOnLastIllnessDay",
    Company = "Company",
    HasEmployeeStartedEmployment = "HasEmployeeStartedEmployment",
    WorkedIntervals = "WorkedIntervals",
}

export interface IPrCsszHzupnSubmissionEmployeeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BirthLastName?: string;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    TitleAfterName?: string;
    TitleBeforeName?: string;
    ContactAddress?: IPrEntityEmployeeContactAddressEntity;
    CzechAddress?: IPrEntityEmployeeCzechAddressEntity;
    Employee?: IPrEmployeeEntity;
    PermanentAddress?: IPrEntityEmployeePermanentAddressEntity;
    TaxResidenceAddress?: IPrEntityEmployeeTaxResidenceAddressEntity;
    EuSocialInsuranceNumber?: string;
}

export enum PrCsszHzupnSubmissionEmployeeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BirthLastName = "BirthLastName",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    TitleAfterName = "TitleAfterName",
    TitleBeforeName = "TitleBeforeName",
    ContactAddress = "ContactAddress",
    CzechAddress = "CzechAddress",
    Employee = "Employee",
    PermanentAddress = "PermanentAddress",
    TaxResidenceAddress = "TaxResidenceAddress",
    EuSocialInsuranceNumber = "EuSocialInsuranceNumber",
}

export interface IPrCsszHzupnSubmissionWorkedIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    DateTo?: Date;
}

export enum PrCsszHzupnSubmissionWorkedIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
}

export interface IPrCsszOzuspojSubmissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Detail?: IPrCsszOzuspojSubmissionDetailEntity;
    Employee?: IPrCsszOzuspojSubmissionEmployeeEntity;
}

export enum PrCsszOzuspojSubmissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Detail = "Detail",
    Employee = "Employee",
}

export interface IPrCsszOzuspojSubmissionCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LegalName?: string;
    LegalNumber?: string;
    Company?: ICompanyEntity;
    CSSZSymbolVariable?: string;
    SocialSecurityCode?: GovernmentInstitutionCode;
    SocialSecurity?: IGovernmentInstitutionEntity;
}

export enum PrCsszOzuspojSubmissionCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Company = "Company",
    CSSZSymbolVariable = "CSSZSymbolVariable",
    SocialSecurityCode = "SocialSecurityCode",
    SocialSecurity = "SocialSecurity",
}

export interface IPrCsszOzuspojSubmissionContactWorkerEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    PhoneNumber?: string;
}

export enum PrCsszOzuspojSubmissionContactWorkerEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    PhoneNumber = "PhoneNumber",
}

export interface IPrCsszOzuspojSubmissionDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEnd?: Date;
    DateStart?: Date;
    UserEmail?: string;
    Company?: IPrCsszOzuspojSubmissionCompanyEntity;
    ContactWorker?: IPrCsszOzuspojSubmissionContactWorkerEntity;
}

export enum PrCsszOzuspojSubmissionDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    UserEmail = "UserEmail",
    Company = "Company",
    ContactWorker = "ContactWorker",
}

export interface IPrCsszOzuspojSubmissionEmployeeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BirthLastName?: string;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    TitleAfterName?: string;
    TitleBeforeName?: string;
    ContactAddress?: IPrEntityEmployeeContactAddressEntity;
    CzechAddress?: IPrEntityEmployeeCzechAddressEntity;
    Employee?: IPrEmployeeEntity;
    PermanentAddress?: IPrEntityEmployeePermanentAddressEntity;
    TaxResidenceAddress?: IPrEntityEmployeeTaxResidenceAddressEntity;
    Email?: string;
    EuSocialInsuranceNumber?: string;
    PhoneNumber?: string;
}

export enum PrCsszOzuspojSubmissionEmployeeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BirthLastName = "BirthLastName",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    TitleAfterName = "TitleAfterName",
    TitleBeforeName = "TitleBeforeName",
    ContactAddress = "ContactAddress",
    CzechAddress = "CzechAddress",
    Employee = "Employee",
    PermanentAddress = "PermanentAddress",
    TaxResidenceAddress = "TaxResidenceAddress",
    Email = "Email",
    EuSocialInsuranceNumber = "EuSocialInsuranceNumber",
    PhoneNumber = "PhoneNumber",
}

export interface IPrCustodyEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEventEnd?: Date;
    DateEventStart?: Date;
    DateRequiredActionFrom?: Date;
    IsProcessed?: boolean;
    NumberOurs?: string;
    NumberTheirs?: string;
    RequiredActionCode?: PrSocialEventRequiredActionCode;
    SocialEventStatusCode?: PrSocialEventStatusCode;
    SocialEventTypeCode?: PrSocialEventTypeCode;
    WorkedHoursOnFirstDay?: number;
    WorkedHoursOnLastDay?: number;
    Employee?: IPrEmployeeEntity;
    Employment?: IPrEmploymentEntity;
    NumberRange?: INumberRangeEntity;
    RequiredAction?: IPrSocialEventRequiredActionEntity;
    SocialEventStatus?: IPrSocialEventStatusEntity;
    SocialEventType?: IPrSocialEventTypeEntity;
    Attachments?: IPrSocialEventAttachmentEntity[];
    AttendanceDayIntervals?: IPrAttendanceDayIntervalEntity[];
    CertificateAttachments?: IPrSocialEventCertificateAttachmentEntity[];
    MonthDetails?: IPrSocialEventMonthDetailEntity[];
    Submissions?: IPrSubmissionEntity[];
}

export enum PrCustodyEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEventEnd = "DateEventEnd",
    DateEventStart = "DateEventStart",
    DateRequiredActionFrom = "DateRequiredActionFrom",
    IsProcessed = "IsProcessed",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    RequiredActionCode = "RequiredActionCode",
    SocialEventStatusCode = "SocialEventStatusCode",
    SocialEventTypeCode = "SocialEventTypeCode",
    WorkedHoursOnFirstDay = "WorkedHoursOnFirstDay",
    WorkedHoursOnLastDay = "WorkedHoursOnLastDay",
    Employee = "Employee",
    Employment = "Employment",
    NumberRange = "NumberRange",
    RequiredAction = "RequiredAction",
    SocialEventStatus = "SocialEventStatus",
    SocialEventType = "SocialEventType",
    Attachments = "Attachments",
    AttendanceDayIntervals = "AttendanceDayIntervals",
    CertificateAttachments = "CertificateAttachments",
    MonthDetails = "MonthDetails",
    Submissions = "Submissions",
}

export interface IPrCzechReductionLimitEntity extends IEntityBase {
    Code?: PrCzechReductionLimitCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Percentage?: number;
    AmountLimit?: number;
    Country?: ICountryEntity;
}

export enum PrCzechReductionLimitEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Percentage = "Percentage",
    AmountLimit = "AmountLimit",
    Country = "Country",
}

export interface IPrDeductionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ChildSupportTypeCode?: PrChildSupportDeductionTypeCode;
    DateEnd?: Date;
    DateLegallyEffective?: Date;
    DateReceived?: Date;
    DateStart?: Date;
    DecreeNumber?: string;
    DepositedAmount?: number;
    DistrainmentDepositClosingCode?: PrDistrainmentDepositClosingCode;
    DistrainmentTypeCode?: PrDistrainmentDeductionTypeCode;
    InsolvencyDepositClosingCode?: PrInsolvencyDepositClosingCode;
    IsCompanyOwn?: boolean;
    IsRegularSupportIncludedInInsolvency?: boolean;
    Name?: string;
    NumberOurs?: string;
    PayableAccountNumber?: string;
    RemittanceInformation?: string;
    StatusCode?: PrDeductionStatusCode;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TypeCode?: PrDeductionTypeCode;
    AmountDebtTotal?: number;
    BankAccount?: IPrDeductionBankAccountEntity;
    ChildSupportType?: IPrChildSupportDeductionTypeEntity;
    CurrentTemporalPropertyBag?: IPrDeductionTemporalCurrentEntity;
    DepositClosingDocument?: IOtherLiabilityEntity;
    DistrainmentDepositClosing?: IPrDistrainmentDepositClosingEntity;
    DistrainmentType?: IPrDistrainmentDeductionTypeEntity;
    Employee?: IPrEmployeeEntity;
    InsolvencyDepositClosing?: IPrInsolvencyDepositClosingEntity;
    NumberRange?: INumberRangeEntity;
    Recipient?: IPrDeductionBusinessPartnerEntity;
    Status?: IPrDeductionStatusEntity;
    Type?: IPrDeductionTypeEntity;
    Attachments?: IPrDeductionAttachmentEntity[];
    Employees?: IPrDeductionEmployeeEntity[];
    OtherPayments?: IPrDeductionOtherPaymentEntity[];
    PayslipDocuments?: IPrDeductionPayslipDocumentEntity[];
    TemporalPropertyBag?: IPrDeductionTemporalEntity[];
    UnpaidChildSupportAmounts?: IPrDeductionUnpaidChildSupportAmountEntity[];
}

export enum PrDeductionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ChildSupportTypeCode = "ChildSupportTypeCode",
    DateEnd = "DateEnd",
    DateLegallyEffective = "DateLegallyEffective",
    DateReceived = "DateReceived",
    DateStart = "DateStart",
    DecreeNumber = "DecreeNumber",
    DepositedAmount = "DepositedAmount",
    DistrainmentDepositClosingCode = "DistrainmentDepositClosingCode",
    DistrainmentTypeCode = "DistrainmentTypeCode",
    InsolvencyDepositClosingCode = "InsolvencyDepositClosingCode",
    IsCompanyOwn = "IsCompanyOwn",
    IsRegularSupportIncludedInInsolvency = "IsRegularSupportIncludedInInsolvency",
    Name = "Name",
    NumberOurs = "NumberOurs",
    PayableAccountNumber = "PayableAccountNumber",
    RemittanceInformation = "RemittanceInformation",
    StatusCode = "StatusCode",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TypeCode = "TypeCode",
    AmountDebtTotal = "AmountDebtTotal",
    BankAccount = "BankAccount",
    ChildSupportType = "ChildSupportType",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    DepositClosingDocument = "DepositClosingDocument",
    DistrainmentDepositClosing = "DistrainmentDepositClosing",
    DistrainmentType = "DistrainmentType",
    Employee = "Employee",
    InsolvencyDepositClosing = "InsolvencyDepositClosing",
    NumberRange = "NumberRange",
    Recipient = "Recipient",
    Status = "Status",
    Type = "Type",
    Attachments = "Attachments",
    Employees = "Employees",
    OtherPayments = "OtherPayments",
    PayslipDocuments = "PayslipDocuments",
    TemporalPropertyBag = "TemporalPropertyBag",
    UnpaidChildSupportAmounts = "UnpaidChildSupportAmounts",
}

export interface IPrDeductionAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrDeductionAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrDeductionBankAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
    Country?: ICountryEntity;
}

export enum PrDeductionBankAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    Country = "Country",
}

export interface IPrDeductionBusinessPartnerEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    LegalNumber?: string;
    Name?: string;
    PayerReliabilityStatusCode?: PayerReliabilityStatusCode;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    BusinessPartner?: IBusinessPartnerEntity;
    Country?: ICountryEntity;
    PayerReliabilityStatus?: IPayerReliabilityStatusEntity;
    VatStatus?: IVatStatusEntity;
}

export enum PrDeductionBusinessPartnerEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PayerReliabilityStatusCode = "PayerReliabilityStatusCode",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    BusinessPartner = "BusinessPartner",
    Country = "Country",
    PayerReliabilityStatus = "PayerReliabilityStatus",
    VatStatus = "VatStatus",
}

export interface IPrDeductionCalculationTypeEntity extends IEntityBase {
    Code?: PrDeductionCalculationTypeCode;
    Name?: string;
}

export enum PrDeductionCalculationTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrDeductionEmployeeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Employee?: IPrEmployeeEntity;
}

export enum PrDeductionEmployeeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Employee = "Employee",
}

export interface IPrDeductionEntityTypeEntity extends IEntityBase {
    Code?: PrDeductionEntityTypeCode;
    Name?: string;
}

export enum PrDeductionEntityTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrDeductionOtherPaymentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    Date?: Date;
    Description?: string;
}

export enum PrDeductionOtherPaymentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    Date = "Date",
    Description = "Description",
}

export interface IPrDeductionPayslipDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Document?: IOtherLiabilityEntity;
    Payslip?: IPrPayslipEntity;
}

export enum PrDeductionPayslipDocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Document = "Document",
    Payslip = "Payslip",
}

export interface IPrDeductionStatusEntity extends IEntityBase {
    Code?: PrDeductionStatusCode;
    Name?: string;
}

export enum PrDeductionStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrDeductionTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    CalculationTypeCode?: PrDeductionCalculationTypeCode;
    IsIncludingAllEmployees?: boolean;
    Amount?: number;
    CalculationType?: IPrDeductionCalculationTypeEntity;
}

export enum PrDeductionTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    CalculationTypeCode = "CalculationTypeCode",
    IsIncludingAllEmployees = "IsIncludingAllEmployees",
    Amount = "Amount",
    CalculationType = "CalculationType",
}

export interface IPrDeductionTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    CalculationTypeCode?: PrDeductionCalculationTypeCode;
    IsIncludingAllEmployees?: boolean;
    Amount?: number;
    CalculationType?: IPrDeductionCalculationTypeEntity;
}

export enum PrDeductionTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    CalculationTypeCode = "CalculationTypeCode",
    IsIncludingAllEmployees = "IsIncludingAllEmployees",
    Amount = "Amount",
    CalculationType = "CalculationType",
}

export interface IPrDeductionTypeEntity extends IEntityBase {
    Code?: PrDeductionTypeCode;
    Name?: string;
}

export enum PrDeductionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrDeductionUnpaidChildSupportAmountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    Payslip?: IPrPayslipEntity;
}

export enum PrDeductionUnpaidChildSupportAmountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    Payslip = "Payslip",
}

export interface IPrDelayedIncomeTypeEntity extends IEntityBase {
    Code?: PrDelayedIncomeTypeCode;
    IsUserSelectable?: boolean;
    MpsvCode?: string;
    Name?: string;
}

export enum PrDelayedIncomeTypeEntity {
    Code = "Code",
    IsUserSelectable = "IsUserSelectable",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrDepositedDeductionEntity extends IEntityBase {
    Id?: number;
    DepositedAmount?: number;
    DepositedDeduction?: IPrDeductionEntity;
    InsolvencyDeposit?: IPrDeductionEntity;
    Payslip?: IPrPayslipEntity;
}

export enum PrDepositedDeductionEntity {
    Id = "Id",
    DepositedAmount = "DepositedAmount",
    DepositedDeduction = "DepositedDeduction",
    InsolvencyDeposit = "InsolvencyDeposit",
    Payslip = "Payslip",
}

export interface IPrDepositedDistrainmentAmountEntity extends IEntityBase {
    Id?: number;
    DepositedAmount?: number;
    DistrainmentDeposit?: IPrDeductionEntity;
    Payslip?: IPrPayslipEntity;
}

export enum PrDepositedDistrainmentAmountEntity {
    Id = "Id",
    DepositedAmount = "DepositedAmount",
    DistrainmentDeposit = "DistrainmentDeposit",
    Payslip = "Payslip",
}

export interface IPrDisabilityDiscountAmountEntity extends IEntityBase {
    Code?: PrDisabilityDiscountAmountCode;
    Amount?: number;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    TypeCode?: PrTaxDiscountTypeCode;
    Country?: ICountryEntity;
    Type?: IPrTaxDiscountTypeEntity;
}

export enum PrDisabilityDiscountAmountEntity {
    Code = "Code",
    Amount = "Amount",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    TypeCode = "TypeCode",
    Country = "Country",
    Type = "Type",
}

export interface IPrDisabilityTypeEntity extends IEntityBase {
    Code?: PrDisabilityTypeCode;
    Description?: string;
    MpsvCode?: string;
    Name?: string;
}

export enum PrDisabilityTypeEntity {
    Code = "Code",
    Description = "Description",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrDistrainmentDeductionTypeEntity extends IEntityBase {
    Code?: PrDistrainmentDeductionTypeCode;
    Name?: string;
}

export enum PrDistrainmentDeductionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrDistrainmentDepositClosingEntity extends IEntityBase {
    Code?: PrDistrainmentDepositClosingCode;
    Name?: string;
}

export enum PrDistrainmentDepositClosingEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrEducationEntity extends IEntityBase {
    Code?: PrEducationCode;
    Name?: string;
}

export enum PrEducationEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrEldpEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateCorrection?: Date;
    DateEmploymentStart?: Date;
    DateIssued?: Date;
    EldpTypeCode?: PrEldpTypeCode;
    SocialAdministrationCode?: GovernmentInstitutionCode;
    Year?: number;
    EldpCompany?: IPrEldpCompanyEntity;
    EldpType?: IPrEldpTypeEntity;
    Employee?: IPrEldpEmployeeEntity;
    SocialAdministration?: IGovernmentInstitutionEntity;
    Items?: IPrEldpItemEntity[];
}

export enum PrEldpEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateCorrection = "DateCorrection",
    DateEmploymentStart = "DateEmploymentStart",
    DateIssued = "DateIssued",
    EldpTypeCode = "EldpTypeCode",
    SocialAdministrationCode = "SocialAdministrationCode",
    Year = "Year",
    EldpCompany = "EldpCompany",
    EldpType = "EldpType",
    Employee = "Employee",
    SocialAdministration = "SocialAdministration",
    Items = "Items",
}

export interface IPrEldpCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LegalName?: string;
    LegalNumber?: string;
    Company?: ICompanyEntity;
    SymbolVariable?: string;
}

export enum PrEldpCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Company = "Company",
    SymbolVariable = "SymbolVariable",
}

export interface IPrEldpEmployeeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BirthLastName?: string;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    TitleAfterName?: string;
    TitleBeforeName?: string;
    ContactAddress?: IPrEntityEmployeeContactAddressEntity;
    CzechAddress?: IPrEntityEmployeeCzechAddressEntity;
    Employee?: IPrEmployeeEntity;
    PermanentAddress?: IPrEntityEmployeePermanentAddressEntity;
    TaxResidenceAddress?: IPrEntityEmployeeTaxResidenceAddressEntity;
    PlaceOfBirth?: string;
    PostOffice?: string;
}

export enum PrEldpEmployeeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BirthLastName = "BirthLastName",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    TitleAfterName = "TitleAfterName",
    TitleBeforeName = "TitleBeforeName",
    ContactAddress = "ContactAddress",
    CzechAddress = "CzechAddress",
    Employee = "Employee",
    PermanentAddress = "PermanentAddress",
    TaxResidenceAddress = "TaxResidenceAddress",
    PlaceOfBirth = "PlaceOfBirth",
    PostOffice = "PostOffice",
}

export interface IPrEldpItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ExcludedMonths?: string;
    IsSmallScaleEmployment?: boolean;
    ItemTypeCode?: PrEldpItemTypeCode;
    DaysInInterval?: number;
    DaysExcluded?: number;
    DaysDeducted?: number;
    CalculationBasis?: number;
    ItemType?: IPrEldpItemTypeEntity;
}

export enum PrEldpItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ExcludedMonths = "ExcludedMonths",
    IsSmallScaleEmployment = "IsSmallScaleEmployment",
    ItemTypeCode = "ItemTypeCode",
    DaysInInterval = "DaysInInterval",
    DaysExcluded = "DaysExcluded",
    DaysDeducted = "DaysDeducted",
    CalculationBasis = "CalculationBasis",
    ItemType = "ItemType",
}

export interface IPrEldpItemTypeEntity extends IEntityBase {
    Code?: PrEldpItemTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    MpsvCode?: string;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrEldpItemTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    MpsvCode = "MpsvCode",
    Name = "Name",
    Country = "Country",
}

export interface IPrEldpTypeEntity extends IEntityBase {
    Code?: PrEldpTypeCode;
    Name?: string;
}

export enum PrEldpTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrEmployeeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ApplicableForeignLegislationCountryCode?: CountryCode;
    BirthLastName?: string;
    CitizenshipCode?: CountryCode;
    CountryOfBirthCode?: CountryCode;
    CountryOfResidencyCode?: CountryCode;
    DateIDEndOfValidity?: Date;
    DateOfBirth?: Date;
    DateResidencyFrom?: Date;
    DateRetirementAgeReached?: Date;
    Email?: string;
    EuHealthCareNumber?: string;
    EuSocialInsuranceNumber?: string;
    ExternalNumber?: string;
    FirstName?: string;
    ForeignPersonalIdentificationNumber?: string;
    ForeignTaxIdentifier?: string;
    ForeignTaxIdentifierTypeCode?: MpsvTaxIdentifierTypeCode;
    FormerLastNames?: string;
    IDAuthorityOfIssue?: string;
    IDCountryOfIssueCode?: CountryCode;
    IDNumber?: string;
    IsMultipleDistrainmentRuleExempt?: boolean;
    LastName?: string;
    MpsvIdentifier?: string;
    NumberOurs?: string;
    PasswordForPayslip?: string;
    PersonalIdentificationNumber?: string;
    PhoneNumber?: string;
    PlaceOfBirth?: string;
    PrEducationCode?: PrEducationCode;
    PrEmployeeStateCode?: string;
    PrIdentificationDocumentCode?: PrIdentityDocumentTypeCode;
    PrSexCode?: PrSexCode;
    RemittanceInformation?: string;
    SalaryCurrencyCode?: CurrencyCode;
    SalaryPayoutTypeCode?: PrSalaryPayoutTypeCode;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TitleAfterName?: string;
    TitleBeforeName?: string;
    PreviousEmploymentDurationDays?: number;
    ApplicableForeignLegislationCountry?: ICountryEntity;
    BankAccount?: IPrEmployeeBankAccountEntity;
    Citizenship?: ICountryEntity;
    ContactAddress?: IPrEmployeeContactAddressEntity;
    CountryOfBirth?: ICountryEntity;
    CountryOfResidency?: ICountryEntity;
    CurrentTemporalPropertyBag?: IPrEmployeeTemporalCurrentEntity;
    CzechAddress?: IPrEmployeeCzechAddressEntity;
    ForeignInsuranceCarrier?: IPrForeignInsuranceCarrierEntity;
    ForeignTaxIdentifierType?: IMpsvTaxIdentifierTypeEntity;
    IDCountryOfIssue?: ICountryEntity;
    InitialData?: IPrInitialDataEntity;
    LaborMarketAccess?: IPrLaborMarketAccessEntity;
    NumberRange?: INumberRangeEntity;
    PermanentAddress?: IPrEmployeePermanentAddressEntity;
    PrEducation?: IPrEducationEntity;
    PrIdentificationDocument?: IPrIdentityDocumentTypeEntity;
    PrSex?: IPrSexEntity;
    SalaryCurrency?: ICurrencyEntity;
    SalaryPayoutType?: IPrSalaryPayoutTypeEntity;
    TaxResidenceAddress?: IPrEmployeeTaxResidenceAddressEntity;
    User?: IUserEntity;
    Attachments?: IPrEmployeeAttachmentEntity[];
    Dependents?: IPrEmployeeDependentPersonEntity[];
    Labels?: IPrEmployeeLabelEntity[];
    PrYearOperationPayrollSheets?: IPrYearOperationPayrollSheetAttachmentEntity[];
    TemporalPropertyBag?: IPrEmployeeTemporalEntity[];
}

export enum PrEmployeeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ApplicableForeignLegislationCountryCode = "ApplicableForeignLegislationCountryCode",
    BirthLastName = "BirthLastName",
    CitizenshipCode = "CitizenshipCode",
    CountryOfBirthCode = "CountryOfBirthCode",
    CountryOfResidencyCode = "CountryOfResidencyCode",
    DateIDEndOfValidity = "DateIDEndOfValidity",
    DateOfBirth = "DateOfBirth",
    DateResidencyFrom = "DateResidencyFrom",
    DateRetirementAgeReached = "DateRetirementAgeReached",
    Email = "Email",
    EuHealthCareNumber = "EuHealthCareNumber",
    EuSocialInsuranceNumber = "EuSocialInsuranceNumber",
    ExternalNumber = "ExternalNumber",
    FirstName = "FirstName",
    ForeignPersonalIdentificationNumber = "ForeignPersonalIdentificationNumber",
    ForeignTaxIdentifier = "ForeignTaxIdentifier",
    ForeignTaxIdentifierTypeCode = "ForeignTaxIdentifierTypeCode",
    FormerLastNames = "FormerLastNames",
    IDAuthorityOfIssue = "IDAuthorityOfIssue",
    IDCountryOfIssueCode = "IDCountryOfIssueCode",
    IDNumber = "IDNumber",
    IsMultipleDistrainmentRuleExempt = "IsMultipleDistrainmentRuleExempt",
    LastName = "LastName",
    MpsvIdentifier = "MpsvIdentifier",
    NumberOurs = "NumberOurs",
    PasswordForPayslip = "PasswordForPayslip",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    PhoneNumber = "PhoneNumber",
    PlaceOfBirth = "PlaceOfBirth",
    PrEducationCode = "PrEducationCode",
    PrEmployeeStateCode = "PrEmployeeStateCode",
    PrIdentificationDocumentCode = "PrIdentificationDocumentCode",
    PrSexCode = "PrSexCode",
    RemittanceInformation = "RemittanceInformation",
    SalaryCurrencyCode = "SalaryCurrencyCode",
    SalaryPayoutTypeCode = "SalaryPayoutTypeCode",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TitleAfterName = "TitleAfterName",
    TitleBeforeName = "TitleBeforeName",
    PreviousEmploymentDurationDays = "PreviousEmploymentDurationDays",
    ApplicableForeignLegislationCountry = "ApplicableForeignLegislationCountry",
    BankAccount = "BankAccount",
    Citizenship = "Citizenship",
    ContactAddress = "ContactAddress",
    CountryOfBirth = "CountryOfBirth",
    CountryOfResidency = "CountryOfResidency",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    CzechAddress = "CzechAddress",
    ForeignInsuranceCarrier = "ForeignInsuranceCarrier",
    ForeignTaxIdentifierType = "ForeignTaxIdentifierType",
    IDCountryOfIssue = "IDCountryOfIssue",
    InitialData = "InitialData",
    LaborMarketAccess = "LaborMarketAccess",
    NumberRange = "NumberRange",
    PermanentAddress = "PermanentAddress",
    PrEducation = "PrEducation",
    PrIdentificationDocument = "PrIdentificationDocument",
    PrSex = "PrSex",
    SalaryCurrency = "SalaryCurrency",
    SalaryPayoutType = "SalaryPayoutType",
    TaxResidenceAddress = "TaxResidenceAddress",
    User = "User",
    Attachments = "Attachments",
    Dependents = "Dependents",
    Labels = "Labels",
    PrYearOperationPayrollSheets = "PrYearOperationPayrollSheets",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrEmployeeAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrEmployeeAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrEmployeeBankAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankAccountRegistrationStatusCode?: BankAccountRegistrationStatusCode;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    BankAccountRegistrationStatus?: IBankAccountRegistrationStatusEntity;
    Country?: ICountryEntity;
}

export enum PrEmployeeBankAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankAccountRegistrationStatusCode = "BankAccountRegistrationStatusCode",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    Country = "Country",
}

export interface IPrEmployeeCarTaxabilityEntity extends IEntityBase {
    Code?: PrEmployeeCarTaxabilityCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Percentage?: number;
    Country?: ICountryEntity;
}

export enum PrEmployeeCarTaxabilityEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Percentage = "Percentage",
    Country = "Country",
}

export interface IPrEmployeeContactAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum PrEmployeeContactAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface IPrEmployeeCzechAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum PrEmployeeCzechAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface IPrEmployeeDependentPersonEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    RelationCode?: PrEmployeeDependentPersonRelationCode;
    Relation?: IPrEmployeeDependentPersonRelationEntity;
}

export enum PrEmployeeDependentPersonEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    RelationCode = "RelationCode",
    Relation = "Relation",
}

export interface IPrEmployeeDependentPersonRelationEntity extends IEntityBase {
    Code?: PrEmployeeDependentPersonRelationCode;
    Name?: string;
}

export enum PrEmployeeDependentPersonRelationEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrEmployeeLabelEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EntityTypeCode?: string;
    EntityType?: IEntityTypeEntity;
    Label?: ILabelEntity;
    LabelHierarchy?: ILabelHierarchyEntity;
}

export enum PrEmployeeLabelEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EntityTypeCode = "EntityTypeCode",
    EntityType = "EntityType",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
}

export interface IPrEmployeePermanentAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum PrEmployeePermanentAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface IPrEmployeeStateEntity extends IEntityBase {
    Code?: PrEmployeeStateCode;
    Name?: string;
}

export enum PrEmployeeStateEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrEmployeeTaxResidenceAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum PrEmployeeTaxResidenceAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface IPrEmployeeTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    DateDisabilityFrom?: Date;
    DateDisabilityTo?: Date;
    DatePensionFrom?: Date;
    DateWorkingRetireeSocialInsuranceDiscountFrom?: Date;
    HasReducedRetirementAge?: boolean;
    HealthInsuranceCode?: PrHealthInsuranceCompanyCode;
    IsEarlyRetirement?: boolean;
    IsZtpP?: boolean;
    PensionTypeCode?: PrPensionTypeCode;
    PrDisabilityTypeCode?: PrDisabilityTypeCode;
    PrFormOfStudyTypeCode?: PrFormOfStudyTypeCode;
    PrMinimumHealthInsuranceTypeCode?: PrMinimumHealthInsuranceTypeCode;
    PrSocialInsuranceDiscountTypeCode?: PrSocialInsuranceDiscountTypeCode;
    HealthInsurance?: IPrHealthInsuranceCompanyEntity;
    PensionType?: IPrPensionTypeEntity;
    PrDisabilityType?: IPrDisabilityTypeEntity;
    PrFormOfStudyType?: IPrFormOfStudyTypeEntity;
    PrMinimumHealthInsuranceType?: IPrMinimumHealthInsuranceTypeEntity;
    PrSocialInsuranceDiscountType?: IPrSocialInsuranceDiscountTypeEntity;
}

export enum PrEmployeeTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    DateDisabilityFrom = "DateDisabilityFrom",
    DateDisabilityTo = "DateDisabilityTo",
    DatePensionFrom = "DatePensionFrom",
    DateWorkingRetireeSocialInsuranceDiscountFrom = "DateWorkingRetireeSocialInsuranceDiscountFrom",
    HasReducedRetirementAge = "HasReducedRetirementAge",
    HealthInsuranceCode = "HealthInsuranceCode",
    IsEarlyRetirement = "IsEarlyRetirement",
    IsZtpP = "IsZtpP",
    PensionTypeCode = "PensionTypeCode",
    PrDisabilityTypeCode = "PrDisabilityTypeCode",
    PrFormOfStudyTypeCode = "PrFormOfStudyTypeCode",
    PrMinimumHealthInsuranceTypeCode = "PrMinimumHealthInsuranceTypeCode",
    PrSocialInsuranceDiscountTypeCode = "PrSocialInsuranceDiscountTypeCode",
    HealthInsurance = "HealthInsurance",
    PensionType = "PensionType",
    PrDisabilityType = "PrDisabilityType",
    PrFormOfStudyType = "PrFormOfStudyType",
    PrMinimumHealthInsuranceType = "PrMinimumHealthInsuranceType",
    PrSocialInsuranceDiscountType = "PrSocialInsuranceDiscountType",
}

export interface IPrEmployeeTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    DateDisabilityFrom?: Date;
    DateDisabilityTo?: Date;
    DatePensionFrom?: Date;
    DateWorkingRetireeSocialInsuranceDiscountFrom?: Date;
    HasReducedRetirementAge?: boolean;
    HealthInsuranceCode?: PrHealthInsuranceCompanyCode;
    IsEarlyRetirement?: boolean;
    IsZtpP?: boolean;
    PensionTypeCode?: PrPensionTypeCode;
    PrDisabilityTypeCode?: PrDisabilityTypeCode;
    PrFormOfStudyTypeCode?: PrFormOfStudyTypeCode;
    PrMinimumHealthInsuranceTypeCode?: PrMinimumHealthInsuranceTypeCode;
    PrSocialInsuranceDiscountTypeCode?: PrSocialInsuranceDiscountTypeCode;
    HealthInsurance?: IPrHealthInsuranceCompanyEntity;
    PensionType?: IPrPensionTypeEntity;
    PrDisabilityType?: IPrDisabilityTypeEntity;
    PrFormOfStudyType?: IPrFormOfStudyTypeEntity;
    PrMinimumHealthInsuranceType?: IPrMinimumHealthInsuranceTypeEntity;
    PrSocialInsuranceDiscountType?: IPrSocialInsuranceDiscountTypeEntity;
}

export enum PrEmployeeTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    DateDisabilityFrom = "DateDisabilityFrom",
    DateDisabilityTo = "DateDisabilityTo",
    DatePensionFrom = "DatePensionFrom",
    DateWorkingRetireeSocialInsuranceDiscountFrom = "DateWorkingRetireeSocialInsuranceDiscountFrom",
    HasReducedRetirementAge = "HasReducedRetirementAge",
    HealthInsuranceCode = "HealthInsuranceCode",
    IsEarlyRetirement = "IsEarlyRetirement",
    IsZtpP = "IsZtpP",
    PensionTypeCode = "PensionTypeCode",
    PrDisabilityTypeCode = "PrDisabilityTypeCode",
    PrFormOfStudyTypeCode = "PrFormOfStudyTypeCode",
    PrMinimumHealthInsuranceTypeCode = "PrMinimumHealthInsuranceTypeCode",
    PrSocialInsuranceDiscountTypeCode = "PrSocialInsuranceDiscountTypeCode",
    HealthInsurance = "HealthInsurance",
    PensionType = "PensionType",
    PrDisabilityType = "PrDisabilityType",
    PrFormOfStudyType = "PrFormOfStudyType",
    PrMinimumHealthInsuranceType = "PrMinimumHealthInsuranceType",
    PrSocialInsuranceDiscountType = "PrSocialInsuranceDiscountType",
}

export interface IPrEmploymentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountingCategoryCode?: PrAccountingCategoryCode;
    CsszEmploymentTypeCode?: CsszEmploymentTypeCode;
    DateCalculatePayslipStart?: Date;
    DateEnd?: Date;
    DateFirstDayAtWork?: Date;
    DateStart?: Date;
    DetailedSpecificationCode?: DetailedEmploymentSpecificationCode;
    EmploymentCategoryCode?: PrEmploymentCategoryCode;
    IsManagerialEmployee?: boolean;
    IscoCode?: CzIscoCode;
    MinimalEducationCode?: PrEducationCode;
    MpsvIdentifier?: string;
    Name?: string;
    NumberOurs?: string;
    TypeCode?: PrEmploymentTypeCode;
    WorkplaceAddressSelectionCode?: PrEmploymentWorkplaceAddressSelectionCode;
    AccountingCategory?: IPrAccountingCategoryEntity;
    CsszEmploymentType?: ICsszEmploymentTypeEntity;
    CurrentTemporalPropertyBag?: IPrEmploymentTemporalCurrentEntity;
    DetailedSpecification?: IDetailedEmploymentSpecificationEntity;
    Employee?: IPrEmployeeEntity;
    EmploymentCategory?: IPrEmploymentCategoryEntity;
    EmploymentClose?: IPrEmploymentCloseEntity;
    InitialData?: IPrEmploymentInitialDataEntity;
    Isco?: ICzIscoEntity;
    MinimalEducation?: IPrEducationEntity;
    NumberRange?: INumberRangeEntity;
    PreviousEmployment?: IPrEmploymentEntity;
    StatisticalData?: IPrStatisticalDataEntity;
    Template?: IPrEmploymentTemplateEntity;
    Type?: IPrEmploymentTypeEntity;
    WorkplaceAddress?: IPrEmploymentWorkplaceAddressEntity;
    WorkplaceAddressSelection?: IPrEmploymentWorkplaceAddressSelectionEntity;
    Benefits?: IPrEmploymentBenefitEntity[];
    Cars?: IPrEmploymentCarEntity[];
    ExtraSalaries?: IPrEmploymentExtraSalaryEntity[];
    RetirementSavings?: IPrEmploymentRetirementSavingEntity[];
    SalaryComponents?: IPrEmploymentSalaryComponentEntity[];
    TemporalPropertyBag?: IPrEmploymentTemporalEntity[];
}

export enum PrEmploymentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountingCategoryCode = "AccountingCategoryCode",
    CsszEmploymentTypeCode = "CsszEmploymentTypeCode",
    DateCalculatePayslipStart = "DateCalculatePayslipStart",
    DateEnd = "DateEnd",
    DateFirstDayAtWork = "DateFirstDayAtWork",
    DateStart = "DateStart",
    DetailedSpecificationCode = "DetailedSpecificationCode",
    EmploymentCategoryCode = "EmploymentCategoryCode",
    IsManagerialEmployee = "IsManagerialEmployee",
    IscoCode = "IscoCode",
    MinimalEducationCode = "MinimalEducationCode",
    MpsvIdentifier = "MpsvIdentifier",
    Name = "Name",
    NumberOurs = "NumberOurs",
    TypeCode = "TypeCode",
    WorkplaceAddressSelectionCode = "WorkplaceAddressSelectionCode",
    AccountingCategory = "AccountingCategory",
    CsszEmploymentType = "CsszEmploymentType",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    DetailedSpecification = "DetailedSpecification",
    Employee = "Employee",
    EmploymentCategory = "EmploymentCategory",
    EmploymentClose = "EmploymentClose",
    InitialData = "InitialData",
    Isco = "Isco",
    MinimalEducation = "MinimalEducation",
    NumberRange = "NumberRange",
    PreviousEmployment = "PreviousEmployment",
    StatisticalData = "StatisticalData",
    Template = "Template",
    Type = "Type",
    WorkplaceAddress = "WorkplaceAddress",
    WorkplaceAddressSelection = "WorkplaceAddressSelection",
    Benefits = "Benefits",
    Cars = "Cars",
    ExtraSalaries = "ExtraSalaries",
    RetirementSavings = "RetirementSavings",
    SalaryComponents = "SalaryComponents",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrEmploymentBalancingPeriodEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEnd?: Date;
    DateStart?: Date;
    PeriodLengthInWeeks?: number;
    TotalFundInMinutes?: number;
    Employment?: IPrEmploymentEntity;
    Months?: IPrEmploymentBalancingPeriodMonthEntity[];
}

export enum PrEmploymentBalancingPeriodEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    PeriodLengthInWeeks = "PeriodLengthInWeeks",
    TotalFundInMinutes = "TotalFundInMinutes",
    Employment = "Employment",
    Months = "Months",
}

export interface IPrEmploymentBalancingPeriodMonthEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BalanceInMinutes?: number;
    Month?: number;
    OvertimeClaimedInMinutes?: number;
    PlannedInMinutes?: number;
    WorkedInMinutes?: number;
    Year?: number;
}

export enum PrEmploymentBalancingPeriodMonthEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BalanceInMinutes = "BalanceInMinutes",
    Month = "Month",
    OvertimeClaimedInMinutes = "OvertimeClaimedInMinutes",
    PlannedInMinutes = "PlannedInMinutes",
    WorkedInMinutes = "WorkedInMinutes",
    Year = "Year",
}

export interface IPrEmploymentBenefitEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    TypeCode?: PrBenefitTypeCode;
    CurrentTemporalPropertyBag?: IPrEmploymentBenefitTemporalCurrentEntity;
    Default?: IPrBenefitEntity;
    Type?: IPrBenefitTypeEntity;
    TemporalPropertyBag?: IPrEmploymentBenefitTemporalEntity[];
}

export enum PrEmploymentBenefitEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    TypeCode = "TypeCode",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    Default = "Default",
    Type = "Type",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrEmploymentBenefitTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    OtherCategoryCode?: PrOtherBenefitCategoryCode;
    TaxAndContributionsApplicabilityCode?: PrOtherBenefitTaxAndContributionsApplicabilityCode;
    TaxDeducibilityCode?: PrOtherBenefitTaxDeducibilityCode;
    Amount?: number;
    AmountEmployee?: number;
    AmountEmployer?: number;
    OtherCategory?: IPrOtherBenefitCategoryEntity;
    TaxAndContributionsApplicability?: IPrOtherBenefitTaxAndContributionsApplicabilityEntity;
    TaxDeducibility?: IPrOtherBenefitTaxDeducibilityEntity;
}

export enum PrEmploymentBenefitTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    OtherCategoryCode = "OtherCategoryCode",
    TaxAndContributionsApplicabilityCode = "TaxAndContributionsApplicabilityCode",
    TaxDeducibilityCode = "TaxDeducibilityCode",
    Amount = "Amount",
    AmountEmployee = "AmountEmployee",
    AmountEmployer = "AmountEmployer",
    OtherCategory = "OtherCategory",
    TaxAndContributionsApplicability = "TaxAndContributionsApplicability",
    TaxDeducibility = "TaxDeducibility",
}

export interface IPrEmploymentBenefitTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    AmountEmployeeSourceCode?: PrEntityValueSourceCode;
    AmountEmployerSourceCode?: PrEntityValueSourceCode;
    AmountSourceCode?: PrEntityValueSourceCode;
    Name?: string;
    NameSourceCode?: PrEntityValueSourceCode;
    OtherCategoryCode?: PrOtherBenefitCategoryCode;
    OtherCategorySourceCode?: PrEntityValueSourceCode;
    TaxAndContributionsApplicabilityCode?: PrOtherBenefitTaxAndContributionsApplicabilityCode;
    TaxAndContributionsApplicabilitySourceCode?: PrEntityValueSourceCode;
    TaxDeducibilityCode?: PrOtherBenefitTaxDeducibilityCode;
    TaxDeducibilitySourceCode?: PrEntityValueSourceCode;
    Amount?: number;
    AmountEmployee?: number;
    AmountEmployer?: number;
    AmountEmployeeSource?: IPrEntityValueSourceEntity;
    AmountEmployerSource?: IPrEntityValueSourceEntity;
    AmountSource?: IPrEntityValueSourceEntity;
    NameSource?: IPrEntityValueSourceEntity;
    OtherCategory?: IPrOtherBenefitCategoryEntity;
    OtherCategorySource?: IPrEntityValueSourceEntity;
    TaxAndContributionsApplicability?: IPrOtherBenefitTaxAndContributionsApplicabilityEntity;
    TaxAndContributionsApplicabilitySource?: IPrEntityValueSourceEntity;
    TaxDeducibility?: IPrOtherBenefitTaxDeducibilityEntity;
    TaxDeducibilitySource?: IPrEntityValueSourceEntity;
}

export enum PrEmploymentBenefitTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    AmountEmployeeSourceCode = "AmountEmployeeSourceCode",
    AmountEmployerSourceCode = "AmountEmployerSourceCode",
    AmountSourceCode = "AmountSourceCode",
    Name = "Name",
    NameSourceCode = "NameSourceCode",
    OtherCategoryCode = "OtherCategoryCode",
    OtherCategorySourceCode = "OtherCategorySourceCode",
    TaxAndContributionsApplicabilityCode = "TaxAndContributionsApplicabilityCode",
    TaxAndContributionsApplicabilitySourceCode = "TaxAndContributionsApplicabilitySourceCode",
    TaxDeducibilityCode = "TaxDeducibilityCode",
    TaxDeducibilitySourceCode = "TaxDeducibilitySourceCode",
    Amount = "Amount",
    AmountEmployee = "AmountEmployee",
    AmountEmployer = "AmountEmployer",
    AmountEmployeeSource = "AmountEmployeeSource",
    AmountEmployerSource = "AmountEmployerSource",
    AmountSource = "AmountSource",
    NameSource = "NameSource",
    OtherCategory = "OtherCategory",
    OtherCategorySource = "OtherCategorySource",
    TaxAndContributionsApplicability = "TaxAndContributionsApplicability",
    TaxAndContributionsApplicabilitySource = "TaxAndContributionsApplicabilitySource",
    TaxDeducibility = "TaxDeducibility",
    TaxDeducibilitySource = "TaxDeducibilitySource",
}

export interface IPrEmploymentCarEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    PurchasePrice?: number;
    TaxabilityCode?: PrEmployeeCarTaxabilityCode;
    Taxability?: IPrEmployeeCarTaxabilityEntity;
}

export enum PrEmploymentCarEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    PurchasePrice = "PurchasePrice",
    TaxabilityCode = "TaxabilityCode",
    Taxability = "Taxability",
}

export interface IPrEmploymentCategoryEntity extends IEntityBase {
    Code?: PrEmploymentCategoryCode;
    Name?: string;
    EmploymentTypes?: IPrEmploymentTypeEntity[];
}

export enum PrEmploymentCategoryEntity {
    Code = "Code",
    Name = "Name",
    EmploymentTypes = "EmploymentTypes",
}

export interface IPrEmploymentCloseEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EmploymentEarlyTerminationReasonCode?: EmploymentEarlyTerminationReasonCode;
    EmploymentRelationshipTerminationReasonCode?: EmploymentRelationshipTerminationReasonCode;
    HasTerminationBenefitEntitledCode?: YesNoCode;
    IsEndByDeath?: boolean;
    IsSeverancePaidInFull?: boolean;
    LaborOfficeEmploymentTypeCode?: LaborOfficeEmploymentTypeCode;
    NoUnemploymentSupportTypeCode?: NoUnemploymentSupportTypeCode;
    PrSalaryComponentTypeCode?: PrSalaryComponentTypeCode;
    ServiceRelationshipTerminationReasonCode?: ServiceRelationshipTerminationReasonCode;
    AverageNetMonthlyIncomeAmount?: number;
    Amount?: number;
    EmploymentEarlyTerminationReason?: IEmploymentEarlyTerminationReasonEntity;
    EmploymentRelationshipTerminationReason?: IEmploymentRelationshipTerminationReasonEntity;
    HasTerminationBenefitEntitled?: IYesNoEntity;
    LaborOfficeEmploymentType?: ILaborOfficeEmploymentTypeEntity;
    NoUnemploymentSupportType?: INoUnemploymentSupportTypeEntity;
    PrSalaryComponentType?: IPrSalaryComponentTypeEntity;
    ServiceRelationshipTerminationReason?: IServiceRelationshipTerminationReasonEntity;
    RetirementInsuranceIntervals?: IPrRetirementInsuranceIntervalEntity[];
}

export enum PrEmploymentCloseEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EmploymentEarlyTerminationReasonCode = "EmploymentEarlyTerminationReasonCode",
    EmploymentRelationshipTerminationReasonCode = "EmploymentRelationshipTerminationReasonCode",
    HasTerminationBenefitEntitledCode = "HasTerminationBenefitEntitledCode",
    IsEndByDeath = "IsEndByDeath",
    IsSeverancePaidInFull = "IsSeverancePaidInFull",
    LaborOfficeEmploymentTypeCode = "LaborOfficeEmploymentTypeCode",
    NoUnemploymentSupportTypeCode = "NoUnemploymentSupportTypeCode",
    PrSalaryComponentTypeCode = "PrSalaryComponentTypeCode",
    ServiceRelationshipTerminationReasonCode = "ServiceRelationshipTerminationReasonCode",
    AverageNetMonthlyIncomeAmount = "AverageNetMonthlyIncomeAmount",
    Amount = "Amount",
    EmploymentEarlyTerminationReason = "EmploymentEarlyTerminationReason",
    EmploymentRelationshipTerminationReason = "EmploymentRelationshipTerminationReason",
    HasTerminationBenefitEntitled = "HasTerminationBenefitEntitled",
    LaborOfficeEmploymentType = "LaborOfficeEmploymentType",
    NoUnemploymentSupportType = "NoUnemploymentSupportType",
    PrSalaryComponentType = "PrSalaryComponentType",
    ServiceRelationshipTerminationReason = "ServiceRelationshipTerminationReason",
    RetirementInsuranceIntervals = "RetirementInsuranceIntervals",
}

export interface IPrEmploymentExtraSalaryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    CurrentTemporalPropertyBag?: IPrEmploymentExtraSalaryTemporalCurrentEntity;
    Default?: IPrExtraSalaryEntity;
    TemporalPropertyBag?: IPrEmploymentExtraSalaryTemporalEntity[];
}

export enum PrEmploymentExtraSalaryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    Default = "Default",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrEmploymentExtraSalaryTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ComputationTypeCode?: PrExtraSalaryComputationTypeCode;
    Name?: string;
    Value?: number;
    ComputationType?: IPrExtraSalaryComputationTypeEntity;
}

export enum PrEmploymentExtraSalaryTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ComputationTypeCode = "ComputationTypeCode",
    Name = "Name",
    Value = "Value",
    ComputationType = "ComputationType",
}

export interface IPrEmploymentExtraSalaryTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ComputationTypeCode?: PrExtraSalaryComputationTypeCode;
    ComputationTypeSourceCode?: PrEntityValueSourceCode;
    Name?: string;
    NameSourceCode?: PrEntityValueSourceCode;
    ValueSourceCode?: PrEntityValueSourceCode;
    Value?: number;
    ComputationType?: IPrExtraSalaryComputationTypeEntity;
    ComputationTypeSource?: IPrEntityValueSourceEntity;
    NameSource?: IPrEntityValueSourceEntity;
    ValueSource?: IPrEntityValueSourceEntity;
}

export enum PrEmploymentExtraSalaryTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ComputationTypeCode = "ComputationTypeCode",
    ComputationTypeSourceCode = "ComputationTypeSourceCode",
    Name = "Name",
    NameSourceCode = "NameSourceCode",
    ValueSourceCode = "ValueSourceCode",
    Value = "Value",
    ComputationType = "ComputationType",
    ComputationTypeSource = "ComputationTypeSource",
    NameSource = "NameSource",
    ValueSource = "ValueSource",
}

export interface IPrEmploymentInitialDataEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AverageSalaryLastQuarter?: number;
    DppWorkedFromLimitInMinutes?: number;
    FullyCountableTowardVacationInMinutes?: number;
    HolidayPreviousInMinutes?: number;
    OvertimePreviousInMinutes?: number;
    PartiallyCountableTowardVacationInMinutes?: number;
    SickDaysDrawdownThisYear?: number;
    VacationDrawdownThisYearInMinutes?: number;
    VacationTransferredFromLastYearInMinutes?: number;
    Year?: number;
    Employment?: IPrEmploymentEntity;
    EmploymentMonthData?: IPrEmploymentInitialMonthDataEntity[];
    LongTermTimeBonuses?: IPrEmploymentInitialLongTermTimeBonusEntity[];
}

export enum PrEmploymentInitialDataEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AverageSalaryLastQuarter = "AverageSalaryLastQuarter",
    DppWorkedFromLimitInMinutes = "DppWorkedFromLimitInMinutes",
    FullyCountableTowardVacationInMinutes = "FullyCountableTowardVacationInMinutes",
    HolidayPreviousInMinutes = "HolidayPreviousInMinutes",
    OvertimePreviousInMinutes = "OvertimePreviousInMinutes",
    PartiallyCountableTowardVacationInMinutes = "PartiallyCountableTowardVacationInMinutes",
    SickDaysDrawdownThisYear = "SickDaysDrawdownThisYear",
    VacationDrawdownThisYearInMinutes = "VacationDrawdownThisYearInMinutes",
    VacationTransferredFromLastYearInMinutes = "VacationTransferredFromLastYearInMinutes",
    Year = "Year",
    Employment = "Employment",
    EmploymentMonthData = "EmploymentMonthData",
    LongTermTimeBonuses = "LongTermTimeBonuses",
}

export interface IPrEmploymentInitialLongTermTimeBonusEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    DateMonth?: Date;
    TimeBasedBonusTypeCode?: PrTimeBasedBonusTypeCode;
    TimeBasedBonusType?: IPrTimeBasedBonusTypeEntity;
}

export enum PrEmploymentInitialLongTermTimeBonusEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    DateMonth = "DateMonth",
    TimeBasedBonusTypeCode = "TimeBasedBonusTypeCode",
    TimeBasedBonusType = "TimeBasedBonusType",
}

export interface IPrEmploymentInitialMonthDataEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateMonth?: Date;
    ExcludedDays?: number;
    SocialSecurityInsuranceBasis?: number;
}

export enum PrEmploymentInitialMonthDataEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateMonth = "DateMonth",
    ExcludedDays = "ExcludedDays",
    SocialSecurityInsuranceBasis = "SocialSecurityInsuranceBasis",
}

export interface IPrEmploymentRetirementSavingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CurrentTemporalPropertyBag?: IPrEmploymentRetirementSavingTemporalCurrentEntity;
    RetirementSavingsProduct?: IPrRetirementSavingsProductEntity;
    TemporalPropertyBag?: IPrEmploymentRetirementSavingTemporalEntity[];
}

export enum PrEmploymentRetirementSavingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    RetirementSavingsProduct = "RetirementSavingsProduct",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrEmploymentRetirementSavingTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ComputationTypeCode?: PrRetirementSavingsComputationTypeCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    Amount?: number;
    Percentage?: number;
    IsIncludedAutomatically?: boolean;
    ComputationType?: IPrRetirementSavingsComputationTypeEntity;
}

export enum PrEmploymentRetirementSavingTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ComputationTypeCode = "ComputationTypeCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    Amount = "Amount",
    Percentage = "Percentage",
    IsIncludedAutomatically = "IsIncludedAutomatically",
    ComputationType = "ComputationType",
}

export interface IPrEmploymentRetirementSavingTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ComputationTypeCode?: PrRetirementSavingsComputationTypeCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    Amount?: number;
    Percentage?: number;
    IsIncludedAutomatically?: boolean;
    ComputationType?: IPrRetirementSavingsComputationTypeEntity;
}

export enum PrEmploymentRetirementSavingTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ComputationTypeCode = "ComputationTypeCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    Amount = "Amount",
    Percentage = "Percentage",
    IsIncludedAutomatically = "IsIncludedAutomatically",
    ComputationType = "ComputationType",
}

export interface IPrEmploymentSalaryComponentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    RegularSalaryTypeCode?: PrRegularSalaryTypeCode;
    TypeCode?: PrSalaryComponentTypeCode;
    CurrentTemporalPropertyBag?: IPrEmploymentSalaryComponentTemporalCurrentEntity;
    Default?: IPrSalaryComponentEntity;
    RegularSalaryType?: IPrRegularSalaryTypeEntity;
    Type?: IPrSalaryComponentTypeEntity;
    TemporalPropertyBag?: IPrEmploymentSalaryComponentTemporalEntity[];
}

export enum PrEmploymentSalaryComponentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    RegularSalaryTypeCode = "RegularSalaryTypeCode",
    TypeCode = "TypeCode",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    Default = "Default",
    RegularSalaryType = "RegularSalaryType",
    Type = "Type",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrEmploymentSalaryComponentTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    FixedBonusDeductionImpactCode?: PrFixedBonusDeductionImpactCode;
    FixedBonusPayOutImpactCode?: PrFixedBonusPayOutImpactCode;
    FixedBonusTaxImpactCode?: PrFixedBonusTaxImpactCode;
    Name?: string;
    Amount?: number;
    Percentage?: number;
    IsBasicSalary?: boolean;
    FixedBonusDeductionImpact?: IPrFixedBonusDeductionImpactEntity;
    FixedBonusPayOutImpact?: IPrFixedBonusPayOutImpactEntity;
    FixedBonusTaxImpact?: IPrFixedBonusTaxImpactEntity;
}

export enum PrEmploymentSalaryComponentTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    FixedBonusDeductionImpactCode = "FixedBonusDeductionImpactCode",
    FixedBonusPayOutImpactCode = "FixedBonusPayOutImpactCode",
    FixedBonusTaxImpactCode = "FixedBonusTaxImpactCode",
    Name = "Name",
    Amount = "Amount",
    Percentage = "Percentage",
    IsBasicSalary = "IsBasicSalary",
    FixedBonusDeductionImpact = "FixedBonusDeductionImpact",
    FixedBonusPayOutImpact = "FixedBonusPayOutImpact",
    FixedBonusTaxImpact = "FixedBonusTaxImpact",
}

export interface IPrEmploymentSalaryComponentTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    AmountSourceCode?: PrEntityValueSourceCode;
    FixedBonusDeductionImpactCode?: PrFixedBonusDeductionImpactCode;
    FixedBonusDeductionImpactSourceCode?: PrEntityValueSourceCode;
    FixedBonusPayOutImpactCode?: PrFixedBonusPayOutImpactCode;
    FixedBonusPayOutImpactSourceCode?: PrEntityValueSourceCode;
    FixedBonusTaxImpactCode?: PrFixedBonusTaxImpactCode;
    FixedBonusTaxImpactSourceCode?: PrEntityValueSourceCode;
    IsBasicSalarySourceCode?: PrEntityValueSourceCode;
    Name?: string;
    NameSourceCode?: PrEntityValueSourceCode;
    PercentageSourceCode?: PrEntityValueSourceCode;
    Amount?: number;
    Percentage?: number;
    IsBasicSalary?: boolean;
    AmountSource?: IPrEntityValueSourceEntity;
    FixedBonusDeductionImpact?: IPrFixedBonusDeductionImpactEntity;
    FixedBonusDeductionImpactSource?: IPrEntityValueSourceEntity;
    FixedBonusPayOutImpact?: IPrFixedBonusPayOutImpactEntity;
    FixedBonusPayOutImpactSource?: IPrEntityValueSourceEntity;
    FixedBonusTaxImpact?: IPrFixedBonusTaxImpactEntity;
    FixedBonusTaxImpactSource?: IPrEntityValueSourceEntity;
    IsBasicSalarySource?: IPrEntityValueSourceEntity;
    NameSource?: IPrEntityValueSourceEntity;
    PercentageSource?: IPrEntityValueSourceEntity;
}

export enum PrEmploymentSalaryComponentTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    AmountSourceCode = "AmountSourceCode",
    FixedBonusDeductionImpactCode = "FixedBonusDeductionImpactCode",
    FixedBonusDeductionImpactSourceCode = "FixedBonusDeductionImpactSourceCode",
    FixedBonusPayOutImpactCode = "FixedBonusPayOutImpactCode",
    FixedBonusPayOutImpactSourceCode = "FixedBonusPayOutImpactSourceCode",
    FixedBonusTaxImpactCode = "FixedBonusTaxImpactCode",
    FixedBonusTaxImpactSourceCode = "FixedBonusTaxImpactSourceCode",
    IsBasicSalarySourceCode = "IsBasicSalarySourceCode",
    Name = "Name",
    NameSourceCode = "NameSourceCode",
    PercentageSourceCode = "PercentageSourceCode",
    Amount = "Amount",
    Percentage = "Percentage",
    IsBasicSalary = "IsBasicSalary",
    AmountSource = "AmountSource",
    FixedBonusDeductionImpact = "FixedBonusDeductionImpact",
    FixedBonusDeductionImpactSource = "FixedBonusDeductionImpactSource",
    FixedBonusPayOutImpact = "FixedBonusPayOutImpact",
    FixedBonusPayOutImpactSource = "FixedBonusPayOutImpactSource",
    FixedBonusTaxImpact = "FixedBonusTaxImpact",
    FixedBonusTaxImpactSource = "FixedBonusTaxImpactSource",
    IsBasicSalarySource = "IsBasicSalarySource",
    NameSource = "NameSource",
    PercentageSource = "PercentageSource",
}

export interface IPrEmploymentTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Name?: string;
    NumberOurs?: string;
    CurrentTemporalPropertyBag?: IPrEmploymentTemplateTemporalCurrentEntity;
    NumberRange?: INumberRangeEntity;
    Benefits?: IPrEmploymentTemplateBenefitEntity[];
    ExtraSalaries?: IPrEmploymentTemplateExtraSalaryEntity[];
    SalaryComponents?: IPrEmploymentTemplateSalaryComponentEntity[];
    TemporalPropertyBag?: IPrEmploymentTemplateTemporalEntity[];
}

export enum PrEmploymentTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Name = "Name",
    NumberOurs = "NumberOurs",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    NumberRange = "NumberRange",
    Benefits = "Benefits",
    ExtraSalaries = "ExtraSalaries",
    SalaryComponents = "SalaryComponents",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrEmploymentTemplateBenefitEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    TypeCode?: PrBenefitTypeCode;
    CurrentTemporalPropertyBag?: IPrEmploymentTemplateBenefitTemporalCurrentEntity;
    Default?: IPrBenefitEntity;
    Type?: IPrBenefitTypeEntity;
    TemporalPropertyBag?: IPrEmploymentTemplateBenefitTemporalEntity[];
}

export enum PrEmploymentTemplateBenefitEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    TypeCode = "TypeCode",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    Default = "Default",
    Type = "Type",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrEmploymentTemplateBenefitTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    OtherCategoryCode?: PrOtherBenefitCategoryCode;
    TaxAndContributionsApplicabilityCode?: PrOtherBenefitTaxAndContributionsApplicabilityCode;
    TaxDeducibilityCode?: PrOtherBenefitTaxDeducibilityCode;
    Amount?: number;
    AmountEmployee?: number;
    AmountEmployer?: number;
    OtherCategory?: IPrOtherBenefitCategoryEntity;
    TaxAndContributionsApplicability?: IPrOtherBenefitTaxAndContributionsApplicabilityEntity;
    TaxDeducibility?: IPrOtherBenefitTaxDeducibilityEntity;
}

export enum PrEmploymentTemplateBenefitTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    OtherCategoryCode = "OtherCategoryCode",
    TaxAndContributionsApplicabilityCode = "TaxAndContributionsApplicabilityCode",
    TaxDeducibilityCode = "TaxDeducibilityCode",
    Amount = "Amount",
    AmountEmployee = "AmountEmployee",
    AmountEmployer = "AmountEmployer",
    OtherCategory = "OtherCategory",
    TaxAndContributionsApplicability = "TaxAndContributionsApplicability",
    TaxDeducibility = "TaxDeducibility",
}

export interface IPrEmploymentTemplateBenefitTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    AmountEmployeeSourceCode?: PrEntityValueSourceCode;
    AmountEmployerSourceCode?: PrEntityValueSourceCode;
    AmountSourceCode?: PrEntityValueSourceCode;
    Name?: string;
    NameSourceCode?: PrEntityValueSourceCode;
    OtherCategoryCode?: PrOtherBenefitCategoryCode;
    OtherCategorySourceCode?: PrEntityValueSourceCode;
    TaxAndContributionsApplicabilityCode?: PrOtherBenefitTaxAndContributionsApplicabilityCode;
    TaxAndContributionsApplicabilitySourceCode?: PrEntityValueSourceCode;
    TaxDeducibilityCode?: PrOtherBenefitTaxDeducibilityCode;
    TaxDeducibilitySourceCode?: PrEntityValueSourceCode;
    Amount?: number;
    AmountEmployee?: number;
    AmountEmployer?: number;
    AmountEmployeeSource?: IPrEntityValueSourceEntity;
    AmountEmployerSource?: IPrEntityValueSourceEntity;
    AmountSource?: IPrEntityValueSourceEntity;
    NameSource?: IPrEntityValueSourceEntity;
    OtherCategory?: IPrOtherBenefitCategoryEntity;
    OtherCategorySource?: IPrEntityValueSourceEntity;
    TaxAndContributionsApplicability?: IPrOtherBenefitTaxAndContributionsApplicabilityEntity;
    TaxAndContributionsApplicabilitySource?: IPrEntityValueSourceEntity;
    TaxDeducibility?: IPrOtherBenefitTaxDeducibilityEntity;
    TaxDeducibilitySource?: IPrEntityValueSourceEntity;
}

export enum PrEmploymentTemplateBenefitTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    AmountEmployeeSourceCode = "AmountEmployeeSourceCode",
    AmountEmployerSourceCode = "AmountEmployerSourceCode",
    AmountSourceCode = "AmountSourceCode",
    Name = "Name",
    NameSourceCode = "NameSourceCode",
    OtherCategoryCode = "OtherCategoryCode",
    OtherCategorySourceCode = "OtherCategorySourceCode",
    TaxAndContributionsApplicabilityCode = "TaxAndContributionsApplicabilityCode",
    TaxAndContributionsApplicabilitySourceCode = "TaxAndContributionsApplicabilitySourceCode",
    TaxDeducibilityCode = "TaxDeducibilityCode",
    TaxDeducibilitySourceCode = "TaxDeducibilitySourceCode",
    Amount = "Amount",
    AmountEmployee = "AmountEmployee",
    AmountEmployer = "AmountEmployer",
    AmountEmployeeSource = "AmountEmployeeSource",
    AmountEmployerSource = "AmountEmployerSource",
    AmountSource = "AmountSource",
    NameSource = "NameSource",
    OtherCategory = "OtherCategory",
    OtherCategorySource = "OtherCategorySource",
    TaxAndContributionsApplicability = "TaxAndContributionsApplicability",
    TaxAndContributionsApplicabilitySource = "TaxAndContributionsApplicabilitySource",
    TaxDeducibility = "TaxDeducibility",
    TaxDeducibilitySource = "TaxDeducibilitySource",
}

export interface IPrEmploymentTemplateExtraSalaryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    CurrentTemporalPropertyBag?: IPrEmploymentTemplateExtraSalaryTemporalCurrentEntity;
    Default?: IPrExtraSalaryEntity;
    TemporalPropertyBag?: IPrEmploymentTemplateExtraSalaryTemporalEntity[];
}

export enum PrEmploymentTemplateExtraSalaryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    Default = "Default",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrEmploymentTemplateExtraSalaryTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ComputationTypeCode?: PrExtraSalaryComputationTypeCode;
    Name?: string;
    Value?: number;
    ComputationType?: IPrExtraSalaryComputationTypeEntity;
}

export enum PrEmploymentTemplateExtraSalaryTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ComputationTypeCode = "ComputationTypeCode",
    Name = "Name",
    Value = "Value",
    ComputationType = "ComputationType",
}

export interface IPrEmploymentTemplateExtraSalaryTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ComputationTypeCode?: PrExtraSalaryComputationTypeCode;
    ComputationTypeSourceCode?: PrEntityValueSourceCode;
    Name?: string;
    NameSourceCode?: PrEntityValueSourceCode;
    ValueSourceCode?: PrEntityValueSourceCode;
    Value?: number;
    ComputationType?: IPrExtraSalaryComputationTypeEntity;
    ComputationTypeSource?: IPrEntityValueSourceEntity;
    NameSource?: IPrEntityValueSourceEntity;
    ValueSource?: IPrEntityValueSourceEntity;
}

export enum PrEmploymentTemplateExtraSalaryTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ComputationTypeCode = "ComputationTypeCode",
    ComputationTypeSourceCode = "ComputationTypeSourceCode",
    Name = "Name",
    NameSourceCode = "NameSourceCode",
    ValueSourceCode = "ValueSourceCode",
    Value = "Value",
    ComputationType = "ComputationType",
    ComputationTypeSource = "ComputationTypeSource",
    NameSource = "NameSource",
    ValueSource = "ValueSource",
}

export interface IPrEmploymentTemplateSalaryComponentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    RegularSalaryTypeCode?: PrRegularSalaryTypeCode;
    TypeCode?: PrSalaryComponentTypeCode;
    CurrentTemporalPropertyBag?: IPrEmploymentTemplateSalaryComponentTemporalCurrentEntity;
    Default?: IPrSalaryComponentEntity;
    RegularSalaryType?: IPrRegularSalaryTypeEntity;
    Type?: IPrSalaryComponentTypeEntity;
    TemporalPropertyBag?: IPrEmploymentTemplateSalaryComponentTemporalEntity[];
}

export enum PrEmploymentTemplateSalaryComponentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    RegularSalaryTypeCode = "RegularSalaryTypeCode",
    TypeCode = "TypeCode",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    Default = "Default",
    RegularSalaryType = "RegularSalaryType",
    Type = "Type",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrEmploymentTemplateSalaryComponentTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    FixedBonusDeductionImpactCode?: PrFixedBonusDeductionImpactCode;
    FixedBonusPayOutImpactCode?: PrFixedBonusPayOutImpactCode;
    FixedBonusTaxImpactCode?: PrFixedBonusTaxImpactCode;
    Name?: string;
    Amount?: number;
    Percentage?: number;
    IsBasicSalary?: boolean;
    FixedBonusDeductionImpact?: IPrFixedBonusDeductionImpactEntity;
    FixedBonusPayOutImpact?: IPrFixedBonusPayOutImpactEntity;
    FixedBonusTaxImpact?: IPrFixedBonusTaxImpactEntity;
}

export enum PrEmploymentTemplateSalaryComponentTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    FixedBonusDeductionImpactCode = "FixedBonusDeductionImpactCode",
    FixedBonusPayOutImpactCode = "FixedBonusPayOutImpactCode",
    FixedBonusTaxImpactCode = "FixedBonusTaxImpactCode",
    Name = "Name",
    Amount = "Amount",
    Percentage = "Percentage",
    IsBasicSalary = "IsBasicSalary",
    FixedBonusDeductionImpact = "FixedBonusDeductionImpact",
    FixedBonusPayOutImpact = "FixedBonusPayOutImpact",
    FixedBonusTaxImpact = "FixedBonusTaxImpact",
}

export interface IPrEmploymentTemplateSalaryComponentTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    AmountSourceCode?: PrEntityValueSourceCode;
    FixedBonusDeductionImpactCode?: PrFixedBonusDeductionImpactCode;
    FixedBonusDeductionImpactSourceCode?: PrEntityValueSourceCode;
    FixedBonusPayOutImpactCode?: PrFixedBonusPayOutImpactCode;
    FixedBonusPayOutImpactSourceCode?: PrEntityValueSourceCode;
    FixedBonusTaxImpactCode?: PrFixedBonusTaxImpactCode;
    FixedBonusTaxImpactSourceCode?: PrEntityValueSourceCode;
    IsBasicSalarySourceCode?: PrEntityValueSourceCode;
    Name?: string;
    NameSourceCode?: PrEntityValueSourceCode;
    PercentageSourceCode?: PrEntityValueSourceCode;
    Amount?: number;
    Percentage?: number;
    IsBasicSalary?: boolean;
    AmountSource?: IPrEntityValueSourceEntity;
    FixedBonusDeductionImpact?: IPrFixedBonusDeductionImpactEntity;
    FixedBonusDeductionImpactSource?: IPrEntityValueSourceEntity;
    FixedBonusPayOutImpact?: IPrFixedBonusPayOutImpactEntity;
    FixedBonusPayOutImpactSource?: IPrEntityValueSourceEntity;
    FixedBonusTaxImpact?: IPrFixedBonusTaxImpactEntity;
    FixedBonusTaxImpactSource?: IPrEntityValueSourceEntity;
    IsBasicSalarySource?: IPrEntityValueSourceEntity;
    NameSource?: IPrEntityValueSourceEntity;
    PercentageSource?: IPrEntityValueSourceEntity;
}

export enum PrEmploymentTemplateSalaryComponentTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    AmountSourceCode = "AmountSourceCode",
    FixedBonusDeductionImpactCode = "FixedBonusDeductionImpactCode",
    FixedBonusDeductionImpactSourceCode = "FixedBonusDeductionImpactSourceCode",
    FixedBonusPayOutImpactCode = "FixedBonusPayOutImpactCode",
    FixedBonusPayOutImpactSourceCode = "FixedBonusPayOutImpactSourceCode",
    FixedBonusTaxImpactCode = "FixedBonusTaxImpactCode",
    FixedBonusTaxImpactSourceCode = "FixedBonusTaxImpactSourceCode",
    IsBasicSalarySourceCode = "IsBasicSalarySourceCode",
    Name = "Name",
    NameSourceCode = "NameSourceCode",
    PercentageSourceCode = "PercentageSourceCode",
    Amount = "Amount",
    Percentage = "Percentage",
    IsBasicSalary = "IsBasicSalary",
    AmountSource = "AmountSource",
    FixedBonusDeductionImpact = "FixedBonusDeductionImpact",
    FixedBonusDeductionImpactSource = "FixedBonusDeductionImpactSource",
    FixedBonusPayOutImpact = "FixedBonusPayOutImpact",
    FixedBonusPayOutImpactSource = "FixedBonusPayOutImpactSource",
    FixedBonusTaxImpact = "FixedBonusTaxImpact",
    FixedBonusTaxImpactSource = "FixedBonusTaxImpactSource",
    IsBasicSalarySource = "IsBasicSalarySource",
    NameSource = "NameSource",
    PercentageSource = "PercentageSource",
}

export interface IPrEmploymentTemplateTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    VacationWeeks?: number;
    SickDays?: number;
    WorkingPattern?: IPrWorkingPatternEntity;
}

export enum PrEmploymentTemplateTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    VacationWeeks = "VacationWeeks",
    SickDays = "SickDays",
    WorkingPattern = "WorkingPattern",
}

export interface IPrEmploymentTemplateTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    SickDaysSourceCode?: PrEntityValueSourceCode;
    VacationWeeksSourceCode?: PrEntityValueSourceCode;
    WorkingPatternSourceCode?: PrEntityValueSourceCode;
    VacationWeeks?: number;
    SickDays?: number;
    SickDaysSource?: IPrEntityValueSourceEntity;
    VacationWeeksSource?: IPrEntityValueSourceEntity;
    WorkingPattern?: IPrWorkingPatternEntity;
    WorkingPatternSource?: IPrEntityValueSourceEntity;
}

export enum PrEmploymentTemplateTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    SickDaysSourceCode = "SickDaysSourceCode",
    VacationWeeksSourceCode = "VacationWeeksSourceCode",
    WorkingPatternSourceCode = "WorkingPatternSourceCode",
    VacationWeeks = "VacationWeeks",
    SickDays = "SickDays",
    SickDaysSource = "SickDaysSource",
    VacationWeeksSource = "VacationWeeksSource",
    WorkingPattern = "WorkingPattern",
    WorkingPatternSource = "WorkingPatternSource",
}

export interface IPrEmploymentTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    IsSmallScaleEmployment?: boolean;
    VacationWeeks?: number;
    SickDays?: number;
    WorkingPattern?: IPrWorkingPatternEntity;
}

export enum PrEmploymentTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    IsSmallScaleEmployment = "IsSmallScaleEmployment",
    VacationWeeks = "VacationWeeks",
    SickDays = "SickDays",
    WorkingPattern = "WorkingPattern",
}

export interface IPrEmploymentTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    IsSmallScaleEmployment?: boolean;
    SickDaysSourceCode?: PrEntityValueSourceCode;
    VacationWeeksSourceCode?: PrEntityValueSourceCode;
    WorkingPatternSourceCode?: PrEntityValueSourceCode;
    VacationWeeks?: number;
    SickDays?: number;
    SickDaysSource?: IPrEntityValueSourceEntity;
    VacationWeeksSource?: IPrEntityValueSourceEntity;
    WorkingPattern?: IPrWorkingPatternEntity;
    WorkingPatternSource?: IPrEntityValueSourceEntity;
}

export enum PrEmploymentTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    IsSmallScaleEmployment = "IsSmallScaleEmployment",
    SickDaysSourceCode = "SickDaysSourceCode",
    VacationWeeksSourceCode = "VacationWeeksSourceCode",
    WorkingPatternSourceCode = "WorkingPatternSourceCode",
    VacationWeeks = "VacationWeeks",
    SickDays = "SickDays",
    SickDaysSource = "SickDaysSource",
    VacationWeeksSource = "VacationWeeksSource",
    WorkingPattern = "WorkingPattern",
    WorkingPatternSource = "WorkingPatternSource",
}

export interface IPrEmploymentTypeEntity extends IEntityBase {
    Code?: PrEmploymentTypeCode;
    CountryCode?: CountryCode;
    Name?: string;
    Country?: ICountryEntity;
    CsszEmploymentTypes?: ICsszEmploymentTypeEntity[];
}

export enum PrEmploymentTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    Name = "Name",
    Country = "Country",
    CsszEmploymentTypes = "CsszEmploymentTypes",
}

export interface IPrEmploymentWorkplaceAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    CityCode?: string;
}

export enum PrEmploymentWorkplaceAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    CityCode = "CityCode",
}

export interface IPrEmploymentWorkplaceAddressSelectionEntity extends IEntityBase {
    Code?: PrEmploymentWorkplaceAddressSelectionCode;
    Name?: string;
}

export enum PrEmploymentWorkplaceAddressSelectionEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrEntityEmployeeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BirthLastName?: string;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    TitleAfterName?: string;
    TitleBeforeName?: string;
    ContactAddress?: IPrEntityEmployeeContactAddressEntity;
    CzechAddress?: IPrEntityEmployeeCzechAddressEntity;
    Employee?: IPrEmployeeEntity;
    PermanentAddress?: IPrEntityEmployeePermanentAddressEntity;
    TaxResidenceAddress?: IPrEntityEmployeeTaxResidenceAddressEntity;
}

export enum PrEntityEmployeeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BirthLastName = "BirthLastName",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    TitleAfterName = "TitleAfterName",
    TitleBeforeName = "TitleBeforeName",
    ContactAddress = "ContactAddress",
    CzechAddress = "CzechAddress",
    Employee = "Employee",
    PermanentAddress = "PermanentAddress",
    TaxResidenceAddress = "TaxResidenceAddress",
}

export interface IPrEntityEmployeeContactAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum PrEntityEmployeeContactAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface IPrEntityEmployeeCzechAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum PrEntityEmployeeCzechAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface IPrEntityEmployeePermanentAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum PrEntityEmployeePermanentAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface IPrEntityEmployeeTaxResidenceAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum PrEntityEmployeeTaxResidenceAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface IPrEntityEmploymentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrEmploymentTypeCode;
    Employment?: IPrEmploymentEntity;
    Type?: IPrEmploymentTypeEntity;
}

export enum PrEntityEmploymentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Employment = "Employment",
    Type = "Type",
}

export interface IPrEntityValueSourceEntity extends IEntityBase {
    Code?: PrEntityValueSourceCode;
    Name?: string;
}

export enum PrEntityValueSourceEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrExtraSalaryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrExtraSalaryTypeCode;
    CurrentTemporalPropertyBag?: IPrExtraSalaryTemporalCurrentEntity;
    Type?: IPrExtraSalaryTypeEntity;
    TemporalPropertyBag?: IPrExtraSalaryTemporalEntity[];
}

export enum PrExtraSalaryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    Type = "Type",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrExtraSalaryComputationTypeEntity extends IEntityBase {
    Code?: PrExtraSalaryComputationTypeCode;
    Name?: string;
}

export enum PrExtraSalaryComputationTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrExtraSalaryLegislativeValueEntity extends IEntityBase {
    Code?: PrExtraSalaryLegislativeValueCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ExtraSalaryComputationTypeCode?: PrExtraSalaryComputationTypeCode;
    ExtraSalaryName?: string;
    ExtraSalaryTypeCode?: PrExtraSalaryTypeCode;
    MinValue?: number;
    Name?: string;
    Country?: ICountryEntity;
    ExtraSalaryComputationType?: IPrExtraSalaryComputationTypeEntity;
    ExtraSalaryType?: IPrExtraSalaryTypeEntity;
}

export enum PrExtraSalaryLegislativeValueEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ExtraSalaryComputationTypeCode = "ExtraSalaryComputationTypeCode",
    ExtraSalaryName = "ExtraSalaryName",
    ExtraSalaryTypeCode = "ExtraSalaryTypeCode",
    MinValue = "MinValue",
    Name = "Name",
    Country = "Country",
    ExtraSalaryComputationType = "ExtraSalaryComputationType",
    ExtraSalaryType = "ExtraSalaryType",
}

export interface IPrExtraSalaryOriginEntity extends IEntityBase {
    Code?: PrExtraSalaryOriginCode;
    Name?: string;
}

export enum PrExtraSalaryOriginEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrExtraSalaryTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ComputationTypeCode?: PrExtraSalaryComputationTypeCode;
    Name?: string;
    Value?: number;
    ComputationType?: IPrExtraSalaryComputationTypeEntity;
}

export enum PrExtraSalaryTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ComputationTypeCode = "ComputationTypeCode",
    Name = "Name",
    Value = "Value",
    ComputationType = "ComputationType",
}

export interface IPrExtraSalaryTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ComputationTypeCode?: PrExtraSalaryComputationTypeCode;
    Name?: string;
    Value?: number;
    ComputationType?: IPrExtraSalaryComputationTypeEntity;
}

export enum PrExtraSalaryTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ComputationTypeCode = "ComputationTypeCode",
    Name = "Name",
    Value = "Value",
    ComputationType = "ComputationType",
}

export interface IPrExtraSalaryTypeEntity extends IEntityBase {
    Code?: PrExtraSalaryTypeCode;
    IsDppDpcApplicable?: boolean;
    Name?: string;
    OriginCode?: PrExtraSalaryOriginCode;
    Origin?: IPrExtraSalaryOriginEntity;
}

export enum PrExtraSalaryTypeEntity {
    Code = "Code",
    IsDppDpcApplicable = "IsDppDpcApplicable",
    Name = "Name",
    OriginCode = "OriginCode",
    Origin = "Origin",
}

export interface IPrFinancialAdministrationDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountNumber?: string;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    Contact?: IPrGovernmentInstitutionContactEntity;
}

export enum PrFinancialAdministrationDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountNumber = "AccountNumber",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    Contact = "Contact",
}

export interface IPrFixedBonusDeductionImpactEntity extends IEntityBase {
    Code?: PrFixedBonusDeductionImpactCode;
    Name?: string;
}

export enum PrFixedBonusDeductionImpactEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrFixedBonusPayOutImpactEntity extends IEntityBase {
    Code?: PrFixedBonusPayOutImpactCode;
    Name?: string;
}

export enum PrFixedBonusPayOutImpactEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrFixedBonusTaxImpactEntity extends IEntityBase {
    Code?: PrFixedBonusTaxImpactCode;
    Name?: string;
}

export enum PrFixedBonusTaxImpactEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrForeignInsuranceCarrierEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    InsuranceNumber?: string;
    InsuranceTypeCode?: PrForeignInsuranceCarrierTypeCode;
    Name?: string;
    SectorTypeCode?: PrForeignInsuranceCarrierSectorTypeCode;
    Address?: IForeignInsuranceCarrierAddressEntity;
    InsuranceType?: IPrForeignInsuranceCarrierTypeEntity;
    SectorType?: IPrForeignInsuranceCarrierSectorTypeEntity;
}

export enum PrForeignInsuranceCarrierEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    InsuranceNumber = "InsuranceNumber",
    InsuranceTypeCode = "InsuranceTypeCode",
    Name = "Name",
    SectorTypeCode = "SectorTypeCode",
    Address = "Address",
    InsuranceType = "InsuranceType",
    SectorType = "SectorType",
}

export interface IPrForeignInsuranceCarrierSectorTypeEntity extends IEntityBase {
    Code?: PrForeignInsuranceCarrierSectorTypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum PrForeignInsuranceCarrierSectorTypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrForeignInsuranceCarrierTypeEntity extends IEntityBase {
    Code?: PrForeignInsuranceCarrierTypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum PrForeignInsuranceCarrierTypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrFormOfStudyTypeEntity extends IEntityBase {
    Code?: PrFormOfStudyTypeCode;
    Name?: string;
}

export enum PrFormOfStudyTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrGovernmentInstitutionContactEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    PhoneNumber?: string;
}

export enum PrGovernmentInstitutionContactEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    PhoneNumber = "PhoneNumber",
}

export interface IPrGovernmentInstitutionDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountNumber?: string;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    Contact?: IPrGovernmentInstitutionContactEntity;
}

export enum PrGovernmentInstitutionDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountNumber = "AccountNumber",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    Contact = "Contact",
}

export interface IPrHealthInsuranceCompanyEntity extends IEntityBase {
    Code?: PrHealthInsuranceCompanyCode;
    City?: string;
    CountryCode?: CountryCode;
    DataBoxId?: string;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    HealthInsuranceCompanyCode?: string;
    LegalName?: string;
    LegalNumber?: string;
    Name?: string;
    PostalCode?: string;
    ShortName?: string;
    Street?: string;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    Country?: ICountryEntity;
    VatStatus?: IVatStatusEntity;
    BankAccounts?: IPrHealthInsuranceCompanyBankAccountEntity[];
}

export enum PrHealthInsuranceCompanyEntity {
    Code = "Code",
    City = "City",
    CountryCode = "CountryCode",
    DataBoxId = "DataBoxId",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PostalCode = "PostalCode",
    ShortName = "ShortName",
    Street = "Street",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    Country = "Country",
    VatStatus = "VatStatus",
    BankAccounts = "BankAccounts",
}

export interface IPrHealthInsuranceCompanyBankAccountEntity extends IEntityBase {
    Code?: PrHealthInsuranceCompanyBankAccountCode;
    AccountNumber?: string;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    IBAN?: string;
    Name?: string;
    RegionCode?: CountryRegionCode;
    Bank?: IBankEntity;
    Country?: ICountryEntity;
    Region?: ICountryRegionEntity;
}

export enum PrHealthInsuranceCompanyBankAccountEntity {
    Code = "Code",
    AccountNumber = "AccountNumber",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    IBAN = "IBAN",
    Name = "Name",
    RegionCode = "RegionCode",
    Bank = "Bank",
    Country = "Country",
    Region = "Region",
}

export interface IPrHealthInsuranceCompanyDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountNumber?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
}

export enum PrHealthInsuranceCompanyDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountNumber = "AccountNumber",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    HealthInsuranceCompany = "HealthInsuranceCompany",
}

export interface IPrHolidayPayoutTypeEntity extends IEntityBase {
    Code?: PrHolidayPayoutTypeCode;
    Name?: string;
}

export enum PrHolidayPayoutTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrHolidayShiftAssignmentEntity extends IEntityBase {
    Code?: PrHolidayShiftAssignmentCode;
    Name?: string;
}

export enum PrHolidayShiftAssignmentEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrHozChangeCodeEntity extends IEntityBase {
    Code?: PrHozChangeCodeCode;
    Name?: string;
}

export enum PrHozChangeCodeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrHozSubmissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Detail?: IPrHozSubmissionDetailEntity;
    Employee?: IPrHozSubmissionEmployeeEntity;
}

export enum PrHozSubmissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Detail = "Detail",
    Employee = "Employee",
}

export interface IPrHozSubmissionCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LegalName?: string;
    LegalNumber?: string;
    Company?: ICompanyEntity;
    City?: string;
    HouseNumber?: string;
    InsurancePayerNumber?: string;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    StreetNumber?: string;
}

export enum PrHozSubmissionCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Company = "Company",
    City = "City",
    HouseNumber = "HouseNumber",
    InsurancePayerNumber = "InsurancePayerNumber",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    StreetNumber = "StreetNumber",
}

export interface IPrHozSubmissionDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    UserEmail?: string;
    Company?: IPrHozSubmissionCompanyEntity;
    Items?: IPrHozSubmissionItemEntity[];
}

export enum PrHozSubmissionDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    UserEmail = "UserEmail",
    Company = "Company",
    Items = "Items",
}

export interface IPrHozSubmissionEmployeeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BirthLastName?: string;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    TitleAfterName?: string;
    TitleBeforeName?: string;
    ContactAddress?: IPrEntityEmployeeContactAddressEntity;
    CzechAddress?: IPrEntityEmployeeCzechAddressEntity;
    Employee?: IPrEmployeeEntity;
    PermanentAddress?: IPrEntityEmployeePermanentAddressEntity;
    TaxResidenceAddress?: IPrEntityEmployeeTaxResidenceAddressEntity;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
}

export enum PrHozSubmissionEmployeeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BirthLastName = "BirthLastName",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    TitleAfterName = "TitleAfterName",
    TitleBeforeName = "TitleBeforeName",
    ContactAddress = "ContactAddress",
    CzechAddress = "CzechAddress",
    Employee = "Employee",
    PermanentAddress = "PermanentAddress",
    TaxResidenceAddress = "TaxResidenceAddress",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    HealthInsuranceCompany = "HealthInsuranceCompany",
}

export interface IPrHozSubmissionItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ChangeCode?: PrHozChangeCodeCode;
    DateChange?: Date;
    Change?: IPrHozChangeCodeEntity;
}

export enum PrHozSubmissionItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ChangeCode = "ChangeCode",
    DateChange = "DateChange",
    Change = "Change",
}

export interface IPrIdentifierEntity extends IEntityBase {
    Code?: PrIdentifierCode;
    Name?: string;
}

export enum PrIdentifierEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrIdentityDocumentTypeEntity extends IEntityBase {
    Code?: PrIdentityDocumentTypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum PrIdentityDocumentTypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrIllnessLeaveEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEventEnd?: Date;
    DateEventStart?: Date;
    DateRequiredActionFrom?: Date;
    IsProcessed?: boolean;
    NumberOurs?: string;
    NumberTheirs?: string;
    RequiredActionCode?: PrSocialEventRequiredActionCode;
    SocialEventStatusCode?: PrSocialEventStatusCode;
    SocialEventTypeCode?: PrSocialEventTypeCode;
    WorkedHoursOnFirstDay?: number;
    WorkedHoursOnLastDay?: number;
    Employee?: IPrEmployeeEntity;
    Employment?: IPrEmploymentEntity;
    NumberRange?: INumberRangeEntity;
    RequiredAction?: IPrSocialEventRequiredActionEntity;
    SocialEventStatus?: IPrSocialEventStatusEntity;
    SocialEventType?: IPrSocialEventTypeEntity;
    Attachments?: IPrSocialEventAttachmentEntity[];
    AttendanceDayIntervals?: IPrAttendanceDayIntervalEntity[];
    CertificateAttachments?: IPrSocialEventCertificateAttachmentEntity[];
    MonthDetails?: IPrSocialEventMonthDetailEntity[];
    Submissions?: IPrSubmissionEntity[];
    CaseId?: string;
    DoctorName?: string;
    HealthcareProviderName?: string;
    IsCancelled?: boolean;
    IsCausedByAlcoholOrDrugs?: boolean;
    IsCausedByAnotherPerson?: boolean;
    IsWorkplaceInjury?: boolean;
    Note?: string;
    NotificationId?: string;
    DoctorAddress?: IPrIllnessLeaveEventDoctorAddressEntity;
    PermittedOutings?: IPrIllnessLeaveEventPermittedOutingEntity[];
    ResidenceAddresses?: IPrIllnessLeaveEventResidenceAddressEntity[];
}

export enum PrIllnessLeaveEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEventEnd = "DateEventEnd",
    DateEventStart = "DateEventStart",
    DateRequiredActionFrom = "DateRequiredActionFrom",
    IsProcessed = "IsProcessed",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    RequiredActionCode = "RequiredActionCode",
    SocialEventStatusCode = "SocialEventStatusCode",
    SocialEventTypeCode = "SocialEventTypeCode",
    WorkedHoursOnFirstDay = "WorkedHoursOnFirstDay",
    WorkedHoursOnLastDay = "WorkedHoursOnLastDay",
    Employee = "Employee",
    Employment = "Employment",
    NumberRange = "NumberRange",
    RequiredAction = "RequiredAction",
    SocialEventStatus = "SocialEventStatus",
    SocialEventType = "SocialEventType",
    Attachments = "Attachments",
    AttendanceDayIntervals = "AttendanceDayIntervals",
    CertificateAttachments = "CertificateAttachments",
    MonthDetails = "MonthDetails",
    Submissions = "Submissions",
    CaseId = "CaseId",
    DoctorName = "DoctorName",
    HealthcareProviderName = "HealthcareProviderName",
    IsCancelled = "IsCancelled",
    IsCausedByAlcoholOrDrugs = "IsCausedByAlcoholOrDrugs",
    IsCausedByAnotherPerson = "IsCausedByAnotherPerson",
    IsWorkplaceInjury = "IsWorkplaceInjury",
    Note = "Note",
    NotificationId = "NotificationId",
    DoctorAddress = "DoctorAddress",
    PermittedOutings = "PermittedOutings",
    ResidenceAddresses = "ResidenceAddresses",
}

export interface IPrIllnessLeaveEventDoctorAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
}

export enum PrIllnessLeaveEventDoctorAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
}

export interface IPrIllnessLeaveEventPermittedOutingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    TimeFrom?: Date;
    TimeTo?: Date;
}

export enum PrIllnessLeaveEventPermittedOutingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    TimeFrom = "TimeFrom",
    TimeTo = "TimeTo",
}

export interface IPrIllnessLeaveEventResidenceAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Note?: string;
}

export enum PrIllnessLeaveEventResidenceAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Note = "Note",
}

export interface IPrImprisonmentEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEventEnd?: Date;
    DateEventStart?: Date;
    DateRequiredActionFrom?: Date;
    IsProcessed?: boolean;
    NumberOurs?: string;
    NumberTheirs?: string;
    RequiredActionCode?: PrSocialEventRequiredActionCode;
    SocialEventStatusCode?: PrSocialEventStatusCode;
    SocialEventTypeCode?: PrSocialEventTypeCode;
    WorkedHoursOnFirstDay?: number;
    WorkedHoursOnLastDay?: number;
    Employee?: IPrEmployeeEntity;
    Employment?: IPrEmploymentEntity;
    NumberRange?: INumberRangeEntity;
    RequiredAction?: IPrSocialEventRequiredActionEntity;
    SocialEventStatus?: IPrSocialEventStatusEntity;
    SocialEventType?: IPrSocialEventTypeEntity;
    Attachments?: IPrSocialEventAttachmentEntity[];
    AttendanceDayIntervals?: IPrAttendanceDayIntervalEntity[];
    CertificateAttachments?: IPrSocialEventCertificateAttachmentEntity[];
    MonthDetails?: IPrSocialEventMonthDetailEntity[];
    Submissions?: IPrSubmissionEntity[];
}

export enum PrImprisonmentEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEventEnd = "DateEventEnd",
    DateEventStart = "DateEventStart",
    DateRequiredActionFrom = "DateRequiredActionFrom",
    IsProcessed = "IsProcessed",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    RequiredActionCode = "RequiredActionCode",
    SocialEventStatusCode = "SocialEventStatusCode",
    SocialEventTypeCode = "SocialEventTypeCode",
    WorkedHoursOnFirstDay = "WorkedHoursOnFirstDay",
    WorkedHoursOnLastDay = "WorkedHoursOnLastDay",
    Employee = "Employee",
    Employment = "Employment",
    NumberRange = "NumberRange",
    RequiredAction = "RequiredAction",
    SocialEventStatus = "SocialEventStatus",
    SocialEventType = "SocialEventType",
    Attachments = "Attachments",
    AttendanceDayIntervals = "AttendanceDayIntervals",
    CertificateAttachments = "CertificateAttachments",
    MonthDetails = "MonthDetails",
    Submissions = "Submissions",
}

export interface IPrIncomeTaxDiscountEntity extends IEntityBase {
    Code?: PrIncomeTaxDiscountCode;
    BasicAmount?: number;
    Child1Amount?: number;
    Child2Amount?: number;
    Child3Amount?: number;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    SpouseAmount?: number;
    Country?: ICountryEntity;
}

export enum PrIncomeTaxDiscountEntity {
    Code = "Code",
    BasicAmount = "BasicAmount",
    Child1Amount = "Child1Amount",
    Child2Amount = "Child2Amount",
    Child3Amount = "Child3Amount",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    SpouseAmount = "SpouseAmount",
    Country = "Country",
}

export interface IPrInitialDataEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    HealthBenefits?: number;
    LeisureTimeBenefits?: number;
    SavingForRetirementTotal?: number;
    Year?: number;
    InitialMonthData?: IPrInitialMonthDataEntity[];
}

export enum PrInitialDataEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    HealthBenefits = "HealthBenefits",
    LeisureTimeBenefits = "LeisureTimeBenefits",
    SavingForRetirementTotal = "SavingForRetirementTotal",
    Year = "Year",
    InitialMonthData = "InitialMonthData",
}

export interface IPrInitialMonthDataEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AdvanceTaxPaid?: number;
    DateMonth?: Date;
    IncomeTaxBasis?: number;
    IncomeTaxBonus?: number;
    WithholdingTaxPaid?: number;
}

export enum PrInitialMonthDataEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AdvanceTaxPaid = "AdvanceTaxPaid",
    DateMonth = "DateMonth",
    IncomeTaxBasis = "IncomeTaxBasis",
    IncomeTaxBonus = "IncomeTaxBonus",
    WithholdingTaxPaid = "WithholdingTaxPaid",
}

export interface IPrInsolvencyDepositClosingEntity extends IEntityBase {
    Code?: PrInsolvencyDepositClosingCode;
    Name?: string;
}

export enum PrInsolvencyDepositClosingEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrJmhzAnnualOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AverageAnnualDisabledEmployeeCount?: number;
    AverageAnnualEmployeeCount?: number;
    DisabledEmployeeShare?: number;
    OwnershipFormTypeCode?: OwnershipFormTypeCode;
    OwnershipFormType?: IOwnershipFormTypeEntity;
    CollectiveAgreementTypes?: IPrJmhzCollectiveAgreementEntity[];
}

export enum PrJmhzAnnualOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AverageAnnualDisabledEmployeeCount = "AverageAnnualDisabledEmployeeCount",
    AverageAnnualEmployeeCount = "AverageAnnualEmployeeCount",
    DisabledEmployeeShare = "DisabledEmployeeShare",
    OwnershipFormTypeCode = "OwnershipFormTypeCode",
    OwnershipFormType = "OwnershipFormType",
    CollectiveAgreementTypes = "CollectiveAgreementTypes",
}

export interface IPrJmhzAnnualTaxSettlementPartnerEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    DiscountMonthsCount?: number;
    IsZtpP?: boolean;
    ZtpPDiscountMonthsCount?: number;
    Children?: IPrJmhzAnnualTaxSettlementPartnerChildEntity[];
}

export enum PrJmhzAnnualTaxSettlementPartnerEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    DiscountMonthsCount = "DiscountMonthsCount",
    IsZtpP = "IsZtpP",
    ZtpPDiscountMonthsCount = "ZtpPDiscountMonthsCount",
    Children = "Children",
}

export interface IPrJmhzAnnualTaxSettlementPartnerChildEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
}

export enum PrJmhzAnnualTaxSettlementPartnerChildEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
}

export interface IPrJmhzAnnualTaxSettlementSupportedChildEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    DiscountMonths?: string;
    OrderCode?: PrChildDeductionOrderCode;
    ZtpPDiscountMonths?: string;
    Order?: IPrChildDeductionOrderEntity;
}

export enum PrJmhzAnnualTaxSettlementSupportedChildEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    DiscountMonths = "DiscountMonths",
    OrderCode = "OrderCode",
    ZtpPDiscountMonths = "ZtpPDiscountMonths",
    Order = "Order",
}

export interface IPrJmhzAnnualTaxSettlementSupportingPersonEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    DiscountMonths?: string;
}

export enum PrJmhzAnnualTaxSettlementSupportingPersonEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    DiscountMonths = "DiscountMonths",
}

export interface IPrJmhzCollectiveAgreementEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CollectiveAgreementTypeCode?: CollectiveAgreementTypeCode;
    CollectiveAgreementType?: ICollectiveAgreementTypeEntity;
}

export enum PrJmhzCollectiveAgreementEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CollectiveAgreementTypeCode = "CollectiveAgreementTypeCode",
    CollectiveAgreementType = "CollectiveAgreementType",
}

export interface IPrJmhzCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LegalName?: string;
    LegalNumber?: string;
    Company?: ICompanyEntity;
    CSSZSymbolVariable?: string;
    SocialSecurityCode?: GovernmentInstitutionCode;
    SocialSecurity?: IGovernmentInstitutionEntity;
}

export enum PrJmhzCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Company = "Company",
    CSSZSymbolVariable = "CSSZSymbolVariable",
    SocialSecurityCode = "SocialSecurityCode",
    SocialSecurity = "SocialSecurity",
}

export interface IPrJmhzDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateSpecificLegalFact?: Date;
    Month?: number;
    NotificationEmail?: string;
    SpecificLegalFactTypeCode?: SpecificLegalFactTypeCode;
    Year?: number;
    AnnualOverview?: IPrJmhzAnnualOverviewEntity;
    Company?: IPrJmhzCompanyEntity;
    IncomeTaxOverview?: IPrJmhzIncomeTaxOverviewEntity;
    SocialInsuranceOverview?: IPrJmhzSocialInsuranceOverviewEntity;
    SpecificLegalFactType?: ISpecificLegalFactTypeEntity;
    Employees?: IPrJmhzEmployeeEntity[];
}

export enum PrJmhzDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateSpecificLegalFact = "DateSpecificLegalFact",
    Month = "Month",
    NotificationEmail = "NotificationEmail",
    SpecificLegalFactTypeCode = "SpecificLegalFactTypeCode",
    Year = "Year",
    AnnualOverview = "AnnualOverview",
    Company = "Company",
    IncomeTaxOverview = "IncomeTaxOverview",
    SocialInsuranceOverview = "SocialInsuranceOverview",
    SpecificLegalFactType = "SpecificLegalFactType",
    Employees = "Employees",
}

export interface IPrJmhzEldpDaysDeductedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DeductedPeriodsTotal?: number;
    TemporaryIncapacityDays?: number;
    MaternityAidDays?: number;
    CareAllowanceDays?: number;
    CareWithoutAllowanceDays?: number;
    PaternityLeaveDays?: number;
    UnpaidLeaveDays?: number;
    UnexcusedAbsenceDays?: number;
}

export enum PrJmhzEldpDaysDeductedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DeductedPeriodsTotal = "DeductedPeriodsTotal",
    TemporaryIncapacityDays = "TemporaryIncapacityDays",
    MaternityAidDays = "MaternityAidDays",
    CareAllowanceDays = "CareAllowanceDays",
    CareWithoutAllowanceDays = "CareWithoutAllowanceDays",
    PaternityLeaveDays = "PaternityLeaveDays",
    UnpaidLeaveDays = "UnpaidLeaveDays",
    UnexcusedAbsenceDays = "UnexcusedAbsenceDays",
}

export interface IPrJmhzEldpDaysExcludedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ExcludedPeriodsTotal?: number;
    TemporaryIncapacityDays?: number;
    MaternityAidDays?: number;
    CareAllowanceDays?: number;
    PaternityLeaveDays?: number;
    Paragraph16Days?: number;
    Paragraph18Days?: number;
    ExcusedAbsenceDays?: number;
    CompensatedTemporaryIncapacityDays?: number;
    PaidBenefitsDays?: number;
}

export enum PrJmhzEldpDaysExcludedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ExcludedPeriodsTotal = "ExcludedPeriodsTotal",
    TemporaryIncapacityDays = "TemporaryIncapacityDays",
    MaternityAidDays = "MaternityAidDays",
    CareAllowanceDays = "CareAllowanceDays",
    PaternityLeaveDays = "PaternityLeaveDays",
    Paragraph16Days = "Paragraph16Days",
    Paragraph18Days = "Paragraph18Days",
    ExcusedAbsenceDays = "ExcusedAbsenceDays",
    CompensatedTemporaryIncapacityDays = "CompensatedTemporaryIncapacityDays",
    PaidBenefitsDays = "PaidBenefitsDays",
}

export interface IPrJmhzEldpItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateDelayedIncomeMonth?: Date;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    ItemTypeCode?: PrEldpItemTypeCode;
    PensionInsuranceDays?: number;
    SocialSecurityCalculationBase?: number;
    DaysDeducted?: IPrJmhzEldpDaysDeductedEntity;
    DaysExcluded?: IPrJmhzEldpDaysExcludedEntity;
    ItemType?: IPrEldpItemTypeEntity;
}

export enum PrJmhzEldpItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateDelayedIncomeMonth = "DateDelayedIncomeMonth",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    ItemTypeCode = "ItemTypeCode",
    PensionInsuranceDays = "PensionInsuranceDays",
    SocialSecurityCalculationBase = "SocialSecurityCalculationBase",
    DaysDeducted = "DaysDeducted",
    DaysExcluded = "DaysExcluded",
    ItemType = "ItemType",
}

export interface IPrJmhzEmployeeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BirthLastName?: string;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    TitleAfterName?: string;
    TitleBeforeName?: string;
    ContactAddress?: IPrEntityEmployeeContactAddressEntity;
    CzechAddress?: IPrEntityEmployeeCzechAddressEntity;
    Employee?: IPrEmployeeEntity;
    PermanentAddress?: IPrEntityEmployeePermanentAddressEntity;
    TaxResidenceAddress?: IPrEntityEmployeeTaxResidenceAddressEntity;
    HasAnnualTaxSettlementPerformedCode?: YesNoCode;
    HasAnnualTaxSettlementRequestCode?: YesNoCode;
    HealthInsuranceByEmployee?: number;
    HealthInsuranceByEmployer?: number;
    MpsvIdentifier?: string;
    AnnualPaymentOverview?: IPrJmhzEmployeeAnnualPaymentOverviewEntity;
    AnnualTaxSettlement?: IPrJmhzEmployeeAnnualTaxSettlementEntity;
    HasAnnualTaxSettlementPerformed?: IYesNoEntity;
    HasAnnualTaxSettlementRequest?: IYesNoEntity;
    IncomeOverview?: IPrJmhzEmployeeIncomeOverviewEntity;
    IncomeTaxOverview?: IPrJmhzEmployeeIncomeTaxOverviewEntity;
    SalaryOverview?: IPrJmhzEmployeeSalaryOverviewEntity;
    WithholdingTaxOverview?: IPrJmhzEmployeeWithholdingTaxOverviewEntity;
    Employments?: IPrJmhzEmploymentEntity[];
}

export enum PrJmhzEmployeeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BirthLastName = "BirthLastName",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    TitleAfterName = "TitleAfterName",
    TitleBeforeName = "TitleBeforeName",
    ContactAddress = "ContactAddress",
    CzechAddress = "CzechAddress",
    Employee = "Employee",
    PermanentAddress = "PermanentAddress",
    TaxResidenceAddress = "TaxResidenceAddress",
    HasAnnualTaxSettlementPerformedCode = "HasAnnualTaxSettlementPerformedCode",
    HasAnnualTaxSettlementRequestCode = "HasAnnualTaxSettlementRequestCode",
    HealthInsuranceByEmployee = "HealthInsuranceByEmployee",
    HealthInsuranceByEmployer = "HealthInsuranceByEmployer",
    MpsvIdentifier = "MpsvIdentifier",
    AnnualPaymentOverview = "AnnualPaymentOverview",
    AnnualTaxSettlement = "AnnualTaxSettlement",
    HasAnnualTaxSettlementPerformed = "HasAnnualTaxSettlementPerformed",
    HasAnnualTaxSettlementRequest = "HasAnnualTaxSettlementRequest",
    IncomeOverview = "IncomeOverview",
    IncomeTaxOverview = "IncomeTaxOverview",
    SalaryOverview = "SalaryOverview",
    WithholdingTaxOverview = "WithholdingTaxOverview",
    Employments = "Employments",
}

export interface IPrJmhzEmployeeAnnualPaymentOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TaxableIncome?: number;
    AdvancedTax?: number;
    AdditionalTaxableIncome?: number;
    AdditionalTaxAdvance?: number;
    WithholdingTaxIncome?: number;
    WithholdingTax?: number;
}

export enum PrJmhzEmployeeAnnualPaymentOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TaxableIncome = "TaxableIncome",
    AdvancedTax = "AdvancedTax",
    AdditionalTaxableIncome = "AdditionalTaxableIncome",
    AdditionalTaxAdvance = "AdditionalTaxAdvance",
    WithholdingTaxIncome = "WithholdingTaxIncome",
    WithholdingTax = "WithholdingTax",
}

export interface IPrJmhzEmployeeAnnualTaxSettlementEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Balance?: number;
    HasChildTaxBenefitCode?: YesNoCode;
    HasOtherSupportingPerson?: boolean;
    HasSpouseDiscountCode?: YesNoCode;
    TaxBalance?: number;
    TaxBonusBalance?: number;
    HasChildTaxBenefit?: IYesNoEntity;
    HasSpouseDiscount?: IYesNoEntity;
    Partners?: IPrJmhzAnnualTaxSettlementPartnerEntity[];
    SupportedChildren?: IPrJmhzAnnualTaxSettlementSupportedChildEntity[];
    SupportingPersons?: IPrJmhzAnnualTaxSettlementSupportingPersonEntity[];
}

export enum PrJmhzEmployeeAnnualTaxSettlementEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Balance = "Balance",
    HasChildTaxBenefitCode = "HasChildTaxBenefitCode",
    HasOtherSupportingPerson = "HasOtherSupportingPerson",
    HasSpouseDiscountCode = "HasSpouseDiscountCode",
    TaxBalance = "TaxBalance",
    TaxBonusBalance = "TaxBonusBalance",
    HasChildTaxBenefit = "HasChildTaxBenefit",
    HasSpouseDiscount = "HasSpouseDiscount",
    Partners = "Partners",
    SupportedChildren = "SupportedChildren",
    SupportingPersons = "SupportingPersons",
}

export interface IPrJmhzEmployeeIncomeOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IncomeTotal?: number;
    SettledIncomeLegalEntityBodyMemberNonResidentRewards?: number;
    NonTaxableIncomeTotal?: number;
    EmployerRetirementSavingsContributionTotal?: number;
    StateContributedSupplementaryPensionInsuranceContribution?: number;
    SupplementaryPensionSavingsContribution?: number;
    PensionInsuranceContribution?: number;
    PrivateLifeInsuranceContribution?: number;
    LongTermInvestmentProductContribution?: number;
    LongTermCareInsuranceContribution?: number;
}

export enum PrJmhzEmployeeIncomeOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IncomeTotal = "IncomeTotal",
    SettledIncomeLegalEntityBodyMemberNonResidentRewards = "SettledIncomeLegalEntityBodyMemberNonResidentRewards",
    NonTaxableIncomeTotal = "NonTaxableIncomeTotal",
    EmployerRetirementSavingsContributionTotal = "EmployerRetirementSavingsContributionTotal",
    StateContributedSupplementaryPensionInsuranceContribution = "StateContributedSupplementaryPensionInsuranceContribution",
    SupplementaryPensionSavingsContribution = "SupplementaryPensionSavingsContribution",
    PensionInsuranceContribution = "PensionInsuranceContribution",
    PrivateLifeInsuranceContribution = "PrivateLifeInsuranceContribution",
    LongTermInvestmentProductContribution = "LongTermInvestmentProductContribution",
    LongTermCareInsuranceContribution = "LongTermCareInsuranceContribution",
}

export interface IPrJmhzEmployeeIncomeTaxOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    HasOtherSupportingPerson?: boolean;
    HasTaxpayerDeclaration?: boolean;
    AdvancedTaxBase?: number;
    AdvancedTaxCalculated?: number;
    TaxPayerDiscount?: number;
    BasicDisabilityDiscount?: number;
    ExtendedDisabilityDiscount?: number;
    ZtpPCardHolderDiscount?: number;
    AdvancedTaxAfterDiscount?: number;
    MonthlyChildTaxBenefit?: number;
    MonthlyChildDiscount?: number;
    PaidMonthlyTaxBonus?: number;
    SupportedChildren?: IPrJmhzSupportedChildEntity[];
    SupportingPersons?: IPrJmhzSupportingPersonEntity[];
}

export enum PrJmhzEmployeeIncomeTaxOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    HasOtherSupportingPerson = "HasOtherSupportingPerson",
    HasTaxpayerDeclaration = "HasTaxpayerDeclaration",
    AdvancedTaxBase = "AdvancedTaxBase",
    AdvancedTaxCalculated = "AdvancedTaxCalculated",
    TaxPayerDiscount = "TaxPayerDiscount",
    BasicDisabilityDiscount = "BasicDisabilityDiscount",
    ExtendedDisabilityDiscount = "ExtendedDisabilityDiscount",
    ZtpPCardHolderDiscount = "ZtpPCardHolderDiscount",
    AdvancedTaxAfterDiscount = "AdvancedTaxAfterDiscount",
    MonthlyChildTaxBenefit = "MonthlyChildTaxBenefit",
    MonthlyChildDiscount = "MonthlyChildDiscount",
    PaidMonthlyTaxBonus = "PaidMonthlyTaxBonus",
    SupportedChildren = "SupportedChildren",
    SupportingPersons = "SupportingPersons",
}

export interface IPrJmhzEmployeeSalaryOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DatePayment?: Date;
    HasEmployerClaimsWageDeductionsCode?: YesNoCode;
    HasSalaryDeduction?: boolean;
    PaidInCashCode?: YesNoCode;
    SalaryNet?: number;
    EmployerCivilCodeDeduction?: number;
    EmployeeDamageDeduction?: number;
    WorkplaceMealsDeduction?: number;
    EmployeeLiabilitiesDeduction?: number;
    HasEmployerClaimsWageDeductions?: IYesNoEntity;
    PaidInCash?: IYesNoEntity;
}

export enum PrJmhzEmployeeSalaryOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DatePayment = "DatePayment",
    HasEmployerClaimsWageDeductionsCode = "HasEmployerClaimsWageDeductionsCode",
    HasSalaryDeduction = "HasSalaryDeduction",
    PaidInCashCode = "PaidInCashCode",
    SalaryNet = "SalaryNet",
    EmployerCivilCodeDeduction = "EmployerCivilCodeDeduction",
    EmployeeDamageDeduction = "EmployeeDamageDeduction",
    WorkplaceMealsDeduction = "WorkplaceMealsDeduction",
    EmployeeLiabilitiesDeduction = "EmployeeLiabilitiesDeduction",
    HasEmployerClaimsWageDeductions = "HasEmployerClaimsWageDeductions",
    PaidInCash = "PaidInCash",
}

export interface IPrJmhzEmployeeWithholdingTaxOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    WithholdingTaxBase?: number;
    BodyMemberReward?: number;
    WithholdingTax?: number;
    BodyMemberTaxAdvance?: number;
}

export enum PrJmhzEmployeeWithholdingTaxOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    WithholdingTaxBase = "WithholdingTaxBase",
    BodyMemberReward = "BodyMemberReward",
    WithholdingTax = "WithholdingTax",
    BodyMemberTaxAdvance = "BodyMemberTaxAdvance",
}

export interface IPrJmhzEmploymentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrEmploymentTypeCode;
    Employment?: IPrEmploymentEntity;
    Type?: IPrEmploymentTypeEntity;
    ActiveEmploymentPolicyToolCode?: ActiveEmploymentPolicyToolCode;
    City?: string;
    CityCode?: string;
    CountryCode?: CountryCode;
    CsszEmploymentTypeCode?: CsszEmploymentTypeCode;
    DateSpecificLegalFactPayDay?: Date;
    DateStart?: Date;
    DelayedIncomeTypeCode?: PrDelayedIncomeTypeCode;
    FormGuid?: string;
    FormTypeCode?: PrJmhzFormTypeCode;
    HasActiveEmploymentPolicyToolContribution?: boolean;
    HasFunctionalBenefits?: boolean;
    HoursPerWeekFullTime?: number;
    IsTemporaryAssignmentToUser?: boolean;
    MonthlyWorkingHours?: number;
    MonthlyWorkingHoursFullTime?: number;
    MpsvIdentifier?: string;
    ActiveEmploymentPolicyTool?: IActiveEmploymentPolicyToolEntity;
    AttendanceOverview?: IPrJmhzEmploymentAttendanceOverviewEntity;
    Country?: ICountryEntity;
    CsszEmploymentType?: ICsszEmploymentTypeEntity;
    DelayedIncomeType?: IPrDelayedIncomeTypeEntity;
    FormType?: IPrJmhzFormTypeEntity;
    IncomeOverview?: IPrJmhzEmploymentIncomeOverviewEntity;
    SocialSecurityOverview?: IPrJmhzEmploymentSocialSecurityOverviewEntity;
}

export enum PrJmhzEmploymentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Employment = "Employment",
    Type = "Type",
    ActiveEmploymentPolicyToolCode = "ActiveEmploymentPolicyToolCode",
    City = "City",
    CityCode = "CityCode",
    CountryCode = "CountryCode",
    CsszEmploymentTypeCode = "CsszEmploymentTypeCode",
    DateSpecificLegalFactPayDay = "DateSpecificLegalFactPayDay",
    DateStart = "DateStart",
    DelayedIncomeTypeCode = "DelayedIncomeTypeCode",
    FormGuid = "FormGuid",
    FormTypeCode = "FormTypeCode",
    HasActiveEmploymentPolicyToolContribution = "HasActiveEmploymentPolicyToolContribution",
    HasFunctionalBenefits = "HasFunctionalBenefits",
    HoursPerWeekFullTime = "HoursPerWeekFullTime",
    IsTemporaryAssignmentToUser = "IsTemporaryAssignmentToUser",
    MonthlyWorkingHours = "MonthlyWorkingHours",
    MonthlyWorkingHoursFullTime = "MonthlyWorkingHoursFullTime",
    MpsvIdentifier = "MpsvIdentifier",
    ActiveEmploymentPolicyTool = "ActiveEmploymentPolicyTool",
    AttendanceOverview = "AttendanceOverview",
    Country = "Country",
    CsszEmploymentType = "CsszEmploymentType",
    DelayedIncomeType = "DelayedIncomeType",
    FormType = "FormType",
    IncomeOverview = "IncomeOverview",
    SocialSecurityOverview = "SocialSecurityOverview",
}

export interface IPrJmhzEmploymentAttendanceOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DaysInRegistrationState?: number;
    RiskCategoryCode?: RiskCategoryCode;
    WorkedHours?: number;
    WorkedDays?: number;
    OvertimeHours?: number;
    RiskWorkHours?: number;
    NonWorkedHoursTotal?: number;
    NonWorkedHoursWithCompensation?: number;
    NonWorkedHoursTemporaryIncapacityWithCompensation?: number;
    NonWorkedHoursTemporaryIncapacityWithoutCompensation?: number;
    NonWorkedHoursVacation?: number;
    NonWorkedHoursCareAllowance?: number;
    EmployeeObstacleNonWorkedHours?: number;
    EmployerObstacleNonWorkedHours?: number;
    RiskCategory?: IRiskCategoryEntity;
}

export enum PrJmhzEmploymentAttendanceOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DaysInRegistrationState = "DaysInRegistrationState",
    RiskCategoryCode = "RiskCategoryCode",
    WorkedHours = "WorkedHours",
    WorkedDays = "WorkedDays",
    OvertimeHours = "OvertimeHours",
    RiskWorkHours = "RiskWorkHours",
    NonWorkedHoursTotal = "NonWorkedHoursTotal",
    NonWorkedHoursWithCompensation = "NonWorkedHoursWithCompensation",
    NonWorkedHoursTemporaryIncapacityWithCompensation = "NonWorkedHoursTemporaryIncapacityWithCompensation",
    NonWorkedHoursTemporaryIncapacityWithoutCompensation = "NonWorkedHoursTemporaryIncapacityWithoutCompensation",
    NonWorkedHoursVacation = "NonWorkedHoursVacation",
    NonWorkedHoursCareAllowance = "NonWorkedHoursCareAllowance",
    EmployeeObstacleNonWorkedHours = "EmployeeObstacleNonWorkedHours",
    EmployerObstacleNonWorkedHours = "EmployerObstacleNonWorkedHours",
    RiskCategory = "RiskCategory",
}

export interface IPrJmhzEmploymentIncomeOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AverageGrossHourlyEarnings?: number;
    SettledWage?: number;
    TaxCalculationBase?: number;
    TariffWages?: number;
    RegularBonusesAndRewards?: number;
    IrregularBonusesAndRewards?: number;
    SupplementsTotal?: number;
    OvertimeSupplement?: number;
    NightWorkSupplement?: number;
    WeekendWorkSupplement?: number;
    HolidayWorkSupplement?: number;
    WageCompensationSettled?: number;
    VacationCompensation?: number;
    HolidayCompensation?: number;
    EmployerObstacleCompensation?: number;
    EmployeeObstacleCompensation?: number;
    TemporaryIncapacityCompensation?: number;
    StandbyDutyReward?: number;
}

export enum PrJmhzEmploymentIncomeOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AverageGrossHourlyEarnings = "AverageGrossHourlyEarnings",
    SettledWage = "SettledWage",
    TaxCalculationBase = "TaxCalculationBase",
    TariffWages = "TariffWages",
    RegularBonusesAndRewards = "RegularBonusesAndRewards",
    IrregularBonusesAndRewards = "IrregularBonusesAndRewards",
    SupplementsTotal = "SupplementsTotal",
    OvertimeSupplement = "OvertimeSupplement",
    NightWorkSupplement = "NightWorkSupplement",
    WeekendWorkSupplement = "WeekendWorkSupplement",
    HolidayWorkSupplement = "HolidayWorkSupplement",
    WageCompensationSettled = "WageCompensationSettled",
    VacationCompensation = "VacationCompensation",
    HolidayCompensation = "HolidayCompensation",
    EmployerObstacleCompensation = "EmployerObstacleCompensation",
    EmployeeObstacleCompensation = "EmployeeObstacleCompensation",
    TemporaryIncapacityCompensation = "TemporaryIncapacityCompensation",
    StandbyDutyReward = "StandbyDutyReward",
}

export interface IPrJmhzEmploymentSocialSecurityOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateInsuranceFrom?: Date;
    DateInsuranceTo?: Date;
    EmployeeSocialSecurityInsurance?: number;
    EmployerInsuranceDiscountTypeCode?: PrSocialInsuranceDiscountTypeCode;
    EmployerSocialSecurityInsurance?: number;
    HasEmployerInsuranceDiscountCode?: YesNoCode;
    HasRetireeDiscountCode?: YesNoCode;
    IncomeTotal?: number;
    EmployeeCalculationBaseInsurance?: number;
    EmployerCalculationBaseSection5aA?: number;
    EmployerCalculationBaseSection5aB?: number;
    EmployerCalculationBaseSection5aC?: number;
    ShorterWorkingTimeScope?: number;
    RetireeDiscountAmount?: number;
    EmployerInsuranceDiscountType?: IPrSocialInsuranceDiscountTypeEntity;
    HasEmployerInsuranceDiscount?: IYesNoEntity;
    HasRetireeDiscount?: IYesNoEntity;
    EldpItems?: IPrJmhzEldpItemEntity[];
}

export enum PrJmhzEmploymentSocialSecurityOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateInsuranceFrom = "DateInsuranceFrom",
    DateInsuranceTo = "DateInsuranceTo",
    EmployeeSocialSecurityInsurance = "EmployeeSocialSecurityInsurance",
    EmployerInsuranceDiscountTypeCode = "EmployerInsuranceDiscountTypeCode",
    EmployerSocialSecurityInsurance = "EmployerSocialSecurityInsurance",
    HasEmployerInsuranceDiscountCode = "HasEmployerInsuranceDiscountCode",
    HasRetireeDiscountCode = "HasRetireeDiscountCode",
    IncomeTotal = "IncomeTotal",
    EmployeeCalculationBaseInsurance = "EmployeeCalculationBaseInsurance",
    EmployerCalculationBaseSection5aA = "EmployerCalculationBaseSection5aA",
    EmployerCalculationBaseSection5aB = "EmployerCalculationBaseSection5aB",
    EmployerCalculationBaseSection5aC = "EmployerCalculationBaseSection5aC",
    ShorterWorkingTimeScope = "ShorterWorkingTimeScope",
    RetireeDiscountAmount = "RetireeDiscountAmount",
    EmployerInsuranceDiscountType = "EmployerInsuranceDiscountType",
    HasEmployerInsuranceDiscount = "HasEmployerInsuranceDiscount",
    HasRetireeDiscount = "HasRetireeDiscount",
    EldpItems = "EldpItems",
}

export interface IPrJmhzFormTypeEntity extends IEntityBase {
    Code?: PrJmhzFormTypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum PrJmhzFormTypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrJmhzIncomeTaxOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AdvancedTaxAfterDiscount?: number;
    MonthlyTaxBonus?: number;
    AnnualTaxSettlementTaxOverpayment?: number;
    AnnualTaxSettlementTaxBonusPayment?: number;
}

export enum PrJmhzIncomeTaxOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AdvancedTaxAfterDiscount = "AdvancedTaxAfterDiscount",
    MonthlyTaxBonus = "MonthlyTaxBonus",
    AnnualTaxSettlementTaxOverpayment = "AnnualTaxSettlementTaxOverpayment",
    AnnualTaxSettlementTaxBonusPayment = "AnnualTaxSettlementTaxBonusPayment",
}

export interface IPrJmhzPersonEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
}

export enum PrJmhzPersonEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
}

export interface IPrJmhzSocialInsuranceOverviewEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    InsuranceByEmployeeTotal?: number;
    InsuranceByEmployerTotal?: number;
    SocialInsuranceToPay?: number;
    SocialInsuranceTotal?: number;
    RegularCalculationBase?: number;
    RegularInsuranceByEmployer?: number;
    RescueCalculationBase?: number;
    RescueInsuranceByEmployer?: number;
    RiskCalculationBase?: number;
    RiskInsuranceByEmployer?: number;
    EmployerDiscountEmployeeCount?: number;
    EmployerDiscountCalculationBase?: number;
    EmployerDiscountAmount?: number;
    EmployeeDiscountEmployeeCount?: number;
    EmployeeDiscountCalculationBase?: number;
    EmployeeDiscountAmount?: number;
    EmployeeOvoZelDiscountEmployeeCount?: number;
    EmployeeOvoZelDiscountCalculationBase?: number;
    EmployeeOvoZelDiscountAmount?: number;
}

export enum PrJmhzSocialInsuranceOverviewEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    InsuranceByEmployeeTotal = "InsuranceByEmployeeTotal",
    InsuranceByEmployerTotal = "InsuranceByEmployerTotal",
    SocialInsuranceToPay = "SocialInsuranceToPay",
    SocialInsuranceTotal = "SocialInsuranceTotal",
    RegularCalculationBase = "RegularCalculationBase",
    RegularInsuranceByEmployer = "RegularInsuranceByEmployer",
    RescueCalculationBase = "RescueCalculationBase",
    RescueInsuranceByEmployer = "RescueInsuranceByEmployer",
    RiskCalculationBase = "RiskCalculationBase",
    RiskInsuranceByEmployer = "RiskInsuranceByEmployer",
    EmployerDiscountEmployeeCount = "EmployerDiscountEmployeeCount",
    EmployerDiscountCalculationBase = "EmployerDiscountCalculationBase",
    EmployerDiscountAmount = "EmployerDiscountAmount",
    EmployeeDiscountEmployeeCount = "EmployeeDiscountEmployeeCount",
    EmployeeDiscountCalculationBase = "EmployeeDiscountCalculationBase",
    EmployeeDiscountAmount = "EmployeeDiscountAmount",
    EmployeeOvoZelDiscountEmployeeCount = "EmployeeOvoZelDiscountEmployeeCount",
    EmployeeOvoZelDiscountCalculationBase = "EmployeeOvoZelDiscountCalculationBase",
    EmployeeOvoZelDiscountAmount = "EmployeeOvoZelDiscountAmount",
}

export interface IPrJmhzSubmissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    SubmissionGuid?: string;
    Detail?: IPrJmhzDetailEntity;
}

export enum PrJmhzSubmissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    SubmissionGuid = "SubmissionGuid",
    Detail = "Detail",
}

export interface IPrJmhzSupportedChildEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    IsZtpP?: boolean;
    OrderCode?: PrChildDeductionOrderCode;
    Order?: IPrChildDeductionOrderEntity;
}

export enum PrJmhzSupportedChildEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    IsZtpP = "IsZtpP",
    OrderCode = "OrderCode",
    Order = "Order",
}

export interface IPrJmhzSupportingPersonEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
}

export enum PrJmhzSupportingPersonEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
}

export interface IPrLaborMarketAccessEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    FreeAccessTypeCode?: MpsvFreeAccessToLaborMarketTypeCode;
    HasFreeAccessToLaborMarket?: boolean;
    PermitIssuingOfficeCode?: LORegionalOfficeCode;
    WorkPermitNumber?: string;
    WorkPermitTypeCode?: PrWorkPermitTypeCode;
    FreeAccessType?: IMpsvFreeAccessToLaborMarketTypeEntity;
    PermitIssuingOffice?: ILORegionalOfficeEntity;
    WorkPermitType?: IPrWorkPermitTypeEntity;
}

export enum PrLaborMarketAccessEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    FreeAccessTypeCode = "FreeAccessTypeCode",
    HasFreeAccessToLaborMarket = "HasFreeAccessToLaborMarket",
    PermitIssuingOfficeCode = "PermitIssuingOfficeCode",
    WorkPermitNumber = "WorkPermitNumber",
    WorkPermitTypeCode = "WorkPermitTypeCode",
    FreeAccessType = "FreeAccessType",
    PermitIssuingOffice = "PermitIssuingOffice",
    WorkPermitType = "WorkPermitType",
}

export interface IPrLaborOfficeDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountNumber?: string;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    Contact?: IPrGovernmentInstitutionContactEntity;
}

export enum PrLaborOfficeDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountNumber = "AccountNumber",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    Contact = "Contact",
}

export interface IPrLegislativeAverageSalaryEntity extends IEntityBase {
    Code?: PrLegislativeAverageSalaryCode;
    Amount?: number;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrLegislativeAverageSalaryEntity {
    Code = "Code",
    Amount = "Amount",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IPrLegislativePayrollConstantEntity extends IEntityBase {
    Code?: PrLegislativePayrollConstantCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    MinimalHourlyWage?: number;
    MinimalMonthlyWage?: number;
    Name?: string;
    NonTaxablePensionEmployeeLimit?: number;
    NonTaxablePensionEmployerBenefitLimit?: number;
    SocialInsuranceBasisLimit?: number;
    Country?: ICountryEntity;
}

export enum PrLegislativePayrollConstantEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    MinimalHourlyWage = "MinimalHourlyWage",
    MinimalMonthlyWage = "MinimalMonthlyWage",
    Name = "Name",
    NonTaxablePensionEmployeeLimit = "NonTaxablePensionEmployeeLimit",
    NonTaxablePensionEmployerBenefitLimit = "NonTaxablePensionEmployerBenefitLimit",
    SocialInsuranceBasisLimit = "SocialInsuranceBasisLimit",
    Country = "Country",
}

export interface IPrLegislativeYouthEventCompensationHourlyLimitEntity extends IEntityBase {
    Code?: PrLegislativeYouthEventCompensationHourlyLimitCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    HourlyLimit?: number;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrLegislativeYouthEventCompensationHourlyLimitEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    HourlyLimit = "HourlyLimit",
    Name = "Name",
    Country = "Country",
}

export interface IPrLongTermCaregivingEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEventEnd?: Date;
    DateEventStart?: Date;
    DateRequiredActionFrom?: Date;
    IsProcessed?: boolean;
    NumberOurs?: string;
    NumberTheirs?: string;
    RequiredActionCode?: PrSocialEventRequiredActionCode;
    SocialEventStatusCode?: PrSocialEventStatusCode;
    SocialEventTypeCode?: PrSocialEventTypeCode;
    WorkedHoursOnFirstDay?: number;
    WorkedHoursOnLastDay?: number;
    Employee?: IPrEmployeeEntity;
    Employment?: IPrEmploymentEntity;
    NumberRange?: INumberRangeEntity;
    RequiredAction?: IPrSocialEventRequiredActionEntity;
    SocialEventStatus?: IPrSocialEventStatusEntity;
    SocialEventType?: IPrSocialEventTypeEntity;
    Attachments?: IPrSocialEventAttachmentEntity[];
    AttendanceDayIntervals?: IPrAttendanceDayIntervalEntity[];
    CertificateAttachments?: IPrSocialEventCertificateAttachmentEntity[];
    MonthDetails?: IPrSocialEventMonthDetailEntity[];
    Submissions?: IPrSubmissionEntity[];
    CareReceiverRelationCode?: PrMpsvRelationCode;
    IsAllowanceReceiverUnfit?: boolean;
    IsSameHousehold?: boolean;
    IsSharedCaregiving?: boolean;
    IsSomeoneElseReceivingAllowance?: boolean;
    CareReceiver?: IPrCareReceiverSocialEventEntity;
    CareReceiverRelation?: IPrMpsvRelationEntity;
}

export enum PrLongTermCaregivingEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEventEnd = "DateEventEnd",
    DateEventStart = "DateEventStart",
    DateRequiredActionFrom = "DateRequiredActionFrom",
    IsProcessed = "IsProcessed",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    RequiredActionCode = "RequiredActionCode",
    SocialEventStatusCode = "SocialEventStatusCode",
    SocialEventTypeCode = "SocialEventTypeCode",
    WorkedHoursOnFirstDay = "WorkedHoursOnFirstDay",
    WorkedHoursOnLastDay = "WorkedHoursOnLastDay",
    Employee = "Employee",
    Employment = "Employment",
    NumberRange = "NumberRange",
    RequiredAction = "RequiredAction",
    SocialEventStatus = "SocialEventStatus",
    SocialEventType = "SocialEventType",
    Attachments = "Attachments",
    AttendanceDayIntervals = "AttendanceDayIntervals",
    CertificateAttachments = "CertificateAttachments",
    MonthDetails = "MonthDetails",
    Submissions = "Submissions",
    CareReceiverRelationCode = "CareReceiverRelationCode",
    IsAllowanceReceiverUnfit = "IsAllowanceReceiverUnfit",
    IsSameHousehold = "IsSameHousehold",
    IsSharedCaregiving = "IsSharedCaregiving",
    IsSomeoneElseReceivingAllowance = "IsSomeoneElseReceivingAllowance",
    CareReceiver = "CareReceiver",
    CareReceiverRelation = "CareReceiverRelation",
}

export interface IPrMaternityLeaveEntitlementEntity extends IEntityBase {
    Code?: PrMaternityLeaveEntitlementCode;
    CsszCode?: string;
    Name?: string;
}

export enum PrMaternityLeaveEntitlementEntity {
    Code = "Code",
    CsszCode = "CsszCode",
    Name = "Name",
}

export interface IPrMaternityLeaveEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEventEnd?: Date;
    DateEventStart?: Date;
    DateRequiredActionFrom?: Date;
    IsProcessed?: boolean;
    NumberOurs?: string;
    NumberTheirs?: string;
    RequiredActionCode?: PrSocialEventRequiredActionCode;
    SocialEventStatusCode?: PrSocialEventStatusCode;
    SocialEventTypeCode?: PrSocialEventTypeCode;
    WorkedHoursOnFirstDay?: number;
    WorkedHoursOnLastDay?: number;
    Employee?: IPrEmployeeEntity;
    Employment?: IPrEmploymentEntity;
    NumberRange?: INumberRangeEntity;
    RequiredAction?: IPrSocialEventRequiredActionEntity;
    SocialEventStatus?: IPrSocialEventStatusEntity;
    SocialEventType?: IPrSocialEventTypeEntity;
    Attachments?: IPrSocialEventAttachmentEntity[];
    AttendanceDayIntervals?: IPrAttendanceDayIntervalEntity[];
    CertificateAttachments?: IPrSocialEventCertificateAttachmentEntity[];
    MonthDetails?: IPrSocialEventMonthDetailEntity[];
    Submissions?: IPrSubmissionEntity[];
    DateOfChildbirth?: Date;
    MaternityLeaveEntitlementCode?: PrMaternityLeaveEntitlementCode;
    MaternityLeaveEntitlement?: IPrMaternityLeaveEntitlementEntity;
    CareReceivers?: IPrCareReceiverSocialEventEntity[];
}

export enum PrMaternityLeaveEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEventEnd = "DateEventEnd",
    DateEventStart = "DateEventStart",
    DateRequiredActionFrom = "DateRequiredActionFrom",
    IsProcessed = "IsProcessed",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    RequiredActionCode = "RequiredActionCode",
    SocialEventStatusCode = "SocialEventStatusCode",
    SocialEventTypeCode = "SocialEventTypeCode",
    WorkedHoursOnFirstDay = "WorkedHoursOnFirstDay",
    WorkedHoursOnLastDay = "WorkedHoursOnLastDay",
    Employee = "Employee",
    Employment = "Employment",
    NumberRange = "NumberRange",
    RequiredAction = "RequiredAction",
    SocialEventStatus = "SocialEventStatus",
    SocialEventType = "SocialEventType",
    Attachments = "Attachments",
    AttendanceDayIntervals = "AttendanceDayIntervals",
    CertificateAttachments = "CertificateAttachments",
    MonthDetails = "MonthDetails",
    Submissions = "Submissions",
    DateOfChildbirth = "DateOfChildbirth",
    MaternityLeaveEntitlementCode = "MaternityLeaveEntitlementCode",
    MaternityLeaveEntitlement = "MaternityLeaveEntitlement",
    CareReceivers = "CareReceivers",
}

export interface IPrMinimumHealthInsuranceBaseEntity extends IEntityBase {
    Code?: PrMinimumHealthInsuranceBaseCode;
    Amount?: number;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    PrMinimumHealthInsuranceTypeCode?: PrMinimumHealthInsuranceTypeCode;
    Country?: ICountryEntity;
    PrMinimumHealthInsuranceType?: IPrMinimumHealthInsuranceTypeEntity;
}

export enum PrMinimumHealthInsuranceBaseEntity {
    Code = "Code",
    Amount = "Amount",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    PrMinimumHealthInsuranceTypeCode = "PrMinimumHealthInsuranceTypeCode",
    Country = "Country",
    PrMinimumHealthInsuranceType = "PrMinimumHealthInsuranceType",
}

export interface IPrMinimumHealthInsuranceTypeEntity extends IEntityBase {
    Code?: PrMinimumHealthInsuranceTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrMinimumHealthInsuranceTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IPrMortgageLocationAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
}

export enum PrMortgageLocationAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
}

export interface IPrMortgageOtherPeopleAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
}

export enum PrMortgageOtherPeopleAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
}

export interface IPrMpsvFamilyRelationEntity extends IEntityBase {
    Code?: PrMpsvFamilyRelationCode;
    Description?: string;
    Name?: string;
}

export enum PrMpsvFamilyRelationEntity {
    Code = "Code",
    Description = "Description",
    Name = "Name",
}

export interface IPrMpsvRelationEntity extends IEntityBase {
    Code?: PrMpsvRelationCode;
    MpsvCode?: string;
    Name?: string;
}

export enum PrMpsvRelationEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrOtherBenefitCategoryEntity extends IEntityBase {
    Code?: PrOtherBenefitCategoryCode;
    Name?: string;
}

export enum PrOtherBenefitCategoryEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrOtherBenefitTaxAndContributionsApplicabilityEntity extends IEntityBase {
    Code?: PrOtherBenefitTaxAndContributionsApplicabilityCode;
    Name?: string;
}

export enum PrOtherBenefitTaxAndContributionsApplicabilityEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrOtherBenefitTaxDeducibilityEntity extends IEntityBase {
    Code?: PrOtherBenefitTaxDeducibilityCode;
    Name?: string;
}

export enum PrOtherBenefitTaxDeducibilityEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrOtherProviderAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
}

export enum PrOtherProviderAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
}

export interface IPrOtherProviderEmployerAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
}

export enum PrOtherProviderEmployerAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
}

export interface IPrParentalLeaveEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEventEnd?: Date;
    DateEventStart?: Date;
    DateRequiredActionFrom?: Date;
    IsProcessed?: boolean;
    NumberOurs?: string;
    NumberTheirs?: string;
    RequiredActionCode?: PrSocialEventRequiredActionCode;
    SocialEventStatusCode?: PrSocialEventStatusCode;
    SocialEventTypeCode?: PrSocialEventTypeCode;
    WorkedHoursOnFirstDay?: number;
    WorkedHoursOnLastDay?: number;
    Employee?: IPrEmployeeEntity;
    Employment?: IPrEmploymentEntity;
    NumberRange?: INumberRangeEntity;
    RequiredAction?: IPrSocialEventRequiredActionEntity;
    SocialEventStatus?: IPrSocialEventStatusEntity;
    SocialEventType?: IPrSocialEventTypeEntity;
    Attachments?: IPrSocialEventAttachmentEntity[];
    AttendanceDayIntervals?: IPrAttendanceDayIntervalEntity[];
    CertificateAttachments?: IPrSocialEventCertificateAttachmentEntity[];
    MonthDetails?: IPrSocialEventMonthDetailEntity[];
    Submissions?: IPrSubmissionEntity[];
    DateOfChildbirth?: Date;
    IsMaternityLeaveTakenBefore?: boolean;
    IsMultipleChildbirth?: boolean;
    CareReceivers?: IPrCareReceiverSocialEventEntity[];
}

export enum PrParentalLeaveEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEventEnd = "DateEventEnd",
    DateEventStart = "DateEventStart",
    DateRequiredActionFrom = "DateRequiredActionFrom",
    IsProcessed = "IsProcessed",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    RequiredActionCode = "RequiredActionCode",
    SocialEventStatusCode = "SocialEventStatusCode",
    SocialEventTypeCode = "SocialEventTypeCode",
    WorkedHoursOnFirstDay = "WorkedHoursOnFirstDay",
    WorkedHoursOnLastDay = "WorkedHoursOnLastDay",
    Employee = "Employee",
    Employment = "Employment",
    NumberRange = "NumberRange",
    RequiredAction = "RequiredAction",
    SocialEventStatus = "SocialEventStatus",
    SocialEventType = "SocialEventType",
    Attachments = "Attachments",
    AttendanceDayIntervals = "AttendanceDayIntervals",
    CertificateAttachments = "CertificateAttachments",
    MonthDetails = "MonthDetails",
    Submissions = "Submissions",
    DateOfChildbirth = "DateOfChildbirth",
    IsMaternityLeaveTakenBefore = "IsMaternityLeaveTakenBefore",
    IsMultipleChildbirth = "IsMultipleChildbirth",
    CareReceivers = "CareReceivers",
}

export interface IPrPaternityLeaveEntitlementEntity extends IEntityBase {
    Code?: PrPaternityLeaveEntitlementCode;
    CsszCode?: string;
    Name?: string;
}

export enum PrPaternityLeaveEntitlementEntity {
    Code = "Code",
    CsszCode = "CsszCode",
    Name = "Name",
}

export interface IPrPaternityLeaveEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEventEnd?: Date;
    DateEventStart?: Date;
    DateRequiredActionFrom?: Date;
    IsProcessed?: boolean;
    NumberOurs?: string;
    NumberTheirs?: string;
    RequiredActionCode?: PrSocialEventRequiredActionCode;
    SocialEventStatusCode?: PrSocialEventStatusCode;
    SocialEventTypeCode?: PrSocialEventTypeCode;
    WorkedHoursOnFirstDay?: number;
    WorkedHoursOnLastDay?: number;
    Employee?: IPrEmployeeEntity;
    Employment?: IPrEmploymentEntity;
    NumberRange?: INumberRangeEntity;
    RequiredAction?: IPrSocialEventRequiredActionEntity;
    SocialEventStatus?: IPrSocialEventStatusEntity;
    SocialEventType?: IPrSocialEventTypeEntity;
    Attachments?: IPrSocialEventAttachmentEntity[];
    AttendanceDayIntervals?: IPrAttendanceDayIntervalEntity[];
    CertificateAttachments?: IPrSocialEventCertificateAttachmentEntity[];
    MonthDetails?: IPrSocialEventMonthDetailEntity[];
    Submissions?: IPrSubmissionEntity[];
    DateOfChildbirth?: Date;
    IsChildHospitalized?: boolean;
    PaternityLeaveEntitlementCode?: PrPaternityLeaveEntitlementCode;
    PaternityLeaveEntitlement?: IPrPaternityLeaveEntitlementEntity;
    CareReceivers?: IPrCareReceiverSocialEventEntity[];
}

export enum PrPaternityLeaveEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEventEnd = "DateEventEnd",
    DateEventStart = "DateEventStart",
    DateRequiredActionFrom = "DateRequiredActionFrom",
    IsProcessed = "IsProcessed",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    RequiredActionCode = "RequiredActionCode",
    SocialEventStatusCode = "SocialEventStatusCode",
    SocialEventTypeCode = "SocialEventTypeCode",
    WorkedHoursOnFirstDay = "WorkedHoursOnFirstDay",
    WorkedHoursOnLastDay = "WorkedHoursOnLastDay",
    Employee = "Employee",
    Employment = "Employment",
    NumberRange = "NumberRange",
    RequiredAction = "RequiredAction",
    SocialEventStatus = "SocialEventStatus",
    SocialEventType = "SocialEventType",
    Attachments = "Attachments",
    AttendanceDayIntervals = "AttendanceDayIntervals",
    CertificateAttachments = "CertificateAttachments",
    MonthDetails = "MonthDetails",
    Submissions = "Submissions",
    DateOfChildbirth = "DateOfChildbirth",
    IsChildHospitalized = "IsChildHospitalized",
    PaternityLeaveEntitlementCode = "PaternityLeaveEntitlementCode",
    PaternityLeaveEntitlement = "PaternityLeaveEntitlement",
    CareReceivers = "CareReceivers",
}

export interface IPrPayrollDocumentEntity extends IEntityBase {
    Id?: number;
    Amount?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateDue?: Date;
    DocumentTypeCode?: DocumentTypeCode;
    IsInternallyManaged?: boolean;
    NumberOurs?: string;
    PeriodDocumentTypeCode?: PrPeriodDocumentTypeCode;
    PostedStatusCode?: PostedStatusCode;
    TransactionAmount?: number;
    TransactionCurrencyCode?: CurrencyCode;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    ClearedStatus?: IClearedStatusEntity;
    Currency?: ICurrencyEntity;
    DocumentType?: IDocumentTypeEntity;
    PeriodDocumentType?: IPrPeriodDocumentTypeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
}

export enum PrPayrollDocumentEntity {
    Id = "Id",
    Amount = "Amount",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateDue = "DateDue",
    DocumentTypeCode = "DocumentTypeCode",
    IsInternallyManaged = "IsInternallyManaged",
    NumberOurs = "NumberOurs",
    PeriodDocumentTypeCode = "PeriodDocumentTypeCode",
    PostedStatusCode = "PostedStatusCode",
    TransactionAmount = "TransactionAmount",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    BusinessPartner = "BusinessPartner",
    ClearedStatus = "ClearedStatus",
    Currency = "Currency",
    DocumentType = "DocumentType",
    PeriodDocumentType = "PeriodDocumentType",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
}

export interface IPrPayrollPeriodEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Month?: number;
    StatusCode?: PrPayrollPeriodStatusCode;
    Year?: number;
    EmployerSocialInsuranceBase?: number;
    EmployerSocialInsurance?: number;
    EmployerSocialInsuranceDiscountBase?: number;
    EmployerSocialInsuranceDiscount?: number;
    Status?: IPrPayrollPeriodStatusEntity;
    Documents?: IPrPayrollPeriodDocumentEntity[];
}

export enum PrPayrollPeriodEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Month = "Month",
    StatusCode = "StatusCode",
    Year = "Year",
    EmployerSocialInsuranceBase = "EmployerSocialInsuranceBase",
    EmployerSocialInsurance = "EmployerSocialInsurance",
    EmployerSocialInsuranceDiscountBase = "EmployerSocialInsuranceDiscountBase",
    EmployerSocialInsuranceDiscount = "EmployerSocialInsuranceDiscount",
    Status = "Status",
    Documents = "Documents",
}

export interface IPrPayrollPeriodDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    PeriodDocumentTypeCode?: PrPeriodDocumentTypeCode;
    Document?: IDocumentEntity;
    PeriodDocumentType?: IPrPeriodDocumentTypeEntity;
}

export enum PrPayrollPeriodDocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    PeriodDocumentTypeCode = "PeriodDocumentTypeCode",
    Document = "Document",
    PeriodDocumentType = "PeriodDocumentType",
}

export interface IPrPayrollPeriodStatusEntity extends IEntityBase {
    Code?: PrPayrollPeriodStatusCode;
    Name?: string;
}

export enum PrPayrollPeriodStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrPayrollSettingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsPaidOutAutomatically?: boolean;
    PayDay?: number;
    SubstitutePayDayCode?: PrPayrollSubstitutePayDayCode;
    CurrentTemporalPropertyBag?: IPrPayrollSettingTemporalCurrentEntity;
    CzechSocialSecurityAdministration?: IPrSocialSecurityDetailEntity;
    FinancialAdministration?: IPrFinancialAdministrationDetailEntity;
    LaborOffice?: IPrLaborOfficeDetailEntity;
    StatutoryInsuranceCompany?: IPrStatutoryInsuranceDetailEntity;
    SubstitutePayDay?: IPrPayrollSubstitutePayDayEntity;
    AccountAssignments?: IPrAccountAssignmentEntity[];
    HealthInsuranceCompanies?: IPrHealthInsuranceCompanyDetailEntity[];
    TemporalPropertyBag?: IPrPayrollSettingTemporalEntity[];
}

export enum PrPayrollSettingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsPaidOutAutomatically = "IsPaidOutAutomatically",
    PayDay = "PayDay",
    SubstitutePayDayCode = "SubstitutePayDayCode",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    CzechSocialSecurityAdministration = "CzechSocialSecurityAdministration",
    FinancialAdministration = "FinancialAdministration",
    LaborOffice = "LaborOffice",
    StatutoryInsuranceCompany = "StatutoryInsuranceCompany",
    SubstitutePayDay = "SubstitutePayDay",
    AccountAssignments = "AccountAssignments",
    HealthInsuranceCompanies = "HealthInsuranceCompanies",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrPayrollSettingTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    HolidayPayoutTypeCode?: PrHolidayPayoutTypeCode;
    HolidayShiftAssignmentCode?: PrHolidayShiftAssignmentCode;
    MinimalMinutesForMealVoucher?: number;
    SickDays?: number;
    StatutoryInsuranceCompanyRate?: number;
    VacationWeeks?: number;
    WorkingHoursPerWeek?: number;
    HolidayPayoutType?: IPrHolidayPayoutTypeEntity;
    HolidayShiftAssignment?: IPrHolidayShiftAssignmentEntity;
}

export enum PrPayrollSettingTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    HolidayPayoutTypeCode = "HolidayPayoutTypeCode",
    HolidayShiftAssignmentCode = "HolidayShiftAssignmentCode",
    MinimalMinutesForMealVoucher = "MinimalMinutesForMealVoucher",
    SickDays = "SickDays",
    StatutoryInsuranceCompanyRate = "StatutoryInsuranceCompanyRate",
    VacationWeeks = "VacationWeeks",
    WorkingHoursPerWeek = "WorkingHoursPerWeek",
    HolidayPayoutType = "HolidayPayoutType",
    HolidayShiftAssignment = "HolidayShiftAssignment",
}

export interface IPrPayrollSettingTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    HolidayPayoutTypeCode?: PrHolidayPayoutTypeCode;
    HolidayShiftAssignmentCode?: PrHolidayShiftAssignmentCode;
    MinimalMinutesForMealVoucher?: number;
    SickDays?: number;
    StatutoryInsuranceCompanyRate?: number;
    VacationWeeks?: number;
    WorkingHoursPerWeek?: number;
    HolidayPayoutType?: IPrHolidayPayoutTypeEntity;
    HolidayShiftAssignment?: IPrHolidayShiftAssignmentEntity;
}

export enum PrPayrollSettingTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    HolidayPayoutTypeCode = "HolidayPayoutTypeCode",
    HolidayShiftAssignmentCode = "HolidayShiftAssignmentCode",
    MinimalMinutesForMealVoucher = "MinimalMinutesForMealVoucher",
    SickDays = "SickDays",
    StatutoryInsuranceCompanyRate = "StatutoryInsuranceCompanyRate",
    VacationWeeks = "VacationWeeks",
    WorkingHoursPerWeek = "WorkingHoursPerWeek",
    HolidayPayoutType = "HolidayPayoutType",
    HolidayShiftAssignment = "HolidayShiftAssignment",
}

export interface IPrPayrollSubstitutePayDayEntity extends IEntityBase {
    Code?: PrPayrollSubstitutePayDayCode;
    Name?: string;
}

export enum PrPayrollSubstitutePayDayEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrPayslipEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AggregatedGrossSalary?: number;
    DelayedIncomeTypeCode?: PrDelayedIncomeTypeCode;
    HealthInsuranceCode?: string;
    IsDeduceMinimumHealthInsurance?: boolean;
    IsLocked?: boolean;
    IsMinimumHealthInsurancePayedByEmployer?: boolean;
    IsMultipleDistrainmentRuleExempt?: boolean;
    Month?: number;
    SocialInsuranceDiscountIneligibilityReasonCode?: PrSocialInsuranceDiscountIneligibilityReasonCode;
    Year?: number;
    HasEmployerSocialInsuranceDiscountOverride?: boolean;
    UnseizableTotalAmount?: number;
    UnseizableTotalAmountOverride?: number;
    IsMultipleDistrainmentRuleExemptOverride?: boolean;
    IsDeduceMinimumHealthInsuranceOverride?: boolean;
    IsMinimumHealthInsurancePayedByEmployerOverride?: boolean;
    DateLastSentByEmail?: Date;
    AnnualTaxSettlement?: IPrAnnualTaxSettlementEntity;
    DelayedIncomeType?: IPrDelayedIncomeTypeEntity;
    Employee?: IPrEmployeeEntity;
    FileMetadata?: IFileMetadataEntity;
    SocialInsuranceDiscountIneligibilityReason?: IPrSocialInsuranceDiscountIneligibilityReasonEntity;
    TaxpayerDeclaration?: IPrTaxpayerDeclarationEntity;
    Deductions?: IPrPayslipDeductionEntity[];
    Employments?: IPrPayslipEmploymentEntity[];
    Items?: IPrPayslipItemEntity[];
    LiabilitiesAndReceivables?: IPrPayslipLiabilityReceivableEntity[];
    MasterDataChanges?: IPrPayslipMasterDataChangeEntity[];
    MinimumHealthInsurance?: IPrPayslipMinimumHealthInsuranceEntity[];
}

export enum PrPayslipEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AggregatedGrossSalary = "AggregatedGrossSalary",
    DelayedIncomeTypeCode = "DelayedIncomeTypeCode",
    HealthInsuranceCode = "HealthInsuranceCode",
    IsDeduceMinimumHealthInsurance = "IsDeduceMinimumHealthInsurance",
    IsLocked = "IsLocked",
    IsMinimumHealthInsurancePayedByEmployer = "IsMinimumHealthInsurancePayedByEmployer",
    IsMultipleDistrainmentRuleExempt = "IsMultipleDistrainmentRuleExempt",
    Month = "Month",
    SocialInsuranceDiscountIneligibilityReasonCode = "SocialInsuranceDiscountIneligibilityReasonCode",
    Year = "Year",
    HasEmployerSocialInsuranceDiscountOverride = "HasEmployerSocialInsuranceDiscountOverride",
    UnseizableTotalAmount = "UnseizableTotalAmount",
    UnseizableTotalAmountOverride = "UnseizableTotalAmountOverride",
    IsMultipleDistrainmentRuleExemptOverride = "IsMultipleDistrainmentRuleExemptOverride",
    IsDeduceMinimumHealthInsuranceOverride = "IsDeduceMinimumHealthInsuranceOverride",
    IsMinimumHealthInsurancePayedByEmployerOverride = "IsMinimumHealthInsurancePayedByEmployerOverride",
    DateLastSentByEmail = "DateLastSentByEmail",
    AnnualTaxSettlement = "AnnualTaxSettlement",
    DelayedIncomeType = "DelayedIncomeType",
    Employee = "Employee",
    FileMetadata = "FileMetadata",
    SocialInsuranceDiscountIneligibilityReason = "SocialInsuranceDiscountIneligibilityReason",
    TaxpayerDeclaration = "TaxpayerDeclaration",
    Deductions = "Deductions",
    Employments = "Employments",
    Items = "Items",
    LiabilitiesAndReceivables = "LiabilitiesAndReceivables",
    MasterDataChanges = "MasterDataChanges",
    MinimumHealthInsurance = "MinimumHealthInsurance",
}

export interface IPrPayslipBalancingPeriodEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEnd?: Date;
    DateStart?: Date;
    OvertimeClaimedDuringPeriod?: number;
    PeriodLengthInWeeks?: number;
    RemainingInMinutes?: number;
    ThisMonthBalanceInMinutes?: number;
    ThisMonthPlannedInMinutes?: number;
    ThisMonthWorkedInMinutes?: number;
    TotalFundInMinutes?: number;
    WholePeriodBalanceInMinutes?: number;
    WholePeriodPlannedInMinutes?: number;
    WholePeriodWorkedInMinutes?: number;
}

export enum PrPayslipBalancingPeriodEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    OvertimeClaimedDuringPeriod = "OvertimeClaimedDuringPeriod",
    PeriodLengthInWeeks = "PeriodLengthInWeeks",
    RemainingInMinutes = "RemainingInMinutes",
    ThisMonthBalanceInMinutes = "ThisMonthBalanceInMinutes",
    ThisMonthPlannedInMinutes = "ThisMonthPlannedInMinutes",
    ThisMonthWorkedInMinutes = "ThisMonthWorkedInMinutes",
    TotalFundInMinutes = "TotalFundInMinutes",
    WholePeriodBalanceInMinutes = "WholePeriodBalanceInMinutes",
    WholePeriodPlannedInMinutes = "WholePeriodPlannedInMinutes",
    WholePeriodWorkedInMinutes = "WholePeriodWorkedInMinutes",
}

export interface IPrPayslipDeductionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CalculationTypeCode?: PrDeductionCalculationTypeCode;
    Name?: string;
    AmountOverride?: number;
    CalculationType?: IPrDeductionCalculationTypeEntity;
    Deduction?: IPrDeductionEntity;
}

export enum PrPayslipDeductionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CalculationTypeCode = "CalculationTypeCode",
    Name = "Name",
    AmountOverride = "AmountOverride",
    CalculationType = "CalculationType",
    Deduction = "Deduction",
}

export interface IPrPayslipEmploymentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AverageSalary?: number;
    DaysWorked?: number;
    HolidayCarriedOver?: number;
    HolidayCompensatory?: number;
    HolidayPrevious?: number;
    HolidayWorked?: number;
    IsSmallScaleEmployment?: boolean;
    OvertimeCarriedOver?: number;
    OvertimeCompensatory?: number;
    OvertimePrevious?: number;
    OvertimeThisMonth?: number;
    PlannedWork?: number;
    Reduced60AverageSalary?: number;
    UnfinishedWeekOvertime?: number;
    WorkedIncludingHolidays?: number;
    AverageSalaryOverride?: number;
    Attendance?: IPrAttendanceEntity;
    Employment?: IPrEmploymentEntity;
    VacationSummary?: IPrPayslipVacationSummaryEntity;
    BalancingPeriods?: IPrPayslipBalancingPeriodEntity[];
    Benefits?: IPrPayslipEmploymentBenefitEntity[];
    ExtraSalaries?: IPrPayslipEmploymentExtraSalaryEntity[];
    Items?: IPrPayslipEmploymentItemEntity[];
    RetirementSavings?: IPrPayslipEmploymentRetirementSavingEntity[];
    SalaryComponents?: IPrPayslipEmploymentSalaryComponentEntity[];
}

export enum PrPayslipEmploymentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AverageSalary = "AverageSalary",
    DaysWorked = "DaysWorked",
    HolidayCarriedOver = "HolidayCarriedOver",
    HolidayCompensatory = "HolidayCompensatory",
    HolidayPrevious = "HolidayPrevious",
    HolidayWorked = "HolidayWorked",
    IsSmallScaleEmployment = "IsSmallScaleEmployment",
    OvertimeCarriedOver = "OvertimeCarriedOver",
    OvertimeCompensatory = "OvertimeCompensatory",
    OvertimePrevious = "OvertimePrevious",
    OvertimeThisMonth = "OvertimeThisMonth",
    PlannedWork = "PlannedWork",
    Reduced60AverageSalary = "Reduced60AverageSalary",
    UnfinishedWeekOvertime = "UnfinishedWeekOvertime",
    WorkedIncludingHolidays = "WorkedIncludingHolidays",
    AverageSalaryOverride = "AverageSalaryOverride",
    Attendance = "Attendance",
    Employment = "Employment",
    VacationSummary = "VacationSummary",
    BalancingPeriods = "BalancingPeriods",
    Benefits = "Benefits",
    ExtraSalaries = "ExtraSalaries",
    Items = "Items",
    RetirementSavings = "RetirementSavings",
    SalaryComponents = "SalaryComponents",
}

export interface IPrPayslipEmploymentBenefitEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    IsOneTime?: boolean;
    Length?: number;
    Name?: string;
    OtherCategoryCode?: PrOtherBenefitCategoryCode;
    TaxAndContributionsApplicabilityCode?: PrOtherBenefitTaxAndContributionsApplicabilityCode;
    TaxDeducibilityCode?: PrOtherBenefitTaxDeducibilityCode;
    TaxedItemCount?: number;
    TypeCode?: PrBenefitTypeCode;
    AmountOverride?: number;
    AmountEmployer?: number;
    AmountEmployerOverride?: number;
    AmountEmployee?: number;
    AmountEmployeeOverride?: number;
    LengthOverride?: number;
    OtherCategory?: IPrOtherBenefitCategoryEntity;
    TaxAndContributionsApplicability?: IPrOtherBenefitTaxAndContributionsApplicabilityEntity;
    TaxDeducibility?: IPrOtherBenefitTaxDeducibilityEntity;
    Type?: IPrBenefitTypeEntity;
}

export enum PrPayslipEmploymentBenefitEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    IsOneTime = "IsOneTime",
    Length = "Length",
    Name = "Name",
    OtherCategoryCode = "OtherCategoryCode",
    TaxAndContributionsApplicabilityCode = "TaxAndContributionsApplicabilityCode",
    TaxDeducibilityCode = "TaxDeducibilityCode",
    TaxedItemCount = "TaxedItemCount",
    TypeCode = "TypeCode",
    AmountOverride = "AmountOverride",
    AmountEmployer = "AmountEmployer",
    AmountEmployerOverride = "AmountEmployerOverride",
    AmountEmployee = "AmountEmployee",
    AmountEmployeeOverride = "AmountEmployeeOverride",
    LengthOverride = "LengthOverride",
    OtherCategory = "OtherCategory",
    TaxAndContributionsApplicability = "TaxAndContributionsApplicability",
    TaxDeducibility = "TaxDeducibility",
    Type = "Type",
}

export interface IPrPayslipEmploymentExtraSalaryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ComputationTypeCode?: PrExtraSalaryComputationTypeCode;
    IsOneTime?: boolean;
    Length?: number;
    Name?: string;
    TypeCode?: PrExtraSalaryTypeCode;
    Value?: number;
    ValueOverride?: number;
    LengthOverride?: number;
    ComputationType?: IPrExtraSalaryComputationTypeEntity;
    Type?: IPrExtraSalaryTypeEntity;
}

export enum PrPayslipEmploymentExtraSalaryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ComputationTypeCode = "ComputationTypeCode",
    IsOneTime = "IsOneTime",
    Length = "Length",
    Name = "Name",
    TypeCode = "TypeCode",
    Value = "Value",
    ValueOverride = "ValueOverride",
    LengthOverride = "LengthOverride",
    ComputationType = "ComputationType",
    Type = "Type",
}

export interface IPrPayslipEmploymentItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbsenceCategoryTypeCode?: PrAbsenceCategoryTypeCode;
    AverageInclusionCode?: PrSalaryComponentAverageInclusionCode;
    FixedBonusDeductionImpactCode?: PrFixedBonusDeductionImpactCode;
    Name?: string;
    ObstacleTypeCode?: PrAbsenceObstacleTypeCode;
    RegularSalaryTypeCode?: PrRegularSalaryTypeCode;
    TimeBasedBonusTypeCode?: PrTimeBasedBonusTypeCode;
    TypeCode?: PrPayslipEmploymentItemTypeCode;
    DecimalValue?: number;
    IntValue?: number;
    Percentage?: number;
    AbsenceCategoryType?: IPrAbsenceCategoryTypeEntity;
    AverageInclusion?: IPrSalaryComponentAverageInclusionEntity;
    FixedBonusDeductionImpact?: IPrFixedBonusDeductionImpactEntity;
    ObstacleType?: IPrAbsenceObstacleTypeEntity;
    RegularSalaryType?: IPrRegularSalaryTypeEntity;
    RetirementSaving?: IPrPayslipEmploymentRetirementSavingEntity;
    TimeBasedBonusType?: IPrTimeBasedBonusTypeEntity;
    Type?: IPrPayslipEmploymentItemTypeEntity;
    Subitems?: IPrPayslipEmploymentSubitemEntity[];
}

export enum PrPayslipEmploymentItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbsenceCategoryTypeCode = "AbsenceCategoryTypeCode",
    AverageInclusionCode = "AverageInclusionCode",
    FixedBonusDeductionImpactCode = "FixedBonusDeductionImpactCode",
    Name = "Name",
    ObstacleTypeCode = "ObstacleTypeCode",
    RegularSalaryTypeCode = "RegularSalaryTypeCode",
    TimeBasedBonusTypeCode = "TimeBasedBonusTypeCode",
    TypeCode = "TypeCode",
    DecimalValue = "DecimalValue",
    IntValue = "IntValue",
    Percentage = "Percentage",
    AbsenceCategoryType = "AbsenceCategoryType",
    AverageInclusion = "AverageInclusion",
    FixedBonusDeductionImpact = "FixedBonusDeductionImpact",
    ObstacleType = "ObstacleType",
    RegularSalaryType = "RegularSalaryType",
    RetirementSaving = "RetirementSaving",
    TimeBasedBonusType = "TimeBasedBonusType",
    Type = "Type",
    Subitems = "Subitems",
}

export interface IPrPayslipEmploymentItemTypeEntity extends IEntityBase {
    Code?: PrPayslipEmploymentItemTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    DecimalValueTypeCode?: PrValueTypeCode;
    IntValueTypeCode?: PrValueTypeCode;
    IsConsolidationItem?: boolean;
    Name?: string;
    Country?: ICountryEntity;
    DecimalValueType?: IPrValueTypeEntity;
    IntValueType?: IPrValueTypeEntity;
}

export enum PrPayslipEmploymentItemTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    DecimalValueTypeCode = "DecimalValueTypeCode",
    IntValueTypeCode = "IntValueTypeCode",
    IsConsolidationItem = "IsConsolidationItem",
    Name = "Name",
    Country = "Country",
    DecimalValueType = "DecimalValueType",
    IntValueType = "IntValueType",
}

export interface IPrPayslipEmploymentRetirementSavingEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ComputationTypeCode?: PrRetirementSavingsComputationTypeCode;
    IsOneTime?: boolean;
    RemittanceInformation?: string;
    RemittanceInformationOverride?: string;
    SymbolConstant?: string;
    SymbolConstantOverride?: string;
    SymbolSpecific?: string;
    SymbolSpecificOverride?: string;
    SymbolVariable?: string;
    SymbolVariableOverride?: string;
    Amount?: number;
    AmountOverride?: number;
    Percentage?: number;
    PercentageOverride?: number;
    IsIncluded?: boolean;
    ComputationType?: IPrRetirementSavingsComputationTypeEntity;
    RetirementSavingsProduct?: IPrRetirementSavingsProductEntity;
}

export enum PrPayslipEmploymentRetirementSavingEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ComputationTypeCode = "ComputationTypeCode",
    IsOneTime = "IsOneTime",
    RemittanceInformation = "RemittanceInformation",
    RemittanceInformationOverride = "RemittanceInformationOverride",
    SymbolConstant = "SymbolConstant",
    SymbolConstantOverride = "SymbolConstantOverride",
    SymbolSpecific = "SymbolSpecific",
    SymbolSpecificOverride = "SymbolSpecificOverride",
    SymbolVariable = "SymbolVariable",
    SymbolVariableOverride = "SymbolVariableOverride",
    Amount = "Amount",
    AmountOverride = "AmountOverride",
    Percentage = "Percentage",
    PercentageOverride = "PercentageOverride",
    IsIncluded = "IsIncluded",
    ComputationType = "ComputationType",
    RetirementSavingsProduct = "RetirementSavingsProduct",
}

export interface IPrPayslipEmploymentSalaryComponentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Amount?: number;
    AverageInclusionCode?: PrSalaryComponentAverageInclusionCode;
    FixedBonusDeductionImpactCode?: PrFixedBonusDeductionImpactCode;
    FixedBonusPayOutImpactCode?: PrFixedBonusPayOutImpactCode;
    FixedBonusTaxImpactCode?: PrFixedBonusTaxImpactCode;
    IsOneTime?: boolean;
    Name?: string;
    RegularSalaryTypeCode?: PrRegularSalaryTypeCode;
    TimeBasedBonusTypeCode?: PrTimeBasedBonusTypeCode;
    TypeCode?: PrSalaryComponentTypeCode;
    AmountOverride?: number;
    IsBasicSalary?: boolean;
    Percentage?: number;
    PercentageOverride?: number;
    Worked?: number;
    PlannedWork?: number;
    HolidayWorked?: number;
    HolidayNotWorked?: number;
    AverageInclusion?: IPrSalaryComponentAverageInclusionEntity;
    FixedBonusDeductionImpact?: IPrFixedBonusDeductionImpactEntity;
    FixedBonusPayOutImpact?: IPrFixedBonusPayOutImpactEntity;
    FixedBonusTaxImpact?: IPrFixedBonusTaxImpactEntity;
    RegularSalaryType?: IPrRegularSalaryTypeEntity;
    TimeBasedBonusType?: IPrTimeBasedBonusTypeEntity;
    Type?: IPrSalaryComponentTypeEntity;
}

export enum PrPayslipEmploymentSalaryComponentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Amount = "Amount",
    AverageInclusionCode = "AverageInclusionCode",
    FixedBonusDeductionImpactCode = "FixedBonusDeductionImpactCode",
    FixedBonusPayOutImpactCode = "FixedBonusPayOutImpactCode",
    FixedBonusTaxImpactCode = "FixedBonusTaxImpactCode",
    IsOneTime = "IsOneTime",
    Name = "Name",
    RegularSalaryTypeCode = "RegularSalaryTypeCode",
    TimeBasedBonusTypeCode = "TimeBasedBonusTypeCode",
    TypeCode = "TypeCode",
    AmountOverride = "AmountOverride",
    IsBasicSalary = "IsBasicSalary",
    Percentage = "Percentage",
    PercentageOverride = "PercentageOverride",
    Worked = "Worked",
    PlannedWork = "PlannedWork",
    HolidayWorked = "HolidayWorked",
    HolidayNotWorked = "HolidayNotWorked",
    AverageInclusion = "AverageInclusion",
    FixedBonusDeductionImpact = "FixedBonusDeductionImpact",
    FixedBonusPayOutImpact = "FixedBonusPayOutImpact",
    FixedBonusTaxImpact = "FixedBonusTaxImpact",
    RegularSalaryType = "RegularSalaryType",
    TimeBasedBonusType = "TimeBasedBonusType",
    Type = "Type",
}

export interface IPrPayslipEmploymentSubitemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValue?: Date;
    StringValue?: string;
    TypeCode?: PrPayslipEmploymentSubitemTypeCode;
    DecimalValue?: number;
    IntValue?: number;
    Type?: IPrPayslipEmploymentSubitemTypeEntity;
}

export enum PrPayslipEmploymentSubitemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValue = "DateValue",
    StringValue = "StringValue",
    TypeCode = "TypeCode",
    DecimalValue = "DecimalValue",
    IntValue = "IntValue",
    Type = "Type",
}

export interface IPrPayslipEmploymentSubitemTypeEntity extends IEntityBase {
    Code?: PrPayslipEmploymentSubitemTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    DateValueTypeCode?: PrValueTypeCode;
    DecimalValueTypeCode?: PrValueTypeCode;
    IntValueTypeCode?: PrValueTypeCode;
    ItemTypeCode?: PrPayslipEmploymentItemTypeCode;
    Label?: string;
    Name?: string;
    StringValueTypeCode?: PrValueTypeCode;
    Country?: ICountryEntity;
    DateValueType?: IPrValueTypeEntity;
    DecimalValueType?: IPrValueTypeEntity;
    IntValueType?: IPrValueTypeEntity;
    ItemType?: IPrPayslipEmploymentItemTypeEntity;
    StringValueType?: IPrValueTypeEntity;
}

export enum PrPayslipEmploymentSubitemTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    DateValueTypeCode = "DateValueTypeCode",
    DecimalValueTypeCode = "DecimalValueTypeCode",
    IntValueTypeCode = "IntValueTypeCode",
    ItemTypeCode = "ItemTypeCode",
    Label = "Label",
    Name = "Name",
    StringValueTypeCode = "StringValueTypeCode",
    Country = "Country",
    DateValueType = "DateValueType",
    DecimalValueType = "DecimalValueType",
    IntValueType = "IntValueType",
    ItemType = "ItemType",
    StringValueType = "StringValueType",
}

export interface IPrPayslipItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DecimalValue?: number;
    IsDeposited?: boolean;
    Name?: string;
    TypeCode?: PrPayslipItemTypeCode;
    Deduction?: IPrDeductionEntity;
    Document?: IDocumentEntity;
    SalaryAdvance?: IPrSalaryAdvanceEntity;
    Type?: IPrPayslipItemTypeEntity;
    Subitems?: IPrPayslipSubitemEntity[];
}

export enum PrPayslipItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DecimalValue = "DecimalValue",
    IsDeposited = "IsDeposited",
    Name = "Name",
    TypeCode = "TypeCode",
    Deduction = "Deduction",
    Document = "Document",
    SalaryAdvance = "SalaryAdvance",
    Type = "Type",
    Subitems = "Subitems",
}

export interface IPrPayslipItemTypeEntity extends IEntityBase {
    Code?: PrPayslipItemTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrPayslipItemTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IPrPayslipLiabilityReceivableEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CurrencyCode?: CurrencyCode;
    ExchangeRatePerUnit?: number;
    TransactionAmount?: number;
    TransactionCurrencyCode?: CurrencyCode;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    TransactionCurrency?: ICurrencyEntity;
}

export enum PrPayslipLiabilityReceivableEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CurrencyCode = "CurrencyCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    TransactionAmount = "TransactionAmount",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    Currency = "Currency",
    Document = "Document",
    TransactionCurrency = "TransactionCurrency",
}

export interface IPrPayslipMasterDataChangeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CollectionItemChangeTypeCode?: PrCollectionItemChangeTypeCode;
    CollectionItemDisplayName?: string;
    CollectionName?: string;
    EntityDisplayName?: string;
    EntityId?: number;
    EntityTypeCode?: string;
    CollectionItemId?: number;
    CollectionItemChangeType?: IPrCollectionItemChangeTypeEntity;
    EntityType?: IEntityTypeEntity;
}

export enum PrPayslipMasterDataChangeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CollectionItemChangeTypeCode = "CollectionItemChangeTypeCode",
    CollectionItemDisplayName = "CollectionItemDisplayName",
    CollectionName = "CollectionName",
    EntityDisplayName = "EntityDisplayName",
    EntityId = "EntityId",
    EntityTypeCode = "EntityTypeCode",
    CollectionItemId = "CollectionItemId",
    CollectionItemChangeType = "CollectionItemChangeType",
    EntityType = "EntityType",
}

export interface IPrPayslipMinimumHealthInsuranceEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    DateTo?: Date;
    PrMinimumHealthInsuranceTypeCode?: PrMinimumHealthInsuranceTypeCode;
    PrMinimumHealthInsuranceType?: IPrMinimumHealthInsuranceTypeEntity;
}

export enum PrPayslipMinimumHealthInsuranceEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
    PrMinimumHealthInsuranceTypeCode = "PrMinimumHealthInsuranceTypeCode",
    PrMinimumHealthInsuranceType = "PrMinimumHealthInsuranceType",
}

export interface IPrPayslipSubitemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    StringValue?: string;
    TypeCode?: PrPayslipSubitemTypeCode;
    DecimalValue?: number;
    IntValue?: number;
    Type?: IPrPayslipSubitemTypeEntity;
}

export enum PrPayslipSubitemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    StringValue = "StringValue",
    TypeCode = "TypeCode",
    DecimalValue = "DecimalValue",
    IntValue = "IntValue",
    Type = "Type",
}

export interface IPrPayslipSubitemTypeEntity extends IEntityBase {
    Code?: PrPayslipSubitemTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    DecimalValueTypeCode?: PrValueTypeCode;
    IntValueTypeCode?: PrValueTypeCode;
    ItemTypeCode?: PrPayslipItemTypeCode;
    Label?: string;
    Name?: string;
    StringValueTypeCode?: PrValueTypeCode;
    Country?: ICountryEntity;
    DecimalValueType?: IPrValueTypeEntity;
    IntValueType?: IPrValueTypeEntity;
    ItemType?: IPrPayslipItemTypeEntity;
    StringValueType?: IPrValueTypeEntity;
}

export enum PrPayslipSubitemTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    DecimalValueTypeCode = "DecimalValueTypeCode",
    IntValueTypeCode = "IntValueTypeCode",
    ItemTypeCode = "ItemTypeCode",
    Label = "Label",
    Name = "Name",
    StringValueTypeCode = "StringValueTypeCode",
    Country = "Country",
    DecimalValueType = "DecimalValueType",
    IntValueType = "IntValueType",
    ItemType = "ItemType",
    StringValueType = "StringValueType",
}

export interface IPrPayslipVacationSummaryEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    MinutesPerDay?: number;
    SickDaysEntitlement?: number;
    SickDaysRemaining?: number;
    SickDaysUsed?: number;
    SickDaysUsedThisMonth?: number;
    VacationCarriedOverFromLastYear?: number;
    VacationEntitlement?: number;
    VacationRealEntitlement?: number;
    VacationRemaining?: number;
    VacationUsed?: number;
    VacationUsedThisMonth?: number;
}

export enum PrPayslipVacationSummaryEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    MinutesPerDay = "MinutesPerDay",
    SickDaysEntitlement = "SickDaysEntitlement",
    SickDaysRemaining = "SickDaysRemaining",
    SickDaysUsed = "SickDaysUsed",
    SickDaysUsedThisMonth = "SickDaysUsedThisMonth",
    VacationCarriedOverFromLastYear = "VacationCarriedOverFromLastYear",
    VacationEntitlement = "VacationEntitlement",
    VacationRealEntitlement = "VacationRealEntitlement",
    VacationRemaining = "VacationRemaining",
    VacationUsed = "VacationUsed",
    VacationUsedThisMonth = "VacationUsedThisMonth",
}

export interface IPrPensionTypeEntity extends IEntityBase {
    Code?: PrPensionTypeCode;
    CsszCode?: string;
    MpsvCode?: string;
    Name?: string;
}

export enum PrPensionTypeEntity {
    Code = "Code",
    CsszCode = "CsszCode",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrPeriodDocumentTypeEntity extends IEntityBase {
    Code?: PrPeriodDocumentTypeCode;
    Name?: string;
}

export enum PrPeriodDocumentTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrPppzSubmissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Detail?: IPrPppzSubmissionDetailEntity;
}

export enum PrPppzSubmissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Detail = "Detail",
}

export interface IPrPppzSubmissionCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LegalName?: string;
    LegalNumber?: string;
    Company?: ICompanyEntity;
    City?: string;
    HouseNumber?: string;
    InsurancePayerNumber?: string;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    StreetNumber?: string;
}

export enum PrPppzSubmissionCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Company = "Company",
    City = "City",
    HouseNumber = "HouseNumber",
    InsurancePayerNumber = "InsurancePayerNumber",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    StreetNumber = "StreetNumber",
}

export interface IPrPppzSubmissionDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AssessmentBaseSum?: number;
    EmployeeCount?: number;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    InsuranceSum?: number;
    Month?: number;
    Year?: number;
    Company?: IPrPppzSubmissionCompanyEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
}

export enum PrPppzSubmissionDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AssessmentBaseSum = "AssessmentBaseSum",
    EmployeeCount = "EmployeeCount",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    InsuranceSum = "InsuranceSum",
    Month = "Month",
    Year = "Year",
    Company = "Company",
    HealthInsuranceCompany = "HealthInsuranceCompany",
}

export interface IPrPropertyAcquisitionEntity extends IEntityBase {
    Code?: PrPropertyAcquisitionCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrPropertyAcquisitionEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IPrRegularSalaryTypeEntity extends IEntityBase {
    Code?: PrRegularSalaryTypeCode;
    Name?: string;
}

export enum PrRegularSalaryTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrRelevantIncomeEntity extends IEntityBase {
    Code?: PrRelevantIncomeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    DppRelevantIncome?: number;
    Name?: string;
    RelevantIncome?: number;
    Country?: ICountryEntity;
}

export enum PrRelevantIncomeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    DppRelevantIncome = "DppRelevantIncome",
    Name = "Name",
    RelevantIncome = "RelevantIncome",
    Country = "Country",
}

export interface IPrRetirementInsuranceIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    DateTo?: Date;
}

export enum PrRetirementInsuranceIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
}

export interface IPrRetirementSavingsBankAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AbaNumber?: string;
    AccountNumber?: string;
    BankCode?: BankCode;
    CountryCode?: CountryCode;
    IBAN?: string;
    PaymentServiceID?: string;
    PaymentServiceName?: string;
    SWIFT?: string;
    Bank?: IBankEntity;
    Country?: ICountryEntity;
}

export enum PrRetirementSavingsBankAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AbaNumber = "AbaNumber",
    AccountNumber = "AccountNumber",
    BankCode = "BankCode",
    CountryCode = "CountryCode",
    IBAN = "IBAN",
    PaymentServiceID = "PaymentServiceID",
    PaymentServiceName = "PaymentServiceName",
    SWIFT = "SWIFT",
    Bank = "Bank",
    Country = "Country",
}

export interface IPrRetirementSavingsCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    DataBoxId?: string;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    LegalName?: string;
    LegalNumber?: string;
    Name?: string;
    PhoneNumber?: string;
    PostalCode?: string;
    Street?: string;
    TaxNumber?: string;
    VatStatusCode?: VatStatusCode;
    Country?: ICountryEntity;
    VatStatus?: IVatStatusEntity;
    Products?: IPrRetirementSavingsProductEntity[];
}

export enum PrRetirementSavingsCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    DataBoxId = "DataBoxId",
    Email = "Email",
    FirstName = "FirstName",
    LastName = "LastName",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Name = "Name",
    PhoneNumber = "PhoneNumber",
    PostalCode = "PostalCode",
    Street = "Street",
    TaxNumber = "TaxNumber",
    VatStatusCode = "VatStatusCode",
    Country = "Country",
    VatStatus = "VatStatus",
    Products = "Products",
}

export interface IPrRetirementSavingsComputationTypeEntity extends IEntityBase {
    Code?: PrRetirementSavingsComputationTypeCode;
    Name?: string;
}

export enum PrRetirementSavingsComputationTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrRetirementSavingsProductEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrRetirementSavingsTypeCode;
    BankAccount?: IPrRetirementSavingsBankAccountEntity;
    PrRetirementSavingsCompany?: IPrRetirementSavingsCompanyEntity;
    Type?: IPrRetirementSavingsTypeEntity;
}

export enum PrRetirementSavingsProductEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    BankAccount = "BankAccount",
    PrRetirementSavingsCompany = "PrRetirementSavingsCompany",
    Type = "Type",
}

export interface IPrRetirementSavingsTypeEntity extends IEntityBase {
    Code?: PrRetirementSavingsTypeCode;
    Name?: string;
}

export enum PrRetirementSavingsTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrSalaryAdvanceEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    Month?: number;
    NumberOurs?: string;
    Year?: number;
    Currency?: ICurrencyEntity;
    Employee?: IPrEmployeeEntity;
    NumberRange?: INumberRangeEntity;
    PairedDocument?: IOtherLiabilityEntity;
}

export enum PrSalaryAdvanceEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    Month = "Month",
    NumberOurs = "NumberOurs",
    Year = "Year",
    Currency = "Currency",
    Employee = "Employee",
    NumberRange = "NumberRange",
    PairedDocument = "PairedDocument",
}

export interface IPrSalaryComponentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    RegularSalaryTypeCode?: PrRegularSalaryTypeCode;
    TypeCode?: PrSalaryComponentTypeCode;
    CurrentTemporalPropertyBag?: IPrSalaryComponentTemporalCurrentEntity;
    RegularSalaryType?: IPrRegularSalaryTypeEntity;
    Type?: IPrSalaryComponentTypeEntity;
    TemporalPropertyBag?: IPrSalaryComponentTemporalEntity[];
}

export enum PrSalaryComponentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    RegularSalaryTypeCode = "RegularSalaryTypeCode",
    TypeCode = "TypeCode",
    CurrentTemporalPropertyBag = "CurrentTemporalPropertyBag",
    RegularSalaryType = "RegularSalaryType",
    Type = "Type",
    TemporalPropertyBag = "TemporalPropertyBag",
}

export interface IPrSalaryComponentAverageInclusionEntity extends IEntityBase {
    Code?: PrSalaryComponentAverageInclusionCode;
    Name?: string;
}

export enum PrSalaryComponentAverageInclusionEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrSalaryComponentTemporalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Amount?: number;
    FixedBonusDeductionImpactCode?: PrFixedBonusDeductionImpactCode;
    FixedBonusPayOutImpactCode?: PrFixedBonusPayOutImpactCode;
    FixedBonusTaxImpactCode?: PrFixedBonusTaxImpactCode;
    Name?: string;
    Percentage?: number;
    IsBasicSalary?: boolean;
    FixedBonusDeductionImpact?: IPrFixedBonusDeductionImpactEntity;
    FixedBonusPayOutImpact?: IPrFixedBonusPayOutImpactEntity;
    FixedBonusTaxImpact?: IPrFixedBonusTaxImpactEntity;
}

export enum PrSalaryComponentTemporalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Amount = "Amount",
    FixedBonusDeductionImpactCode = "FixedBonusDeductionImpactCode",
    FixedBonusPayOutImpactCode = "FixedBonusPayOutImpactCode",
    FixedBonusTaxImpactCode = "FixedBonusTaxImpactCode",
    Name = "Name",
    Percentage = "Percentage",
    IsBasicSalary = "IsBasicSalary",
    FixedBonusDeductionImpact = "FixedBonusDeductionImpact",
    FixedBonusPayOutImpact = "FixedBonusPayOutImpact",
    FixedBonusTaxImpact = "FixedBonusTaxImpact",
}

export interface IPrSalaryComponentTemporalCurrentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Amount?: number;
    FixedBonusDeductionImpactCode?: PrFixedBonusDeductionImpactCode;
    FixedBonusPayOutImpactCode?: PrFixedBonusPayOutImpactCode;
    FixedBonusTaxImpactCode?: PrFixedBonusTaxImpactCode;
    Name?: string;
    Percentage?: number;
    IsBasicSalary?: boolean;
    FixedBonusDeductionImpact?: IPrFixedBonusDeductionImpactEntity;
    FixedBonusPayOutImpact?: IPrFixedBonusPayOutImpactEntity;
    FixedBonusTaxImpact?: IPrFixedBonusTaxImpactEntity;
}

export enum PrSalaryComponentTemporalCurrentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Amount = "Amount",
    FixedBonusDeductionImpactCode = "FixedBonusDeductionImpactCode",
    FixedBonusPayOutImpactCode = "FixedBonusPayOutImpactCode",
    FixedBonusTaxImpactCode = "FixedBonusTaxImpactCode",
    Name = "Name",
    Percentage = "Percentage",
    IsBasicSalary = "IsBasicSalary",
    FixedBonusDeductionImpact = "FixedBonusDeductionImpact",
    FixedBonusPayOutImpact = "FixedBonusPayOutImpact",
    FixedBonusTaxImpact = "FixedBonusTaxImpact",
}

export interface IPrSalaryComponentTypeEntity extends IEntityBase {
    Code?: PrSalaryComponentTypeCode;
    IsPayslipOnly?: boolean;
    Name?: string;
}

export enum PrSalaryComponentTypeEntity {
    Code = "Code",
    IsPayslipOnly = "IsPayslipOnly",
    Name = "Name",
}

export interface IPrSalaryPayoutTypeEntity extends IEntityBase {
    Code?: PrSalaryPayoutTypeCode;
    Name?: string;
}

export enum PrSalaryPayoutTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrSexEntity extends IEntityBase {
    Code?: PrSexCode;
    MpsvCode?: string;
    Name?: string;
}

export enum PrSexEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrSocialEventEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEventEnd?: Date;
    DateEventStart?: Date;
    DateRequiredActionFrom?: Date;
    IsProcessed?: boolean;
    NumberOurs?: string;
    NumberTheirs?: string;
    RequiredActionCode?: PrSocialEventRequiredActionCode;
    SocialEventStatusCode?: PrSocialEventStatusCode;
    SocialEventTypeCode?: PrSocialEventTypeCode;
    WorkedHoursOnFirstDay?: number;
    WorkedHoursOnLastDay?: number;
    Employee?: IPrEmployeeEntity;
    Employment?: IPrEmploymentEntity;
    NumberRange?: INumberRangeEntity;
    RequiredAction?: IPrSocialEventRequiredActionEntity;
    SocialEventStatus?: IPrSocialEventStatusEntity;
    SocialEventType?: IPrSocialEventTypeEntity;
    Attachments?: IPrSocialEventAttachmentEntity[];
    AttendanceDayIntervals?: IPrAttendanceDayIntervalEntity[];
    CertificateAttachments?: IPrSocialEventCertificateAttachmentEntity[];
    MonthDetails?: IPrSocialEventMonthDetailEntity[];
    Submissions?: IPrSubmissionEntity[];
}

export enum PrSocialEventEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEventEnd = "DateEventEnd",
    DateEventStart = "DateEventStart",
    DateRequiredActionFrom = "DateRequiredActionFrom",
    IsProcessed = "IsProcessed",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    RequiredActionCode = "RequiredActionCode",
    SocialEventStatusCode = "SocialEventStatusCode",
    SocialEventTypeCode = "SocialEventTypeCode",
    WorkedHoursOnFirstDay = "WorkedHoursOnFirstDay",
    WorkedHoursOnLastDay = "WorkedHoursOnLastDay",
    Employee = "Employee",
    Employment = "Employment",
    NumberRange = "NumberRange",
    RequiredAction = "RequiredAction",
    SocialEventStatus = "SocialEventStatus",
    SocialEventType = "SocialEventType",
    Attachments = "Attachments",
    AttendanceDayIntervals = "AttendanceDayIntervals",
    CertificateAttachments = "CertificateAttachments",
    MonthDetails = "MonthDetails",
    Submissions = "Submissions",
}

export interface IPrSocialEventAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrSocialEventAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrSocialEventBirthCertificateAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrSocialEventBirthCertificateAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrSocialEventCertificateAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrSocialEventCertificateAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrSocialEventMonthDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEventContinues?: Date;
    IsEnd?: boolean;
    Month?: number;
    MonthDetailTypeCode?: PrSocialEventMonthDetailTypeCode;
    Year?: number;
    MonthDetailType?: IPrSocialEventMonthDetailTypeEntity;
    Intervals?: IPrSocialEventMonthIntervalEntity[];
}

export enum PrSocialEventMonthDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEventContinues = "DateEventContinues",
    IsEnd = "IsEnd",
    Month = "Month",
    MonthDetailTypeCode = "MonthDetailTypeCode",
    Year = "Year",
    MonthDetailType = "MonthDetailType",
    Intervals = "Intervals",
}

export interface IPrSocialEventMonthDetailTypeEntity extends IEntityBase {
    Code?: PrSocialEventMonthDetailTypeCode;
    Name?: string;
}

export enum PrSocialEventMonthDetailTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrSocialEventMonthIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    DateTo?: Date;
}

export enum PrSocialEventMonthIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
}

export interface IPrSocialEventRequiredActionEntity extends IEntityBase {
    Code?: PrSocialEventRequiredActionCode;
    Name?: string;
}

export enum PrSocialEventRequiredActionEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrSocialEventStatusEntity extends IEntityBase {
    Code?: PrSocialEventStatusCode;
    Name?: string;
}

export enum PrSocialEventStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrSocialEventTypeEntity extends IEntityBase {
    Code?: PrSocialEventTypeCode;
    AbsenceCategoryCode?: PrAbsenceCategoryTypeCode;
    Name?: string;
    AbsenceCategory?: IPrAbsenceCategoryTypeEntity;
}

export enum PrSocialEventTypeEntity {
    Code = "Code",
    AbsenceCategoryCode = "AbsenceCategoryCode",
    Name = "Name",
    AbsenceCategory = "AbsenceCategory",
}

export interface IPrSocialInsuranceDiscountIneligibilityReasonEntity extends IEntityBase {
    Code?: PrSocialInsuranceDiscountIneligibilityReasonCode;
    Name?: string;
}

export enum PrSocialInsuranceDiscountIneligibilityReasonEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrSocialInsuranceDiscountTypeEntity extends IEntityBase {
    Code?: PrSocialInsuranceDiscountTypeCode;
    Description?: string;
    MpsvCode?: string;
    Name?: string;
}

export enum PrSocialInsuranceDiscountTypeEntity {
    Code = "Code",
    Description = "Description",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrSocialInsuranceRateEntity extends IEntityBase {
    Code?: PrSocialInsuranceRateCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    EmployeeRate?: number;
    EmployerRate?: number;
    Name?: string;
    EmplyeeDiscountRate?: number;
    EmployerDiscountRate?: number;
    Country?: ICountryEntity;
}

export enum PrSocialInsuranceRateEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    EmployeeRate = "EmployeeRate",
    EmployerRate = "EmployerRate",
    Name = "Name",
    EmplyeeDiscountRate = "EmplyeeDiscountRate",
    EmployerDiscountRate = "EmployerDiscountRate",
    Country = "Country",
}

export interface IPrSocialSecurityDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountNumber?: string;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    Contact?: IPrGovernmentInstitutionContactEntity;
}

export enum PrSocialSecurityDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountNumber = "AccountNumber",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    Contact = "Contact",
}

export interface IPrStatisticalDataEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsContinuesOperation?: boolean;
    IsceCode?: CzIsceCode;
    ShiftPatternCode?: ShiftPatternCode;
    WorkplaceTypeCode?: WorkplaceTypeCode;
    Isce?: ICzIsceEntity;
    ShiftPattern?: IShiftPatternEntity;
    WorkplaceType?: IWorkplaceTypeEntity;
}

export enum PrStatisticalDataEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsContinuesOperation = "IsContinuesOperation",
    IsceCode = "IsceCode",
    ShiftPatternCode = "ShiftPatternCode",
    WorkplaceTypeCode = "WorkplaceTypeCode",
    Isce = "Isce",
    ShiftPattern = "ShiftPattern",
    WorkplaceType = "WorkplaceType",
}

export interface IPrStatutoryInsuranceDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountNumber?: string;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    Contact?: IPrGovernmentInstitutionContactEntity;
}

export enum PrStatutoryInsuranceDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountNumber = "AccountNumber",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    Contact = "Contact",
}

export interface IPrSubmissionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
}

export enum PrSubmissionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
}

export interface IPrSubmissionAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrSubmissionAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrSubmissionCaregivingIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    DateTo?: Date;
}

export enum PrSubmissionCaregivingIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
}

export interface IPrSubmissionElectronicAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrSubmissionElectronicAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrSubmissionRegZecEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    NumberOurs?: string;
    SubmissionStatusCode?: PrSubmissionStatusCode;
    SubmissionSubtypeCode?: PrSubmissionSubtypeCode;
    SubmissionTypeCode?: PrSubmissionTypeCode;
    ValidationStatusCode?: PrSubmissionValidationStatusCode;
    DateSubmission?: Date;
    DateSubmitted?: Date;
    EmployeeHeader?: IPrEmployeeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    NumberRange?: INumberRangeEntity;
    SocialEvent?: IPrSocialEventEntity;
    SubmissionStatus?: IPrSubmissionStatusEntity;
    SubmissionSubtype?: IPrSubmissionSubtypeEntity;
    SubmissionType?: IPrSubmissionTypeEntity;
    ValidationStatus?: IPrSubmissionValidationStatusEntity;
    Attachments?: IPrSubmissionAttachmentEntity[];
    ElectronicAttachments?: IPrSubmissionElectronicAttachmentEntity[];
    PodaniValidationErrors?: IPodaniValidationErrorEntity[];
    Company?: IRegZecCompanyEntity;
    Detail?: IPrSubmissionRegZecDetailEntity;
    Employee?: IRegZecEmployeeEntity;
    Employment?: IRegZecEmploymentEntity;
}

export enum PrSubmissionRegZecEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    NumberOurs = "NumberOurs",
    SubmissionStatusCode = "SubmissionStatusCode",
    SubmissionSubtypeCode = "SubmissionSubtypeCode",
    SubmissionTypeCode = "SubmissionTypeCode",
    ValidationStatusCode = "ValidationStatusCode",
    DateSubmission = "DateSubmission",
    DateSubmitted = "DateSubmitted",
    EmployeeHeader = "EmployeeHeader",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    NumberRange = "NumberRange",
    SocialEvent = "SocialEvent",
    SubmissionStatus = "SubmissionStatus",
    SubmissionSubtype = "SubmissionSubtype",
    SubmissionType = "SubmissionType",
    ValidationStatus = "ValidationStatus",
    Attachments = "Attachments",
    ElectronicAttachments = "ElectronicAttachments",
    PodaniValidationErrors = "PodaniValidationErrors",
    Company = "Company",
    Detail = "Detail",
    Employee = "Employee",
    Employment = "Employment",
}

export interface IPrSubmissionRegZecDetailEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ApplicableForeignLegislationCode?: YesNoCode;
    ApplicableForeignLegislationCountryCode?: CountryCode;
    CurrentSocialInsuranceProviderName?: string;
    DateChangeOrCorrectionFrom?: Date;
    ForeignTaxIdentifier?: string;
    ForeignTaxIdentifierTypeCode?: MpsvTaxIdentifierTypeCode;
    HealthInsuranceCompanyCode?: PrHealthInsuranceCompanyCode;
    IsZtpPCode?: YesNoCode;
    PrEducationCode?: PrEducationCode;
    PreviousSocialInsuranceProviderName?: string;
    UserEmail?: string;
    ApplicableForeignLegislation?: IYesNoEntity;
    ApplicableForeignLegislationCountry?: ICountryEntity;
    Disability?: IRegZecDisabilityEntity;
    ForeignInsurer?: IRegZecForeignInsurerEntity;
    ForeignTaxIdentifierType?: IMpsvTaxIdentifierTypeEntity;
    HealthInsuranceCompany?: IPrHealthInsuranceCompanyEntity;
    IdentityDocument?: IRegZecIdentityDocumentEntity;
    IsZtpP?: IYesNoEntity;
    LaborMarketAccess?: IRegZecLaborMarketAccessEntity;
    Pension?: IRegZecPensionEntity;
    PrEducation?: IPrEducationEntity;
}

export enum PrSubmissionRegZecDetailEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ApplicableForeignLegislationCode = "ApplicableForeignLegislationCode",
    ApplicableForeignLegislationCountryCode = "ApplicableForeignLegislationCountryCode",
    CurrentSocialInsuranceProviderName = "CurrentSocialInsuranceProviderName",
    DateChangeOrCorrectionFrom = "DateChangeOrCorrectionFrom",
    ForeignTaxIdentifier = "ForeignTaxIdentifier",
    ForeignTaxIdentifierTypeCode = "ForeignTaxIdentifierTypeCode",
    HealthInsuranceCompanyCode = "HealthInsuranceCompanyCode",
    IsZtpPCode = "IsZtpPCode",
    PrEducationCode = "PrEducationCode",
    PreviousSocialInsuranceProviderName = "PreviousSocialInsuranceProviderName",
    UserEmail = "UserEmail",
    ApplicableForeignLegislation = "ApplicableForeignLegislation",
    ApplicableForeignLegislationCountry = "ApplicableForeignLegislationCountry",
    Disability = "Disability",
    ForeignInsurer = "ForeignInsurer",
    ForeignTaxIdentifierType = "ForeignTaxIdentifierType",
    HealthInsuranceCompany = "HealthInsuranceCompany",
    IdentityDocument = "IdentityDocument",
    IsZtpP = "IsZtpP",
    LaborMarketAccess = "LaborMarketAccess",
    Pension = "Pension",
    PrEducation = "PrEducation",
}

export interface IPrSubmissionStatusEntity extends IEntityBase {
    Code?: PrSubmissionStatusCode;
    Name?: string;
}

export enum PrSubmissionStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrSubmissionSubtypeEntity extends IEntityBase {
    Code?: PrSubmissionSubtypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum PrSubmissionSubtypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrSubmissionTypeEntity extends IEntityBase {
    Code?: PrSubmissionTypeCode;
    Name?: string;
    ShortName?: string;
    Subtypes?: IPrSubmissionSubtypeEntity[];
}

export enum PrSubmissionTypeEntity {
    Code = "Code",
    Name = "Name",
    ShortName = "ShortName",
    Subtypes = "Subtypes",
}

export interface IPrSubmissionValidationStatusEntity extends IEntityBase {
    Code?: PrSubmissionValidationStatusCode;
    Name?: string;
}

export enum PrSubmissionValidationStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrSubsequentMaternityLeaveStatusEntity extends IEntityBase {
    Code?: PrSubsequentMaternityLeaveStatusCode;
    Name?: string;
}

export enum PrSubsequentMaternityLeaveStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrTaxDiscountTypeEntity extends IEntityBase {
    Code?: PrTaxDiscountTypeCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrTaxDiscountTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IPrTaxpayerDeclarationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateApplyFrom?: Date;
    DateApplyTo?: Date;
    NumberOurs?: string;
    StatusCode?: PrTaxpayerDeclarationStatusCode;
    TypeCode?: PrTaxpayerDeclarationTypeCode;
    Year?: number;
    DateSigned?: Date;
    DateEnded?: Date;
    Employee?: IPrEmployeeEntity;
    NumberRange?: INumberRangeEntity;
    OtherProvider?: IPrTaxpayerDeclarationOtherProviderEntity;
    Status?: IPrTaxpayerDeclarationStatusEntity;
    Type?: IPrTaxpayerDeclarationTypeEntity;
    Attachments?: IPrTaxpayerDeclarationAttachmentEntity[];
    Children?: IPrTaxpayerDeclarationChildEntity[];
    Discounts?: IPrTaxpayerDeclarationDiscountEntity[];
}

export enum PrTaxpayerDeclarationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateApplyFrom = "DateApplyFrom",
    DateApplyTo = "DateApplyTo",
    NumberOurs = "NumberOurs",
    StatusCode = "StatusCode",
    TypeCode = "TypeCode",
    Year = "Year",
    DateSigned = "DateSigned",
    DateEnded = "DateEnded",
    Employee = "Employee",
    NumberRange = "NumberRange",
    OtherProvider = "OtherProvider",
    Status = "Status",
    Type = "Type",
    Attachments = "Attachments",
    Children = "Children",
    Discounts = "Discounts",
}

export interface IPrTaxpayerDeclarationAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrTaxpayerDeclarationAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrTaxpayerDeclarationChildEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    FirstName?: string;
    IncludedMonths?: string;
    IsDisabilityDiscount?: boolean;
    LastName?: string;
    OrderCode?: PrChildDeductionOrderCode;
    PersonalIdentificationNumber?: string;
    Order?: IPrChildDeductionOrderEntity;
}

export enum PrTaxpayerDeclarationChildEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    FirstName = "FirstName",
    IncludedMonths = "IncludedMonths",
    IsDisabilityDiscount = "IsDisabilityDiscount",
    LastName = "LastName",
    OrderCode = "OrderCode",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    Order = "Order",
}

export interface IPrTaxpayerDeclarationDiscountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DiscountTypeCode?: PrTaxDiscountTypeCode;
    IncludedMonths?: string;
    DiscountType?: IPrTaxDiscountTypeEntity;
}

export enum PrTaxpayerDeclarationDiscountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DiscountTypeCode = "DiscountTypeCode",
    IncludedMonths = "IncludedMonths",
    DiscountType = "DiscountType",
}

export interface IPrTaxpayerDeclarationOtherProviderEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EmployerName?: string;
    FirstName?: string;
    IsApplyingTaxBenefits?: boolean;
    IsEmployed?: boolean;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    Address?: IPrOtherProviderAddressEntity;
    EmployerAddress?: IPrOtherProviderEmployerAddressEntity;
}

export enum PrTaxpayerDeclarationOtherProviderEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EmployerName = "EmployerName",
    FirstName = "FirstName",
    IsApplyingTaxBenefits = "IsApplyingTaxBenefits",
    IsEmployed = "IsEmployed",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    Address = "Address",
    EmployerAddress = "EmployerAddress",
}

export interface IPrTaxpayerDeclarationStatusEntity extends IEntityBase {
    Code?: PrTaxpayerDeclarationStatusCode;
    Name?: string;
}

export enum PrTaxpayerDeclarationStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrTaxpayerDeclarationTypeEntity extends IEntityBase {
    Code?: PrTaxpayerDeclarationTypeCode;
    Name?: string;
}

export enum PrTaxpayerDeclarationTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrTimeBasedBonusTypeEntity extends IEntityBase {
    Code?: PrTimeBasedBonusTypeCode;
    Name?: string;
}

export enum PrTimeBasedBonusTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrUnseizableAmountEntity extends IEntityBase {
    Code?: PrUnseizableAmountCode;
    AmountBase?: number;
    AmountDependant?: number;
    AmountInsolvencyReward?: number;
    AmountToBeDistributedLimit?: number;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum PrUnseizableAmountEntity {
    Code = "Code",
    AmountBase = "AmountBase",
    AmountDependant = "AmountDependant",
    AmountInsolvencyReward = "AmountInsolvencyReward",
    AmountToBeDistributedLimit = "AmountToBeDistributedLimit",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IPrVacationEntitlementEntity extends IEntityBase {
    Code?: PrVacationEntitlementCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    VacationEntitlementDays?: number;
    Country?: ICountryEntity;
}

export enum PrVacationEntitlementEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    VacationEntitlementDays = "VacationEntitlementDays",
    Country = "Country",
}

export interface IPrVacationEntitlementInclusionEntity extends IEntityBase {
    Code?: PrVacationEntitlementInclusionCode;
    Name?: string;
}

export enum PrVacationEntitlementInclusionEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrValueTypeEntity extends IEntityBase {
    Code?: PrValueTypeCode;
    Name?: string;
}

export enum PrValueTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrWorkIntervalTypeEntity extends IEntityBase {
    Code?: PrWorkIntervalTypeCode;
    IncludeInWorkingHours?: boolean;
    Name?: string;
}

export enum PrWorkIntervalTypeEntity {
    Code = "Code",
    IncludeInWorkingHours = "IncludeInWorkingHours",
    Name = "Name",
}

export interface IPrWorkLeaveDaysIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    DateTo?: Date;
}

export enum PrWorkLeaveDaysIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
}

export interface IPrWorkPermitTypeEntity extends IEntityBase {
    Code?: PrWorkPermitTypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum PrWorkPermitTypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IPrWorkScheduleDaysIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    DateTo?: Date;
}

export enum PrWorkScheduleDaysIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
}

export interface IPrWorkedInDaysIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    DateTo?: Date;
}

export enum PrWorkedInDaysIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
}

export interface IPrWorkingPatternEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateBalancingPeriodStart?: Date;
    DefaultDayStart?: Date;
    HoursPerWeekFullTime?: number;
    IsDifferentOddAndEvenWeek?: boolean;
    IsIncludingHolidays?: boolean;
    Name?: string;
    TypeCode?: PrWorkingPatternTypeCode;
    WorkingMinutesWeekly?: number;
    BalancingPeriodWeeks?: number;
    Type?: IPrWorkingPatternTypeEntity;
    Days?: IPrWorkingPatternDayEntity[];
}

export enum PrWorkingPatternEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateBalancingPeriodStart = "DateBalancingPeriodStart",
    DefaultDayStart = "DefaultDayStart",
    HoursPerWeekFullTime = "HoursPerWeekFullTime",
    IsDifferentOddAndEvenWeek = "IsDifferentOddAndEvenWeek",
    IsIncludingHolidays = "IsIncludingHolidays",
    Name = "Name",
    TypeCode = "TypeCode",
    WorkingMinutesWeekly = "WorkingMinutesWeekly",
    BalancingPeriodWeeks = "BalancingPeriodWeeks",
    Type = "Type",
    Days = "Days",
}

export interface IPrWorkingPatternDayEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Date?: Date;
    WorkingHours?: Date;
    Intervals?: IPrWorkingPatternDayIntervalEntity[];
}

export enum PrWorkingPatternDayEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Date = "Date",
    WorkingHours = "WorkingHours",
    Intervals = "Intervals",
}

export interface IPrWorkingPatternDayIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsEndNextDay?: boolean;
    IsStartNextDay?: boolean;
    Order?: number;
    TimeEnd?: Date;
    TimeStart?: Date;
    TypeCode?: PrWorkingPatternIntervalTypeCode;
    Type?: IPrWorkingPatternIntervalTypeEntity;
}

export enum PrWorkingPatternDayIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsEndNextDay = "IsEndNextDay",
    IsStartNextDay = "IsStartNextDay",
    Order = "Order",
    TimeEnd = "TimeEnd",
    TimeStart = "TimeStart",
    TypeCode = "TypeCode",
    Type = "Type",
}

export interface IPrWorkingPatternIntervalTypeEntity extends IEntityBase {
    Code?: PrWorkingPatternIntervalTypeCode;
    IncludeInWorkingHours?: boolean;
    Name?: string;
}

export enum PrWorkingPatternIntervalTypeEntity {
    Code = "Code",
    IncludeInWorkingHours = "IncludeInWorkingHours",
    Name = "Name",
}

export interface IPrWorkingPatternTypeEntity extends IEntityBase {
    Code?: PrWorkingPatternTypeCode;
    Name?: string;
}

export enum PrWorkingPatternTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IPrYearOperationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsClosed?: boolean;
    Year?: number;
    DisabledShareByOrders?: number;
    Attachments?: IPrYearOperationAttachmentEntity[];
    PrYearOperationPayrollSheets?: IPrYearOperationPayrollSheetAttachmentEntity[];
    Sections?: IPrYearOperationSectionEntity[];
}

export enum PrYearOperationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsClosed = "IsClosed",
    Year = "Year",
    DisabledShareByOrders = "DisabledShareByOrders",
    Attachments = "Attachments",
    PrYearOperationPayrollSheets = "PrYearOperationPayrollSheets",
    Sections = "Sections",
}

export interface IPrYearOperationAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum PrYearOperationAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IPrYearOperationPayrollSheetAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
    Employee?: IPrEmployeeEntity;
}

export enum PrYearOperationPayrollSheetAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
    Employee = "Employee",
}

export interface IPrYearOperationSectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsChecked?: boolean;
    TypeCode?: PrYearOperationSectionTypeCode;
    Type?: IPrYearOperationSectionTypeEntity;
}

export enum PrYearOperationSectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsChecked = "IsChecked",
    TypeCode = "TypeCode",
    Type = "Type",
}

export interface IPrYearOperationSectionTypeEntity extends IEntityBase {
    Code?: PrYearOperationSectionTypeCode;
    Name?: string;
}

export enum PrYearOperationSectionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IProductEntity extends IEntityBase {
    Code?: ProductCode;
    Name?: string;
}

export enum ProductEntity {
    Code = "Code",
    Name = "Name",
}

export interface IProformaInvoiceIssuedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaDocument?: Date;
    DateClearing?: Date;
    DateDocumentVatStatement?: Date;
    DateVatDeduction?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsInternallyManaged?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: VatStatementStatusCode;
    VatOssStatementStatusCode?: VatStatementStatusCode;
    VatStatementStatusCode?: VatStatementStatusCode;
    VatViesStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnitDateVatDeduction?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionEntity;
    BankAccount?: IDocumentBankAccountEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    CbaCategory?: IDocumentCbaCategoryEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    NumberRange?: INumberRangeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionEntity;
    VatControlStatementStatus?: IVatStatementStatusEntity;
    VatOssStatementStatus?: IVatStatementStatusEntity;
    VatStatementStatus?: IVatStatementStatusEntity;
    VatViesStatementStatus?: IVatStatementStatusEntity;
    Attachments?: IDocumentAttachmentEntity[];
    DocumentItems?: IDocumentItemViewEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Labels?: IDocumentLabelEntity[];
    Locks?: IDocumentLockEntity[];
    OppositeDocumentLinks?: IOppositeDocumentDocumentLinkEntity[];
    Payments?: IOppositePaymentDocumentDocumentLinkEntity[];
    ClearingDocumentLinks?: IClearingDocumentLinkEntity[];
    CorrectiveDocumentDrafts?: IDocumentDraftEntity[];
    DeferredPlans?: IDeferredPlanEntity[];
    Chats?: IChatEntity[];
    ElectronicSubmissions?: IElectronicSubmissionEntity[];
    CalculateVat?: boolean;
    DateDue?: Date;
    DateIssued?: Date;
    DatePaymentReceived?: Date;
    DateProcessed?: Date;
    DateTaxableSupply?: Date;
    IsDeducted?: boolean;
    IsTaxDocument?: boolean;
    PaymentMethodCode?: PaymentMethodCode;
    SymbolMatching?: string;
    TextBeforeItems?: string;
    TransactionAmountToPay?: number;
    TransactionAmountToReceive?: number;
    CashBox?: ICashBoxEntity;
    PaymentMethod?: IPaymentMethodEntity;
    Items?: IRegularDocumentItemEntity[];
}

export enum ProformaInvoiceIssuedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaDocument = "DateCbaDocument",
    DateClearing = "DateClearing",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateVatDeduction = "DateVatDeduction",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsInternallyManaged = "IsInternallyManaged",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BusinessPartner = "BusinessPartner",
    CbaCategory = "CbaCategory",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    DocumentDraft = "DocumentDraft",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    NumberRange = "NumberRange",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassificationSelection = "VatClassificationSelection",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
    Attachments = "Attachments",
    DocumentItems = "DocumentItems",
    DocumentLinks = "DocumentLinks",
    Labels = "Labels",
    Locks = "Locks",
    OppositeDocumentLinks = "OppositeDocumentLinks",
    Payments = "Payments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    CorrectiveDocumentDrafts = "CorrectiveDocumentDrafts",
    DeferredPlans = "DeferredPlans",
    Chats = "Chats",
    ElectronicSubmissions = "ElectronicSubmissions",
    CalculateVat = "CalculateVat",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DatePaymentReceived = "DatePaymentReceived",
    DateProcessed = "DateProcessed",
    DateTaxableSupply = "DateTaxableSupply",
    IsDeducted = "IsDeducted",
    IsTaxDocument = "IsTaxDocument",
    PaymentMethodCode = "PaymentMethodCode",
    SymbolMatching = "SymbolMatching",
    TextBeforeItems = "TextBeforeItems",
    TransactionAmountToPay = "TransactionAmountToPay",
    TransactionAmountToReceive = "TransactionAmountToReceive",
    CashBox = "CashBox",
    PaymentMethod = "PaymentMethod",
    Items = "Items",
}

export interface IProformaInvoiceReceivedEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaDocument?: Date;
    DateClearing?: Date;
    DateDocumentVatStatement?: Date;
    DateVatDeduction?: Date;
    DocumentSourceName?: string;
    DocumentSourceTypeCode?: DocumentSourceTypeCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsInternallyManaged?: boolean;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: PostedStatusCode;
    RemittanceInformation?: string;
    SymbolConstant?: string;
    SymbolSpecific?: string;
    SymbolVariable?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: VatStatementStatusCode;
    VatOssStatementStatusCode?: VatStatementStatusCode;
    VatStatementStatusCode?: VatStatementStatusCode;
    VatViesStatementStatusCode?: VatStatementStatusCode;
    ExchangeRatePerUnitDateVatDeduction?: number;
    SourceSystemDocumentId?: number;
    DateSourceSystemDocumentLastModified?: Date;
    InvoiceServiceIntegrationId?: number;
    AccountAssignmentSelection?: IDocumentAccountAssignmentSelectionEntity;
    BankAccount?: IDocumentBankAccountEntity;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    CbaCategory?: IDocumentCbaCategoryEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DefaultGrantAssignment?: IDocumentGrantAssignmentEntity;
    DocumentDraft?: IDocumentDraftEntity;
    DocumentSourceType?: IDocumentSourceTypeEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    DocumentVatStatementStatus?: IVatStatementStatusEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    NumberRange?: INumberRangeEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatClassificationSelection?: IDocumentVatClassificationSelectionEntity;
    VatControlStatementStatus?: IVatStatementStatusEntity;
    VatOssStatementStatus?: IVatStatementStatusEntity;
    VatStatementStatus?: IVatStatementStatusEntity;
    VatViesStatementStatus?: IVatStatementStatusEntity;
    Attachments?: IDocumentAttachmentEntity[];
    DocumentItems?: IDocumentItemViewEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Labels?: IDocumentLabelEntity[];
    Locks?: IDocumentLockEntity[];
    OppositeDocumentLinks?: IOppositeDocumentDocumentLinkEntity[];
    Payments?: IOppositePaymentDocumentDocumentLinkEntity[];
    ClearingDocumentLinks?: IClearingDocumentLinkEntity[];
    CorrectiveDocumentDrafts?: IDocumentDraftEntity[];
    DeferredPlans?: IDeferredPlanEntity[];
    Chats?: IChatEntity[];
    ElectronicSubmissions?: IElectronicSubmissionEntity[];
    BankPaymentOrderStateCode?: BankPaymentOrderStateCode;
    CalculateVat?: boolean;
    DateBankApiPaymentOrder?: Date;
    DateDue?: Date;
    DateIssued?: Date;
    DateProcessed?: Date;
    DateReceived?: Date;
    DateTaxableSupply?: Date;
    IsDeducted?: boolean;
    IsTaxDocument?: boolean;
    PaymentMethodCode?: PaymentMethodCode;
    SymbolMatching?: string;
    TextBeforeItems?: string;
    TransactionAmountToPay?: number;
    TransactionAmountToReceive?: number;
    BankPaymentOrderState?: IBankPaymentOrderStateEntity;
    CashBox?: ICashBoxEntity;
    PaymentMethod?: IPaymentMethodEntity;
    Items?: IRegularDocumentItemEntity[];
}

export enum ProformaInvoiceReceivedEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaDocument = "DateCbaDocument",
    DateClearing = "DateClearing",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateVatDeduction = "DateVatDeduction",
    DocumentSourceName = "DocumentSourceName",
    DocumentSourceTypeCode = "DocumentSourceTypeCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsInternallyManaged = "IsInternallyManaged",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    RemittanceInformation = "RemittanceInformation",
    SymbolConstant = "SymbolConstant",
    SymbolSpecific = "SymbolSpecific",
    SymbolVariable = "SymbolVariable",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    ExchangeRatePerUnitDateVatDeduction = "ExchangeRatePerUnitDateVatDeduction",
    SourceSystemDocumentId = "SourceSystemDocumentId",
    DateSourceSystemDocumentLastModified = "DateSourceSystemDocumentLastModified",
    InvoiceServiceIntegrationId = "InvoiceServiceIntegrationId",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    BankAccount = "BankAccount",
    BusinessPartner = "BusinessPartner",
    CbaCategory = "CbaCategory",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DefaultGrantAssignment = "DefaultGrantAssignment",
    DocumentDraft = "DocumentDraft",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatStatementStatus = "DocumentVatStatementStatus",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    NumberRange = "NumberRange",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassificationSelection = "VatClassificationSelection",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
    Attachments = "Attachments",
    DocumentItems = "DocumentItems",
    DocumentLinks = "DocumentLinks",
    Labels = "Labels",
    Locks = "Locks",
    OppositeDocumentLinks = "OppositeDocumentLinks",
    Payments = "Payments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    CorrectiveDocumentDrafts = "CorrectiveDocumentDrafts",
    DeferredPlans = "DeferredPlans",
    Chats = "Chats",
    ElectronicSubmissions = "ElectronicSubmissions",
    BankPaymentOrderStateCode = "BankPaymentOrderStateCode",
    CalculateVat = "CalculateVat",
    DateBankApiPaymentOrder = "DateBankApiPaymentOrder",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DateProcessed = "DateProcessed",
    DateReceived = "DateReceived",
    DateTaxableSupply = "DateTaxableSupply",
    IsDeducted = "IsDeducted",
    IsTaxDocument = "IsTaxDocument",
    PaymentMethodCode = "PaymentMethodCode",
    SymbolMatching = "SymbolMatching",
    TextBeforeItems = "TextBeforeItems",
    TransactionAmountToPay = "TransactionAmountToPay",
    TransactionAmountToReceive = "TransactionAmountToReceive",
    BankPaymentOrderState = "BankPaymentOrderState",
    CashBox = "CashBox",
    PaymentMethod = "PaymentMethod",
    Items = "Items",
}

export interface IPurchaseStatusEntity extends IEntityBase {
    Code?: PurchaseStatusCode;
    Name?: string;
}

export enum PurchaseStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IReceivableAdjustmentGroupEntity extends IEntityBase {
    Code?: ReceivableAdjustmentGroupCode;
    CountryCode?: CountryCode;
    Name?: string;
    Country?: ICountryEntity;
}

export enum ReceivableAdjustmentGroupEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    Name = "Name",
    Country = "Country",
}

export interface IReceivableAdjustmentTypeEntity extends IEntityBase {
    Code?: ReceivableAdjustmentTypeCode;
    CountryCode?: CountryCode;
    Explanation?: string;
    GroupCode?: ReceivableAdjustmentGroupCode;
    Name?: string;
    Country?: ICountryEntity;
    Group?: IReceivableAdjustmentGroupEntity;
}

export enum ReceivableAdjustmentTypeEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    Explanation = "Explanation",
    GroupCode = "GroupCode",
    Name = "Name",
    Country = "Country",
    Group = "Group",
}

export interface IRecurrentPaymentStateEntity extends IEntityBase {
    Code?: RecurrentPaymentStateCode;
    Name?: string;
}

export enum RecurrentPaymentStateEntity {
    Code = "Code",
    Name = "Name",
}

export interface IRecurringTaskEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateEnd?: Date;
    DateNextExecution?: Date;
    DateStart?: Date;
    DoesExecuteEveryWeekDay?: boolean;
    ExecuteEverySpecificDayOfWeekCode?: DayOfWeekCode;
    ExecuteInMonthCode?: MonthOfYearCode;
    IntervalCode?: RecurringTaskIntervalCode;
    Name?: string;
    PeriodCode?: RecurringTaskPeriodCode;
    StateCode?: RecurringTaskStateCode;
    TypeCode?: RecurringTaskTypeCode;
    ExecuteEveryNth?: number;
    ExecuteEveryNthDayOfMonth?: number;
    Company?: ICompanyEntity;
    DocumentDraft?: IDocumentDraftEntity;
    ExecuteEverySpecificDayOfWeek?: IDayOfWeekEntity;
    ExecuteInMonth?: IMonthOfYearEntity;
    Interval?: IRecurringTaskIntervalEntity;
    Period?: IRecurringTaskPeriodEntity;
    State?: IRecurringTaskStateEntity;
    Type?: IRecurringTaskTypeEntity;
    Executions?: IRecurringTaskExecutionEntity[];
}

export enum RecurringTaskEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateEnd = "DateEnd",
    DateNextExecution = "DateNextExecution",
    DateStart = "DateStart",
    DoesExecuteEveryWeekDay = "DoesExecuteEveryWeekDay",
    ExecuteEverySpecificDayOfWeekCode = "ExecuteEverySpecificDayOfWeekCode",
    ExecuteInMonthCode = "ExecuteInMonthCode",
    IntervalCode = "IntervalCode",
    Name = "Name",
    PeriodCode = "PeriodCode",
    StateCode = "StateCode",
    TypeCode = "TypeCode",
    ExecuteEveryNth = "ExecuteEveryNth",
    ExecuteEveryNthDayOfMonth = "ExecuteEveryNthDayOfMonth",
    Company = "Company",
    DocumentDraft = "DocumentDraft",
    ExecuteEverySpecificDayOfWeek = "ExecuteEverySpecificDayOfWeek",
    ExecuteInMonth = "ExecuteInMonth",
    Interval = "Interval",
    Period = "Period",
    State = "State",
    Type = "Type",
    Executions = "Executions",
}

export interface IRecurringTaskExecutionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ErrorMessage?: string;
    GeneratedDocument?: IDocumentEntity;
    GeneratedDocumentDraft?: IDocumentDraftEntity;
}

export enum RecurringTaskExecutionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ErrorMessage = "ErrorMessage",
    GeneratedDocument = "GeneratedDocument",
    GeneratedDocumentDraft = "GeneratedDocumentDraft",
}

export interface IRecurringTaskIntervalEntity extends IEntityBase {
    Code?: RecurringTaskIntervalCode;
    Name?: string;
    Number?: number;
}

export enum RecurringTaskIntervalEntity {
    Code = "Code",
    Name = "Name",
    Number = "Number",
}

export interface IRecurringTaskPeriodEntity extends IEntityBase {
    Code?: RecurringTaskPeriodCode;
    Name?: string;
}

export enum RecurringTaskPeriodEntity {
    Code = "Code",
    Name = "Name",
}

export interface IRecurringTaskStateEntity extends IEntityBase {
    Code?: RecurringTaskStateCode;
    Name?: string;
}

export enum RecurringTaskStateEntity {
    Code = "Code",
    Name = "Name",
}

export interface IRecurringTaskTypeEntity extends IEntityBase {
    Code?: RecurringTaskTypeCode;
    Name?: string;
}

export enum RecurringTaskTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IRegZecCompanyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    LegalName?: string;
    LegalNumber?: string;
    Company?: ICompanyEntity;
    CSSZSymbolVariable?: string;
    SocialSecurityCode?: GovernmentInstitutionCode;
    SocialSecurity?: IGovernmentInstitutionEntity;
}

export enum RegZecCompanyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    LegalName = "LegalName",
    LegalNumber = "LegalNumber",
    Company = "Company",
    CSSZSymbolVariable = "CSSZSymbolVariable",
    SocialSecurityCode = "SocialSecurityCode",
    SocialSecurity = "SocialSecurity",
}

export interface IRegZecDisabilityEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateDisabilityFrom?: Date;
    DateDisabilityTo?: Date;
    PrDisabilityTypeCode?: PrDisabilityTypeCode;
    PrDisabilityType?: IPrDisabilityTypeEntity;
}

export enum RegZecDisabilityEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateDisabilityFrom = "DateDisabilityFrom",
    DateDisabilityTo = "DateDisabilityTo",
    PrDisabilityTypeCode = "PrDisabilityTypeCode",
    PrDisabilityType = "PrDisabilityType",
}

export interface IRegZecEmployeeEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BirthLastName?: string;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    PersonalIdentificationNumber?: string;
    TitleAfterName?: string;
    TitleBeforeName?: string;
    ContactAddress?: IPrEntityEmployeeContactAddressEntity;
    CzechAddress?: IPrEntityEmployeeCzechAddressEntity;
    Employee?: IPrEmployeeEntity;
    PermanentAddress?: IPrEntityEmployeePermanentAddressEntity;
    TaxResidenceAddress?: IPrEntityEmployeeTaxResidenceAddressEntity;
    CitizenshipCode?: CountryCode;
    CountryOfBirthCode?: CountryCode;
    CountryOfResidencyCode?: CountryCode;
    DateResidencyFrom?: Date;
    EuSocialInsuranceNumber?: string;
    FormerLastNames?: string;
    MpsvIdentifier?: string;
    OwnTaxPayerNumber?: string;
    PlaceOfBirth?: string;
    PrSexCode?: PrSexCode;
    Citizenship?: ICountryEntity;
    CountryOfBirth?: ICountryEntity;
    CountryOfResidency?: ICountryEntity;
    PrSex?: IPrSexEntity;
}

export enum RegZecEmployeeEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BirthLastName = "BirthLastName",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
    TitleAfterName = "TitleAfterName",
    TitleBeforeName = "TitleBeforeName",
    ContactAddress = "ContactAddress",
    CzechAddress = "CzechAddress",
    Employee = "Employee",
    PermanentAddress = "PermanentAddress",
    TaxResidenceAddress = "TaxResidenceAddress",
    CitizenshipCode = "CitizenshipCode",
    CountryOfBirthCode = "CountryOfBirthCode",
    CountryOfResidencyCode = "CountryOfResidencyCode",
    DateResidencyFrom = "DateResidencyFrom",
    EuSocialInsuranceNumber = "EuSocialInsuranceNumber",
    FormerLastNames = "FormerLastNames",
    MpsvIdentifier = "MpsvIdentifier",
    OwnTaxPayerNumber = "OwnTaxPayerNumber",
    PlaceOfBirth = "PlaceOfBirth",
    PrSexCode = "PrSexCode",
    Citizenship = "Citizenship",
    CountryOfBirth = "CountryOfBirth",
    CountryOfResidency = "CountryOfResidency",
    PrSex = "PrSex",
}

export interface IRegZecEmploymentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    TypeCode?: PrEmploymentTypeCode;
    Employment?: IPrEmploymentEntity;
    Type?: IPrEmploymentTypeEntity;
    City?: string;
    CityCode?: string;
    ContractPlaceOfWork?: string;
    CsszEmploymentTypeCode?: CsszEmploymentTypeCode;
    DateContractFrom?: Date;
    DateEnd?: Date;
    DateStart?: Date;
    DetailedSpecificationCode?: DetailedEmploymentSpecificationCode;
    ExpectedPlaceOfWork?: string;
    IsContinuousOperationCode?: YesNoCode;
    IsEndedByDeathCode?: YesNoCode;
    IsManagerialEmployeeCode?: YesNoCode;
    IsSmallScaleEmploymentCode?: YesNoCode;
    IsceCode?: CzIsceCode;
    IscoCode?: CzIscoCode;
    MinimalEducationCode?: PrEducationCode;
    MpsvIdentifier?: string;
    PositionName?: string;
    ShiftPatternCode?: ShiftPatternCode;
    WorkplaceTypeCode?: WorkplaceTypeCode;
    CsszEmploymentType?: ICsszEmploymentTypeEntity;
    DetailedSpecification?: IDetailedEmploymentSpecificationEntity;
    Isce?: ICzIsceEntity;
    Isco?: ICzIscoEntity;
    IsContinuousOperation?: IYesNoEntity;
    IsEndedByDeath?: IYesNoEntity;
    IsManagerialEmployee?: IYesNoEntity;
    IsSmallScaleEmployment?: IYesNoEntity;
    MinimalEducation?: IPrEducationEntity;
    ShiftPattern?: IShiftPatternEntity;
    UnemploymentSupport?: IRegZecUnemploymentSupportEntity;
    WorkplaceType?: IWorkplaceTypeEntity;
}

export enum RegZecEmploymentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    TypeCode = "TypeCode",
    Employment = "Employment",
    Type = "Type",
    City = "City",
    CityCode = "CityCode",
    ContractPlaceOfWork = "ContractPlaceOfWork",
    CsszEmploymentTypeCode = "CsszEmploymentTypeCode",
    DateContractFrom = "DateContractFrom",
    DateEnd = "DateEnd",
    DateStart = "DateStart",
    DetailedSpecificationCode = "DetailedSpecificationCode",
    ExpectedPlaceOfWork = "ExpectedPlaceOfWork",
    IsContinuousOperationCode = "IsContinuousOperationCode",
    IsEndedByDeathCode = "IsEndedByDeathCode",
    IsManagerialEmployeeCode = "IsManagerialEmployeeCode",
    IsSmallScaleEmploymentCode = "IsSmallScaleEmploymentCode",
    IsceCode = "IsceCode",
    IscoCode = "IscoCode",
    MinimalEducationCode = "MinimalEducationCode",
    MpsvIdentifier = "MpsvIdentifier",
    PositionName = "PositionName",
    ShiftPatternCode = "ShiftPatternCode",
    WorkplaceTypeCode = "WorkplaceTypeCode",
    CsszEmploymentType = "CsszEmploymentType",
    DetailedSpecification = "DetailedSpecification",
    Isce = "Isce",
    Isco = "Isco",
    IsContinuousOperation = "IsContinuousOperation",
    IsEndedByDeath = "IsEndedByDeath",
    IsManagerialEmployee = "IsManagerialEmployee",
    IsSmallScaleEmployment = "IsSmallScaleEmployment",
    MinimalEducation = "MinimalEducation",
    ShiftPattern = "ShiftPattern",
    UnemploymentSupport = "UnemploymentSupport",
    WorkplaceType = "WorkplaceType",
}

export interface IRegZecForeignInsuranceCarrierAddressEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    City?: string;
    CountryCode?: CountryCode;
    PostalCode?: string;
    Street?: string;
    Country?: ICountryEntity;
    HouseNumber?: string;
    StreetNumber?: string;
}

export enum RegZecForeignInsuranceCarrierAddressEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    City = "City",
    CountryCode = "CountryCode",
    PostalCode = "PostalCode",
    Street = "Street",
    Country = "Country",
    HouseNumber = "HouseNumber",
    StreetNumber = "StreetNumber",
}

export interface IRegZecForeignInsurerEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    InsuranceCarrierName?: string;
    InsuranceCarrierSectorTypeCode?: PrForeignInsuranceCarrierSectorTypeCode;
    InsuranceCarrierTypeCode?: PrForeignInsuranceCarrierTypeCode;
    InsuranceNumber?: string;
    InsuranceCarrierAddress?: IRegZecForeignInsuranceCarrierAddressEntity;
    InsuranceCarrierSectorType?: IPrForeignInsuranceCarrierSectorTypeEntity;
    InsuranceCarrierType?: IPrForeignInsuranceCarrierTypeEntity;
}

export enum RegZecForeignInsurerEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    InsuranceCarrierName = "InsuranceCarrierName",
    InsuranceCarrierSectorTypeCode = "InsuranceCarrierSectorTypeCode",
    InsuranceCarrierTypeCode = "InsuranceCarrierTypeCode",
    InsuranceNumber = "InsuranceNumber",
    InsuranceCarrierAddress = "InsuranceCarrierAddress",
    InsuranceCarrierSectorType = "InsuranceCarrierSectorType",
    InsuranceCarrierType = "InsuranceCarrierType",
}

export interface IRegZecIdentityDocumentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateIDEndOfValidity?: Date;
    IDAuthorityOfIssue?: string;
    IDCountryOfIssueCode?: CountryCode;
    IDNumber?: string;
    IdentificationDocumentTypeCode?: PrIdentityDocumentTypeCode;
    IDCountryOfIssue?: ICountryEntity;
    IdentificationDocumentType?: IPrIdentityDocumentTypeEntity;
}

export enum RegZecIdentityDocumentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateIDEndOfValidity = "DateIDEndOfValidity",
    IDAuthorityOfIssue = "IDAuthorityOfIssue",
    IDCountryOfIssueCode = "IDCountryOfIssueCode",
    IDNumber = "IDNumber",
    IdentificationDocumentTypeCode = "IdentificationDocumentTypeCode",
    IDCountryOfIssue = "IDCountryOfIssue",
    IdentificationDocumentType = "IdentificationDocumentType",
}

export interface IRegZecLaborMarketAccessEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    FreeAccessTypeCode?: MpsvFreeAccessToLaborMarketTypeCode;
    HasFreeAccessToLaborMarketCode?: YesNoCode;
    PermitIssuingOfficeCode?: LORegionalOfficeCode;
    WorkPermitNumber?: string;
    WorkPermitTypeCode?: PrWorkPermitTypeCode;
    FreeAccessType?: IMpsvFreeAccessToLaborMarketTypeEntity;
    HasFreeAccessToLaborMarket?: IYesNoEntity;
    PermitIssuingOffice?: ILORegionalOfficeEntity;
    WorkPermitType?: IPrWorkPermitTypeEntity;
}

export enum RegZecLaborMarketAccessEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    FreeAccessTypeCode = "FreeAccessTypeCode",
    HasFreeAccessToLaborMarketCode = "HasFreeAccessToLaborMarketCode",
    PermitIssuingOfficeCode = "PermitIssuingOfficeCode",
    WorkPermitNumber = "WorkPermitNumber",
    WorkPermitTypeCode = "WorkPermitTypeCode",
    FreeAccessType = "FreeAccessType",
    HasFreeAccessToLaborMarket = "HasFreeAccessToLaborMarket",
    PermitIssuingOffice = "PermitIssuingOffice",
    WorkPermitType = "WorkPermitType",
}

export interface IRegZecPensionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DatePensionFrom?: Date;
    HasReducedRetirementAgeCode?: YesNoCode;
    IsEarlyRetirementCode?: YesNoCode;
    PensionTypeCode?: PrPensionTypeCode;
    HasReducedRetirementAge?: IYesNoEntity;
    IsEarlyRetirement?: IYesNoEntity;
    PensionType?: IPrPensionTypeEntity;
}

export enum RegZecPensionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DatePensionFrom = "DatePensionFrom",
    HasReducedRetirementAgeCode = "HasReducedRetirementAgeCode",
    IsEarlyRetirementCode = "IsEarlyRetirementCode",
    PensionTypeCode = "PensionTypeCode",
    HasReducedRetirementAge = "HasReducedRetirementAge",
    IsEarlyRetirement = "IsEarlyRetirement",
    PensionType = "PensionType",
}

export interface IRegZecPensionInsuranceIntervalEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    DateTo?: Date;
}

export enum RegZecPensionInsuranceIntervalEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
}

export interface IRegZecUnemploymentSupportEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    EmploymentEarlyTerminationReasonCode?: EmploymentEarlyTerminationReasonCode;
    EmploymentRelationshipTerminationReasonCode?: EmploymentRelationshipTerminationReasonCode;
    HasTerminationBenefitEntitledCode?: YesNoCode;
    IsSeverancePaidInFullCode?: YesNoCode;
    LaborOfficeEmploymentTypeCode?: LaborOfficeEmploymentTypeCode;
    NoUnemploymentSupportTypeCode?: NoUnemploymentSupportTypeCode;
    ServiceRelationshipTerminationReasonCode?: ServiceRelationshipTerminationReasonCode;
    AverageNetMonthlyEarnings?: number;
    MedicalLossCompensationAmount?: number;
    SeverancePayAmount?: number;
    RetirementBenefitAmount?: number;
    TerminationSettlementAmount?: number;
    EmploymentEarlyTerminationReason?: IEmploymentEarlyTerminationReasonEntity;
    EmploymentRelationshipTerminationReason?: IEmploymentRelationshipTerminationReasonEntity;
    HasTerminationBenefitEntitled?: IYesNoEntity;
    IsSeverancePaidInFull?: IYesNoEntity;
    LaborOfficeEmploymentType?: ILaborOfficeEmploymentTypeEntity;
    NoUnemploymentSupportType?: INoUnemploymentSupportTypeEntity;
    ServiceRelationshipTerminationReason?: IServiceRelationshipTerminationReasonEntity;
    PensionInsuranceIntervals?: IRegZecPensionInsuranceIntervalEntity[];
}

export enum RegZecUnemploymentSupportEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    EmploymentEarlyTerminationReasonCode = "EmploymentEarlyTerminationReasonCode",
    EmploymentRelationshipTerminationReasonCode = "EmploymentRelationshipTerminationReasonCode",
    HasTerminationBenefitEntitledCode = "HasTerminationBenefitEntitledCode",
    IsSeverancePaidInFullCode = "IsSeverancePaidInFullCode",
    LaborOfficeEmploymentTypeCode = "LaborOfficeEmploymentTypeCode",
    NoUnemploymentSupportTypeCode = "NoUnemploymentSupportTypeCode",
    ServiceRelationshipTerminationReasonCode = "ServiceRelationshipTerminationReasonCode",
    AverageNetMonthlyEarnings = "AverageNetMonthlyEarnings",
    MedicalLossCompensationAmount = "MedicalLossCompensationAmount",
    SeverancePayAmount = "SeverancePayAmount",
    RetirementBenefitAmount = "RetirementBenefitAmount",
    TerminationSettlementAmount = "TerminationSettlementAmount",
    EmploymentEarlyTerminationReason = "EmploymentEarlyTerminationReason",
    EmploymentRelationshipTerminationReason = "EmploymentRelationshipTerminationReason",
    HasTerminationBenefitEntitled = "HasTerminationBenefitEntitled",
    IsSeverancePaidInFull = "IsSeverancePaidInFull",
    LaborOfficeEmploymentType = "LaborOfficeEmploymentType",
    NoUnemploymentSupportType = "NoUnemploymentSupportType",
    ServiceRelationshipTerminationReason = "ServiceRelationshipTerminationReason",
    PensionInsuranceIntervals = "PensionInsuranceIntervals",
}

export interface IRegularDocumentItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    Description?: string;
    Note?: string;
    Order?: number;
    TransactionAmount?: number;
    TransactionAmountNet?: number;
    TransactionAmountVat?: number;
    VatCode?: VatCode;
    AccountAssignmentSelection?: IDocumentItemAccountAssignmentSelectionEntity;
    CbaCategory?: IDocumentItemCbaCategoryEntity;
    DocumentItemDraft?: IDocumentItemDraftEntity;
    GrantAssignment?: IDocumentItemGrantAssignmentEntity;
    GrantClaim?: IGrantClaimEntity;
    LabelSelection?: IDocumentItemLabelSelectionEntity;
    Vat?: IVatEntity;
    VatClassificationSelection?: IDocumentItemVatClassificationSelectionEntity;
    GrantEntries?: IGrantEntryEntity[];
    Quantity?: number;
    TransactionUnitPrice?: number;
    TransactionUnitPriceNet?: number;
    TransactionUnitPriceVat?: number;
    UnitOfMeasureCode?: UnitOfMeasureCode;
    UnitPrice?: number;
    UnitPriceNet?: number;
    UnitPriceVat?: number;
    DiscountPercent?: number;
    Discount?: number;
    LinkedDocument?: IDocumentEntity;
    UnitOfMeasure?: IUnitOfMeasureEntity;
}

export enum RegularDocumentItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    Description = "Description",
    Note = "Note",
    Order = "Order",
    TransactionAmount = "TransactionAmount",
    TransactionAmountNet = "TransactionAmountNet",
    TransactionAmountVat = "TransactionAmountVat",
    VatCode = "VatCode",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    CbaCategory = "CbaCategory",
    DocumentItemDraft = "DocumentItemDraft",
    GrantAssignment = "GrantAssignment",
    GrantClaim = "GrantClaim",
    LabelSelection = "LabelSelection",
    Vat = "Vat",
    VatClassificationSelection = "VatClassificationSelection",
    GrantEntries = "GrantEntries",
    Quantity = "Quantity",
    TransactionUnitPrice = "TransactionUnitPrice",
    TransactionUnitPriceNet = "TransactionUnitPriceNet",
    TransactionUnitPriceVat = "TransactionUnitPriceVat",
    UnitOfMeasureCode = "UnitOfMeasureCode",
    UnitPrice = "UnitPrice",
    UnitPriceNet = "UnitPriceNet",
    UnitPriceVat = "UnitPriceVat",
    DiscountPercent = "DiscountPercent",
    Discount = "Discount",
    LinkedDocument = "LinkedDocument",
    UnitOfMeasure = "UnitOfMeasure",
}

export interface IReportSectionTypeEntity extends IEntityBase {
    Code?: ReportSectionTypeCode;
    Name?: string;
    ReportTypeCode?: ReportTypeCode;
    ReportType?: IReportTypeEntity;
}

export enum ReportSectionTypeEntity {
    Code = "Code",
    Name = "Name",
    ReportTypeCode = "ReportTypeCode",
    ReportType = "ReportType",
}

export interface IReportTypeEntity extends IEntityBase {
    Code?: ReportTypeCode;
    Name?: string;
}

export enum ReportTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IRequiredAccountEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountNumber?: string;
    ReceivableAdjustmentGroupCode?: ReceivableAdjustmentGroupCode;
    RequiredAccountTypeCode?: RequiredAccountTypeCode;
    VatRate?: number;
    ReceivableAdjustmentGroup?: IReceivableAdjustmentGroupEntity;
    RequiredAccountType?: IRequiredAccountTypeEntity;
}

export enum RequiredAccountEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountNumber = "AccountNumber",
    ReceivableAdjustmentGroupCode = "ReceivableAdjustmentGroupCode",
    RequiredAccountTypeCode = "RequiredAccountTypeCode",
    VatRate = "VatRate",
    ReceivableAdjustmentGroup = "ReceivableAdjustmentGroup",
    RequiredAccountType = "RequiredAccountType",
}

export interface IRequiredAccountTemplateEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccountNumber?: string;
    ReceivableAdjustmentGroupCode?: ReceivableAdjustmentGroupCode;
    RequiredAccountTypeCode?: RequiredAccountTypeCode;
    VatRate?: number;
    ReceivableAdjustmentGroup?: IReceivableAdjustmentGroupEntity;
    RequiredAccountType?: IRequiredAccountTypeEntity;
}

export enum RequiredAccountTemplateEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccountNumber = "AccountNumber",
    ReceivableAdjustmentGroupCode = "ReceivableAdjustmentGroupCode",
    RequiredAccountTypeCode = "RequiredAccountTypeCode",
    VatRate = "VatRate",
    ReceivableAdjustmentGroup = "ReceivableAdjustmentGroup",
    RequiredAccountType = "RequiredAccountType",
}

export interface IRequiredAccountTypeEntity extends IEntityBase {
    Code?: RequiredAccountTypeCode;
    Name?: string;
}

export enum RequiredAccountTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IRiskCategoryEntity extends IEntityBase {
    Code?: RiskCategoryCode;
    MpsvCode?: string;
    Name?: string;
}

export enum RiskCategoryEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IRossumJobEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    FileMetadataId?: number;
    NumberOfPages?: number;
    RossumAnnotationId?: string;
    RossumDocumentId?: string;
    RossumStatusCode?: RossumJobStatusCode;
    BackgroundJob?: IBackgroundJobEntity;
    RossumStatus?: IRossumJobStatusEntity;
}

export enum RossumJobEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    FileMetadataId = "FileMetadataId",
    NumberOfPages = "NumberOfPages",
    RossumAnnotationId = "RossumAnnotationId",
    RossumDocumentId = "RossumDocumentId",
    RossumStatusCode = "RossumStatusCode",
    BackgroundJob = "BackgroundJob",
    RossumStatus = "RossumStatus",
}

export interface IRossumJobStatusEntity extends IEntityBase {
    Code?: RossumJobStatusCode;
    Name?: string;
}

export enum RossumJobStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface ISelectionEntity extends IEntityBase {
    Code?: SelectionCode;
    Name?: string;
}

export enum SelectionEntity {
    Code = "Code",
    Name = "Name",
}

export interface IServiceRelationshipTerminationReasonEntity extends IEntityBase {
    Code?: ServiceRelationshipTerminationReasonCode;
    MpsvCode?: string;
    Name?: string;
}

export enum ServiceRelationshipTerminationReasonEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IShiftPatternEntity extends IEntityBase {
    Code?: ShiftPatternCode;
    MpsvCode?: string;
    Name?: string;
}

export enum ShiftPatternEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface ISignatoryPersonEntity extends IEntityBase {
    Code?: SignatoryPersonCode;
    Name?: string;
}

export enum SignatoryPersonEntity {
    Code = "Code",
    Name = "Name",
}

export interface ISingleJournalEntryEntity extends IEntityBase {
    NotId?: number;
    Amount?: number;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    Description?: string;
    DocumentTypeCode?: DocumentTypeCode;
    IsBalancing?: boolean;
    IsClosing?: boolean;
    IsOpening?: boolean;
    JournalEntryId?: number;
    JournalEntryTypeCode?: JournalEntryTypeCode;
    TransactionAmount?: number;
    TransactionCurrencyCode?: CurrencyCode;
    Account?: IAccountEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
    DocumentType?: IDocumentTypeEntity;
    FiscalPeriod?: IFiscalPeriodEntity;
    FiscalYear?: IFiscalYearEntity;
    JournalEntryType?: IJournalEntryTypeEntity;
    PairAccount?: IAccountEntity;
    PaymentDocument?: IPaymentDocumentEntity;
    PaymentDocumentItem?: IPaymentDocumentItemEntity;
    TransactionCurrency?: ICurrencyEntity;
}

export enum SingleJournalEntryEntity {
    NotId = "NotId",
    Amount = "Amount",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    Description = "Description",
    DocumentTypeCode = "DocumentTypeCode",
    IsBalancing = "IsBalancing",
    IsClosing = "IsClosing",
    IsOpening = "IsOpening",
    JournalEntryId = "JournalEntryId",
    JournalEntryTypeCode = "JournalEntryTypeCode",
    TransactionAmount = "TransactionAmount",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    Account = "Account",
    Company = "Company",
    Currency = "Currency",
    Document = "Document",
    DocumentItem = "DocumentItem",
    DocumentType = "DocumentType",
    FiscalPeriod = "FiscalPeriod",
    FiscalYear = "FiscalYear",
    JournalEntryType = "JournalEntryType",
    PairAccount = "PairAccount",
    PaymentDocument = "PaymentDocument",
    PaymentDocumentItem = "PaymentDocumentItem",
    TransactionCurrency = "TransactionCurrency",
}

export interface ISpecificLegalFactTypeEntity extends IEntityBase {
    Code?: SpecificLegalFactTypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum SpecificLegalFactTypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface ISplitAccountAssignmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    Description?: string;
    IsDebitAccountVatDeductionForced?: boolean;
    TransactionAmount?: number;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
}

export enum SplitAccountAssignmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    Description = "Description",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    TransactionAmount = "TransactionAmount",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
}

export interface ISplitAccountAssignmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    IsDebitAccountVatDeductionForced?: boolean;
    Amount?: number;
    TransactionAmount?: number;
    ChartOfAccounts?: IChartOfAccountsEntity;
    CreditAccount?: IAccountEntity;
    DebitAccount?: IAccountEntity;
}

export enum SplitAccountAssignmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    IsDebitAccountVatDeductionForced = "IsDebitAccountVatDeductionForced",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    ChartOfAccounts = "ChartOfAccounts",
    CreditAccount = "CreditAccount",
    DebitAccount = "DebitAccount",
}

export interface IStatementEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    BankStatementTypeCode?: BankStatementTypeCode;
    DateFrom?: Date;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    Balance?: IStatementBalanceEntity;
    BankAccountBase?: IBusinessAccountBaseEntity;
    BankStatementType?: IBankStatementTypeEntity;
    NumberRange?: INumberRangeEntity;
    Attachments?: IStatementAttachmentEntity[];
    Locks?: IBankStatementLockEntity[];
    Chats?: IChatEntity[];
}

export enum StatementEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    BankStatementTypeCode = "BankStatementTypeCode",
    DateFrom = "DateFrom",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    Balance = "Balance",
    BankAccountBase = "BankAccountBase",
    BankStatementType = "BankStatementType",
    NumberRange = "NumberRange",
    Attachments = "Attachments",
    Locks = "Locks",
    Chats = "Chats",
}

export interface IStatementAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum StatementAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IStatementAttachmentDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum StatementAttachmentDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface IStatementBalanceEntity extends IEntityBase {
    Id?: number;
    CreditTransactionsCount?: number;
    CreditTurnover?: number;
    DebitTransactionsCount?: number;
    DebitTurnover?: number;
    TransactionCurrencyCode?: CurrencyCode;
    TransactionsCount?: number;
    TransactionsTurnover?: number;
    TransactionCurrency?: ICurrencyEntity;
}

export enum StatementBalanceEntity {
    Id = "Id",
    CreditTransactionsCount = "CreditTransactionsCount",
    CreditTurnover = "CreditTurnover",
    DebitTransactionsCount = "DebitTransactionsCount",
    DebitTurnover = "DebitTurnover",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    TransactionsCount = "TransactionsCount",
    TransactionsTurnover = "TransactionsTurnover",
    TransactionCurrency = "TransactionCurrency",
}

export interface IStatementDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateFrom?: Date;
    Note?: string;
    NumberOurs?: string;
    NumberTheirs?: string;
    StatementTypeCode?: BankStatementTypeCode;
    CreditTurnover?: number;
    DebitTurnover?: number;
    TransactionsTurnover?: number;
    CreditTransactionsCount?: number;
    DebitTransactionsCount?: number;
    TransactionsCount?: number;
    BankAccount?: ICompanyBankAccountEntity;
    LoanAccount?: ILoanAccountEntity;
    NumberRange?: INumberRangeEntity;
    StatementType?: IBankStatementTypeEntity;
    Attachments?: IStatementAttachmentDraftEntity[];
    Transactions?: IPaymentDocumentDraftEntity[];
}

export enum StatementDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateFrom = "DateFrom",
    Note = "Note",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    StatementTypeCode = "StatementTypeCode",
    CreditTurnover = "CreditTurnover",
    DebitTurnover = "DebitTurnover",
    TransactionsTurnover = "TransactionsTurnover",
    CreditTransactionsCount = "CreditTransactionsCount",
    DebitTransactionsCount = "DebitTransactionsCount",
    TransactionsCount = "TransactionsCount",
    BankAccount = "BankAccount",
    LoanAccount = "LoanAccount",
    NumberRange = "NumberRange",
    StatementType = "StatementType",
    Attachments = "Attachments",
    Transactions = "Transactions",
}

export interface ISubscriptionStatusEntity extends IEntityBase {
    Code?: SubscriptionStatusCode;
    Name?: string;
}

export enum SubscriptionStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface ISubscriptionTypeEntity extends IEntityBase {
    Code?: SubscriptionTypeCode;
    Name?: string;
}

export enum SubscriptionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ITaxApplicabilityEntity extends IEntityBase {
    Code?: TaxApplicabilityCode;
    Name?: string;
}

export enum TaxApplicabilityEntity {
    Code = "Code",
    Name = "Name",
}

export interface ITaxCalendarEntity extends IEntityBase {
    Id?: number;
    CountryCode?: CountryCode;
    Date?: Date;
    Description?: string;
    TaxTypeCode?: TaxCalendarTaxTypeCode;
    Country?: ICountryEntity;
    TaxType?: ITaxCalendarTaxTypeEntity;
}

export enum TaxCalendarEntity {
    Id = "Id",
    CountryCode = "CountryCode",
    Date = "Date",
    Description = "Description",
    TaxTypeCode = "TaxTypeCode",
    Country = "Country",
    TaxType = "TaxType",
}

export interface ITaxCalendarTaxTypeEntity extends IEntityBase {
    Code?: TaxCalendarTaxTypeCode;
    Name?: string;
}

export enum TaxCalendarTaxTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface ITaxDepreciationCategoryEntity extends IEntityBase {
    Code?: TaxDepreciationCategoryCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    ReportName?: string;
    YearsOfDepreciation?: number;
    Country?: ICountryEntity;
    DepreciationCoefficients?: ITaxDepreciationCoefficientEntity[];
}

export enum TaxDepreciationCategoryEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    ReportName = "ReportName",
    YearsOfDepreciation = "YearsOfDepreciation",
    Country = "Country",
    DepreciationCoefficients = "DepreciationCoefficients",
}

export interface ITaxDepreciationCoefficientEntity extends IEntityBase {
    Code?: string;
    CanBeImproved?: boolean;
    CanBeInterrupted?: boolean;
    DepreciationTypeCode?: DepreciationTypeCode;
    FirstYearRate?: number;
    IncreasedValueRate?: number;
    IsMonthly?: boolean;
    Name?: string;
    NextYearsRate?: number;
    TaxDepreciationCategoryCode?: TaxDepreciationCategoryCode;
    FirstYearValueIncrease?: number;
    DepreciationType?: IDepreciationTypeEntity;
    TaxDepreciationCategory?: ITaxDepreciationCategoryEntity;
}

export enum TaxDepreciationCoefficientEntity {
    Code = "Code",
    CanBeImproved = "CanBeImproved",
    CanBeInterrupted = "CanBeInterrupted",
    DepreciationTypeCode = "DepreciationTypeCode",
    FirstYearRate = "FirstYearRate",
    IncreasedValueRate = "IncreasedValueRate",
    IsMonthly = "IsMonthly",
    Name = "Name",
    NextYearsRate = "NextYearsRate",
    TaxDepreciationCategoryCode = "TaxDepreciationCategoryCode",
    FirstYearValueIncrease = "FirstYearValueIncrease",
    DepreciationType = "DepreciationType",
    TaxDepreciationCategory = "TaxDepreciationCategory",
}

export interface ITaxDepreciationPolicyEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccumulatedDepreciation?: number;
    CurrencyCode?: CurrencyCode;
    DateFirstDepreciation?: Date;
    DateLastDepreciation?: Date;
    DateRequestedLastDepreciation?: Date;
    Currency?: ICurrencyEntity;
    CoefficientCode?: string;
    ReductionRate?: number;
    TaxPriceLimitCode?: TaxPriceLimitCode;
    Coefficient?: ITaxDepreciationCoefficientEntity;
    TaxPriceLimit?: ITaxPriceLimitEntity;
    DepreciationSettings?: IDepreciationSettingEntity[];
    Items?: ITaxDepreciationPolicyItemEntity[];
}

export enum TaxDepreciationPolicyEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccumulatedDepreciation = "AccumulatedDepreciation",
    CurrencyCode = "CurrencyCode",
    DateFirstDepreciation = "DateFirstDepreciation",
    DateLastDepreciation = "DateLastDepreciation",
    DateRequestedLastDepreciation = "DateRequestedLastDepreciation",
    Currency = "Currency",
    CoefficientCode = "CoefficientCode",
    ReductionRate = "ReductionRate",
    TaxPriceLimitCode = "TaxPriceLimitCode",
    Coefficient = "Coefficient",
    TaxPriceLimit = "TaxPriceLimit",
    DepreciationSettings = "DepreciationSettings",
    Items = "Items",
}

export interface ITaxDepreciationPolicyItemEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccumulatedDepreciation?: number;
    CalculatedExpense?: number;
    CurrencyCode?: CurrencyCode;
    DateDepreciation?: Date;
    EndValue?: number;
    Order?: number;
    Currency?: ICurrencyEntity;
    AccumulatedDepreciationExpense?: number;
    AccumulatedLimitedDepreciation?: number;
    DateCalculatedFor?: Date;
    DepreciationExpense?: number;
    IsDisposedDepreciation?: boolean;
    IsForReportOnly?: boolean;
    IsWholeYear?: boolean;
    LimitedExpense?: number;
    ReductionRate?: number;
    TaxPriceLimitCode?: TaxPriceLimitCode;
    PartialExpense?: number;
    TaxPriceLimit?: ITaxPriceLimitEntity;
}

export enum TaxDepreciationPolicyItemEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccumulatedDepreciation = "AccumulatedDepreciation",
    CalculatedExpense = "CalculatedExpense",
    CurrencyCode = "CurrencyCode",
    DateDepreciation = "DateDepreciation",
    EndValue = "EndValue",
    Order = "Order",
    Currency = "Currency",
    AccumulatedDepreciationExpense = "AccumulatedDepreciationExpense",
    AccumulatedLimitedDepreciation = "AccumulatedLimitedDepreciation",
    DateCalculatedFor = "DateCalculatedFor",
    DepreciationExpense = "DepreciationExpense",
    IsDisposedDepreciation = "IsDisposedDepreciation",
    IsForReportOnly = "IsForReportOnly",
    IsWholeYear = "IsWholeYear",
    LimitedExpense = "LimitedExpense",
    ReductionRate = "ReductionRate",
    TaxPriceLimitCode = "TaxPriceLimitCode",
    PartialExpense = "PartialExpense",
    TaxPriceLimit = "TaxPriceLimit",
}

export interface ITaxPriceLimitEntity extends IEntityBase {
    Code?: TaxPriceLimitCode;
    AssetPrice?: number;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    ShortName?: string;
    TaxDepreciationCategoryCode?: TaxDepreciationCategoryCode;
    Country?: ICountryEntity;
    TaxDepreciationCategory?: ITaxDepreciationCategoryEntity;
}

export enum TaxPriceLimitEntity {
    Code = "Code",
    AssetPrice = "AssetPrice",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    ShortName = "ShortName",
    TaxDepreciationCategoryCode = "TaxDepreciationCategoryCode",
    Country = "Country",
    TaxDepreciationCategory = "TaxDepreciationCategory",
}

export interface ITaxStatementSignatoryPersonEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateOfBirth?: Date;
    FirstName?: string;
    LastName?: string;
    LegalNumber?: string;
    LegalPersonName?: string;
    PersonTypeCode?: TypeOfBusinessCode;
    RelationshipToTaxSubject?: string;
    SignatoryPersonCode?: SignatoryPersonCode;
    TaxAdvisorRegistrationNumber?: string;
    TaxStatementSubmitterCode?: TaxStatementSubmitterCode;
    PersonType?: ITypeOfBusinessEntity;
    SignatoryPerson?: ISignatoryPersonEntity;
    TaxStatementSubmitter?: ITaxStatementSubmitterEntity;
}

export enum TaxStatementSignatoryPersonEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateOfBirth = "DateOfBirth",
    FirstName = "FirstName",
    LastName = "LastName",
    LegalNumber = "LegalNumber",
    LegalPersonName = "LegalPersonName",
    PersonTypeCode = "PersonTypeCode",
    RelationshipToTaxSubject = "RelationshipToTaxSubject",
    SignatoryPersonCode = "SignatoryPersonCode",
    TaxAdvisorRegistrationNumber = "TaxAdvisorRegistrationNumber",
    TaxStatementSubmitterCode = "TaxStatementSubmitterCode",
    PersonType = "PersonType",
    SignatoryPerson = "SignatoryPerson",
    TaxStatementSubmitter = "TaxStatementSubmitter",
}

export interface ITaxStatementSubmitterEntity extends IEntityBase {
    Code?: TaxStatementSubmitterCode;
    Name?: string;
}

export enum TaxStatementSubmitterEntity {
    Code = "Code",
    Name = "Name",
}

export interface ITaxStatementXmlAttachmentEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Description?: string;
    File?: IFileMetadataEntity;
}

export enum TaxStatementXmlAttachmentEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Description = "Description",
    File = "File",
}

export interface ITemporalEntityEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    DateValidFrom?: Date;
    DateValidTo?: Date;
}

export enum TemporalEntityEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
}

export interface ITimeFormatEntity extends IEntityBase {
    Code?: TimeFormatCode;
    Format?: string;
    Name?: string;
}

export enum TimeFormatEntity {
    Code = "Code",
    Format = "Format",
    Name = "Name",
}

export interface ITimeZoneEntity extends IEntityBase {
    Code?: TimeZoneCode;
    Name?: string;
}

export enum TimeZoneEntity {
    Code = "Code",
    Name = "Name",
}

export interface ITransactionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Amount?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    ExchangeRatePerUnit?: number;
    InboxSenderEmail?: string;
    IsUnrelatedToBusiness?: boolean;
    Note?: string;
    NumberOurs?: string;
    PaymentStatusCode?: PaymentStatusCode;
    PostedStatusCode?: PostedStatusCode;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionCurrencyCode?: CurrencyCode;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    Currency?: ICurrencyEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    NumberRange?: INumberRangeEntity;
    PaymentDocumentDraft?: IPaymentDocumentDraftEntity;
    PaymentStatus?: IPaymentStatusEntity;
    PostedStatus?: IPostedStatusEntity;
    TransactionCurrency?: ICurrencyEntity;
    Attachments?: IPaymentDocumentAttachmentEntity[];
    DocumentLinks?: IDocumentLinkEntity[];
    Items?: IPaymentDocumentItemEntity[];
    Labels?: IPaymentDocumentLabelEntity[];
    Locks?: IPaymentDocumentLockEntity[];
    Chats?: IChatEntity[];
    BankTransactionTypeCode?: BankTransactionTypeCode;
    DateBankTransaction?: Date;
    Order?: number;
    RemittanceInformation?: string;
    PaymentInformation?: string;
    SymbolVariable?: string;
    SymbolSpecific?: string;
    SymbolConstant?: string;
    BankTransactionType?: IBankTransactionTypeEntity;
}

export enum TransactionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Amount = "Amount",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    ExchangeRatePerUnit = "ExchangeRatePerUnit",
    InboxSenderEmail = "InboxSenderEmail",
    IsUnrelatedToBusiness = "IsUnrelatedToBusiness",
    Note = "Note",
    NumberOurs = "NumberOurs",
    PaymentStatusCode = "PaymentStatusCode",
    PostedStatusCode = "PostedStatusCode",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    Currency = "Currency",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    NumberRange = "NumberRange",
    PaymentDocumentDraft = "PaymentDocumentDraft",
    PaymentStatus = "PaymentStatus",
    PostedStatus = "PostedStatus",
    TransactionCurrency = "TransactionCurrency",
    Attachments = "Attachments",
    DocumentLinks = "DocumentLinks",
    Items = "Items",
    Labels = "Labels",
    Locks = "Locks",
    Chats = "Chats",
    BankTransactionTypeCode = "BankTransactionTypeCode",
    DateBankTransaction = "DateBankTransaction",
    Order = "Order",
    RemittanceInformation = "RemittanceInformation",
    PaymentInformation = "PaymentInformation",
    SymbolVariable = "SymbolVariable",
    SymbolSpecific = "SymbolSpecific",
    SymbolConstant = "SymbolConstant",
    BankTransactionType = "BankTransactionType",
}

export interface IPropertyTranslationEntity extends IEntityBase {
    Language?: string;
    Namespace?: string;
    EntityType?: string;
    Property?: string;
    Translation?: string;
}

export enum PropertyTranslationEntity {
    Language = "Language",
    Namespace = "Namespace",
    EntityType = "EntityType",
    Property = "Property",
    Translation = "Translation",
}

export interface ITrustedSenderEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Email?: string;
}

export enum TrustedSenderEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Email = "Email",
}

export interface ITypeOfBusinessEntity extends IEntityBase {
    Code?: TypeOfBusinessCode;
    Name?: string;
}

export enum TypeOfBusinessEntity {
    Code = "Code",
    Name = "Name",
}

export interface IUndirectedDocumentLinkEntity extends IEntityBase {
    Id?: number;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaPayment?: Date;
    PairedDocumentIsTaxDocument?: boolean;
    TransactionCurrencyCode?: CurrencyCode;
    TypeCode?: DocumentLinkTypeCode;
    Amount?: number;
    TransactionAmount?: number;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    PairedDocument?: IDocumentEntity;
    TransactionCurrency?: ICurrencyEntity;
    Type?: IDocumentLinkTypeEntity;
}

export enum UndirectedDocumentLinkEntity {
    Id = "Id",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaPayment = "DateCbaPayment",
    PairedDocumentIsTaxDocument = "PairedDocumentIsTaxDocument",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    TypeCode = "TypeCode",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    Currency = "Currency",
    Document = "Document",
    PairedDocument = "PairedDocument",
    TransactionCurrency = "TransactionCurrency",
    Type = "Type",
}

export interface IUndirectedPaymentDocumentLinkEntity extends IEntityBase {
    Id?: number;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateCbaPayment?: Date;
    PairedDocumentIsTaxDocument?: boolean;
    TransactionCurrencyCode?: CurrencyCode;
    TypeCode?: DocumentLinkTypeCode;
    Amount?: number;
    TransactionAmount?: number;
    Currency?: ICurrencyEntity;
    Document?: IPaymentDocumentEntity;
    PairedDocument?: IDocumentEntity;
    TransactionCurrency?: ICurrencyEntity;
    Type?: IDocumentLinkTypeEntity;
}

export enum UndirectedPaymentDocumentLinkEntity {
    Id = "Id",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateCbaPayment = "DateCbaPayment",
    PairedDocumentIsTaxDocument = "PairedDocumentIsTaxDocument",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    TypeCode = "TypeCode",
    Amount = "Amount",
    TransactionAmount = "TransactionAmount",
    Currency = "Currency",
    Document = "Document",
    PairedDocument = "PairedDocument",
    TransactionCurrency = "TransactionCurrency",
    Type = "Type",
}

export interface IUnitOfMeasureEntity extends IEntityBase {
    Code?: UnitOfMeasureCode;
    Name?: string;
    ShortName?: string;
}

export enum UnitOfMeasureEntity {
    Code = "Code",
    Name = "Name",
    ShortName = "ShortName",
}

export interface IUnorganizedAssetEntity extends IEntityBase {
    Id?: number;
    Amount?: number;
    AssetTypeCode?: AssetTypeCode;
    CurrencyCode?: CurrencyCode;
    EntryDate?: Date;
    AssetType?: IAssetTypeEntity;
    Currency?: ICurrencyEntity;
    Document?: IDocumentEntity;
    DocumentItem?: IDocumentItemEntity;
    Labels?: IItemLabelEntity[];
}

export enum UnorganizedAssetEntity {
    Id = "Id",
    Amount = "Amount",
    AssetTypeCode = "AssetTypeCode",
    CurrencyCode = "CurrencyCode",
    EntryDate = "EntryDate",
    AssetType = "AssetType",
    Currency = "Currency",
    Document = "Document",
    DocumentItem = "DocumentItem",
    Labels = "Labels",
}

export interface IUserEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    ColourThemeCode?: ColourThemeCode;
    CustomerSupportPin?: string;
    DateFormatCode?: DateFormatCode;
    Email?: string;
    EvalaZoomCode?: EvalaZoomCode;
    FirstName?: string;
    LanguageCode?: LanguageCode;
    LastName?: string;
    Name?: string;
    PhoneNumber?: string;
    StatusCode?: UserStatusCode;
    TimeFormatCode?: TimeFormatCode;
    TimeZoneCode?: TimeZoneCode;
    CustomerSupportGuid?: string;
    CompanyRoles?: IUserCompanyRoleEntity[];
    ColourTheme?: IColourThemeEntity;
    DateFormat?: IDateFormatEntity;
    EvalaZoom?: IEvalaZoomEntity;
    GeneralRole?: IGeneralRoleEntity;
    Language?: ILanguageEntity;
    NotificationSetting?: INotificationSettingEntity;
    Status?: IUserStatusEntity;
    TimeFormat?: ITimeFormatEntity;
    TimeZone?: ITimeZoneEntity;
}

export enum UserEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    ColourThemeCode = "ColourThemeCode",
    CustomerSupportPin = "CustomerSupportPin",
    DateFormatCode = "DateFormatCode",
    Email = "Email",
    EvalaZoomCode = "EvalaZoomCode",
    FirstName = "FirstName",
    LanguageCode = "LanguageCode",
    LastName = "LastName",
    Name = "Name",
    PhoneNumber = "PhoneNumber",
    StatusCode = "StatusCode",
    TimeFormatCode = "TimeFormatCode",
    TimeZoneCode = "TimeZoneCode",
    CustomerSupportGuid = "CustomerSupportGuid",
    CompanyRoles = "CompanyRoles",
    ColourTheme = "ColourTheme",
    DateFormat = "DateFormat",
    EvalaZoom = "EvalaZoom",
    GeneralRole = "GeneralRole",
    Language = "Language",
    NotificationSetting = "NotificationSetting",
    Status = "Status",
    TimeFormat = "TimeFormat",
    TimeZone = "TimeZone",
}

export interface IUserCompanyRoleEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    Company?: ICompanyEntity;
    CompanyRole?: ICompanyRoleEntity;
}

export enum UserCompanyRoleEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    Company = "Company",
    CompanyRole = "CompanyRole",
}

export interface IUserNotificationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    IsRead?: boolean;
    Notification?: INotificationEntity;
    User?: IUserEntity;
}

export enum UserNotificationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    IsRead = "IsRead",
    Notification = "Notification",
    User = "User",
}

export interface IUserStatusEntity extends IEntityBase {
    Code?: UserStatusCode;
    Name?: string;
}

export enum UserStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVariantEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    AccessTypeCode?: VariantAccessTypeCode;
    AccountingCode?: AccountingCode;
    DefaultValues?: string;
    EntityTypeCode?: string;
    Name?: string;
    VariantData?: string;
    VariantTypeCode?: VariantTypeCode;
    VatStatusCode?: VatStatusCode;
    ViewId?: string;
    AccessType?: IVariantAccessTypeEntity;
    Accounting?: IAccountingEntity;
    EntityType?: IEntityTypeEntity;
    Owner?: IUserEntity;
    VariantType?: IVariantTypeEntity;
    VatStatus?: IVatStatusEntity;
}

export enum VariantEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    AccessTypeCode = "AccessTypeCode",
    AccountingCode = "AccountingCode",
    DefaultValues = "DefaultValues",
    EntityTypeCode = "EntityTypeCode",
    Name = "Name",
    VariantData = "VariantData",
    VariantTypeCode = "VariantTypeCode",
    VatStatusCode = "VatStatusCode",
    ViewId = "ViewId",
    AccessType = "AccessType",
    Accounting = "Accounting",
    EntityType = "EntityType",
    Owner = "Owner",
    VariantType = "VariantType",
    VatStatus = "VatStatus",
}

export interface IVariantAccessTypeEntity extends IEntityBase {
    Code?: VariantAccessTypeCode;
    Name?: string;
}

export enum VariantAccessTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVariantTypeEntity extends IEntityBase {
    Code?: VariantTypeCode;
    Name?: string;
}

export enum VariantTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatEntity extends IEntityBase {
    Code?: VatCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Rate?: number;
    RateName?: string;
    VatRateTypeCode?: VatRateTypeCode;
    Country?: ICountryEntity;
    VatRateType?: IVatRateTypeEntity;
}

export enum VatEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Rate = "Rate",
    RateName = "RateName",
    VatRateTypeCode = "VatRateTypeCode",
    Country = "Country",
    VatRateType = "VatRateType",
}

export interface IVatCanceledStatusEntity extends IEntityBase {
    Code?: VatCanceledStatusCode;
    Name?: string;
}

export enum VatCanceledStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatClassificationEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    CountryClassificationCode?: CountryClassificationCode;
    IsInAutomatedVatInclusionMode?: boolean;
    IsVatRegistered?: boolean;
    Name?: string;
    NonTaxAccountName?: string;
    NonTaxAccountNumber?: string;
    Note?: string;
    PayableReceivableTypeCode?: PayableReceivableTypeCode;
    VatControlStatementSectionCode?: VatControlStatementSectionCode;
    VatDeductionTypeCode?: VatDeductionTypeCode;
    VatOssCode?: VatOssCode;
    VatReverseChargeCode?: VatReverseChargeCode;
    VatStatementSectionCode?: VatStatementSectionCode;
    VatViesCode?: VatViesCode;
    VatProportionalDeduction?: number;
    CountryClassification?: ICountryClassificationEntity;
    PayableReceivableType?: IPayableReceivableTypeEntity;
    VatControlStatementSection?: IVatControlStatementSectionEntity;
    VatDeductionType?: IVatDeductionTypeEntity;
    VatOss?: IVatOssEntity;
    VatReverseCharge?: IVatReverseChargeEntity;
    VatStatementSection?: IVatStatementSectionEntity;
    VatVies?: IVatViesEntity;
}

export enum VatClassificationEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    CountryClassificationCode = "CountryClassificationCode",
    IsInAutomatedVatInclusionMode = "IsInAutomatedVatInclusionMode",
    IsVatRegistered = "IsVatRegistered",
    Name = "Name",
    NonTaxAccountName = "NonTaxAccountName",
    NonTaxAccountNumber = "NonTaxAccountNumber",
    Note = "Note",
    PayableReceivableTypeCode = "PayableReceivableTypeCode",
    VatControlStatementSectionCode = "VatControlStatementSectionCode",
    VatDeductionTypeCode = "VatDeductionTypeCode",
    VatOssCode = "VatOssCode",
    VatReverseChargeCode = "VatReverseChargeCode",
    VatStatementSectionCode = "VatStatementSectionCode",
    VatViesCode = "VatViesCode",
    VatProportionalDeduction = "VatProportionalDeduction",
    CountryClassification = "CountryClassification",
    PayableReceivableType = "PayableReceivableType",
    VatControlStatementSection = "VatControlStatementSection",
    VatDeductionType = "VatDeductionType",
    VatOss = "VatOss",
    VatReverseCharge = "VatReverseCharge",
    VatStatementSection = "VatStatementSection",
    VatVies = "VatVies",
}

export interface IVatClassificationSelectionEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
}

export enum VatClassificationSelectionEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
}

export interface IVatClassificationSelectionDraftEntity extends IEntityBase {
    Id?: number;
    DateCreated?: Date;
    DateLastModified?: Date;
    TemporaryGuid?: string;
    CreatedBy?: IUserEntity;
    LastModifiedBy?: IUserEntity;
    SelectionCode?: SelectionCode;
    Selection?: ISelectionEntity;
}

export enum VatClassificationSelectionDraftEntity {
    Id = "Id",
    DateCreated = "DateCreated",
    DateLastModified = "DateLastModified",
    TemporaryGuid = "TemporaryGuid",
    CreatedBy = "CreatedBy",
    LastModifiedBy = "LastModifiedBy",
    SelectionCode = "SelectionCode",
    Selection = "Selection",
}

export interface IVatControlStatementEntity extends IEntityBase {
    Code?: VatControlStatementCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum VatControlStatementEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IVatControlStatementSectionEntity extends IEntityBase {
    Code?: VatControlStatementSectionCode;
    Description?: string;
    Name?: string;
    PayableReceivableTypeCode?: PayableReceivableTypeCode;
    SecondaryStatementSection?: string;
    StatementSection?: string;
    VatControlStatementCode?: VatControlStatementCode;
    PayableReceivableType?: IPayableReceivableTypeEntity;
    VatControlStatement?: IVatControlStatementEntity;
}

export enum VatControlStatementSectionEntity {
    Code = "Code",
    Description = "Description",
    Name = "Name",
    PayableReceivableTypeCode = "PayableReceivableTypeCode",
    SecondaryStatementSection = "SecondaryStatementSection",
    StatementSection = "StatementSection",
    VatControlStatementCode = "VatControlStatementCode",
    PayableReceivableType = "PayableReceivableType",
    VatControlStatement = "VatControlStatement",
}

export interface IVatDeductionTypeEntity extends IEntityBase {
    Code?: VatDeductionTypeCode;
    Name?: string;
}

export enum VatDeductionTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatOssEntity extends IEntityBase {
    Code?: VatOssCode;
    Name?: string;
}

export enum VatOssEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatPayerRegistrationActionEntity extends IEntityBase {
    Code?: VatPayerRegistrationActionCode;
    Name?: string;
}

export enum VatPayerRegistrationActionEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatPayerRegistrationLimitEntity extends IEntityBase {
    Code?: VatPayerRegistrationLimitCode;
    ActionCode?: VatPayerRegistrationActionCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Limit?: number;
    Name?: string;
    Action?: IVatPayerRegistrationActionEntity;
    Country?: ICountryEntity;
}

export enum VatPayerRegistrationLimitEntity {
    Code = "Code",
    ActionCode = "ActionCode",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Limit = "Limit",
    Name = "Name",
    Action = "Action",
    Country = "Country",
}

export interface IVatRateTypeEntity extends IEntityBase {
    Code?: VatRateTypeCode;
    Name?: string;
}

export enum VatRateTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatReverseChargeEntity extends IEntityBase {
    Code?: VatReverseChargeCode;
    Name?: string;
}

export enum VatReverseChargeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatStatementEntity extends IEntityBase {
    Code?: VatStatementCode;
    CountryCode?: CountryCode;
    DateValidFrom?: Date;
    DateValidTo?: Date;
    Name?: string;
    Country?: ICountryEntity;
}

export enum VatStatementEntity {
    Code = "Code",
    CountryCode = "CountryCode",
    DateValidFrom = "DateValidFrom",
    DateValidTo = "DateValidTo",
    Name = "Name",
    Country = "Country",
}

export interface IVatStatementDocumentEntity extends IEntityBase {
    Id?: number;
    Amount?: number;
    AmountNet?: number;
    AmountVat?: number;
    ClearedStatusCode?: ClearedStatusCode;
    CurrencyCode?: CurrencyCode;
    DateAccountingTransaction?: Date;
    DateClearing?: Date;
    DateCreated?: Date;
    DateDocumentVatStatement?: Date;
    DateDue?: Date;
    DateIssued?: Date;
    DateVatCancellation?: Date;
    DateVatReapplication?: Date;
    DocumentStatusCode?: DocumentStatusCode;
    DocumentTypeCode?: DocumentTypeCode;
    DocumentVatStatementStatusCode?: string;
    IsInAutomatedVatInclusionMode?: boolean;
    NumberOurs?: string;
    NumberTheirs?: string;
    PostedStatusCode?: string;
    TransactionAmount?: number;
    TransactionAmountDue?: number;
    TransactionAmountVat?: number;
    TransactionCurrencyCode?: CurrencyCode;
    VatCanceledStatusCode?: VatCanceledStatusCode;
    VatControlStatementStatusCode?: DocumentStatusCode;
    VatOssStatementStatusCode?: DocumentStatusCode;
    VatReverseChargeCode?: string;
    VatStatementStatusCode?: DocumentStatusCode;
    VatViesStatementStatusCode?: DocumentStatusCode;
    VatCancellationAmount?: number;
    BusinessPartner?: IDocumentBusinessPartnerEntity;
    ClearedStatus?: IClearedStatusEntity;
    Company?: ICompanyEntity;
    CreatedBy?: IUserEntity;
    Currency?: ICurrencyEntity;
    DocumentStatus?: IDocumentStatusEntity;
    DocumentType?: IDocumentTypeEntity;
    TransactionCurrency?: ICurrencyEntity;
    VatCanceledStatus?: IVatCanceledStatusEntity;
    VatControlStatementStatus?: IDocumentStatusEntity;
    VatOssStatementStatus?: IDocumentStatusEntity;
    VatStatementStatus?: IDocumentStatusEntity;
    VatViesStatementStatus?: IDocumentStatusEntity;
}

export enum VatStatementDocumentEntity {
    Id = "Id",
    Amount = "Amount",
    AmountNet = "AmountNet",
    AmountVat = "AmountVat",
    ClearedStatusCode = "ClearedStatusCode",
    CurrencyCode = "CurrencyCode",
    DateAccountingTransaction = "DateAccountingTransaction",
    DateClearing = "DateClearing",
    DateCreated = "DateCreated",
    DateDocumentVatStatement = "DateDocumentVatStatement",
    DateDue = "DateDue",
    DateIssued = "DateIssued",
    DateVatCancellation = "DateVatCancellation",
    DateVatReapplication = "DateVatReapplication",
    DocumentStatusCode = "DocumentStatusCode",
    DocumentTypeCode = "DocumentTypeCode",
    DocumentVatStatementStatusCode = "DocumentVatStatementStatusCode",
    IsInAutomatedVatInclusionMode = "IsInAutomatedVatInclusionMode",
    NumberOurs = "NumberOurs",
    NumberTheirs = "NumberTheirs",
    PostedStatusCode = "PostedStatusCode",
    TransactionAmount = "TransactionAmount",
    TransactionAmountDue = "TransactionAmountDue",
    TransactionAmountVat = "TransactionAmountVat",
    TransactionCurrencyCode = "TransactionCurrencyCode",
    VatCanceledStatusCode = "VatCanceledStatusCode",
    VatControlStatementStatusCode = "VatControlStatementStatusCode",
    VatOssStatementStatusCode = "VatOssStatementStatusCode",
    VatReverseChargeCode = "VatReverseChargeCode",
    VatStatementStatusCode = "VatStatementStatusCode",
    VatViesStatementStatusCode = "VatViesStatementStatusCode",
    VatCancellationAmount = "VatCancellationAmount",
    BusinessPartner = "BusinessPartner",
    ClearedStatus = "ClearedStatus",
    Company = "Company",
    CreatedBy = "CreatedBy",
    Currency = "Currency",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    TransactionCurrency = "TransactionCurrency",
    VatCanceledStatus = "VatCanceledStatus",
    VatControlStatementStatus = "VatControlStatementStatus",
    VatOssStatementStatus = "VatOssStatementStatus",
    VatStatementStatus = "VatStatementStatus",
    VatViesStatementStatus = "VatViesStatementStatus",
}

export interface IVatStatementFrequencyEntity extends IEntityBase {
    Code?: VatStatementFrequencyCode;
    Name?: string;
}

export enum VatStatementFrequencyEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatStatementSectionEntity extends IEntityBase {
    Code?: VatStatementSectionCode;
    Description?: string;
    Name?: string;
    VatStatementCode?: VatStatementCode;
    VatStatementSectionCategoryCode?: VatStatementSectionCategoryCode;
    StandardVatRateRow?: number;
    ReducedVatRateRow?: number;
    AdditionalStandardVatRateRow?: number;
    AdditionalReducedVatRateRow?: number;
    VatStatement?: IVatStatementEntity;
    VatStatementSectionCategory?: IVatStatementSectionCategoryEntity;
}

export enum VatStatementSectionEntity {
    Code = "Code",
    Description = "Description",
    Name = "Name",
    VatStatementCode = "VatStatementCode",
    VatStatementSectionCategoryCode = "VatStatementSectionCategoryCode",
    StandardVatRateRow = "StandardVatRateRow",
    ReducedVatRateRow = "ReducedVatRateRow",
    AdditionalStandardVatRateRow = "AdditionalStandardVatRateRow",
    AdditionalReducedVatRateRow = "AdditionalReducedVatRateRow",
    VatStatement = "VatStatement",
    VatStatementSectionCategory = "VatStatementSectionCategory",
}

export interface IVatStatementSectionCategoryEntity extends IEntityBase {
    Code?: VatStatementSectionCategoryCode;
    Name?: string;
}

export enum VatStatementSectionCategoryEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatStatementStatusEntity extends IEntityBase {
    Code?: VatStatementStatusCode;
    Name?: string;
}

export enum VatStatementStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatStatusEntity extends IEntityBase {
    Code?: VatStatusCode;
    Name?: string;
}

export enum VatStatusEntity {
    Code = "Code",
    Name = "Name",
}

export interface IVatViesEntity extends IEntityBase {
    Code?: VatViesCode;
    Description?: string;
    Name?: string;
}

export enum VatViesEntity {
    Code = "Code",
    Description = "Description",
    Name = "Name",
}

export interface IWebSocketMessageTypeEntity extends IEntityBase {
    Code?: WebSocketMessageTypeCode;
    Name?: string;
}

export enum WebSocketMessageTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IWorkplaceTypeEntity extends IEntityBase {
    Code?: WorkplaceTypeCode;
    MpsvCode?: string;
    Name?: string;
}

export enum WorkplaceTypeEntity {
    Code = "Code",
    MpsvCode = "MpsvCode",
    Name = "Name",
}

export interface IWriteOffTypeEntity extends IEntityBase {
    Code?: WriteOffTypeCode;
    Name?: string;
}

export enum WriteOffTypeEntity {
    Code = "Code",
    Name = "Name",
}

export interface IYesNoEntity extends IEntityBase {
    Code?: YesNoCode;
    Name?: string;
}

export enum YesNoEntity {
    Code = "Code",
    Name = "Name",
}

export enum EntityTypeName {
    BackgroundJobsParametersBankTransactionsPostMultipleLabelParameter = "BankTransactionsPostMultipleLabelParameter",
    BackgroundJobsParametersSourcedDate = "SourcedDate",
    BusinessLogicExportedFileDto = "ExportedFileDto",
    CentralBillingAddress = "BillingAddress",
    CentralBillingContact = "BillingContact",
    CentralBillingDiscount = "BillingDiscount",
    CentralDatabase = "Database",
    CentralEnabledFeature = "EnabledFeature",
    CentralInvitation = "Invitation",
    CentralInvoice = "Invoice",
    CentralInvoiceItem = "InvoiceItem",
    CentralSubscription = "Subscription",
    CentralTenant = "Tenant",
    Account = "Account",
    AccountActivityType = "AccountActivityType",
    AccountAssignment = "AccountAssignment",
    AccountAssignmentCompany = "AccountAssignmentCompany",
    AccountAssignmentDocumentType = "AccountAssignmentDocumentType",
    AccountAssignmentDocumentTypeTemplate = "AccountAssignmentDocumentTypeTemplate",
    AccountAssignmentSelection = "AccountAssignmentSelection",
    AccountAssignmentSelectionDraft = "AccountAssignmentSelectionDraft",
    AccountAssignmentTemplate = "AccountAssignmentTemplate",
    AccountCategory = "AccountCategory",
    AccountRole = "AccountRole",
    AccountTemplate = "AccountTemplate",
    AccountType = "AccountType",
    Accounting = "Accounting",
    AccountingDepreciationPolicy = "AccountingDepreciationPolicy",
    AccountingDepreciationPolicyItem = "AccountingDepreciationPolicyItem",
    AccruedProcessingType = "AccruedProcessingType",
    ActionLog = "ActionLog",
    ActionType = "ActionType",
    ActiveEmploymentPolicyTool = "ActiveEmploymentPolicyTool",
    Address = "Address",
    ApprovalStatusType = "ApprovalStatusType",
    Asset = "Asset",
    AssetAttachment = "AssetAttachment",
    AssetDisposalType = "AssetDisposalType",
    AssetItem = "AssetItem",
    AssetItemType = "AssetItemType",
    AssetLabel = "AssetLabel",
    AssetStatus = "AssetStatus",
    AssetType = "AssetType",
    AssetValue = "AssetValue",
    BackgroundJob = "BackgroundJob",
    BackgroundJobStatus = "BackgroundJobStatus",
    BackgroundJobType = "BackgroundJobType",
    BalanceSheetLayout = "BalanceSheetLayout",
    BalanceSheetLayoutTemplate = "BalanceSheetLayoutTemplate",
    Bank = "Bank",
    BankAccount = "BankAccount",
    BankAccountBalance = "BankAccountBalance",
    BankAccountNumberFormatType = "BankAccountNumberFormatType",
    BankAccountRegistrationStatus = "BankAccountRegistrationStatus",
    BankApiConnectionSetting = "BankApiConnectionSetting",
    BankApiStatementImportFrequency = "BankApiStatementImportFrequency",
    BankApiStatementImportRange = "BankApiStatementImportRange",
    BankApiStatementImportSetting = "BankApiStatementImportSetting",
    BankExchangeRateFreshness = "BankExchangeRateFreshness",
    BankPaymentOrderState = "BankPaymentOrderState",
    BankStatement = "BankStatement",
    BankStatementCsvSettingsText = "BankStatementCsvSettingsText",
    BankStatementLock = "BankStatementLock",
    BankStatementType = "BankStatementType",
    BankTransaction = "BankTransaction",
    BankTransactionBankAccount = "BankTransactionBankAccount",
    BankTransactionBankAccountDraft = "BankTransactionBankAccountDraft",
    BankTransactionBusinessPartner = "BankTransactionBusinessPartner",
    BankTransactionBusinessPartnerDraft = "BankTransactionBusinessPartnerDraft",
    BankTransactionCsvColumnMapping = "BankTransactionCsvColumnMapping",
    BankTransactionDocumentNumberLocation = "BankTransactionDocumentNumberLocation",
    BankTransactionDuplicate = "BankTransactionDuplicate",
    BankTransactionType = "BankTransactionType",
    BillingEvent = "BillingEvent",
    BillingItemType = "BillingItemType",
    BillingModuleType = "BillingModuleType",
    BillingPricing = "BillingPricing",
    Bookkeeping = "Bookkeeping",
    BusinessAccountBase = "BusinessAccountBase",
    BusinessPartner = "BusinessPartner",
    BusinessPartnerAttachment = "BusinessPartnerAttachment",
    BusinessPartnerBankAccount = "BusinessPartnerBankAccount",
    BusinessPartnerBankAccountView = "BusinessPartnerBankAccountView",
    BusinessPartnerBillingAddress = "BusinessPartnerBillingAddress",
    BusinessPartnerContact = "BusinessPartnerContact",
    BusinessPartnerCorrespondenceAddress = "BusinessPartnerCorrespondenceAddress",
    BusinessPartnerDocumentDefault = "BusinessPartnerDocumentDefault",
    BusinessPartnerDocumentDefaultType = "BusinessPartnerDocumentDefaultType",
    BusinessPartnerIssuedDocumentDefault = "BusinessPartnerIssuedDocumentDefault",
    BusinessPartnerReceivedDocumentDefault = "BusinessPartnerReceivedDocumentDefault",
    CBATransactionType = "CBATransactionType",
    CSSZBankType = "CSSZBankType",
    CSSZSubmissionType = "CSSZSubmissionType",
    CSSZTransactionStatus = "CSSZTransactionStatus",
    CashBox = "CashBox",
    CashBoxBalance = "CashBoxBalance",
    CashReceipt = "CashReceipt",
    CashReceiptIssued = "CashReceiptIssued",
    CashReceiptReceived = "CashReceiptReceived",
    CbaAssetDisposalType = "CbaAssetDisposalType",
    CbaCategory = "CbaCategory",
    CbaCategoryTaxImpact = "CbaCategoryTaxImpact",
    CbaEntry = "CbaEntry",
    CbaEntryLabel = "CbaEntryLabel",
    CbaEntryLedgerDocumentType = "CbaEntryLedgerDocumentType",
    CbaEntrySpecialVatCalculation = "CbaEntrySpecialVatCalculation",
    CbaEntryType = "CbaEntryType",
    ChartOfAccounts = "ChartOfAccounts",
    ChartOfAccountsTemplate = "ChartOfAccountsTemplate",
    ChartedAccountAssignment = "ChartedAccountAssignment",
    Chat = "Chat",
    ChatMessage = "ChatMessage",
    ChatMessageAttachment = "ChatMessageAttachment",
    ChatParticipant = "ChatParticipant",
    ChatParticipantRecipient = "ChatParticipantRecipient",
    ChatParticipantSender = "ChatParticipantSender",
    ChatParticipantType = "ChatParticipantType",
    ClearedStatus = "ClearedStatus",
    ClearingDocumentLink = "ClearingDocumentLink",
    CollectiveAgreementType = "CollectiveAgreementType",
    ColourTheme = "ColourTheme",
    CommunicationEntry = "CommunicationEntry",
    CommunicationEntryAttachment = "CommunicationEntryAttachment",
    CommunicationEntryChannel = "CommunicationEntryChannel",
    CommunicationEntryState = "CommunicationEntryState",
    CommunicationEntryType = "CommunicationEntryType",
    Company = "Company",
    CompanyBankAccount = "CompanyBankAccount",
    CompanyBankAccountType = "CompanyBankAccountType",
    CompanyCommunicationAddress = "CompanyCommunicationAddress",
    CompanyCommunicationContact = "CompanyCommunicationContact",
    CompanyFixedExchangeRate = "CompanyFixedExchangeRate",
    CompanyLegalAddress = "CompanyLegalAddress",
    CompanyModule = "CompanyModule",
    CompanyPermission = "CompanyPermission",
    CompanyRole = "CompanyRole",
    CompanyRolePermission = "CompanyRolePermission",
    CompanyRoleType = "CompanyRoleType",
    CompanySetting = "CompanySetting",
    CompanyState = "CompanyState",
    CompanyVatReducedCoefficient = "CompanyVatReducedCoefficient",
    CompanyVatStatusTemporal = "CompanyVatStatusTemporal",
    CompanyVatStatusTemporalCurrent = "CompanyVatStatusTemporalCurrent",
    CompoundJournalEntry = "CompoundJournalEntry",
    Contact = "Contact",
    CorrectiveInvoiceIssued = "CorrectiveInvoiceIssued",
    CorrectiveInvoiceReceived = "CorrectiveInvoiceReceived",
    Country = "Country",
    CountryClassification = "CountryClassification",
    CountryOrUnion = "CountryOrUnion",
    CountryRegion = "CountryRegion",
    CsszEmploymentType = "CsszEmploymentType",
    Currency = "Currency",
    CurrencyUsedByCompany = "CurrencyUsedByCompany",
    CurrencyWithExchangeRateInfo = "CurrencyWithExchangeRateInfo",
    CustomerPortalPayment = "CustomerPortalPayment",
    CzIsce = "CzIsce",
    CzIsco = "CzIsco",
    CzNace = "CzNace",
    DashboardTask = "DashboardTask",
    DataBox = "DataBox",
    DateFormat = "DateFormat",
    DatesInterval = "DatesInterval",
    DayOfWeek = "DayOfWeek",
    DefaultVariant = "DefaultVariant",
    DeferredDocument = "DeferredDocument",
    DeferredPlan = "DeferredPlan",
    DeferredPlanDocument = "DeferredPlanDocument",
    DeferredPlanDocumentItem = "DeferredPlanDocumentItem",
    DeferredPlanOriginalDocumentItem = "DeferredPlanOriginalDocumentItem",
    DeferredPlanPostingType = "DeferredPlanPostingType",
    DepreciationPolicy = "DepreciationPolicy",
    DepreciationPolicyItem = "DepreciationPolicyItem",
    DepreciationPolicyType = "DepreciationPolicyType",
    DepreciationSetting = "DepreciationSetting",
    DepreciationSettingType = "DepreciationSettingType",
    DepreciationType = "DepreciationType",
    DetailedEmploymentSpecification = "DetailedEmploymentSpecification",
    Document = "Document",
    DocumentAccountAssignment = "DocumentAccountAssignment",
    DocumentAccountAssignmentDraft = "DocumentAccountAssignmentDraft",
    DocumentAccountAssignmentSelection = "DocumentAccountAssignmentSelection",
    DocumentAccountAssignmentSelectionDraft = "DocumentAccountAssignmentSelectionDraft",
    DocumentAssetEntry = "DocumentAssetEntry",
    DocumentAttachment = "DocumentAttachment",
    DocumentAttachmentDeleted = "DocumentAttachmentDeleted",
    DocumentAttachmentDraft = "DocumentAttachmentDraft",
    DocumentBankAccount = "DocumentBankAccount",
    DocumentBankAccountDraft = "DocumentBankAccountDraft",
    DocumentBusinessPartner = "DocumentBusinessPartner",
    DocumentBusinessPartnerDraft = "DocumentBusinessPartnerDraft",
    DocumentBusinessPartnerType = "DocumentBusinessPartnerType",
    DocumentCbaCategory = "DocumentCbaCategory",
    DocumentCbaCategoryDraft = "DocumentCbaCategoryDraft",
    DocumentDeleteLog = "DocumentDeleteLog",
    DocumentDraft = "DocumentDraft",
    DocumentGrantAssignment = "DocumentGrantAssignment",
    DocumentGrantAssignmentDraft = "DocumentGrantAssignmentDraft",
    DocumentImportType = "DocumentImportType",
    DocumentItem = "DocumentItem",
    DocumentItemAccountAssignment = "DocumentItemAccountAssignment",
    DocumentItemAccountAssignmentDraft = "DocumentItemAccountAssignmentDraft",
    DocumentItemAccountAssignmentSelection = "DocumentItemAccountAssignmentSelection",
    DocumentItemAccountAssignmentSelectionDraft = "DocumentItemAccountAssignmentSelectionDraft",
    DocumentItemCbaCategory = "DocumentItemCbaCategory",
    DocumentItemCbaCategoryDraft = "DocumentItemCbaCategoryDraft",
    DocumentItemDraft = "DocumentItemDraft",
    DocumentItemGrantAssignment = "DocumentItemGrantAssignment",
    DocumentItemGrantAssignmentDraft = "DocumentItemGrantAssignmentDraft",
    DocumentItemLabelSelection = "DocumentItemLabelSelection",
    DocumentItemLabelSelectionDraft = "DocumentItemLabelSelectionDraft",
    DocumentItemLinkableToGrantView = "DocumentItemLinkableToGrantView",
    DocumentItemType = "DocumentItemType",
    DocumentItemVatClassification = "DocumentItemVatClassification",
    DocumentItemVatClassificationDraft = "DocumentItemVatClassificationDraft",
    DocumentItemVatClassificationSelection = "DocumentItemVatClassificationSelection",
    DocumentItemVatClassificationSelectionDraft = "DocumentItemVatClassificationSelectionDraft",
    DocumentItemView = "DocumentItemView",
    DocumentLabel = "DocumentLabel",
    DocumentLabelDraft = "DocumentLabelDraft",
    DocumentLink = "DocumentLink",
    DocumentLinkClearingType = "DocumentLinkClearingType",
    DocumentLinkDraft = "DocumentLinkDraft",
    DocumentLinkType = "DocumentLinkType",
    DocumentLock = "DocumentLock",
    DocumentLockDraft = "DocumentLockDraft",
    DocumentMinorAssetItem = "DocumentMinorAssetItem",
    DocumentSourceType = "DocumentSourceType",
    DocumentStatus = "DocumentStatus",
    DocumentType = "DocumentType",
    DocumentVatClassification = "DocumentVatClassification",
    DocumentVatClassificationDraft = "DocumentVatClassificationDraft",
    DocumentVatClassificationSelection = "DocumentVatClassificationSelection",
    DocumentVatClassificationSelectionDraft = "DocumentVatClassificationSelectionDraft",
    ElectronicSubmission = "ElectronicSubmission",
    ElectronicSubmissionPeriodWithDeletedDocument = "ElectronicSubmissionPeriodWithDeletedDocument",
    ElectronicSubmissionSubmissionType = "ElectronicSubmissionSubmissionType",
    ElectronicSubmissionType = "ElectronicSubmissionType",
    EmploymentEarlyTerminationReason = "EmploymentEarlyTerminationReason",
    EmploymentRelationshipTerminationReason = "EmploymentRelationshipTerminationReason",
    Entity = "Entity",
    EntityAccountAssignment = "EntityAccountAssignment",
    EntityAccountAssignmentDraft = "EntityAccountAssignmentDraft",
    EntityAttachment = "EntityAttachment",
    EntityBankAccount = "EntityBankAccount",
    EntityBankAccountDraft = "EntityBankAccountDraft",
    EntityBusinessPartner = "EntityBusinessPartner",
    EntityBusinessPartnerDraft = "EntityBusinessPartnerDraft",
    EntityCbaCategory = "EntityCbaCategory",
    EntityCbaCategoryDraft = "EntityCbaCategoryDraft",
    EntityCompany = "EntityCompany",
    EntityGrantAssignment = "EntityGrantAssignment",
    EntityGrantAssignmentDraft = "EntityGrantAssignmentDraft",
    EntityLabel = "EntityLabel",
    EntityLock = "EntityLock",
    EntityPermissionLevel = "EntityPermissionLevel",
    EntityType = "EntityType",
    EntityVatClassification = "EntityVatClassification",
    EntityVatClassificationDraft = "EntityVatClassificationDraft",
    EvalaZoom = "EvalaZoom",
    ExchangeRate = "ExchangeRate",
    ExchangeRateType = "ExchangeRateType",
    ExpenseTaxRate = "ExpenseTaxRate",
    ExportLog = "ExportLog",
    ExportRange = "ExportRange",
    ExportResultType = "ExportResultType",
    ExportType = "ExportType",
    ExternalCorrectedDocumentType = "ExternalCorrectedDocumentType",
    Feature = "Feature",
    FileMetadata = "FileMetadata",
    FinancialReportClose = "FinancialReportClose",
    FinancialReportCloseItem = "FinancialReportCloseItem",
    FinancialReportLayout = "FinancialReportLayout",
    FinancialReportLayoutSection = "FinancialReportLayoutSection",
    FiscalPeriod = "FiscalPeriod",
    FiscalPeriodUsage = "FiscalPeriodUsage",
    FiscalYear = "FiscalYear",
    FiscalYearClose = "FiscalYearClose",
    FiscalYearCloseAdvanceTax = "FiscalYearCloseAdvanceTax",
    FiscalYearCloseAttachment = "FiscalYearCloseAttachment",
    FiscalYearCloseExchangeRate = "FiscalYearCloseExchangeRate",
    FiscalYearCloseInventory = "FiscalYearCloseInventory",
    FiscalYearCloseSection = "FiscalYearCloseSection",
    FiscalYearCloseSectionType = "FiscalYearCloseSectionType",
    FiscalYearStatus = "FiscalYearStatus",
    FiscalYearUsage = "FiscalYearUsage",
    FlattenAccount = "FlattenAccount",
    ForeignInsuranceCarrierAddress = "ForeignInsuranceCarrierAddress",
    FulfilmentType = "FulfilmentType",
    GeneralPermission = "GeneralPermission",
    GeneralRole = "GeneralRole",
    GeneralRolePermission = "GeneralRolePermission",
    GovernmentInstitution = "GovernmentInstitution",
    GovernmentInstitutionBankAccount = "GovernmentInstitutionBankAccount",
    GovernmentInstitutionBankAccountType = "GovernmentInstitutionBankAccountType",
    GovernmentInstitutionType = "GovernmentInstitutionType",
    Grant = "Grant",
    GrantAssignmentDivision = "GrantAssignmentDivision",
    GrantAssignmentDivisionDraft = "GrantAssignmentDivisionDraft",
    GrantAssignmentType = "GrantAssignmentType",
    GrantAttachment = "GrantAttachment",
    GrantBalance = "GrantBalance",
    GrantBusinessPartner = "GrantBusinessPartner",
    GrantClaim = "GrantClaim",
    GrantClaimType = "GrantClaimType",
    GrantEntry = "GrantEntry",
    GrantStatus = "GrantStatus",
    Hotspot = "Hotspot",
    ImportDocument = "ImportDocument",
    InboxEntityType = "InboxEntityType",
    InboxFile = "InboxFile",
    InboxFileLog = "InboxFileLog",
    InboxFileSource = "InboxFileSource",
    InboxFileStatus = "InboxFileStatus",
    InboxItemLog = "InboxItemLog",
    InboxItemLogState = "InboxItemLogState",
    IncomeStatementLayout = "IncomeStatementLayout",
    IncomeStatementLayoutTemplate = "IncomeStatementLayoutTemplate",
    InitialAccountBalance = "InitialAccountBalance",
    IntegrationApiImportFrequency = "IntegrationApiImportFrequency",
    IntegrationApiImportFromWhen = "IntegrationApiImportFromWhen",
    IntegrationApiImportRange = "IntegrationApiImportRange",
    IntegrationApiImportedDocuments = "IntegrationApiImportedDocuments",
    InteractionType = "InteractionType",
    InternalDocument = "InternalDocument",
    InternalDocumentItem = "InternalDocumentItem",
    InventoryType = "InventoryType",
    InvoiceIssued = "InvoiceIssued",
    InvoiceReceived = "InvoiceReceived",
    InvoiceServiceIntegration = "InvoiceServiceIntegration",
    InvoiceServiceIntegrationParameters = "InvoiceServiceIntegrationParameters",
    InvoiceServiceIntegrationSettings = "InvoiceServiceIntegrationSettings",
    InvoiceServiceIntegrationType = "InvoiceServiceIntegrationType",
    IsdocImportDocument = "IsdocImportDocument",
    ItemLabel = "ItemLabel",
    ItemLabelDraft = "ItemLabelDraft",
    ItemTemplate = "ItemTemplate",
    ItemTemplateAccountAssignment = "ItemTemplateAccountAssignment",
    ItemTemplateAccountAssignmentSelection = "ItemTemplateAccountAssignmentSelection",
    ItemTemplateCbaTaxImpact = "ItemTemplateCbaTaxImpact",
    ItemTemplateVatClassification = "ItemTemplateVatClassification",
    ItemTemplateVatClassificationSelection = "ItemTemplateVatClassificationSelection",
    JournalEntry = "JournalEntry",
    JournalEntryLabel = "JournalEntryLabel",
    JournalEntryType = "JournalEntryType",
    LORegionalOffice = "LORegionalOffice",
    Label = "Label",
    LabelHierarchy = "LabelHierarchy",
    LabelSelection = "LabelSelection",
    LabelSelectionDraft = "LabelSelectionDraft",
    LaborOfficeEmploymentType = "LaborOfficeEmploymentType",
    Language = "Language",
    LegalEntityCategory = "LegalEntityCategory",
    LegislativeFixedExchangeRate = "LegislativeFixedExchangeRate",
    LoanAccount = "LoanAccount",
    LoanStatement = "LoanStatement",
    LoanTransaction = "LoanTransaction",
    LockType = "LockType",
    MandatoryAccount = "MandatoryAccount",
    MandatoryChartOfAccounts = "MandatoryChartOfAccounts",
    MinorAsset = "MinorAsset",
    MinorAssetAttachment = "MinorAssetAttachment",
    MinorAssetHistoryEntry = "MinorAssetHistoryEntry",
    MinorAssetHistoryItem = "MinorAssetHistoryItem",
    MinorAssetItem = "MinorAssetItem",
    MinorAssetLabel = "MinorAssetLabel",
    MinorAssetStatus = "MinorAssetStatus",
    Module = "Module",
    MoneyS3ImportDocument = "MoneyS3ImportDocument",
    MonthOfYear = "MonthOfYear",
    MpsvFreeAccessToLaborMarketType = "MpsvFreeAccessToLaborMarketType",
    MpsvTaxIdentifierType = "MpsvTaxIdentifierType",
    NoUnemploymentSupportType = "NoUnemploymentSupportType",
    Notification = "Notification",
    NotificationPriority = "NotificationPriority",
    NotificationSetting = "NotificationSetting",
    NotificationType = "NotificationType",
    NotificationTypeGroup = "NotificationTypeGroup",
    NotificationTypeSetting = "NotificationTypeSetting",
    NumberRange = "NumberRange",
    NumberRangeDefinition = "NumberRangeDefinition",
    NumberRangeDefinitionTemplate = "NumberRangeDefinitionTemplate",
    NumberRangeType = "NumberRangeType",
    NumberRangeUsage = "NumberRangeUsage",
    NumberRangeWildcard = "NumberRangeWildcard",
    OppositeDocumentDocumentLink = "OppositeDocumentDocumentLink",
    OppositeDocumentLink = "OppositeDocumentLink",
    OppositePaymentDocumentDocumentLink = "OppositePaymentDocumentDocumentLink",
    Organization = "Organization",
    OtherLiability = "OtherLiability",
    OtherReceivable = "OtherReceivable",
    OwnershipFormType = "OwnershipFormType",
    PayableReceivableType = "PayableReceivableType",
    PayerReliabilityStatus = "PayerReliabilityStatus",
    PayingDocument = "PayingDocument",
    PayingDocumentItemView = "PayingDocumentItemView",
    PaymentDocument = "PaymentDocument",
    PaymentDocumentAttachment = "PaymentDocumentAttachment",
    PaymentDocumentAttachmentDraft = "PaymentDocumentAttachmentDraft",
    PaymentDocumentDraft = "PaymentDocumentDraft",
    PaymentDocumentDraftLabel = "PaymentDocumentDraftLabel",
    PaymentDocumentItem = "PaymentDocumentItem",
    PaymentDocumentItemAccountAssignment = "PaymentDocumentItemAccountAssignment",
    PaymentDocumentItemAccountAssignmentDraft = "PaymentDocumentItemAccountAssignmentDraft",
    PaymentDocumentItemAccountAssignmentSelection = "PaymentDocumentItemAccountAssignmentSelection",
    PaymentDocumentItemAccountAssignmentSelectionDraft = "PaymentDocumentItemAccountAssignmentSelectionDraft",
    PaymentDocumentItemCbaCategory = "PaymentDocumentItemCbaCategory",
    PaymentDocumentItemCbaCategoryDraft = "PaymentDocumentItemCbaCategoryDraft",
    PaymentDocumentItemDraft = "PaymentDocumentItemDraft",
    PaymentDocumentItemGrantAssignment = "PaymentDocumentItemGrantAssignment",
    PaymentDocumentItemGrantAssignmentDraft = "PaymentDocumentItemGrantAssignmentDraft",
    PaymentDocumentItemLabelSelection = "PaymentDocumentItemLabelSelection",
    PaymentDocumentItemLabelSelectionDraft = "PaymentDocumentItemLabelSelectionDraft",
    PaymentDocumentItemType = "PaymentDocumentItemType",
    PaymentDocumentLabel = "PaymentDocumentLabel",
    PaymentDocumentLock = "PaymentDocumentLock",
    PaymentDocumentLockDraft = "PaymentDocumentLockDraft",
    PaymentMethod = "PaymentMethod",
    PaymentOrderFormat = "PaymentOrderFormat",
    PaymentOrderOutput = "PaymentOrderOutput",
    PaymentStatus = "PaymentStatus",
    PeriodDay = "PeriodDay",
    PodaniValidationError = "PodaniValidationError",
    PohodaImportDocument = "PohodaImportDocument",
    PostedStatus = "PostedStatus",
    PostingRule = "PostingRule",
    PostingRuleDocumentType = "PostingRuleDocumentType",
    PrAbsenceCategory = "PrAbsenceCategory",
    PrAbsenceCategoryOrigin = "PrAbsenceCategoryOrigin",
    PrAbsenceCategorySubtype = "PrAbsenceCategorySubtype",
    PrAbsenceCategoryTemporal = "PrAbsenceCategoryTemporal",
    PrAbsenceCategoryTemporalCurrent = "PrAbsenceCategoryTemporalCurrent",
    PrAbsenceCategoryType = "PrAbsenceCategoryType",
    PrAbsenceCompensation = "PrAbsenceCompensation",
    PrAbsenceObstacleType = "PrAbsenceObstacleType",
    PrAccountAssignment = "PrAccountAssignment",
    PrAccountAssignmentTemplate = "PrAccountAssignmentTemplate",
    PrAccountingCategory = "PrAccountingCategory",
    PrAccountingGroupSelection = "PrAccountingGroupSelection",
    PrAccountingItemGroup = "PrAccountingItemGroup",
    PrAccountingItemType = "PrAccountingItemType",
    PrAnnualTaxItemType = "PrAnnualTaxItemType",
    PrAnnualTaxSettlement = "PrAnnualTaxSettlement",
    PrAnnualTaxSettlementAttachment = "PrAnnualTaxSettlementAttachment",
    PrAnnualTaxSettlementItem = "PrAnnualTaxSettlementItem",
    PrAnnualTaxSettlementRequest = "PrAnnualTaxSettlementRequest",
    PrAnnualTaxSettlementRequestAttachment = "PrAnnualTaxSettlementRequestAttachment",
    PrAnnualTaxSettlementRequestFormSectionDetailType = "PrAnnualTaxSettlementRequestFormSectionDetailType",
    PrAnnualTaxSettlementRequestFormSectionType = "PrAnnualTaxSettlementRequestFormSectionType",
    PrAnnualTaxSettlementRequestResultType = "PrAnnualTaxSettlementRequestResultType",
    PrAnnualTaxSettlementRequestStatusType = "PrAnnualTaxSettlementRequestStatusType",
    PrAnnualTaxSettlementStatus = "PrAnnualTaxSettlementStatus",
    PrAtsrFormSection = "PrAtsrFormSection",
    PrAtsrFormSectionAttachment = "PrAtsrFormSectionAttachment",
    PrAtsrFormSectionDIP = "PrAtsrFormSectionDIP",
    PrAtsrFormSectionDetail = "PrAtsrFormSectionDetail",
    PrAtsrFormSectionDetailAttachment = "PrAtsrFormSectionDetailAttachment",
    PrAtsrFormSectionDetailChildAttachment = "PrAtsrFormSectionDetailChildAttachment",
    PrAtsrFormSectionDetailChildDeduction = "PrAtsrFormSectionDetailChildDeduction",
    PrAtsrFormSectionDetailMortgageLocation = "PrAtsrFormSectionDetailMortgageLocation",
    PrAtsrFormSectionDetailMortgageOtherPeople = "PrAtsrFormSectionDetailMortgageOtherPeople",
    PrAtsrFormSectionDetailPartnerTaxCredit = "PrAtsrFormSectionDetailPartnerTaxCredit",
    PrAtsrFormSectionDetailPartnerTaxCreditZtp = "PrAtsrFormSectionDetailPartnerTaxCreditZtp",
    PrAtsrFormSectionDetailZtp = "PrAtsrFormSectionDetailZtp",
    PrAtsrFormSectionForeclosureEndBonus = "PrAtsrFormSectionForeclosureEndBonus",
    PrAtsrFormSectionGifts = "PrAtsrFormSectionGifts",
    PrAtsrFormSectionLifeInsurance = "PrAtsrFormSectionLifeInsurance",
    PrAtsrFormSectionLongTermCareInsurance = "PrAtsrFormSectionLongTermCareInsurance",
    PrAtsrFormSectionMortgageInterest = "PrAtsrFormSectionMortgageInterest",
    PrAtsrFormSectionOtherEmploymentAttachment = "PrAtsrFormSectionOtherEmploymentAttachment",
    PrAtsrFormSectionOtherEmploymentRecords = "PrAtsrFormSectionOtherEmploymentRecords",
    PrAtsrFormSectionOtherEmployments = "PrAtsrFormSectionOtherEmployments",
    PrAtsrFormSectionPartnerTaxCredit = "PrAtsrFormSectionPartnerTaxCredit",
    PrAtsrFormSectionPensionInsurance = "PrAtsrFormSectionPensionInsurance",
    PrAtsrFormSectionSupplementaryPensionSavingsNew = "PrAtsrFormSectionSupplementaryPensionSavingsNew",
    PrAtsrFormSectionSupplementaryPensionSavingsOld = "PrAtsrFormSectionSupplementaryPensionSavingsOld",
    PrAtsrSimpleFormSection = "PrAtsrSimpleFormSection",
    PrAttendance = "PrAttendance",
    PrAttendanceDay = "PrAttendanceDay",
    PrAttendanceDayInterval = "PrAttendanceDayInterval",
    PrAttendanceStatus = "PrAttendanceStatus",
    PrAttendanceStatusDisplay = "PrAttendanceStatusDisplay",
    PrAttendanceSummary = "PrAttendanceSummary",
    PrAttendanceSummaryAbsence = "PrAttendanceSummaryAbsence",
    PrBenefit = "PrBenefit",
    PrBenefitTaxFreeLimit = "PrBenefitTaxFreeLimit",
    PrBenefitTemporal = "PrBenefitTemporal",
    PrBenefitTemporalCurrent = "PrBenefitTemporalCurrent",
    PrBenefitType = "PrBenefitType",
    PrCSSZDecisivePeriod = "PrCSSZDecisivePeriod",
    PrCSSZPaymentConnectionDelivery = "PrCSSZPaymentConnectionDelivery",
    PrCSSZPaymentConnectionWireTransferAbroad = "PrCSSZPaymentConnectionWireTransferAbroad",
    PrCSSZPaymentConnectionWireTransferCZ = "PrCSSZPaymentConnectionWireTransferCZ",
    PrCSSZPaymentMethod = "PrCSSZPaymentMethod",
    PrCSSZSubmission = "PrCSSZSubmission",
    PrCSSZSubmissionCaregiving = "PrCSSZSubmissionCaregiving",
    PrCSSZSubmissionCaregivingDetail = "PrCSSZSubmissionCaregivingDetail",
    PrCSSZSubmissionCaregivingDetailBase = "PrCSSZSubmissionCaregivingDetailBase",
    PrCSSZSubmissionCompany = "PrCSSZSubmissionCompany",
    PrCSSZSubmissionDetail = "PrCSSZSubmissionDetail",
    PrCSSZSubmissionEmployee = "PrCSSZSubmissionEmployee",
    PrCSSZSubmissionEmployerConfirmation = "PrCSSZSubmissionEmployerConfirmation",
    PrCSSZSubmissionEmployerConfirmationCaregiving = "PrCSSZSubmissionEmployerConfirmationCaregiving",
    PrCSSZSubmissionEmployerConfirmationCaregivingBase = "PrCSSZSubmissionEmployerConfirmationCaregivingBase",
    PrCSSZSubmissionEmployerConfirmationIllnessLeave = "PrCSSZSubmissionEmployerConfirmationIllnessLeave",
    PrCSSZSubmissionEmployerConfirmationLongtermCaregiving = "PrCSSZSubmissionEmployerConfirmationLongtermCaregiving",
    PrCSSZSubmissionEmployerConfirmationMaternityLeave = "PrCSSZSubmissionEmployerConfirmationMaternityLeave",
    PrCSSZSubmissionEmployerConfirmationPaternityLeave = "PrCSSZSubmissionEmployerConfirmationPaternityLeave",
    PrCSSZSubmissionEmployment = "PrCSSZSubmissionEmployment",
    PrCSSZSubmissionIllnessLeave = "PrCSSZSubmissionIllnessLeave",
    PrCSSZSubmissionIllnessLeaveDetail = "PrCSSZSubmissionIllnessLeaveDetail",
    PrCSSZSubmissionLongtermCaregiving = "PrCSSZSubmissionLongtermCaregiving",
    PrCSSZSubmissionLongtermCaregivingDetail = "PrCSSZSubmissionLongtermCaregivingDetail",
    PrCSSZSubmissionMaternityLeave = "PrCSSZSubmissionMaternityLeave",
    PrCSSZSubmissionMaternityLeaveDetail = "PrCSSZSubmissionMaternityLeaveDetail",
    PrCSSZSubmissionPaternityLeave = "PrCSSZSubmissionPaternityLeave",
    PrCSSZSubmissionPaternityLeaveDetail = "PrCSSZSubmissionPaternityLeaveDetail",
    PrCSSZSubmissionPaymentBasis = "PrCSSZSubmissionPaymentBasis",
    PrCSSZSubmissionPaymentBasisCaregiving = "PrCSSZSubmissionPaymentBasisCaregiving",
    PrCSSZSubmissionPaymentBasisLongtermCaregiving = "PrCSSZSubmissionPaymentBasisLongtermCaregiving",
    PrCSSZSubmissionPaymentBasisPaternityLeave = "PrCSSZSubmissionPaymentBasisPaternityLeave",
    PrCSSZSubmissionResult = "PrCSSZSubmissionResult",
    PrCareReceiver = "PrCareReceiver",
    PrCareReceiverChild = "PrCareReceiverChild",
    PrCareReceiverSocialEvent = "PrCareReceiverSocialEvent",
    PrCareReceiverSubmission = "PrCareReceiverSubmission",
    PrCaregivingEvent = "PrCaregivingEvent",
    PrCaregivingType = "PrCaregivingType",
    PrChildDeductionOrder = "PrChildDeductionOrder",
    PrChildSupportDeductionType = "PrChildSupportDeductionType",
    PrCollectionItemChangeType = "PrCollectionItemChangeType",
    PrCsszHzupnSubmission = "PrCsszHzupnSubmission",
    PrCsszHzupnSubmissionCompany = "PrCsszHzupnSubmissionCompany",
    PrCsszHzupnSubmissionDetail = "PrCsszHzupnSubmissionDetail",
    PrCsszHzupnSubmissionEmployee = "PrCsszHzupnSubmissionEmployee",
    PrCsszHzupnSubmissionWorkedInterval = "PrCsszHzupnSubmissionWorkedInterval",
    PrCsszOzuspojSubmission = "PrCsszOzuspojSubmission",
    PrCsszOzuspojSubmissionCompany = "PrCsszOzuspojSubmissionCompany",
    PrCsszOzuspojSubmissionContactWorker = "PrCsszOzuspojSubmissionContactWorker",
    PrCsszOzuspojSubmissionDetail = "PrCsszOzuspojSubmissionDetail",
    PrCsszOzuspojSubmissionEmployee = "PrCsszOzuspojSubmissionEmployee",
    PrCustodyEvent = "PrCustodyEvent",
    PrCzechReductionLimit = "PrCzechReductionLimit",
    PrDeduction = "PrDeduction",
    PrDeductionAttachment = "PrDeductionAttachment",
    PrDeductionBankAccount = "PrDeductionBankAccount",
    PrDeductionBusinessPartner = "PrDeductionBusinessPartner",
    PrDeductionCalculationType = "PrDeductionCalculationType",
    PrDeductionEmployee = "PrDeductionEmployee",
    PrDeductionEntityType = "PrDeductionEntityType",
    PrDeductionOtherPayment = "PrDeductionOtherPayment",
    PrDeductionPayslipDocument = "PrDeductionPayslipDocument",
    PrDeductionStatus = "PrDeductionStatus",
    PrDeductionTemporal = "PrDeductionTemporal",
    PrDeductionTemporalCurrent = "PrDeductionTemporalCurrent",
    PrDeductionType = "PrDeductionType",
    PrDeductionUnpaidChildSupportAmount = "PrDeductionUnpaidChildSupportAmount",
    PrDelayedIncomeType = "PrDelayedIncomeType",
    PrDepositedDeduction = "PrDepositedDeduction",
    PrDepositedDistrainmentAmount = "PrDepositedDistrainmentAmount",
    PrDisabilityDiscountAmount = "PrDisabilityDiscountAmount",
    PrDisabilityType = "PrDisabilityType",
    PrDistrainmentDeductionType = "PrDistrainmentDeductionType",
    PrDistrainmentDepositClosing = "PrDistrainmentDepositClosing",
    PrEducation = "PrEducation",
    PrEldp = "PrEldp",
    PrEldpCompany = "PrEldpCompany",
    PrEldpEmployee = "PrEldpEmployee",
    PrEldpItem = "PrEldpItem",
    PrEldpItemType = "PrEldpItemType",
    PrEldpType = "PrEldpType",
    PrEmployee = "PrEmployee",
    PrEmployeeAttachment = "PrEmployeeAttachment",
    PrEmployeeBankAccount = "PrEmployeeBankAccount",
    PrEmployeeCarTaxability = "PrEmployeeCarTaxability",
    PrEmployeeContactAddress = "PrEmployeeContactAddress",
    PrEmployeeCzechAddress = "PrEmployeeCzechAddress",
    PrEmployeeDependentPerson = "PrEmployeeDependentPerson",
    PrEmployeeDependentPersonRelation = "PrEmployeeDependentPersonRelation",
    PrEmployeeLabel = "PrEmployeeLabel",
    PrEmployeePermanentAddress = "PrEmployeePermanentAddress",
    PrEmployeeState = "PrEmployeeState",
    PrEmployeeTaxResidenceAddress = "PrEmployeeTaxResidenceAddress",
    PrEmployeeTemporal = "PrEmployeeTemporal",
    PrEmployeeTemporalCurrent = "PrEmployeeTemporalCurrent",
    PrEmployment = "PrEmployment",
    PrEmploymentBalancingPeriod = "PrEmploymentBalancingPeriod",
    PrEmploymentBalancingPeriodMonth = "PrEmploymentBalancingPeriodMonth",
    PrEmploymentBenefit = "PrEmploymentBenefit",
    PrEmploymentBenefitTemporal = "PrEmploymentBenefitTemporal",
    PrEmploymentBenefitTemporalCurrent = "PrEmploymentBenefitTemporalCurrent",
    PrEmploymentCar = "PrEmploymentCar",
    PrEmploymentCategory = "PrEmploymentCategory",
    PrEmploymentClose = "PrEmploymentClose",
    PrEmploymentExtraSalary = "PrEmploymentExtraSalary",
    PrEmploymentExtraSalaryTemporal = "PrEmploymentExtraSalaryTemporal",
    PrEmploymentExtraSalaryTemporalCurrent = "PrEmploymentExtraSalaryTemporalCurrent",
    PrEmploymentInitialData = "PrEmploymentInitialData",
    PrEmploymentInitialLongTermTimeBonus = "PrEmploymentInitialLongTermTimeBonus",
    PrEmploymentInitialMonthData = "PrEmploymentInitialMonthData",
    PrEmploymentRetirementSaving = "PrEmploymentRetirementSaving",
    PrEmploymentRetirementSavingTemporal = "PrEmploymentRetirementSavingTemporal",
    PrEmploymentRetirementSavingTemporalCurrent = "PrEmploymentRetirementSavingTemporalCurrent",
    PrEmploymentSalaryComponent = "PrEmploymentSalaryComponent",
    PrEmploymentSalaryComponentTemporal = "PrEmploymentSalaryComponentTemporal",
    PrEmploymentSalaryComponentTemporalCurrent = "PrEmploymentSalaryComponentTemporalCurrent",
    PrEmploymentTemplate = "PrEmploymentTemplate",
    PrEmploymentTemplateBenefit = "PrEmploymentTemplateBenefit",
    PrEmploymentTemplateBenefitTemporal = "PrEmploymentTemplateBenefitTemporal",
    PrEmploymentTemplateBenefitTemporalCurrent = "PrEmploymentTemplateBenefitTemporalCurrent",
    PrEmploymentTemplateExtraSalary = "PrEmploymentTemplateExtraSalary",
    PrEmploymentTemplateExtraSalaryTemporal = "PrEmploymentTemplateExtraSalaryTemporal",
    PrEmploymentTemplateExtraSalaryTemporalCurrent = "PrEmploymentTemplateExtraSalaryTemporalCurrent",
    PrEmploymentTemplateSalaryComponent = "PrEmploymentTemplateSalaryComponent",
    PrEmploymentTemplateSalaryComponentTemporal = "PrEmploymentTemplateSalaryComponentTemporal",
    PrEmploymentTemplateSalaryComponentTemporalCurrent = "PrEmploymentTemplateSalaryComponentTemporalCurrent",
    PrEmploymentTemplateTemporal = "PrEmploymentTemplateTemporal",
    PrEmploymentTemplateTemporalCurrent = "PrEmploymentTemplateTemporalCurrent",
    PrEmploymentTemporal = "PrEmploymentTemporal",
    PrEmploymentTemporalCurrent = "PrEmploymentTemporalCurrent",
    PrEmploymentType = "PrEmploymentType",
    PrEmploymentWorkplaceAddress = "PrEmploymentWorkplaceAddress",
    PrEmploymentWorkplaceAddressSelection = "PrEmploymentWorkplaceAddressSelection",
    PrEntityEmployee = "PrEntityEmployee",
    PrEntityEmployeeContactAddress = "PrEntityEmployeeContactAddress",
    PrEntityEmployeeCzechAddress = "PrEntityEmployeeCzechAddress",
    PrEntityEmployeePermanentAddress = "PrEntityEmployeePermanentAddress",
    PrEntityEmployeeTaxResidenceAddress = "PrEntityEmployeeTaxResidenceAddress",
    PrEntityEmployment = "PrEntityEmployment",
    PrEntityValueSource = "PrEntityValueSource",
    PrExtraSalary = "PrExtraSalary",
    PrExtraSalaryComputationType = "PrExtraSalaryComputationType",
    PrExtraSalaryLegislativeValue = "PrExtraSalaryLegislativeValue",
    PrExtraSalaryOrigin = "PrExtraSalaryOrigin",
    PrExtraSalaryTemporal = "PrExtraSalaryTemporal",
    PrExtraSalaryTemporalCurrent = "PrExtraSalaryTemporalCurrent",
    PrExtraSalaryType = "PrExtraSalaryType",
    PrFinancialAdministrationDetail = "PrFinancialAdministrationDetail",
    PrFixedBonusDeductionImpact = "PrFixedBonusDeductionImpact",
    PrFixedBonusPayOutImpact = "PrFixedBonusPayOutImpact",
    PrFixedBonusTaxImpact = "PrFixedBonusTaxImpact",
    PrForeignInsuranceCarrier = "PrForeignInsuranceCarrier",
    PrForeignInsuranceCarrierSectorType = "PrForeignInsuranceCarrierSectorType",
    PrForeignInsuranceCarrierType = "PrForeignInsuranceCarrierType",
    PrFormOfStudyType = "PrFormOfStudyType",
    PrGovernmentInstitutionContact = "PrGovernmentInstitutionContact",
    PrGovernmentInstitutionDetail = "PrGovernmentInstitutionDetail",
    PrHealthInsuranceCompany = "PrHealthInsuranceCompany",
    PrHealthInsuranceCompanyBankAccount = "PrHealthInsuranceCompanyBankAccount",
    PrHealthInsuranceCompanyDetail = "PrHealthInsuranceCompanyDetail",
    PrHolidayPayoutType = "PrHolidayPayoutType",
    PrHolidayShiftAssignment = "PrHolidayShiftAssignment",
    PrHozChangeCode = "PrHozChangeCode",
    PrHozSubmission = "PrHozSubmission",
    PrHozSubmissionCompany = "PrHozSubmissionCompany",
    PrHozSubmissionDetail = "PrHozSubmissionDetail",
    PrHozSubmissionEmployee = "PrHozSubmissionEmployee",
    PrHozSubmissionItem = "PrHozSubmissionItem",
    PrIdentifier = "PrIdentifier",
    PrIdentityDocumentType = "PrIdentityDocumentType",
    PrIllnessLeaveEvent = "PrIllnessLeaveEvent",
    PrIllnessLeaveEventDoctorAddress = "PrIllnessLeaveEventDoctorAddress",
    PrIllnessLeaveEventPermittedOuting = "PrIllnessLeaveEventPermittedOuting",
    PrIllnessLeaveEventResidenceAddress = "PrIllnessLeaveEventResidenceAddress",
    PrImprisonmentEvent = "PrImprisonmentEvent",
    PrIncomeTaxDiscount = "PrIncomeTaxDiscount",
    PrInitialData = "PrInitialData",
    PrInitialMonthData = "PrInitialMonthData",
    PrInsolvencyDepositClosing = "PrInsolvencyDepositClosing",
    PrJmhzAnnualOverview = "PrJmhzAnnualOverview",
    PrJmhzAnnualTaxSettlementPartner = "PrJmhzAnnualTaxSettlementPartner",
    PrJmhzAnnualTaxSettlementPartnerChild = "PrJmhzAnnualTaxSettlementPartnerChild",
    PrJmhzAnnualTaxSettlementSupportedChild = "PrJmhzAnnualTaxSettlementSupportedChild",
    PrJmhzAnnualTaxSettlementSupportingPerson = "PrJmhzAnnualTaxSettlementSupportingPerson",
    PrJmhzCollectiveAgreement = "PrJmhzCollectiveAgreement",
    PrJmhzCompany = "PrJmhzCompany",
    PrJmhzDetail = "PrJmhzDetail",
    PrJmhzEldpDaysDeducted = "PrJmhzEldpDaysDeducted",
    PrJmhzEldpDaysExcluded = "PrJmhzEldpDaysExcluded",
    PrJmhzEldpItem = "PrJmhzEldpItem",
    PrJmhzEmployee = "PrJmhzEmployee",
    PrJmhzEmployeeAnnualPaymentOverview = "PrJmhzEmployeeAnnualPaymentOverview",
    PrJmhzEmployeeAnnualTaxSettlement = "PrJmhzEmployeeAnnualTaxSettlement",
    PrJmhzEmployeeIncomeOverview = "PrJmhzEmployeeIncomeOverview",
    PrJmhzEmployeeIncomeTaxOverview = "PrJmhzEmployeeIncomeTaxOverview",
    PrJmhzEmployeeSalaryOverview = "PrJmhzEmployeeSalaryOverview",
    PrJmhzEmployeeWithholdingTaxOverview = "PrJmhzEmployeeWithholdingTaxOverview",
    PrJmhzEmployment = "PrJmhzEmployment",
    PrJmhzEmploymentAttendanceOverview = "PrJmhzEmploymentAttendanceOverview",
    PrJmhzEmploymentIncomeOverview = "PrJmhzEmploymentIncomeOverview",
    PrJmhzEmploymentSocialSecurityOverview = "PrJmhzEmploymentSocialSecurityOverview",
    PrJmhzFormType = "PrJmhzFormType",
    PrJmhzIncomeTaxOverview = "PrJmhzIncomeTaxOverview",
    PrJmhzPerson = "PrJmhzPerson",
    PrJmhzSocialInsuranceOverview = "PrJmhzSocialInsuranceOverview",
    PrJmhzSubmission = "PrJmhzSubmission",
    PrJmhzSupportedChild = "PrJmhzSupportedChild",
    PrJmhzSupportingPerson = "PrJmhzSupportingPerson",
    PrLaborMarketAccess = "PrLaborMarketAccess",
    PrLaborOfficeDetail = "PrLaborOfficeDetail",
    PrLegislativeAverageSalary = "PrLegislativeAverageSalary",
    PrLegislativePayrollConstant = "PrLegislativePayrollConstant",
    PrLegislativeYouthEventCompensationHourlyLimit = "PrLegislativeYouthEventCompensationHourlyLimit",
    PrLongTermCaregivingEvent = "PrLongTermCaregivingEvent",
    PrMaternityLeaveEntitlement = "PrMaternityLeaveEntitlement",
    PrMaternityLeaveEvent = "PrMaternityLeaveEvent",
    PrMinimumHealthInsuranceBase = "PrMinimumHealthInsuranceBase",
    PrMinimumHealthInsuranceType = "PrMinimumHealthInsuranceType",
    PrMortgageLocationAddress = "PrMortgageLocationAddress",
    PrMortgageOtherPeopleAddress = "PrMortgageOtherPeopleAddress",
    PrMpsvFamilyRelation = "PrMpsvFamilyRelation",
    PrMpsvRelation = "PrMpsvRelation",
    PrOtherBenefitCategory = "PrOtherBenefitCategory",
    PrOtherBenefitTaxAndContributionsApplicability = "PrOtherBenefitTaxAndContributionsApplicability",
    PrOtherBenefitTaxDeducibility = "PrOtherBenefitTaxDeducibility",
    PrOtherProviderAddress = "PrOtherProviderAddress",
    PrOtherProviderEmployerAddress = "PrOtherProviderEmployerAddress",
    PrParentalLeaveEvent = "PrParentalLeaveEvent",
    PrPaternityLeaveEntitlement = "PrPaternityLeaveEntitlement",
    PrPaternityLeaveEvent = "PrPaternityLeaveEvent",
    PrPayrollDocument = "PrPayrollDocument",
    PrPayrollPeriod = "PrPayrollPeriod",
    PrPayrollPeriodDocument = "PrPayrollPeriodDocument",
    PrPayrollPeriodStatus = "PrPayrollPeriodStatus",
    PrPayrollSetting = "PrPayrollSetting",
    PrPayrollSettingTemporal = "PrPayrollSettingTemporal",
    PrPayrollSettingTemporalCurrent = "PrPayrollSettingTemporalCurrent",
    PrPayrollSubstitutePayDay = "PrPayrollSubstitutePayDay",
    PrPayslip = "PrPayslip",
    PrPayslipBalancingPeriod = "PrPayslipBalancingPeriod",
    PrPayslipDeduction = "PrPayslipDeduction",
    PrPayslipEmployment = "PrPayslipEmployment",
    PrPayslipEmploymentBenefit = "PrPayslipEmploymentBenefit",
    PrPayslipEmploymentExtraSalary = "PrPayslipEmploymentExtraSalary",
    PrPayslipEmploymentItem = "PrPayslipEmploymentItem",
    PrPayslipEmploymentItemType = "PrPayslipEmploymentItemType",
    PrPayslipEmploymentRetirementSaving = "PrPayslipEmploymentRetirementSaving",
    PrPayslipEmploymentSalaryComponent = "PrPayslipEmploymentSalaryComponent",
    PrPayslipEmploymentSubitem = "PrPayslipEmploymentSubitem",
    PrPayslipEmploymentSubitemType = "PrPayslipEmploymentSubitemType",
    PrPayslipItem = "PrPayslipItem",
    PrPayslipItemType = "PrPayslipItemType",
    PrPayslipLiabilityReceivable = "PrPayslipLiabilityReceivable",
    PrPayslipMasterDataChange = "PrPayslipMasterDataChange",
    PrPayslipMinimumHealthInsurance = "PrPayslipMinimumHealthInsurance",
    PrPayslipSubitem = "PrPayslipSubitem",
    PrPayslipSubitemType = "PrPayslipSubitemType",
    PrPayslipVacationSummary = "PrPayslipVacationSummary",
    PrPensionType = "PrPensionType",
    PrPeriodDocumentType = "PrPeriodDocumentType",
    PrPppzSubmission = "PrPppzSubmission",
    PrPppzSubmissionCompany = "PrPppzSubmissionCompany",
    PrPppzSubmissionDetail = "PrPppzSubmissionDetail",
    PrPropertyAcquisition = "PrPropertyAcquisition",
    PrRegularSalaryType = "PrRegularSalaryType",
    PrRelevantIncome = "PrRelevantIncome",
    PrRetirementInsuranceInterval = "PrRetirementInsuranceInterval",
    PrRetirementSavingsBankAccount = "PrRetirementSavingsBankAccount",
    PrRetirementSavingsCompany = "PrRetirementSavingsCompany",
    PrRetirementSavingsComputationType = "PrRetirementSavingsComputationType",
    PrRetirementSavingsProduct = "PrRetirementSavingsProduct",
    PrRetirementSavingsType = "PrRetirementSavingsType",
    PrSalaryAdvance = "PrSalaryAdvance",
    PrSalaryComponent = "PrSalaryComponent",
    PrSalaryComponentAverageInclusion = "PrSalaryComponentAverageInclusion",
    PrSalaryComponentTemporal = "PrSalaryComponentTemporal",
    PrSalaryComponentTemporalCurrent = "PrSalaryComponentTemporalCurrent",
    PrSalaryComponentType = "PrSalaryComponentType",
    PrSalaryPayoutType = "PrSalaryPayoutType",
    PrSex = "PrSex",
    PrSocialEvent = "PrSocialEvent",
    PrSocialEventAttachment = "PrSocialEventAttachment",
    PrSocialEventBirthCertificateAttachment = "PrSocialEventBirthCertificateAttachment",
    PrSocialEventCertificateAttachment = "PrSocialEventCertificateAttachment",
    PrSocialEventMonthDetail = "PrSocialEventMonthDetail",
    PrSocialEventMonthDetailType = "PrSocialEventMonthDetailType",
    PrSocialEventMonthInterval = "PrSocialEventMonthInterval",
    PrSocialEventRequiredAction = "PrSocialEventRequiredAction",
    PrSocialEventStatus = "PrSocialEventStatus",
    PrSocialEventType = "PrSocialEventType",
    PrSocialInsuranceDiscountIneligibilityReason = "PrSocialInsuranceDiscountIneligibilityReason",
    PrSocialInsuranceDiscountType = "PrSocialInsuranceDiscountType",
    PrSocialInsuranceRate = "PrSocialInsuranceRate",
    PrSocialSecurityDetail = "PrSocialSecurityDetail",
    PrStatisticalData = "PrStatisticalData",
    PrStatutoryInsuranceDetail = "PrStatutoryInsuranceDetail",
    PrSubmission = "PrSubmission",
    PrSubmissionAttachment = "PrSubmissionAttachment",
    PrSubmissionCaregivingInterval = "PrSubmissionCaregivingInterval",
    PrSubmissionElectronicAttachment = "PrSubmissionElectronicAttachment",
    PrSubmissionRegZec = "PrSubmissionRegZec",
    PrSubmissionRegZecDetail = "PrSubmissionRegZecDetail",
    PrSubmissionStatus = "PrSubmissionStatus",
    PrSubmissionSubtype = "PrSubmissionSubtype",
    PrSubmissionType = "PrSubmissionType",
    PrSubmissionValidationStatus = "PrSubmissionValidationStatus",
    PrSubsequentMaternityLeaveStatus = "PrSubsequentMaternityLeaveStatus",
    PrTaxDiscountType = "PrTaxDiscountType",
    PrTaxpayerDeclaration = "PrTaxpayerDeclaration",
    PrTaxpayerDeclarationAttachment = "PrTaxpayerDeclarationAttachment",
    PrTaxpayerDeclarationChild = "PrTaxpayerDeclarationChild",
    PrTaxpayerDeclarationDiscount = "PrTaxpayerDeclarationDiscount",
    PrTaxpayerDeclarationOtherProvider = "PrTaxpayerDeclarationOtherProvider",
    PrTaxpayerDeclarationStatus = "PrTaxpayerDeclarationStatus",
    PrTaxpayerDeclarationType = "PrTaxpayerDeclarationType",
    PrTimeBasedBonusType = "PrTimeBasedBonusType",
    PrUnseizableAmount = "PrUnseizableAmount",
    PrVacationEntitlement = "PrVacationEntitlement",
    PrVacationEntitlementInclusion = "PrVacationEntitlementInclusion",
    PrValueType = "PrValueType",
    PrWorkIntervalType = "PrWorkIntervalType",
    PrWorkLeaveDaysInterval = "PrWorkLeaveDaysInterval",
    PrWorkPermitType = "PrWorkPermitType",
    PrWorkScheduleDaysInterval = "PrWorkScheduleDaysInterval",
    PrWorkedInDaysInterval = "PrWorkedInDaysInterval",
    PrWorkingPattern = "PrWorkingPattern",
    PrWorkingPatternDay = "PrWorkingPatternDay",
    PrWorkingPatternDayInterval = "PrWorkingPatternDayInterval",
    PrWorkingPatternIntervalType = "PrWorkingPatternIntervalType",
    PrWorkingPatternType = "PrWorkingPatternType",
    PrYearOperation = "PrYearOperation",
    PrYearOperationAttachment = "PrYearOperationAttachment",
    PrYearOperationPayrollSheetAttachment = "PrYearOperationPayrollSheetAttachment",
    PrYearOperationSection = "PrYearOperationSection",
    PrYearOperationSectionType = "PrYearOperationSectionType",
    Product = "Product",
    ProformaInvoiceIssued = "ProformaInvoiceIssued",
    ProformaInvoiceReceived = "ProformaInvoiceReceived",
    PurchaseStatus = "PurchaseStatus",
    ReceivableAdjustmentGroup = "ReceivableAdjustmentGroup",
    ReceivableAdjustmentType = "ReceivableAdjustmentType",
    RecurrentPaymentState = "RecurrentPaymentState",
    RecurringTask = "RecurringTask",
    RecurringTaskExecution = "RecurringTaskExecution",
    RecurringTaskInterval = "RecurringTaskInterval",
    RecurringTaskPeriod = "RecurringTaskPeriod",
    RecurringTaskState = "RecurringTaskState",
    RecurringTaskType = "RecurringTaskType",
    RegZecCompany = "RegZecCompany",
    RegZecDisability = "RegZecDisability",
    RegZecEmployee = "RegZecEmployee",
    RegZecEmployment = "RegZecEmployment",
    RegZecForeignInsuranceCarrierAddress = "RegZecForeignInsuranceCarrierAddress",
    RegZecForeignInsurer = "RegZecForeignInsurer",
    RegZecIdentityDocument = "RegZecIdentityDocument",
    RegZecLaborMarketAccess = "RegZecLaborMarketAccess",
    RegZecPension = "RegZecPension",
    RegZecPensionInsuranceInterval = "RegZecPensionInsuranceInterval",
    RegZecUnemploymentSupport = "RegZecUnemploymentSupport",
    RegularDocumentItem = "RegularDocumentItem",
    ReportSectionType = "ReportSectionType",
    ReportType = "ReportType",
    RequiredAccount = "RequiredAccount",
    RequiredAccountTemplate = "RequiredAccountTemplate",
    RequiredAccountType = "RequiredAccountType",
    RiskCategory = "RiskCategory",
    RossumJob = "RossumJob",
    RossumJobStatus = "RossumJobStatus",
    Selection = "Selection",
    ServiceRelationshipTerminationReason = "ServiceRelationshipTerminationReason",
    ShiftPattern = "ShiftPattern",
    SignatoryPerson = "SignatoryPerson",
    SingleJournalEntry = "SingleJournalEntry",
    SpecificLegalFactType = "SpecificLegalFactType",
    SplitAccountAssignment = "SplitAccountAssignment",
    SplitAccountAssignmentDraft = "SplitAccountAssignmentDraft",
    Statement = "Statement",
    StatementAttachment = "StatementAttachment",
    StatementAttachmentDraft = "StatementAttachmentDraft",
    StatementBalance = "StatementBalance",
    StatementDraft = "StatementDraft",
    SubscriptionStatus = "SubscriptionStatus",
    SubscriptionType = "SubscriptionType",
    TaxApplicability = "TaxApplicability",
    TaxCalendar = "TaxCalendar",
    TaxCalendarTaxType = "TaxCalendarTaxType",
    TaxDepreciationCategory = "TaxDepreciationCategory",
    TaxDepreciationCoefficient = "TaxDepreciationCoefficient",
    TaxDepreciationPolicy = "TaxDepreciationPolicy",
    TaxDepreciationPolicyItem = "TaxDepreciationPolicyItem",
    TaxPriceLimit = "TaxPriceLimit",
    TaxStatementSignatoryPerson = "TaxStatementSignatoryPerson",
    TaxStatementSubmitter = "TaxStatementSubmitter",
    TaxStatementXmlAttachment = "TaxStatementXmlAttachment",
    TemporalEntity = "TemporalEntity",
    TimeFormat = "TimeFormat",
    TimeZone = "TimeZone",
    Transaction = "Transaction",
    PropertyTranslation = "PropertyTranslation",
    TrustedSender = "TrustedSender",
    TypeOfBusiness = "TypeOfBusiness",
    UndirectedDocumentLink = "UndirectedDocumentLink",
    UndirectedPaymentDocumentLink = "UndirectedPaymentDocumentLink",
    UnitOfMeasure = "UnitOfMeasure",
    UnorganizedAsset = "UnorganizedAsset",
    User = "User",
    UserCompanyRole = "UserCompanyRole",
    UserNotification = "UserNotification",
    UserStatus = "UserStatus",
    Variant = "Variant",
    VariantAccessType = "VariantAccessType",
    VariantType = "VariantType",
    Vat = "Vat",
    VatCanceledStatus = "VatCanceledStatus",
    VatClassification = "VatClassification",
    VatClassificationSelection = "VatClassificationSelection",
    VatClassificationSelectionDraft = "VatClassificationSelectionDraft",
    VatControlStatement = "VatControlStatement",
    VatControlStatementSection = "VatControlStatementSection",
    VatDeductionType = "VatDeductionType",
    VatOss = "VatOss",
    VatPayerRegistrationAction = "VatPayerRegistrationAction",
    VatPayerRegistrationLimit = "VatPayerRegistrationLimit",
    VatRateType = "VatRateType",
    VatReverseCharge = "VatReverseCharge",
    VatStatement = "VatStatement",
    VatStatementDocument = "VatStatementDocument",
    VatStatementFrequency = "VatStatementFrequency",
    VatStatementSection = "VatStatementSection",
    VatStatementSectionCategory = "VatStatementSectionCategory",
    VatStatementStatus = "VatStatementStatus",
    VatStatus = "VatStatus",
    VatVies = "VatVies",
    WebSocketMessageType = "WebSocketMessageType",
    WorkplaceType = "WorkplaceType",
    WriteOffType = "WriteOffType",
    YesNo = "YesNo",
}

export enum EntitySetName {
    AccountActivityTypes = "AccountActivityTypes",
    AccountCategories = "AccountCategories",
    Accountings = "Accountings",
    AccountRoles = "AccountRoles",
    AccountTypes = "AccountTypes",
    AccruedProcessingTypes = "AccruedProcessingTypes",
    ApprovalStatusTypes = "ApprovalStatusTypes",
    AssetDisposalTypes = "AssetDisposalTypes",
    AssetItemTypes = "AssetItemTypes",
    AssetStatuses = "AssetStatuses",
    AssetTypes = "AssetTypes",
    AssetValues = "AssetValues",
    BackgroundJobStatuses = "BackgroundJobStatuses",
    BackgroundJobTypes = "BackgroundJobTypes",
    Banks = "Banks",
    BankAccountNumberFormatTypes = "BankAccountNumberFormatTypes",
    BankAccountRegistrationStatuses = "BankAccountRegistrationStatuses",
    BankApiStatementImportFrequencies = "BankApiStatementImportFrequencies",
    BankApiStatementImportRanges = "BankApiStatementImportRanges",
    BankExchangeRateFreshnesses = "BankExchangeRateFreshnesses",
    BankPaymentOrderStates = "BankPaymentOrderStates",
    BankStatementTypes = "BankStatementTypes",
    BankTransactionDocumentNumberLocations = "BankTransactionDocumentNumberLocations",
    BankTransactionTypes = "BankTransactionTypes",
    BillingItemTypes = "BillingItemTypes",
    BillingModuleTypes = "BillingModuleTypes",
    BillingPricings = "BillingPricings",
    Bookkeepings = "Bookkeepings",
    BusinessPartnerDocumentDefaultTypes = "BusinessPartnerDocumentDefaultTypes",
    CbaAssetDisposalTypes = "CbaAssetDisposalTypes",
    CbaCategoryTaxTypes = "CbaCategoryTaxTypes",
    CbaEntryLedgerDocumentTypes = "CbaEntryLedgerDocumentTypes",
    CbaEntrySpecialVatCalculations = "CbaEntrySpecialVatCalculations",
    CbaEntryTypes = "CbaEntryTypes",
    CBATransactionTypes = "CBATransactionTypes",
    ChatParticipantTypes = "ChatParticipantTypes",
    ClearedStatuses = "ClearedStatuses",
    ColourThemes = "ColourThemes",
    CommunicationEntryChannels = "CommunicationEntryChannels",
    CommunicationEntryStates = "CommunicationEntryStates",
    CommunicationEntryTypes = "CommunicationEntryTypes",
    CompanyBankAccountTypes = "CompanyBankAccountTypes",
    CompanyPermissions = "CompanyPermissions",
    CompanyRoleTypes = "CompanyRoleTypes",
    CompanyStates = "CompanyStates",
    Countries = "Countries",
    CountryClassifications = "CountryClassifications",
    CountriesAndUnions = "CountriesAndUnions",
    CountryRegions = "CountryRegions",
    CSSZBankTypes = "CSSZBankTypes",
    CSSZSubmissionTypes = "CSSZSubmissionTypes",
    CSSZTransactionStatuses = "CSSZTransactionStatuses",
    Currencies = "Currencies",
    CzIsces = "CzIsces",
    CzIscos = "CzIscos",
    CzNaces = "CzNaces",
    DateFormats = "DateFormats",
    DaysOfWeek = "DaysOfWeek",
    DeferredPlanPostingTypes = "DeferredPlanPostingTypes",
    DepreciationPolicyTypes = "DepreciationPolicyTypes",
    DepreciationSettingTypes = "DepreciationSettingTypes",
    DepreciationTypes = "DepreciationTypes",
    DocumentBusinessPartnerTypes = "DocumentBusinessPartnerTypes",
    DocumentImportTypes = "DocumentImportTypes",
    DocumentItemTypes = "DocumentItemTypes",
    DocumentLinkClearingTypes = "DocumentLinkClearingTypes",
    DocumentLinkTypes = "DocumentLinkTypes",
    DocumentSourceTypes = "DocumentSourceTypes",
    DocumentStatuses = "DocumentStatuses",
    DocumentTypes = "DocumentTypes",
    ElectronicSubmissionSubmissionTypes = "ElectronicSubmissionSubmissionTypes",
    ElectronicSubmissionTypes = "ElectronicSubmissionTypes",
    EntityPermissionLevels = "EntityPermissionLevels",
    EntityTypes = "EntityTypes",
    EvalaZooms = "EvalaZooms",
    ExchangeRateTypes = "ExchangeRateTypes",
    ExpenseTaxRates = "ExpenseTaxRates",
    ExportRanges = "ExportRanges",
    ExportResultTypes = "ExportResultTypes",
    ExportTypes = "ExportTypes",
    ExternalCorrectedDocumentTypes = "ExternalCorrectedDocumentTypes",
    Features = "Features",
    FinancialReportLayouts = "FinancialReportLayouts",
    FinancialReportLayoutSections = "FinancialReportLayoutSections",
    FiscalYearCloseSectionTypes = "FiscalYearCloseSectionTypes",
    FiscalYearStatuses = "FiscalYearStatuses",
    FulfilmentTypes = "FulfilmentTypes",
    GeneralPermissions = "GeneralPermissions",
    GovernmentInstitutions = "GovernmentInstitutions",
    GovernmentInstitutionBankAccounts = "GovernmentInstitutionBankAccounts",
    GovernmentInstitutionBankAccountTypes = "GovernmentInstitutionBankAccountTypes",
    GovernmentInstitutionTypes = "GovernmentInstitutionTypes",
    GrantAssignmentTypes = "GrantAssignmentTypes",
    GrantClaimTypes = "GrantClaimTypes",
    GrantStatuses = "GrantStatuses",
    InboxEntityTypes = "InboxEntityTypes",
    InboxFileSources = "InboxFileSources",
    InboxFileStatuses = "InboxFileStatuses",
    InboxItemLogStates = "InboxItemLogStates",
    IntegrationApiImportedDocuments = "IntegrationApiImportedDocuments",
    IntegrationApiImportFrequencies = "IntegrationApiImportFrequencies",
    IntegrationApiImportFromWhenList = "IntegrationApiImportFromWhenList",
    IntegrationApiImportRanges = "IntegrationApiImportRanges",
    InteractionTypes = "InteractionTypes",
    InventoryTypes = "InventoryTypes",
    InvoiceServiceIntegrationTypes = "InvoiceServiceIntegrationTypes",
    JournalEntryTypes = "JournalEntryTypes",
    Languages = "Languages",
    LegalEntityCategories = "LegalEntityCategories",
    LegislativeFixedExchangeRates = "LegislativeFixedExchangeRates",
    DocumentLockTypes = "DocumentLockTypes",
    LORegionalOffices = "LORegionalOffices",
    MandatoryAccounts = "MandatoryAccounts",
    MandatoryChartsOfAccounts = "MandatoryChartsOfAccounts",
    MinorAssetStatuses = "MinorAssetStatuses",
    Modules = "Modules",
    MonthsOfYear = "MonthsOfYear",
    NotificationPriorities = "NotificationPriorities",
    NotificationTypes = "NotificationTypes",
    NotificationTypeGroups = "NotificationTypeGroups",
    NumberRangeTypes = "NumberRangeTypes",
    NumberRangeWildcards = "NumberRangeWildcards",
    PayableReceivableTypes = "PayableReceivableTypes",
    PayerReliabilityStauses = "PayerReliabilityStauses",
    PaymentDocumentItemTypes = "PaymentDocumentItemTypes",
    PaymentMethods = "PaymentMethods",
    PaymentOrderFormats = "PaymentOrderFormats",
    PaymentOrderOutput = "PaymentOrderOutput",
    PaymentStatuses = "PaymentStatuses",
    ActiveEmploymentPolicyTools = "ActiveEmploymentPolicyTools",
    CollectiveAgreementTypes = "CollectiveAgreementTypes",
    CsszEmploymentTypes = "CsszEmploymentTypes",
    DetailedEmploymentSpecifications = "DetailedEmploymentSpecifications",
    EmploymentEarlyTerminationReasons = "EmploymentEarlyTerminationReasons",
    EmploymentRelationshipTerminationReasons = "EmploymentRelationshipTerminationReasons",
    LaborOfficeEmploymentTypes = "LaborOfficeEmploymentTypes",
    MpsvFreeAccessToLaborMarketTypes = "MpsvFreeAccessToLaborMarketTypes",
    MpsvTaxIdentificators = "MpsvTaxIdentificators",
    NoUnemploymentSupportTypes = "NoUnemploymentSupportTypes",
    OwnershipFormTypes = "OwnershipFormTypes",
    PrAbsenceCategoryOrigins = "PrAbsenceCategoryOrigins",
    PrAbsenceCategorySubtypes = "PrAbsenceCategorySubtypes",
    PrAbsenceCategoryTypes = "PrAbsenceCategoryTypes",
    PrAbsenceCompensations = "PrAbsenceCompensations",
    PrAbsenceObstacleTypes = "PrAbsenceObstacleTypes",
    PrAccountingCategories = "PrAccountingCategories",
    PrAccountingGroupSelections = "PrAccountingGroupSelections",
    PrAccountingItemGroups = "PrAccountingItemGroups",
    PrAccountingItemTypes = "PrAccountingItemTypes",
    PrAnnualTaxItemTypes = "PrAnnualTaxItemTypes",
    PrAnnualTaxSettlementRequestFormSectionDetailTypes = "PrAnnualTaxSettlementRequestFormSectionDetailTypes",
    PrAnnualTaxSettlementRequestFormSectionTypes = "PrAnnualTaxSettlementRequestFormSectionTypes",
    PrAnnualTaxSettlementRequestResultTypes = "PrAnnualTaxSettlementRequestResultTypes",
    PrAnnualTaxSettlementRequestStatusTypes = "PrAnnualTaxSettlementRequestStatusTypes",
    PrAnnualTaxSettlementStatuses = "PrAnnualTaxSettlementStatuses",
    PrAttendanceStatuses = "PrAttendanceStatuses",
    PrAttendanceStatusDisplays = "PrAttendanceStatusDisplays",
    PrBenefitTaxFreeLimits = "PrBenefitTaxFreeLimits",
    PrBenefitTypes = "PrBenefitTypes",
    PrCaregivingTypes = "PrCaregivingTypes",
    PrChildDeductionOrders = "PrChildDeductionOrders",
    PrCollectionItemChangeTypes = "PrCollectionItemChangeTypes",
    PrCzechReductionLimits = "PrCzechReductionLimits",
    PrDelayedIncomeTypes = "PrDelayedIncomeTypes",
    PrDisabilityDiscountAmounts = "PrDisabilityDiscountAmounts",
    PrDisabilityTypes = "PrDisabilityTypes",
    PrDistrainmentDepositClosings = "PrDistrainmentDepositClosings",
    PrEducations = "PrEducations",
    PrEldpItemTypes = "PrEldpItemTypes",
    PrEldpTypes = "PrEldpTypes",
    PrEmployeeCarTaxabilities = "PrEmployeeCarTaxabilities",
    PrEmployeeDependentPersonRelations = "PrEmployeeDependentPersonRelations",
    PrEmployeeStates = "PrEmployeeStates",
    PrEmploymentCategories = "PrEmploymentCategories",
    PrEmploymentTypes = "PrEmploymentTypes",
    PrEmploymentWorkplaceAddressSelections = "PrEmploymentWorkplaceAddressSelections",
    PrExtraSalaryComputationTypes = "PrExtraSalaryComputationTypes",
    PrExtraSalaryLegislativeValues = "PrExtraSalaryLegislativeValues",
    PrExtraSalaryTypes = "PrExtraSalaryTypes",
    PrForeignInsuranceCarrierSectorTypes = "PrForeignInsuranceCarrierSectorTypes",
    PrForeignInsuranceCarrierTypes = "PrForeignInsuranceCarrierTypes",
    PrFormOfStudyTypes = "PrFormOfStudyTypes",
    PrHealthInsuranceCompanies = "PrHealthInsuranceCompanies",
    PrHealthInsuranceCompanyBankAccounts = "PrHealthInsuranceCompanyBankAccounts",
    PrHolidayPayoutTypes = "PrHolidayPayoutTypes",
    PrHolidayShiftAssignments = "PrHolidayShiftAssignments",
    PrHozChangeCodes = "PrHozChangeCodes",
    PrIdentifiers = "PrIdentifiers",
    PrIdentityDocumentTypes = "PrIdentityDocumentTypes",
    PrIncomeTaxDiscounts = "PrIncomeTaxDiscounts",
    PrInsolvencyDepositClosings = "PrInsolvencyDepositClosings",
    PrJmhzFormTypes = "PrJmhzFormTypes",
    PrLegislativeAverageSalaries = "PrLegislativeAverageSalaries",
    PrLegislativePayrollConstants = "PrLegislativePayrollConstants",
    PrLegislativeYouthEventCompensationHourlyLimits = "PrLegislativeYouthEventCompensationHourlyLimits",
    PrMaternityLeaveEntitlements = "PrMaternityLeaveEntitlements",
    PrMinimumHealthInsuranceBases = "PrMinimumHealthInsuranceBases",
    PrMinimumHealthInsuranceTypes = "PrMinimumHealthInsuranceTypes",
    PrMpsvFamilyRelations = "PrMpsvFamilyRelations",
    PrMpsvRelations = "PrMpsvRelations",
    PrOtherBenefitCategories = "PrOtherBenefitCategories",
    PrOtherBenefitTaxAndContributionsApplicabilities = "PrOtherBenefitTaxAndContributionsApplicabilities",
    PrOtherBenefitTaxDeducibilities = "PrOtherBenefitTaxDeducibilities",
    PrPaternityLeaveEntitlements = "PrPaternityLeaveEntitlements",
    PrPayrollPeriodStatuses = "PrPayrollPeriodStatuses",
    PrPayrollSubstitutePayDays = "PrPayrollSubstitutePayDays",
    PrPayslipEmploymentItemTypes = "PrPayslipEmploymentItemTypes",
    PrPayslipEmploymentSubitemTypes = "PrPayslipEmploymentSubitemTypes",
    PrPayslipItemTypes = "PrPayslipItemTypes",
    PrPayslipSubitemTypes = "PrPayslipSubitemTypes",
    PrPropertyAcquisitions = "PrPropertyAcquisitions",
    PrRegularSalaryTypes = "PrRegularSalaryTypes",
    PrRelevantIncomes = "PrRelevantIncomes",
    PrRetirementSavingsComputationTypes = "PrRetirementSavingsComputationTypes",
    PrRetirementSavingsTypes = "PrRetirementSavingsTypes",
    PrSalaryComponentTypes = "PrSalaryComponentTypes",
    PrSalaryPayoutTypes = "PrSalaryPayoutTypes",
    PrSex = "PrSex",
    PrSocialEventMonthDetailTypes = "PrSocialEventMonthDetailTypes",
    PrSocialEventRequiredActions = "PrSocialEventRequiredActions",
    PrSocialEventStatus = "PrSocialEventStatus",
    PrSocialEventTypes = "PrSocialEventTypes",
    PrSocialInsuranceDiscountIneligibilityReasons = "PrSocialInsuranceDiscountIneligibilityReasons",
    PrSocialInsuranceDiscountTypes = "PrSocialInsuranceDiscountTypes",
    PrSocialInsuranceRates = "PrSocialInsuranceRates",
    PrSubmissionStatuses = "PrSubmissionStatuses",
    PrSubmissionSubtypes = "PrSubmissionSubtypes",
    PrSubmissionTypes = "PrSubmissionTypes",
    PrSubmissionValidationStatuses = "PrSubmissionValidationStatuses",
    PrTaxDiscountTypes = "PrTaxDiscountTypes",
    PrTaxpayerDeclarationStatuses = "PrTaxpayerDeclarationStatuses",
    PrTimeBasedBonusTypes = "PrTimeBasedBonusTypes",
    PrUnseizableAmounts = "PrUnseizableAmounts",
    PrVacationEntitlements = "PrVacationEntitlements",
    PrVacationEntitlementInclusions = "PrVacationEntitlementInclusions",
    PrWorkingPatternTypes = "PrWorkingPatternTypes",
    PrWorkPermitTypes = "PrWorkPermitTypes",
    PrYearOperationSectionTypes = "PrYearOperationSectionTypes",
    RiskCategories = "RiskCategories",
    ServiceRelationshipTerminationReasons = "ServiceRelationshipTerminationReasons",
    ShiftPatterns = "ShiftPatterns",
    SpecificLegalFactTypes = "SpecificLegalFactTypes",
    WorkplaceTypes = "WorkplaceTypes",
    PeriodDays = "PeriodDays",
    PostedStatuses = "PostedStatuses",
    PostingRuleDocumentTypes = "PostingRuleDocumentTypes",
    PrChildSupportDeductionTypes = "PrChildSupportDeductionTypes",
    PrCSSZPaymentMethods = "PrCSSZPaymentMethods",
    PrDeductionCalculationTypes = "PrDeductionCalculationTypes",
    PrDeductionEntityTypes = "PrDeductionEntityTypes",
    PrDeductionStatuses = "PrDeductionStatuses",
    PrDeductionTypes = "PrDeductionTypes",
    PrDistrainmentDeductionTypes = "PrDistrainmentDeductionTypes",
    PrEntityValueSources = "PrEntityValueSources",
    PrExtraSalaryOrigins = "PrExtraSalaryOrigins",
    PrFixedBonusDeductionImpacts = "PrFixedBonusDeductionImpacts",
    PrFixedBonusPayOutImpacts = "PrFixedBonusPayOutImpacts",
    PrFixedBonusTaxImpacts = "PrFixedBonusTaxImpacts",
    Products = "Products",
    PrPensionTypes = "PrPensionTypes",
    PrPeriodDocumentTypes = "PrPeriodDocumentTypes",
    PrSalaryComponentAverageInclusions = "PrSalaryComponentAverageInclusions",
    PrSubsequentMaternityLeaveStatuses = "PrSubsequentMaternityLeaveStatuses",
    PrTaxpayerDeclarationTypes = "PrTaxpayerDeclarationTypes",
    PrValueTypes = "PrValueTypes",
    PrWorkingPatternIntervalTypes = "PrWorkingPatternIntervalTypes",
    PrWorkIntervalTypes = "PrWorkIntervalTypes",
    PurchaseStatuses = "PurchaseStatuses",
    ReceivableAdjustmentGroups = "ReceivableAdjustmentGroups",
    ReceivableAdjustmentTypes = "ReceivableAdjustmentTypes",
    RecurrentPaymentStates = "RecurrentPaymentStates",
    RecurringTaskIntervals = "RecurringTaskIntervals",
    RecurringTaskPeriods = "RecurringTaskPeriods",
    RecurringTaskStates = "RecurringTaskStates",
    RecurringTaskTypes = "RecurringTaskTypes",
    ReportSectionTypes = "ReportSectionTypes",
    ReportTypes = "ReportTypes",
    RequiredAccountTypes = "RequiredAccountTypes",
    RosumJobStatuses = "RosumJobStatuses",
    Selections = "Selections",
    SignatoryPersons = "SignatoryPersons",
    SubscriptionStatuses = "SubscriptionStatuses",
    SubscriptionTypes = "SubscriptionTypes",
    TaxApplicabilities = "TaxApplicabilities",
    TaxCalendarTaxTypes = "TaxCalendarTaxTypes",
    TaxDepreciationCategories = "TaxDepreciationCategories",
    TaxDepreciationCoefficients = "TaxDepreciationCoefficients",
    TaxPriceLimits = "TaxPriceLimits",
    TaxStatementSubmitters = "TaxStatementSubmitters",
    TimeFormats = "TimeFormats",
    TimeZones = "TimeZones",
    TypeOfBusinesses = "TypeOfBusinesses",
    UnitsOfMeasure = "UnitsOfMeasure",
    UserStatuses = "UserStatuses",
    VariantAccessTypes = "VariantAccessTypes",
    VariantTypes = "VariantTypes",
    Vats = "Vats",
    VatCanceledStatuses = "VatCanceledStatuses",
    VatControlStatements = "VatControlStatements",
    VatControlStatementSections = "VatControlStatementSections",
    VatDeductionTypes = "VatDeductionTypes",
    VatOsses = "VatOsses",
    VatPayerRegistrationActions = "VatPayerRegistrationActions",
    VatPayerRegistrationLimits = "VatPayerRegistrationLimits",
    VatRateTypes = "VatRateTypes",
    VatReverseCharges = "VatReverseCharges",
    VatStatements = "VatStatements",
    VatStatementFrequencies = "VatStatementFrequencies",
    VatStatementSections = "VatStatementSections",
    VatStatementSectionCategories = "VatStatementSectionCategories",
    VatStatementStatuses = "VatStatementStatuses",
    VatStatuses = "VatStatuses",
    VatVieses = "VatVieses",
    WebSocketMessageTypes = "WebSocketMessageTypes",
    WriteOffTypes = "WriteOffTypes",
    YesNos = "YesNos",
    Documents = "Documents",
    Statements = "Statements",
    PrEldps = "PrEldps",
    CashReceipts = "CashReceipts",
    PrSubmissions = "PrSubmissions",
    PrSocialEvents = "PrSocialEvents",
    AccountAssignments = "AccountAssignments",
    CorrectiveInvoicesReceived = "CorrectiveInvoicesReceived",
    InvoicesReceived = "InvoicesReceived",
    OtherLiabilities = "OtherLiabilities",
    ProformaInvoicesReceived = "ProformaInvoicesReceived",
    CorrectiveInvoicesIssued = "CorrectiveInvoicesIssued",
    InvoicesIssued = "InvoicesIssued",
    OtherReceivables = "OtherReceivables",
    ProformaInvoicesIssued = "ProformaInvoicesIssued",
    DeferredDocuments = "DeferredDocuments",
    DeferredPlans = "DeferredPlans",
    ActionLogs = "ActionLogs",
    Assets = "Assets",
    DocumentAssetEntries = "DocumentAssetEntries",
    DocumentMinorAssetItems = "DocumentMinorAssetItems",
    MinorAssets = "MinorAssets",
    MinorAssetHistoryEntries = "MinorAssetHistoryEntries",
    UnorganizedAssets = "UnorganizedAssets",
    BackgroundJobs = "BackgroundJobs",
    BusinessPartners = "BusinessPartners",
    CbaCategories = "CbaCategories",
    CbaEntries = "CbaEntries",
    ChartedAccountAssignments = "ChartedAccountAssignments",
    ChartsOfAccounts = "ChartsOfAccounts",
    Chats = "Chats",
    CommunicationEntries = "CommunicationEntries",
    Companies = "Companies",
    CompanyRoles = "CompanyRoles",
    CompanySettings = "CompanySettings",
    CurrenciesUsedByCompany = "CurrenciesUsedByCompany",
    CurrenciesWithExchangeRateInfo = "CurrenciesWithExchangeRateInfo",
    CustomerPortalPayments = "CustomerPortalPayments",
    DashboardTasks = "DashboardTasks",
    DataBoxes = "DataBoxes",
    IsdocImportDocuments = "IsdocImportDocuments",
    MoneyS3ImportDocuments = "MoneyS3ImportDocuments",
    PohodaImportDocuments = "PohodaImportDocuments",
    ClearingDocumentLinks = "ClearingDocumentLinks",
    DocumentDeleteLogs = "DocumentDeleteLogs",
    DocumentDrafts = "DocumentDrafts",
    PayingDocuments = "PayingDocuments",
    UndirectedDocumentLinks = "UndirectedDocumentLinks",
    VatStatementDocuments = "VatStatementDocuments",
    ElectronicSubmissions = "ElectronicSubmissions",
    ElectronicSubmissionPeriodWithDeletedDocuments = "ElectronicSubmissionPeriodWithDeletedDocuments",
    ExchangeRates = "ExchangeRates",
    ExportLogs = "ExportLogs",
    FilesMetadata = "FilesMetadata",
    FinancialReportCloses = "FinancialReportCloses",
    FinancialReportCloseItems = "FinancialReportCloseItems",
    FiscalYears = "FiscalYears",
    FiscalYearCloses = "FiscalYearCloses",
    FlattenAccounts = "FlattenAccounts",
    GeneralRoles = "GeneralRoles",
    DocumentItemsLinkableToGrant = "DocumentItemsLinkableToGrant",
    Grants = "Grants",
    GrantClaims = "GrantClaims",
    GrantEntries = "GrantEntries",
    Hotspots = "Hotspots",
    InboxFiles = "InboxFiles",
    InboxFileLogs = "InboxFileLogs",
    InboxItemLogs = "InboxItemLogs",
    InternalDocuments = "InternalDocuments",
    InvoiceServiceIntegrations = "InvoiceServiceIntegrations",
    ItemTemplates = "ItemTemplates",
    CompoundJournalEntries = "CompoundJournalEntries",
    JournalEntries = "JournalEntries",
    SingleJournalEntries = "SingleJournalEntries",
    LabelHierarchies = "LabelHierarchies",
    NotificationSettings = "NotificationSettings",
    Notifications = "Notifications",
    NumberRanges = "NumberRanges",
    NumberRangeDefinitions = "NumberRangeDefinitions",
    Organizations = "Organizations",
    BankStatements = "BankStatements",
    BankTransactions = "BankTransactions",
    BankTransactionDuplicates = "BankTransactionDuplicates",
    BusinessPartnerBankAccounts = "BusinessPartnerBankAccounts",
    CompanyBankAccounts = "CompanyBankAccounts",
    LoanAccounts = "LoanAccounts",
    LoanStatements = "LoanStatements",
    LoanTransactions = "LoanTransactions",
    PostingRules = "PostingRules",
    StatementDrafts = "StatementDrafts",
    CashBoxes = "CashBoxes",
    CashReceiptsIssued = "CashReceiptsIssued",
    CashReceiptsReceived = "CashReceiptsReceived",
    PaymentDocumentDrafts = "PaymentDocumentDrafts",
    UndirectedPaymentDocumentLinks = "UndirectedPaymentDocumentLinks",
    PrAnnualTaxSettlements = "PrAnnualTaxSettlements",
    PrAnnualTaxSettlementRequests = "PrAnnualTaxSettlementRequests",
    PrPayrollDocuments = "PrPayrollDocuments",
    PrPayrollPeriods = "PrPayrollPeriods",
    PrPayslips = "PrPayslips",
    PrAbsenceCategories = "PrAbsenceCategories",
    PrAccountAssignmentTemplates = "PrAccountAssignmentTemplates",
    PrAttendances = "PrAttendances",
    PrBenefits = "PrBenefits",
    PrCSSZSubmissionsCaregiving = "PrCSSZSubmissionsCaregiving",
    PrCSSZSubmissionsIllnessLeave = "PrCSSZSubmissionsIllnessLeave",
    PrCSSZSubmissionsLongtermCaregiving = "PrCSSZSubmissionsLongtermCaregiving",
    PrCSSZSubmissionsMaternityLeave = "PrCSSZSubmissionsMaternityLeave",
    PrCSSZSubmissionsPaternityLeave = "PrCSSZSubmissionsPaternityLeave",
    PrDeductions = "PrDeductions",
    PrDepositedDeductions = "PrDepositedDeductions",
    PrDepositedDistrainmentAmounts = "PrDepositedDistrainmentAmounts",
    PrEmployees = "PrEmployees",
    PrEmployments = "PrEmployments",
    PrEmploymentBalancingPeriods = "PrEmploymentBalancingPeriods",
    PrEmploymentTemplates = "PrEmploymentTemplates",
    PrExtraSalaries = "PrExtraSalaries",
    PrJmhzSubmissions = "PrJmhzSubmissions",
    PrPayrollSettings = "PrPayrollSettings",
    PrSalaryAdvances = "PrSalaryAdvances",
    PrSalaryComponents = "PrSalaryComponents",
    PrSubmissionsRegZec = "PrSubmissionsRegZec",
    PrTaxpayerDeclarations = "PrTaxpayerDeclarations",
    PrWorkingPatterns = "PrWorkingPatterns",
    PrYearOperations = "PrYearOperations",
    PrRetirementSavingsCompanies = "PrRetirementSavingsCompanies",
    PrRetirementSavingsProducts = "PrRetirementSavingsProducts",
    PrCaregivingEvents = "PrCaregivingEvents",
    PrCustodyEvents = "PrCustodyEvents",
    PrIllnessLeaveEvents = "PrIllnessLeaveEvents",
    PrImprisonmentEvents = "PrImprisonmentEvents",
    PrLongTermCaregivingEvents = "PrLongTermCaregivingEvents",
    PrMaternityLeaveEvents = "PrMaternityLeaveEvents",
    PrParentalLeaveEvents = "PrParentalLeaveEvents",
    PrPaternityLeaveEvents = "PrPaternityLeaveEvents",
    PrCsszHzupnSubmissions = "PrCsszHzupnSubmissions",
    PrCsszOzuspojSubmissions = "PrCsszOzuspojSubmissions",
    PrHozSubmissions = "PrHozSubmissions",
    PrPppzSubmissions = "PrPppzSubmissions",
    PodaniValidationErrors = "PodaniValidationErrors",
    RecurringTasks = "RecurringTasks",
    RequiredAccounts = "RequiredAccounts",
    RossumJobs = "RossumJobs",
    TaxCalendars = "TaxCalendars",
    AccountAssignmentTemplates = "AccountAssignmentTemplates",
    ChartOfAccountsTemplates = "ChartOfAccountsTemplates",
    Users = "Users",
    DefaultVariants = "DefaultVariants",
    Variants = "Variants",
    VatClassifications = "VatClassifications",
    PropertyTranslations = "PropertyTranslations",
    BillingAddresses = "BillingAddresses",
    BillingContacts = "BillingContacts",
    EnabledFeatures = "EnabledFeatures",
    Invitations = "Invitations",
    Subscriptions = "Subscriptions",
    Tenants = "Tenants",
}

export enum OdataActionName {
    BackgroundJobCancel = "BackgroundJobCancel",
    BackgroundJobMarkSeen = "BackgroundJobMarkSeen",
    BackgroundJobRollback = "BackgroundJobRollback",
    BankTransactionsConfirm = "BankTransactionsConfirm",
    BankTransactionsMatchMultiple = "BankTransactionsMatchMultiple",
    BankTransactionsPostMultiple = "BankTransactionsPostMultiple",
    DocumentDraftsPostMultiple = "DocumentDraftsPostMultiple",
    DocumentDraftCancelRossum = "DocumentDraftCancelRossum",
    ChatsHandOver = "ChatsHandOver",
    ChatReadMessages = "ChatReadMessages",
    ChatsToggleFlag = "ChatsToggleFlag",
    PrEmploymentCreateDelayedIncome = "PrEmploymentCreateDelayedIncome",
    CashBoxCreateReceipt = "CashBoxCreateReceipt",
    ElectronicSubmissionsLock = "ElectronicSubmissionsLock",
    ElectronicSubmissionUnlock = "ElectronicSubmissionUnlock",
    DocumentDraftExtractIsdoc = "DocumentDraftExtractIsdoc",
    DocumentDraftExtractRossum = "DocumentDraftExtractRossum",
    PrEldpsGenerateEldp = "PrEldpsGenerateEldp",
    PrPayrollPeriodGeneratePppzSubmissions = "PrPayrollPeriodGeneratePppzSubmissions",
    UserNotificationsMarkAllIsRead = "UserNotificationsMarkAllIsRead",
    PrEmployeeInviteToCustomerPortal = "PrEmployeeInviteToCustomerPortal",
    PrEmployeeSendPayslipPassword = "PrEmployeeSendPayslipPassword",
    InboxFileRemoveInboxFileLeaveFileMetadata = "InboxFileRemoveInboxFileLeaveFileMetadata",
    UserNotificationSwitchIsRead = "UserNotificationSwitchIsRead",
}

export const ODataActionPath = {
    [OdataActionName.BackgroundJobCancel]: "Cancel",
    [OdataActionName.BackgroundJobMarkSeen]: "MarkSeen",
    [OdataActionName.BackgroundJobRollback]: "Rollback",
    [OdataActionName.BankTransactionsConfirm]: "Confirm",
    [OdataActionName.BankTransactionsMatchMultiple]: "MatchMultiple",
    [OdataActionName.BankTransactionsPostMultiple]: "PostMultiple",
    [OdataActionName.DocumentDraftsPostMultiple]: "PostMultiple",
    [OdataActionName.DocumentDraftCancelRossum]: "CancelRossum",
    [OdataActionName.ChatsHandOver]: "HandOver",
    [OdataActionName.ChatReadMessages]: "ReadMessages",
    [OdataActionName.ChatsToggleFlag]: "ToggleFlag",
    [OdataActionName.PrEmploymentCreateDelayedIncome]: "CreateDelayedIncome",
    [OdataActionName.CashBoxCreateReceipt]: "CreateReceipt",
    [OdataActionName.ElectronicSubmissionsLock]: "Lock",
    [OdataActionName.ElectronicSubmissionUnlock]: "Unlock",
    [OdataActionName.DocumentDraftExtractIsdoc]: "ExtractIsdoc",
    [OdataActionName.DocumentDraftExtractRossum]: "ExtractRossum",
    [OdataActionName.PrEldpsGenerateEldp]: "GenerateEldp",
    [OdataActionName.PrPayrollPeriodGeneratePppzSubmissions]: "GeneratePppzSubmissions",
    [OdataActionName.UserNotificationsMarkAllIsRead]: "MarkAllIsRead",
    [OdataActionName.PrEmployeeInviteToCustomerPortal]: "InviteToCustomerPortal",
    [OdataActionName.PrEmployeeSendPayslipPassword]: "SendPayslipPassword",
    [OdataActionName.InboxFileRemoveInboxFileLeaveFileMetadata]: "RemoveInboxFileLeaveFileMetadata",
    [OdataActionName.UserNotificationSwitchIsRead]: "SwitchIsRead",
};

export enum OdataFunctionName {
    PrSubmissionsExportXml = "PrSubmissionsExportXml",
    PrCaregivingEventGenerateSubmission = "PrCaregivingEventGenerateSubmission",
    PrIllnessLeaveEventGenerateSubmission = "PrIllnessLeaveEventGenerateSubmission",
    PrLongTermCaregivingEventGenerateSubmission = "PrLongTermCaregivingEventGenerateSubmission",
    PrMaternityLeaveEventGenerateSubmission = "PrMaternityLeaveEventGenerateSubmission",
    PrPaternityLeaveEventGenerateSubmission = "PrPaternityLeaveEventGenerateSubmission",
    PrEmployeeGenerateHozSubmission = "PrEmployeeGenerateHozSubmission",
    PrIllnessLeaveEventGenerateHzupnSubmission = "PrIllnessLeaveEventGenerateHzupnSubmission",
    PrPayrollPeriodGenerateJmhzSubmission = "PrPayrollPeriodGenerateJmhzSubmission",
    PrEmploymentGenerateRegZecSubmission = "PrEmploymentGenerateRegZecSubmission",
    PrSubmissionValidate = "PrSubmissionValidate",
}

export const ODataFunctionPath = {
    [OdataFunctionName.PrSubmissionsExportXml]: "ExportXml",
    [OdataFunctionName.PrCaregivingEventGenerateSubmission]: "GenerateSubmission",
    [OdataFunctionName.PrIllnessLeaveEventGenerateSubmission]: "GenerateSubmission",
    [OdataFunctionName.PrLongTermCaregivingEventGenerateSubmission]: "GenerateSubmission",
    [OdataFunctionName.PrMaternityLeaveEventGenerateSubmission]: "GenerateSubmission",
    [OdataFunctionName.PrPaternityLeaveEventGenerateSubmission]: "GenerateSubmission",
    [OdataFunctionName.PrEmployeeGenerateHozSubmission]: "GenerateHozSubmission",
    [OdataFunctionName.PrIllnessLeaveEventGenerateHzupnSubmission]: "GenerateHzupnSubmission",
    [OdataFunctionName.PrPayrollPeriodGenerateJmhzSubmission]: "GenerateJmhzSubmission",
    [OdataFunctionName.PrEmploymentGenerateRegZecSubmission]: "GenerateRegZecSubmission",
    [OdataFunctionName.PrSubmissionValidate]: "Validate",
};

export interface IBankTransactionsConfirmParameters {
    BankTransactionIds: number[];
}

export interface IBankTransactionsMatchMultipleParameters {
    DocumentId: number;
    TransactionIds: number[];
}

export interface IBankTransactionsPostMultipleParameters {
    AccountNumber?: string;
    TransactionIds: number[];
    Labels?: IBankTransactionsPostMultipleLabelParameterEntity[];
}

export interface IDocumentDraftsPostMultipleParameters {
    DraftIds: number[];
    DocumentTypeCode: string;
    IsTaxProformaDocument?: boolean;
    DateAccountingTransaction?: ISourcedDateEntity;
    ReplaceDateAccountingTransaction?: boolean;
    ReplaceAccountAssignment?: boolean;
    CreditAccountNumber?: string;
    DebitAccountNumber?: string;
    AccountAssignmentName?: string;
    IsAccountAssignmentCustom?: boolean;
    CbaCategoryId?: number;
    CbaCategoryName?: string;
    CbaTaxImpactCode?: string;
    TaxPercentage?: number;
    IsAssetAcquisition?: boolean;
}

export interface IDocumentDraftCancelRossumParameters {
    BackgroundJobId: number;
}

export interface IChatsHandOverParameters {
    User: IUserEntity;
    ChatIds: number[];
}

export interface IChatsToggleFlagParameters {
    ChatIds: number[];
}

export interface IPrEmploymentCreateDelayedIncomeParameters {
    Year?: number;
    Month?: number;
    Employee?: IPrEmployeeEntity;
    DelayedIncomeType?: IPrDelayedIncomeTypeEntity;
    SalaryComponents?: IPrPayslipEmploymentSalaryComponentEntity[];
}

export interface ICashBoxCreateReceiptParameters {
    Document: IDocumentEntity;
}

export interface IElectronicSubmissionsLockParameters {
    Company?: ICompanyEntity;
    DatePeriodStart?: string;
    DatePeriodEnd?: string;
    ElectronicSubmissionTypeCode?: string;
    ElectronicSubmissionSubmissionTypeCode?: string;
    DateCorrectionDiscovered?: string;
    CorrectionReason?: string;
    ReferenceNumberOfNotice?: string;
    ForceLock?: boolean;
}

export interface IDocumentDraftExtractIsdocParameters {
    FileMetadata: IFileMetadataEntity;
    WorkDate?: string;
}

export interface IDocumentDraftExtractRossumParameters {
    FileMetadata: IFileMetadataEntity;
    WorkDate?: string;
}

export interface IPrEldpsGenerateEldpParameters {
    Year: number;
    EmployeeIds?: number[];
}

export interface IPrPayrollPeriodGeneratePppzSubmissionsParameters {
    SubmissionSubtypeCode?: string;
    HealthInsuranceCompanyCodes?: string[];
}

export interface IPrEmployeeInviteToCustomerPortalParameters {
    Email: string;
}

export interface IPrEmployeeSendPayslipPasswordParameters {
    Email: string;
}

export interface IOdataActionParameters {
    [OdataActionName.BackgroundJobCancel]: null;
    [OdataActionName.BackgroundJobMarkSeen]: null;
    [OdataActionName.BackgroundJobRollback]: null;
    [OdataActionName.BankTransactionsConfirm]: IBankTransactionsConfirmParameters;
    [OdataActionName.BankTransactionsMatchMultiple]: IBankTransactionsMatchMultipleParameters;
    [OdataActionName.BankTransactionsPostMultiple]: IBankTransactionsPostMultipleParameters;
    [OdataActionName.DocumentDraftsPostMultiple]: IDocumentDraftsPostMultipleParameters;
    [OdataActionName.DocumentDraftCancelRossum]: IDocumentDraftCancelRossumParameters;
    [OdataActionName.ChatsHandOver]: IChatsHandOverParameters;
    [OdataActionName.ChatReadMessages]: null;
    [OdataActionName.ChatsToggleFlag]: IChatsToggleFlagParameters;
    [OdataActionName.PrEmploymentCreateDelayedIncome]: IPrEmploymentCreateDelayedIncomeParameters;
    [OdataActionName.CashBoxCreateReceipt]: ICashBoxCreateReceiptParameters;
    [OdataActionName.ElectronicSubmissionsLock]: IElectronicSubmissionsLockParameters;
    [OdataActionName.ElectronicSubmissionUnlock]: null;
    [OdataActionName.DocumentDraftExtractIsdoc]: IDocumentDraftExtractIsdocParameters;
    [OdataActionName.DocumentDraftExtractRossum]: IDocumentDraftExtractRossumParameters;
    [OdataActionName.PrEldpsGenerateEldp]: IPrEldpsGenerateEldpParameters;
    [OdataActionName.PrPayrollPeriodGeneratePppzSubmissions]: IPrPayrollPeriodGeneratePppzSubmissionsParameters;
    [OdataActionName.UserNotificationsMarkAllIsRead]: null;
    [OdataActionName.PrEmployeeInviteToCustomerPortal]: IPrEmployeeInviteToCustomerPortalParameters;
    [OdataActionName.PrEmployeeSendPayslipPassword]: IPrEmployeeSendPayslipPasswordParameters;
    [OdataActionName.InboxFileRemoveInboxFileLeaveFileMetadata]: null;
    [OdataActionName.UserNotificationSwitchIsRead]: null;
}